webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resourcePreloader_service_1 = __webpack_require__(146);
exports.ResourcePreloaderService = resourcePreloader_service_1.ResourcePreloaderService;
var event_service_1 = __webpack_require__(143);
exports.EventService = event_service_1.EventService;
var progress_service_1 = __webpack_require__(145);
exports.ProgressService = progress_service_1.ProgressService;
var pack_level_service_1 = __webpack_require__(101);
exports.PackLevelService = pack_level_service_1.PackLevelService;
var localization_service_1 = __webpack_require__(261);
exports.LocalizationService = localization_service_1.LocalizationService;
var storage_service_1 = __webpack_require__(69);
exports.StorageService = storage_service_1.StorageService;
var tool_service_1 = __webpack_require__(147);
exports.ToolService = tool_service_1.ToolService;
var user_service_1 = __webpack_require__(264);
exports.UserService = user_service_1.UserService;
var level_box_guard_service_1 = __webpack_require__(259);
exports.LevelBoxGuardService = level_box_guard_service_1.LevelBoxGuardService;
var level_guard_service_1 = __webpack_require__(260);
exports.LevelGuardService = level_guard_service_1.LevelGuardService;
var short_path_game_guard_service_1 = __webpack_require__(263);
exports.ShortPathGameGuardService = short_path_game_guard_service_1.ShortPathGameGuardService;
var level_permutation_analyzer_service_1 = __webpack_require__(144);
exports.LevelPermutationAnalyzerService = level_permutation_analyzer_service_1.LevelPermutationAnalyzerService;
var migration_service_1 = __webpack_require__(262);
exports.MigrationService = migration_service_1.MigrationService;


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/StarIcon.37451e9ac05e273f0cec4df5ce3f719c.svg";

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var retina = false;
if (window.devicePixelRatio > 1) {
    retina = true;
}
exports.RETINA = retina;
exports.VERSION = 'v5.16';


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Star0Icon.6c8c164666f545d9c3be05f8ac6fa8b5.svg";

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CloseBtn.36440b7d2e7981d6a80c765efc3eb302.svg";

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Star00Icon.ecf8e117cb6fcff194859d93fad9632b.svg";

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var StorageService = (function () {
    function StorageService() {
        this.storageErrorMessage = 'Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.';
    }
    StorageService.prototype.save = function (property, data) {
        try {
            localStorage.setItem(property, JSON.stringify(data));
        }
        catch (error) {
            alert(this.storageErrorMessage);
        }
    };
    StorageService.prototype.saveString = function (property, stringItem) {
        try {
            localStorage.setItem(property, stringItem);
        }
        catch (error) {
            alert(this.storageErrorMessage);
        }
    };
    StorageService.prototype.get = function (property) {
        return localStorage.getItem(property);
    };
    StorageService.prototype.getArray = function (property) {
        try {
            return JSON.parse(localStorage.getItem(property));
        }
        catch (error) {
            return [];
        }
    };
    StorageService.prototype.getObject = function (property) {
        try {
            return JSON.parse(localStorage.getItem(property));
        }
        catch (error) {
            return {};
        }
    };
    StorageService.prototype.clear = function () {
        localStorage.clear();
    };
    StorageService.prototype.remove = function (item) {
        localStorage.removeItem(item);
    };
    StorageService.prototype.getStorage = function () {
        return localStorage;
    };
    return StorageService;
}());
StorageService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], StorageService);
exports.StorageService = StorageService;


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/StarCheckIcon.978f2df4889c3deaa84316d81408585c.svg";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/StarEMovesIcon.54740b83353d1907c04f321bf0b7205b.svg";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/StarLMovesIcon.c429d93810c6102397731a81491817a3.svg";

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var http_1 = __webpack_require__(53);
var _1 = __webpack_require__(11);
var interfaces_1 = __webpack_require__(256);
var storage_service_1 = __webpack_require__(69);
var Module = window.Module;
var PackLevelService = (function () {
    function PackLevelService(http, resourcePreloaderService, storageService) {
        this.http = http;
        this.resourcePreloaderService = resourcePreloaderService;
        this.storageService = storageService;
        this.levelIdsByNumbers = {};
        this.gameControl = Module.GMGameControl.create(1, 1, true, false);
        this.GM_OPENED_MAX_LEVEL_ID = "TEquilateral";
        this.GM_COMBO_TUTORIAL_LEVEL_ID = "TEquilateral";
        this.GM_MOVE_TOOL_TUTORIAL_LEVEL_ID = "TMove";
        this.readLevels();
    }
    PackLevelService.prototype.packWithLevelId = function (levelId) {
        for (var _i = 0, _a = this.packIds; _i < _a.length; _i++) {
            var packId = _a[_i];
            var pack = this.packs[packId];
            if (pack != null && pack.levelIds.indexOf(levelId) != -1) {
                return pack;
            }
        }
        return null;
    };
    PackLevelService.prototype.previousPackId = function (packId) {
        var index = this.numberForPackWithId(packId) - 1;
        if (index === 0) {
            return null;
        }
        return this.packIds[index - 1];
    };
    PackLevelService.prototype.numberForPackWithId = function (packId) {
        return this.packIds.indexOf(packId) + 1;
    };
    PackLevelService.prototype.nextLevelId = function (levelId) {
        var pack = this.packWithLevelId(levelId);
        var currentIndex = pack.levelIds.indexOf(levelId);
        if (currentIndex === pack.levelIds.length - 1) {
            var nextPackId = this.nextPackId(pack.packId);
            if (nextPackId == null) {
                return null;
            }
            var nextPack = this.packs[nextPackId];
            return nextPack.levelIds[0];
        }
        return pack.levelIds[currentIndex + 1];
    };
    PackLevelService.prototype.previousLevelId = function (levelId) {
        var pack = this.packWithLevelId(levelId);
        var currentIndex = pack.levelIds.indexOf(levelId);
        if (currentIndex === 0) {
            var prevPackId = this.previousPackId(pack.packId);
            if (prevPackId == null) {
                return null;
            }
            var prevPack = this.packs[prevPackId];
            return prevPack.levelIds[prevPack.levelIds.length - 1];
        }
        return pack.levelIds[currentIndex - 1];
    };
    PackLevelService.prototype.nextPackId = function (packId) {
        var index = this.numberForPackWithId(packId) - 1;
        if (index + 1 > this.packIds.length) {
            return null;
        }
        return this.packIds[index + 1];
    };
    PackLevelService.prototype.countTutorialsBeforeLevelWithId = function (levelId) {
        var pack = this.packWithLevelId(levelId);
        var count = 0;
        for (var i = 0; i < pack.levelIds.length; i++) {
            var curLevelId = pack.levelIds[i];
            if (curLevelId === levelId) {
                return count;
            }
            var level = this.levels[curLevelId];
            if (level.tutorial) {
                count++;
            }
        }
        return -1;
    };
    PackLevelService.prototype.numberOfLevelWithId = function (levelId) {
        var level = this.levels[levelId];
        if (level.tutorial) {
            return 0;
        }
        var pack = this.packWithLevelId(levelId);
        var index = pack.levelIds.indexOf(levelId);
        var tutorialsBeforeCount = this.countTutorialsBeforeLevelWithId(levelId);
        index = index - tutorialsBeforeCount + 1;
        return index;
    };
    PackLevelService.prototype.levelsInPackId = function (packId) {
        var levels = [];
        var levelIds = this.packs[packId].levelIds;
        for (var i = 0; i < levelIds.length; i++) {
            var levelId = levelIds[i];
            levels.push(this.levels[levelId]);
        }
        return levels;
    };
    PackLevelService.prototype.totalStars = function () {
        var totalStars = 0;
        for (var i = 0; i < this.levelIds.length; i++) {
            var level = this.levels[this.levelIds[i]];
            totalStars += 3;
            if (level.hasVStar)
                totalStars += 1;
        }
        return totalStars;
    };
    PackLevelService.prototype.starsCountForPackId = function (packId) {
        var starsCount = 0;
        var pack = this.packs[packId];
        for (var i = 0; i < pack.levelIds.length; i++) {
            var levelId = pack.levelIds[i];
            var level = this.levels[levelId];
            starsCount += 3;
            if (level.hasVStar) {
                starsCount += 1;
            }
        }
        return starsCount;
    };
    PackLevelService.prototype.getPacksData = function () {
        var parser = new DOMParser();
        var xmlData = parser.parseFromString(this.resourcePreloaderService.levels, "application/xml");
        return xmlData;
    };
    PackLevelService.prototype.readLevels = function () {
        var tempPacksObj = {};
        var tempLevelsObj = {};
        var tempPacksIdsArr = [];
        var tempLevelsIdsArr = [];
        var xml = this.getPacksData();
        var packNumber = 0;
        for (var _i = 0, _a = xml.querySelectorAll('pack'); _i < _a.length; _i++) {
            var pack = _a[_i];
            packNumber++;
            var levelIdsInPack = [];
            var levelCounter = 0;
            var packId = pack.getAttribute('id');
            tempPacksObj[packId] = { packId: packId };
            tempPacksIdsArr.push(packId);
            for (var _b = 0, _c = pack.querySelectorAll('level'); _b < _c.length; _b++) {
                var level = _c[_b];
                var allowedTools = level.getAttribute('allowed');
                var levelId = level.getAttribute('id');
                var levelTutorial = level.getAttribute('tutorial');
                var levelLearned = level.getAttribute('learned');
                allowedTools = allowedTools ? allowedTools.split(',') : [];
                var reward = level.querySelector('reward');
                var moves = void 0;
                var lines = void 0;
                var variantsCount = void 0;
                if (!reward) {
                    moves = 0;
                }
                else {
                    variantsCount = Number(reward.getAttribute('variants'));
                    moves = Number(reward.getAttribute('moves'));
                    lines = Number(reward.getAttribute('lines'));
                }
                lines = lines ? lines : moves;
                var levelObj = {
                    levelId: levelId,
                    tutorial: levelTutorial === 'true',
                    allowedToolTypes: allowedTools,
                    unlockedToolType: levelLearned,
                    goalElementaryMoves: moves,
                    goalLineMoves: lines,
                    variantsCount: variantsCount,
                    packNumber: packNumber
                };
                tempLevelsObj[levelId] = new interfaces_1.Level(levelObj);
                if (variantsCount > 1) {
                    tempLevelsObj[levelId].hasVStar = true;
                }
                if (!tempLevelsObj[levelId].tutorial) {
                    levelCounter += 1;
                }
                tempLevelsObj[levelId].levelNumber = levelCounter;
                tempLevelsIdsArr.push(levelId);
                levelIdsInPack.push(levelId);
            }
            tempPacksObj[pack.getAttribute('id')].levelIds = levelIdsInPack;
        }
        for (var _d = 0, tempLevelsIdsArr_1 = tempLevelsIdsArr; _d < tempLevelsIdsArr_1.length; _d++) {
            var idStr = tempLevelsIdsArr_1[_d];
            var float = tempLevelsObj[idStr].packNumber + '.' + tempLevelsObj[idStr].levelNumber;
            var isTutorial = tempLevelsObj[idStr].tutorial;
            !isTutorial ? this.levelIdsByNumbers[float] = idStr : '';
        }
        this.levels = tempLevelsObj;
        this.packs = tempPacksObj;
        this.levelIds = tempLevelsIdsArr;
        this.packIds = tempPacksIdsArr;
    };
    return PackLevelService;
}());
PackLevelService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        _1.ResourcePreloaderService,
        storage_service_1.StorageService])
], PackLevelService);
exports.PackLevelService = PackLevelService;


/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/nextTaskBtn.baa8196367c0717323e0447da033aade.svg";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/StarVIcon.bb55a43473b661978e8f0baebd978980.svg";

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */

var base_cookie_options_1 = __webpack_require__(140);
exports.BaseCookieOptions = base_cookie_options_1.BaseCookieOptions;
exports.CookieOptions = base_cookie_options_1.CookieOptions;
var cookies_service_1 = __webpack_require__(141);
exports.CookieService = cookies_service_1.CookieService;

//# sourceMappingURL=services.js.map


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var common_1 = __webpack_require__(68);
var core_1 = __webpack_require__(3);
/** @private */
var CookieOptions = (function () {
    function CookieOptions(_a) {
        var _b = _a === void 0 ? {} : _a, path = _b.path, domain = _b.domain, expires = _b.expires, secure = _b.secure;
        this.path = this.isPresent(path) ? path : null;
        this.domain = this.isPresent(domain) ? domain : null;
        this.expires = this.isPresent(expires) ? expires : null;
        this.secure = this.isPresent(secure) ? secure : false;
    }
    CookieOptions.prototype.merge = function (options) {
        return new CookieOptions({
            path: this.isPresent(options) && this.isPresent(options.path) ? options.path : this.path,
            domain: this.isPresent(options) && this.isPresent(options.domain) ? options.domain :
                this.domain,
            expires: this.isPresent(options) && this.isPresent(options.expires) ? options.expires :
                this.expires,
            secure: this.isPresent(options) && this.isPresent(options.secure) ? options.secure :
                this.secure,
        });
    };
    CookieOptions.prototype.isPresent = function (obj) {
        return obj !== undefined && obj !== null;
    };
    return CookieOptions;
}());
exports.CookieOptions = CookieOptions;
/** @private */
var BaseCookieOptions = (function (_super) {
    __extends(BaseCookieOptions, _super);
    function BaseCookieOptions(baseHref) {
        _super.call(this, { path: baseHref || '/' });
        this.baseHref = baseHref;
    }
    BaseCookieOptions = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(common_1.APP_BASE_HREF)), 
        __metadata('design:paramtypes', [String])
    ], BaseCookieOptions);
    return BaseCookieOptions;
}(CookieOptions));
exports.BaseCookieOptions = BaseCookieOptions;

//# sourceMappingURL=base-cookie-options.js.map


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(3);
var base_cookie_options_1 = __webpack_require__(140);
var CookieService = (function () {
    function CookieService(_defaultOptions) {
        this._defaultOptions = _defaultOptions;
    }
    Object.defineProperty(CookieService.prototype, "cookieString", {
        get: function () {
            return document.cookie || '';
        },
        set: function (val) {
            document.cookie = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @name CookieService#get
     *
     * @description
     * Returns the value of given cookie key.
     *
     * @param {string} key Id to use for lookup.
     * @returns {string} Raw cookie value.
     */
    CookieService.prototype.get = function (key) {
        return this._cookieReader()[key];
    };
    /**
     * @name CookieService#getObject
     *
     * @description
     * Returns the deserialized value of given cookie key.
     *
     * @param {string} key Id to use for lookup.
     * @returns {Object} Deserialized cookie value.
     */
    CookieService.prototype.getObject = function (key) {
        var value = this.get(key);
        return value ? JSON.parse(value) : value;
    };
    /**
     * @name CookieService#getAll
     *
     * @description
     * Returns a key value object with all the cookies.
     *
     * @returns {Object} All cookies
     */
    CookieService.prototype.getAll = function () {
        return this._cookieReader();
    };
    /**
     * @name CookieService#put
     *
     * @description
     * Sets a value for given cookie key.
     *
     * @param {string} key Id for the `value`.
     * @param {string} value Raw value to be stored.
     * @param {CookieOptionsArgs} options (Optional) Options object.
     */
    CookieService.prototype.put = function (key, value, options) {
        this._cookieWriter()(key, value, options);
    };
    /**
     * @name CookieService#putObject
     *
     * @description
     * Serializes and sets a value for given cookie key.
     *
     * @param {string} key Id for the `value`.
     * @param {Object} value Value to be stored.
     * @param {CookieOptionsArgs} options (Optional) Options object.
     */
    CookieService.prototype.putObject = function (key, value, options) {
        this.put(key, JSON.stringify(value), options);
    };
    /**
     * @name CookieService#remove
     *
     * @description
     * Remove given cookie.
     *
     * @param {string} key Id of the key-value pair to delete.
     * @param {CookieOptionsArgs} options (Optional) Options object.
     */
    CookieService.prototype.remove = function (key, options) {
        this._cookieWriter()(key, undefined, options);
    };
    /**
     * @name CookieService#removeAll
     *
     * @description
     * Remove all cookies.
     */
    CookieService.prototype.removeAll = function () {
        var _this = this;
        var cookies = this.getAll();
        Object.keys(cookies).forEach(function (key) {
            _this.remove(key);
        });
    };
    CookieService.prototype._cookieReader = function () {
        var lastCookies = {};
        var lastCookieString = '';
        var that = this;
        var cookieArray, cookie, i, index, name;
        var currentCookieString = this.cookieString;
        if (currentCookieString !== lastCookieString) {
            lastCookieString = currentCookieString;
            cookieArray = lastCookieString.split('; ');
            lastCookies = {};
            for (i = 0; i < cookieArray.length; i++) {
                cookie = cookieArray[i];
                index = cookie.indexOf('=');
                if (index > 0) {
                    name = that._safeDecodeURIComponent(cookie.substring(0, index));
                    // the first value that is seen for a cookie is the most
                    // specific one.  values for the same cookie name that
                    // follow are for less specific paths.
                    if (this.isBlank(lastCookies[name])) {
                        lastCookies[name] = that._safeDecodeURIComponent(cookie.substring(index + 1));
                    }
                }
            }
        }
        return lastCookies;
    };
    CookieService.prototype._cookieWriter = function () {
        var that = this;
        return function (name, value, options) {
            that.cookieString = that._buildCookieString(name, value, options);
        };
    };
    CookieService.prototype._safeDecodeURIComponent = function (str) {
        try {
            return decodeURIComponent(str);
        }
        catch (e) {
            return str;
        }
    };
    CookieService.prototype._buildCookieString = function (name, value, options) {
        var cookiePath = '/';
        var path, expires;
        var defaultOpts = this._defaultOptions || new base_cookie_options_1.CookieOptions({ path: cookiePath });
        var opts = this._mergeOptions(defaultOpts, options);
        expires = opts.expires;
        if (this.isBlank(value)) {
            expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
            value = '';
        }
        if (this.isString(expires)) {
            expires = new Date(expires);
        }
        var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
        str += opts.path ? ';path=' + opts.path : '';
        str += opts.domain ? ';domain=' + opts.domain : '';
        str += expires ? ';expires=' + expires.toUTCString() : '';
        str += opts.secure ? ';secure' : '';
        // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
        // - 300 cookies
        // - 20 cookies per unique domain
        // - 4096 bytes per cookie
        var cookieLength = str.length + 1;
        if (cookieLength > 4096) {
            console.log("Cookie '" + name + "' possibly not set or overflowed because it was too \n      large (" + cookieLength + " > 4096 bytes)!");
        }
        return str;
    };
    CookieService.prototype._mergeOptions = function (defaultOpts, providedOpts) {
        var newOpts = defaultOpts;
        if (this.isPresent(providedOpts)) {
            return newOpts.merge(new base_cookie_options_1.CookieOptions(providedOpts));
        }
        return newOpts;
    };
    CookieService.prototype.isBlank = function (obj) {
        return obj === undefined || obj === null;
    };
    CookieService.prototype.isPresent = function (obj) {
        return obj !== undefined && obj !== null;
    };
    CookieService.prototype.isString = function (obj) {
        return typeof obj === 'string';
    };
    CookieService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()), 
        __metadata('design:paramtypes', [base_cookie_options_1.CookieOptions])
    ], CookieService);
    return CookieService;
}());
exports.CookieService = CookieService;

//# sourceMappingURL=cookies.service.js.map


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_component_1 = __webpack_require__(240);
exports.AppComponent = app_component_1.AppComponent;
var header_component_1 = __webpack_require__(241);
exports.HeaderComponent = header_component_1.HeaderComponent;
var modal_component_1 = __webpack_require__(250);
exports.ModalComponent = modal_component_1.ModalComponent;
var packs_box_component_1 = __webpack_require__(251);
exports.PacksBoxComponent = packs_box_component_1.PacksBoxComponent;
var modal_help_component_1 = __webpack_require__(248);
exports.ModalHelpComponent = modal_help_component_1.ModalHelpComponent;
var main_component_1 = __webpack_require__(244);
exports.MainComponent = main_component_1.MainComponent;
var levels_box_component_1 = __webpack_require__(243);
exports.LevelsBoxComponent = levels_box_component_1.LevelsBoxComponent;
var level_component_1 = __webpack_require__(242);
exports.LevelComponent = level_component_1.LevelComponent;
var modal_success_component_1 = __webpack_require__(249);
exports.ModalSuccessComponent = modal_success_component_1.ModalSuccessComponent;
var modal_description_component_1 = __webpack_require__(245);
exports.ModalDescriptionComponent = modal_description_component_1.ModalDescriptionComponent;
var modal_help_addon_component_1 = __webpack_require__(247);
exports.ModalHelpAddonComponent = modal_help_addon_component_1.ModalHelpAddonComponent;
var user_menu_component_1 = __webpack_require__(252);
exports.UserMenuComponent = user_menu_component_1.UserMenuComponent;
var modal_help_addon_progress_component_1 = __webpack_require__(246);
exports.ModalHelpAddonProgressComponent = modal_help_addon_progress_component_1.ModalHelpAddonProgressComponent;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var rxjs_1 = __webpack_require__(137);
var EventService = (function () {
    function EventService() {
        this.events = {};
        this.observables = {};
    }
    EventService.prototype.fire = function (eventName, data) {
        if (eventName in this.events) {
            this.events[eventName].next(data);
        }
    };
    EventService.prototype.subscribe = function (eventName, callback) {
        if (!(eventName in this.events)) {
            this.events[eventName] = new rxjs_1.Subject();
            this.observables[eventName] = this.events[eventName].asObservable();
        }
        return this.observables[eventName].subscribe(callback);
    };
    return EventService;
}());
EventService = __decorate([
    core_1.Injectable()
], EventService);
exports.EventService = EventService;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var LevelPermutationAnalyzerService = (function () {
    function LevelPermutationAnalyzerService() {
        this.addedLevelIds = [];
        this.removedLevelIds = [];
        this.rearrangedLevelIds = [];
    }
    LevelPermutationAnalyzerService.prototype.analize = function (currentLevelsId, existedLevelsId) {
        var levelsToUnlock = [];
        if (!existedLevelsId) {
            return;
        }
        var matrix = this.createLevenshteinMatrix(existedLevelsId, currentLevelsId);
        var i = existedLevelsId.length;
        var j = currentLevelsId.length;
        while (i > 0 || j > 0) {
            var top_1 = i - 1 >= 0 ? matrix[i - 1][j] : Infinity;
            var left = j - 1 >= 0 ? matrix[i][j - 1] : Infinity;
            var min = Math.min(top_1, left);
            if (i > 0 && j > 0 && existedLevelsId[i - 1] === currentLevelsId[j - 1]) {
                i--;
                j--;
            }
            else if (min === left) {
                this.insertLevel(currentLevelsId[j - 1]);
                j--;
            }
            else {
                this.removeLevel(existedLevelsId[i - 1]);
                i--;
            }
        }
    };
    LevelPermutationAnalyzerService.prototype.insertLevel = function (levelId) {
        if (this.removedLevelIds.indexOf(levelId) === -1) {
            this.addedLevelIds.push(levelId);
        }
        else {
            this.removedLevelIds = this.removedLevelIds.filter(function (id) { return id !== levelId; });
            this.rearrangedLevelIds.push(levelId);
        }
    };
    LevelPermutationAnalyzerService.prototype.removeLevel = function (levelId) {
        if (this.addedLevelIds.indexOf(levelId) === -1) {
            this.removedLevelIds.push(levelId);
        }
        else {
            this.addedLevelIds = this.addedLevelIds.filter(function (id) { return id !== levelId; });
            this.rearrangedLevelIds.push(levelId);
        }
    };
    LevelPermutationAnalyzerService.prototype.createLevenshteinMatrix = function (existed, current) {
        var existedSize = existed.length;
        var currentSize = current.length;
        var matrix = [];
        for (var i = 0; i <= existedSize; i++) {
            matrix[i] = [];
            matrix[i][0] = i;
        }
        for (var i = 0; i <= currentSize; i++) {
            matrix[0][i] = i;
        }
        for (var i = 1; i <= existedSize; i++) {
            for (var j = 1; j <= currentSize; j++) {
                if (existed[i - 1] === current[j - 1]) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                }
                else {
                    var top_2 = matrix[i - 1][j];
                    var left = matrix[i][j - 1];
                    matrix[i][j] = Math.min(top_2, left) + 1;
                }
            }
        }
        return matrix;
    };
    return LevelPermutationAnalyzerService;
}());
LevelPermutationAnalyzerService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], LevelPermutationAnalyzerService);
exports.LevelPermutationAnalyzerService = LevelPermutationAnalyzerService;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var storage_service_1 = __webpack_require__(69);
var pack_level_service_1 = __webpack_require__(101);
var tool_service_1 = __webpack_require__(147);
var core_2 = __webpack_require__(239);
var constants_1 = __webpack_require__(43);
var level_permutation_analyzer_service_1 = __webpack_require__(144);
var ProgressService = (function () {
    function ProgressService(storageService, packLevelService, cookieService, toolService, levelPermutationAnalyzerService) {
        this.storageService = storageService;
        this.packLevelService = packLevelService;
        this.cookieService = cookieService;
        this.toolService = toolService;
        this.levelPermutationAnalyzerService = levelPermutationAnalyzerService;
        this.version = constants_1.VERSION;
        this.sharedPreferences = {};
        this.playedLevels = [];
        this.unlockedLevels = [];
        this.skippedLevels = [];
        this.levelsResults = {};
        this.addedLevelIds = [];
        this.auxiliaryTools = ['HandTool', 'PointTool', 'IntersectTool'];
        this.basicTools = ['LineTool', 'CircleTool'];
        this.LAST_PLAYED_LEVEL_STR = 'LastPlayedLevel';
        this.NEW_LEVEL_IDS_STR = 'newLevelIds';
        this.EXISTED_LEVEL_IDS_STR = 'existedLevelIds';
        this.GM_APP_VERSION_STR = 'GMAppVersion';
        this.originalNewLevelsCount = 0;
        this.levelsToUnlock = [];
        this.levelsToLock = [];
        this.levelsToSkip = [];
        this.baseLevelIds = [];
        this.init();
    }
    ProgressService.prototype.init = function () {
        this.loadSharedPreferences();
        if (this.cookieService.get('MGSession')) {
            this.unzipSession(this.cookieService.get('MGSession'));
            this.cookieService.put('MGSession', '');
        }
        if (!this.loadLevelResults()) {
            this.saveLevelsResults();
        }
        if (!this.loadUnlockedLevels()) {
            this.saveUnlockedLevels();
        }
        if (!this.loadPlayedLevels()) {
            this.savePlayedLevels();
        }
        if (!this.loadSkippedLevels()) {
            this.saveSkippedLevels();
        }
        if (this.unlockedLevels == null || this.unlockedLevels.length == 0) {
            this.unlockedLevels = this.baseOpenedLevelIds();
        }
        this.baseLevelIds = this.baseOpenedLevelIds();
        this.removeNonexistentLevelResults();
        this.calculateStarsForExistedResults();
        this.lockUnlockLevelsIfNeeded();
        this.loadAddedLevels();
        if (this.isNewVersion()) {
            this.checkForNewLevels();
        }
        this.initFinished = true;
    };
    ProgressService.prototype.lockUnlockLevelsIfNeeded = function () {
        var allLevelIds = this.packLevelService.levelIds;
        this.levelPermutationAnalyzerService.analize(allLevelIds, this.sharedPreferences[this.EXISTED_LEVEL_IDS_STR]);
        this.findLevelIdsToUnlockOrLockForLevels(allLevelIds);
        this.unlockLevelsWithIds(this.levelsToUnlock);
        this.lockLevelsWithIds(this.levelsToLock);
        this.skipLevelsWithIds(this.levelsToSkip);
    };
    ProgressService.prototype.findLevelIdsToUnlockOrLockForLevels = function (levels) {
        this.levelsToUnlock = [];
        this.levelsToLock = [];
        this.levelsToSkip = [];
        var lastOpenedOldLevelIndex = this.getLastOpenedLevelIndex(levels);
        var firstLockedOldLevelIndex = this.getFirstLockedLevelIndex(levels);
        if ((lastOpenedOldLevelIndex != null) && (firstLockedOldLevelIndex != null) && (firstLockedOldLevelIndex <= lastOpenedOldLevelIndex)) {
            if (lastOpenedOldLevelIndex < levels.length - 1) {
                firstLockedOldLevelIndex = lastOpenedOldLevelIndex + 1;
            }
            else {
                firstLockedOldLevelIndex = null;
            }
        }
        if (firstLockedOldLevelIndex !== null) {
            for (var i = firstLockedOldLevelIndex; i < levels.length; i++) {
                var levelId = levels[i];
                if (!this.isLevelLocked(levelId)) {
                    this.levelsToLock.push(levelId);
                }
            }
        }
        if (lastOpenedOldLevelIndex !== null) {
            for (var i = lastOpenedOldLevelIndex; i >= 0; i--) {
                var levelId = levels[i];
                if (this.isLevelLocked(levelId)) {
                    this.levelsToUnlock.push(levelId);
                }
            }
        }
        this.levelsToSkip = this.levelsToSkip.concat(this.levelsToUnlock);
        if (lastOpenedOldLevelIndex == null || firstLockedOldLevelIndex == null) {
            return;
        }
        var lastOpenedLevelId = levels[lastOpenedOldLevelIndex];
        var isLastOpenedLevelSolved = this.levelsResults[lastOpenedLevelId];
        if (isLastOpenedLevelSolved) {
            var lastOpenedOldLevelPack = this.packLevelService.packWithLevelId(lastOpenedLevelId);
            var firstLockedLevelId = levels[firstLockedOldLevelIndex];
            var firstLockedOldLevelPack = this.packLevelService.packWithLevelId(firstLockedLevelId);
            var arePacksSame = lastOpenedOldLevelPack.packId === firstLockedOldLevelPack.packId;
            var additionalLevelIdsToUnlock = [];
            if (!arePacksSame) {
                var firstLevelInLockedPack = firstLockedOldLevelPack.levelIds[0];
                var firstLevelIndex = levels.indexOf(firstLevelInLockedPack);
                for (var i = lastOpenedOldLevelIndex; i < firstLevelIndex; i++) {
                    var levelId = levels[i];
                    if (this.isLevelLocked(levelId)) {
                        additionalLevelIdsToUnlock.push(levelId);
                    }
                }
                this.levelsToSkip = this.levelsToSkip.concat(additionalLevelIdsToUnlock);
                additionalLevelIdsToUnlock.push(firstLevelInLockedPack);
            }
            this.levelsToUnlock = this.levelsToUnlock.concat(additionalLevelIdsToUnlock);
            if (additionalLevelIdsToUnlock.length) {
                return;
            }
            var lastLevelIdInOpenedPack = lastOpenedOldLevelPack.levelIds[lastOpenedOldLevelPack.levelIds.length - 1];
            if (lastOpenedLevelId === lastLevelIdInOpenedPack) {
                return;
            }
            var nextLevelId = levels[lastOpenedOldLevelIndex + 1];
            if (this.isLevelLocked(nextLevelId)) {
                this.levelsToUnlock.push(nextLevelId);
            }
        }
        else {
            for (var i = lastOpenedOldLevelIndex + 1; i < firstLockedOldLevelIndex; i++) {
                this.levelsToLock.push(levels[i]);
            }
        }
    };
    ProgressService.prototype.getLastOpenedLevelIndex = function (levels) {
        if (!levels || !levels.length) {
            return null;
        }
        var index;
        for (var i = levels.length - 1; i >= 0; i--) {
            var levelId = levels[i];
            if (!this.isLevelLocked(levelId) && !this.isLevelNewOrRearranged(levelId)) {
                index = i;
                break;
            }
        }
        return index;
    };
    ProgressService.prototype.getFirstLockedLevelIndex = function (levels) {
        if (!levels || !levels.length) {
            return null;
        }
        var index;
        for (var i = 0; i < levels.length; i++) {
            var levelId = levels[i];
            if (this.isLevelLocked(levelId) && !this.isLevelNewOrRearranged(levelId)) {
                index = i;
                break;
            }
        }
        return index;
    };
    ProgressService.prototype.isLevelNewOrRearranged = function (levelId) {
        return this.levelPermutationAnalyzerService.addedLevelIds.indexOf(levelId) !== -1 || this.levelPermutationAnalyzerService.rearrangedLevelIds.indexOf(levelId) !== -1;
    };
    ProgressService.prototype.lockLevelsWithIds = function (levels) {
        if (!levels || !levels.length) {
            return;
        }
        for (var _i = 0, levels_1 = levels; _i < levels_1.length; _i++) {
            var levelId = levels_1[_i];
            this.removeUnlockedLevel(levelId);
            this.removeLevelResult(levelId);
            this.removeSkippedLevel(levelId);
        }
    };
    ProgressService.prototype.removeUnlockedLevel = function (levelId) {
        var index = this.unlockedLevels.indexOf(levelId);
        if (index !== -1) {
            this.unlockedLevels.splice(index, 1);
        }
        this.saveUnlockedLevels();
    };
    ProgressService.prototype.removeLevelResult = function (levelId) {
        delete this.levelsResults[levelId];
        this.saveLevelsResults();
    };
    ProgressService.prototype.removeSkippedLevel = function (levelId) {
        delete this.skippedLevels[levelId];
        this.saveSkippedLevels();
    };
    ProgressService.prototype.skipLevelsWithIds = function (levelIds) {
        for (var _i = 0, levelIds_1 = levelIds; _i < levelIds_1.length; _i++) {
            var levelId = levelIds_1[_i];
            this.skipLevel(levelId);
        }
    };
    ProgressService.prototype.isLevelLocked = function (levelId) {
        return this.unlockedLevels.indexOf(levelId) === -1;
    };
    ProgressService.prototype.setLastPlayedLevelId = function (lastPlayedLevelId) {
        this.sharedPreferences[this.LAST_PLAYED_LEVEL_STR] = lastPlayedLevelId;
        this.saveSharedPreferences();
        if (lastPlayedLevelId == null) {
            return;
        }
        if (this.playedLevels.indexOf(lastPlayedLevelId) == -1) {
            this.unmarkLevel(lastPlayedLevelId);
            this.playedLevels.push(lastPlayedLevelId);
            this.savePlayedLevels();
        }
    };
    ProgressService.prototype.toolTypesAvailableForLevel = function (levelId) {
        var level = this.packLevelService.levels[levelId];
        var levelTools = level.allowedToolTypes.slice();
        if (levelTools.length == 0) {
            levelTools = this.unlockedToolsForLevel(levelId);
        }
        if (!level.tutorial) {
            for (var _i = 0, _a = this.auxiliaryTools; _i < _a.length; _i++) {
                var auxTool = _a[_i];
                if (levelTools.indexOf(auxTool) == -1) {
                    levelTools.push(auxTool);
                }
            }
        }
        this.sortTools(levelTools);
        return levelTools;
    };
    ProgressService.prototype.toolTypesAvailableForExploreForLevel = function (levelId) {
        var level = this.packLevelService.levels[levelId];
        var levelTools = this.unlockedToolsForLevel(levelId);
        var availableTools = levelTools.slice();
        if (!level.tutorial) {
            for (var _i = 0, _a = this.auxiliaryTools; _i < _a.length; _i++) {
                var auxTool = _a[_i];
                if (availableTools.indexOf(auxTool) == -1) {
                    availableTools.push(auxTool);
                }
            }
        }
        this.sortTools(availableTools);
        return availableTools;
    };
    ProgressService.prototype.unlockedToolsForLevel = function (levelId) {
        var toolTypes = this.basicTools.slice();
        var levelIds = this.packLevelService.levelIds;
        var currentLevelNum = levelIds.indexOf(levelId);
        for (var i = 0; i < currentLevelNum; i++) {
            var tempLevelId = levelIds[i];
            var keys = Object.keys(this.levelsResults);
            var level = this.packLevelService.levels[tempLevelId];
            if (level.unlockedToolType != undefined) {
                if (toolTypes.indexOf(level.unlockedToolType) == -1) {
                    toolTypes.push(level.unlockedToolType);
                }
            }
        }
        return toolTypes;
    };
    ProgressService.prototype.totalStarsEarned = function () {
        var totalStars = 0;
        var keys = Object.keys(this.levelsResults);
        for (var i = 0; i < keys.length; i++) {
            var levelResult = this.levelsResults[keys[i]];
            totalStars += levelResult.stars.length;
        }
        return totalStars;
    };
    ProgressService.prototype.unlockAllLevels = function () {
        var levelToUnlock = [];
        var allLevelIds = this.packLevelService.levelIds;
        for (var i = 0; i < allLevelIds.length; i++) {
            var levelId = allLevelIds[i];
            if (this.isLevelLocked(levelId)) {
                if (levelToUnlock.indexOf(levelId))
                    levelToUnlock.push(levelId);
            }
            this.skipLevel(levelId);
        }
        this.unlockLevelsWithIds(levelToUnlock);
    };
    ProgressService.prototype.saveSharedPreferences = function () {
        this.storageService.save('SharedPreferences', this.sharedPreferences);
    };
    ProgressService.prototype.isPackLocked = function (packId) {
        var pack = this.packLevelService.packs[packId];
        for (var _i = 0, _a = pack.levelIds; _i < _a.length; _i++) {
            var levelId = _a[_i];
            if (!this.isLevelLocked(levelId)) {
                return false;
            }
        }
        return true;
    };
    ProgressService.prototype.starsEarnedWithPackId = function (packId) {
        var pack = this.packLevelService.packs[packId];
        var starsInPack = 0;
        for (var i = 0; i < pack.levelIds.length; i++) {
            var levelId = pack.levelIds[i];
            var result = this.levelsResults[levelId];
            if (result != null) {
                starsInPack += result.stars.length;
            }
        }
        return starsInPack;
    };
    ProgressService.prototype.registerResultForLevel = function (result, levelId) {
        if (this.skippedLevels != null && this.skippedLevels.indexOf(levelId) != -1) {
            this.skippedLevels.splice(this.skippedLevels.indexOf(levelId), 1);
            this.saveSkippedLevels();
        }
        var existedResult = this.levelsResults[levelId];
        result.justEarnedStars = [];
        if (existedResult == null) {
            this.levelsResults[levelId] = result;
            result.justEarnedStars = result.stars.slice();
            this.saveLevelsResults();
            var level = this.packLevelService.levels[levelId];
            this.didCompleteNewLevel(level);
            this.notifyIfCompletePack(result.levelId);
            return;
        }
        if (existedResult.e_moves > result.e_moves || existedResult.l_moves > result.l_moves || existedResult.v_count < result.v_count) {
            existedResult.e_moves = Math.min(existedResult.e_moves, result.e_moves);
            existedResult.l_moves = Math.min(existedResult.l_moves, result.l_moves);
            existedResult.v_count = Math.max(existedResult.v_count, result.v_count);
            var stars = result.stars.slice();
            for (var i = 0; i < existedResult.stars.length; i++) {
                var exStar = existedResult.stars[i];
                if (stars.indexOf(exStar) == -1) {
                    stars.push(exStar);
                }
            }
            var newStars = result.stars.slice();
            for (var i = 0; i < existedResult.stars.length; i++) {
                var curStar = existedResult.stars[i];
                if (newStars.indexOf(curStar) != -1) {
                    newStars.splice(newStars.indexOf(curStar), 1);
                }
            }
            existedResult.stars = stars;
            existedResult.date = result.date;
            result.justEarnedStars = newStars;
            this.saveLevelsResults();
            this.notifyIfCompletePack(result.levelId);
        }
    };
    ProgressService.prototype.isNewVersion = function () {
        var previousVersion = this.sharedPreferences[this.GM_APP_VERSION_STR];
        if (this.version == previousVersion) {
            return false;
        }
        else {
            this.sharedPreferences[this.GM_APP_VERSION_STR] = this.version;
            this.saveSharedPreferences();
            return true;
        }
    };
    ProgressService.prototype.resetProgress = function () {
        this.storageService.remove('LevelsResult');
        this.storageService.remove('PlayedLevels');
        this.storageService.remove('SkippedLevels');
        this.storageService.remove('UnlockedLevels');
        this.storageService.remove('ExploreModeAlreadyShown');
        this.storageService.remove('CircleHintAlreadyShown');
        this.levelsResults = {};
        this.playedLevels = [];
        this.skippedLevels = [];
        this.unlockedLevels = [];
        this.levelsToUnlock = [];
        this.levelsToLock = [];
        this.levelsToSkip = [];
        this.init();
    };
    ProgressService.prototype.isLevelPlayed = function (levelId) {
        return this.playedLevels.indexOf(levelId) !== -1;
    };
    ProgressService.prototype.baseOpenedLevelIds = function () {
        var baseTutIds = [];
        var levelIds = this.packLevelService.levelIds;
        for (var i = 0; i < levelIds.length; i++) {
            var levelId = levelIds[i];
            baseTutIds.push(levelId);
            if (levelId === this.packLevelService.GM_OPENED_MAX_LEVEL_ID) {
                return baseTutIds;
            }
        }
        return baseTutIds;
    };
    ProgressService.prototype.isLevelBaseOpened = function (levelId) {
        return this.baseLevelIds.indexOf(levelId) !== -1;
    };
    ProgressService.prototype.loadSharedPreferences = function () {
        var data = this.storageService.getObject('SharedPreferences');
        if (data == null) {
            return false;
        }
        this.sharedPreferences = data;
    };
    ProgressService.prototype.unzipSession = function (string) {
        var parts = string.split('||');
        this.sharedPreferences.local = parts[2];
        string = parts[3];
        var levels = string.split('|');
        for (var _i = 0, levels_2 = levels; _i < levels_2.length; _i++) {
            var lvlstr = levels_2[_i];
            var lvlarr = lvlstr.split('/');
            lvlarr[1] = parseInt(lvlarr[1]);
            var levelResult = {};
            levelResult.levelId = lvlarr[0];
            levelResult.date = new Date();
            levelResult.e_moves = lvlarr[2];
            levelResult.l_moves = lvlarr[3];
            levelResult.stars = [];
            if (lvlarr[1] > 1) {
                levelResult.stars.push('GM_STAR_TYPE_B');
                if (!!(lvlarr[1] & 1)) {
                    levelResult.stars.push('GM_STAR_TYPE_L');
                }
                lvlarr[1] = lvlarr[1] >> 1;
                if (!!(lvlarr[1] & 1)) {
                    levelResult.stars.push('GM_STAR_TYPE_E');
                }
            }
            if (this.unlockedLevels.indexOf(levelResult.levelId) == -1) {
                this.unlockedLevels.push(levelResult.levelId);
            }
            if (lvlarr[1] != 0) {
                if (this.playedLevels.indexOf(levelResult.levelId) == -1) {
                    this.playedLevels.push(levelResult.levelId);
                }
                this.registerResultForLevel(levelResult, levelResult.levelId);
            }
        }
        this.savePlayedLevels();
        this.saveUnlockedLevels();
        this.saveSharedPreferences();
    };
    ProgressService.prototype.savePlayedLevels = function () {
        this.storageService.save('PlayedLevels', this.playedLevels);
    };
    ProgressService.prototype.saveUnlockedLevels = function () {
        this.storageService.save('UnlockedLevels', this.unlockedLevels);
    };
    ProgressService.prototype.loadLevelResults = function () {
        var data = this.storageService.getArray('LevelsResult');
        if (data == null) {
            return false;
        }
        this.levelsResults = data;
    };
    ProgressService.prototype.saveLevelsResults = function () {
        this.storageService.save('LevelsResult', this.levelsResults);
    };
    ProgressService.prototype.loadUnlockedLevels = function () {
        var data = this.storageService.getArray('UnlockedLevels');
        if (data == null) {
            return false;
        }
        this.unlockedLevels = data;
    };
    ProgressService.prototype.loadPlayedLevels = function () {
        var data = this.storageService.getArray('PlayedLevels');
        if (data == null) {
            return false;
        }
        this.playedLevels = data;
    };
    ProgressService.prototype.loadSkippedLevels = function () {
        var data = this.storageService.getArray('SkippedLevels');
        if (data == null) {
            return false;
        }
        this.skippedLevels = data;
    };
    ProgressService.prototype.saveSkippedLevels = function () {
        this.storageService.save('SkippedLevels', this.skippedLevels);
    };
    ProgressService.prototype.sortTools = function (toolTypes) {
        var orderedTools = this.toolService.allToolTypes();
        toolTypes.sort(function (obj1, obj2) {
            var index1 = orderedTools.indexOf(obj1);
            var index2 = orderedTools.indexOf(obj2);
            return index1 < index2 ? -1 : 1;
        });
    };
    ProgressService.prototype.removeNonexistentLevelResults = function () {
        var allLevelIds = this.packLevelService.levelIds;
        var toRemove = [];
        var levelId;
        for (var i = 0; i < this.unlockedLevels.length; i++) {
            levelId = this.unlockedLevels[i];
            if (allLevelIds.indexOf(levelId) == -1 && toRemove.indexOf(levelId) != -1) {
                toRemove.push(levelId);
            }
        }
        if (toRemove.length == 0) {
            return;
        }
        var keys = Object.keys(this.unlockedLevels);
        for (var i = 0; i < toRemove.length; i++) {
            this.unlockedLevels.splice(this.unlockedLevels.indexOf(levelId), 1);
            if (keys.indexOf(levelId) != -1) {
                this.levelsResults.splice(this.levelsResults.indexOf(levelId), 1);
            }
            if (this.playedLevels != null && this.playedLevels.indexOf(levelId) != -1) {
                this.playedLevels.splice(this.playedLevels.indexOf(levelId), 1);
            }
        }
        this.saveLevelsResults();
        this.saveUnlockedLevels();
        this.savePlayedLevels();
        this.saveSkippedLevels();
    };
    ProgressService.prototype.calculateStarsForExistedResults = function () {
        var keys = Object.keys(this.levelsResults);
        for (var i = 0; i < keys.length; i++) {
            var levelId = keys[i];
            var result = this.levelsResults[levelId];
            var level = this.packLevelService.levels[levelId];
            if (!level) {
                continue;
            }
            ;
            result.stars = level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(result.e_moves, result.l_moves, result.v_count);
        }
    };
    ProgressService.prototype.loadAddedLevels = function () {
        var data = this.sharedPreferences[this.NEW_LEVEL_IDS_STR];
        if (data != null) {
            this.addedLevelIds = new Array(data);
        }
        else {
            this.addedLevelIds = [];
        }
    };
    ProgressService.prototype.checkForNewLevels = function () {
        this.findNewLevelIds();
        this.unmarkNewLocked();
    };
    ProgressService.prototype.findNewLevelIds = function () {
        var currentLevelIds = this.packLevelService.levelIds.slice();
        var existedLevelIds = this.sharedPreferences[this.EXISTED_LEVEL_IDS_STR];
        this.sharedPreferences[this.EXISTED_LEVEL_IDS_STR] = currentLevelIds.slice();
        if (existedLevelIds == null) {
            this.saveSharedPreferences();
            return;
        }
        // get diff with previous version
        for (var i = 0; i < existedLevelIds.length; i++) {
            var levelId = existedLevelIds[i];
            currentLevelIds.splice(currentLevelIds.indexOf(levelId), 1);
        }
        this.originalNewLevelsCount = currentLevelIds.length;
        // union old_new with new new
        for (var i = 0; i < this.originalNewLevelsCount; i++) {
            var levelId = currentLevelIds[i];
            if (this.addedLevelIds.indexOf(levelId) == -1) {
                this.addedLevelIds.push(levelId);
            }
        }
        this.sharedPreferences[this.NEW_LEVEL_IDS_STR] = this.addedLevelIds;
        this.saveSharedPreferences();
    };
    ProgressService.prototype.unmarkNewLocked = function () {
        var levelsToUnmark = [];
        var i;
        for (i = 0; i < this.addedLevelIds.length; i++) {
            var levelId = this.addedLevelIds[i];
            if (this.isLevelLocked(levelId) && levelsToUnmark.indexOf(levelId) != -1) {
                levelsToUnmark.push(levelId);
            }
        }
        for (i = 0; i < levelsToUnmark; i++) {
            var lvlId = levelsToUnmark[i];
            this.unmarkLevel(lvlId);
        }
    };
    ProgressService.prototype.unmarkLevel = function (levelId) {
        if (this.addedLevelIds.indexOf(levelId) === -1) {
            return;
        }
        this.addedLevelIds.splice(this.addedLevelIds.indexOf(levelId), 1);
        this.sharedPreferences[this.NEW_LEVEL_IDS_STR] = this.addedLevelIds;
        this.saveSharedPreferences();
    };
    ProgressService.prototype.unlockLevelsWithIds = function (levels) {
        if (levels == undefined || levels.length == 0) {
            return;
        }
        for (var i = 0; i < levels.length; i++) {
            if (this.unlockedLevels.indexOf(levels[i]) == -1) {
                this.unlockedLevels.push(levels[i]);
            }
        }
        this.saveUnlockedLevels();
    };
    ProgressService.prototype.didCompleteNewLevel = function (level) {
        this.unlockLevelsWithIds(this.dependentLevelsOfLevel(level.levelId));
    };
    ProgressService.prototype.dependentLevelsOfLevel = function (levelId) {
        var dependentLevels = [];
        var nextLevelId = this.packLevelService.nextLevelId(levelId);
        if (nextLevelId != undefined && !(this.unlockedLevels.indexOf(nextLevelId) != -1)) {
            if (dependentLevels.indexOf(nextLevelId) == -1) {
                dependentLevels.push(nextLevelId);
            }
        }
        return dependentLevels;
    };
    ProgressService.prototype.notifyIfCompletePack = function (levelId) {
        var pack = this.packLevelService.packWithLevelId(levelId);
        var earnedStars = this.starsEarnedWithPackId(pack.packId);
        var limitStars = this.packLevelService.starsCountForPackId(pack.packId);
        if (earnedStars != limitStars) {
            return;
        }
    };
    ProgressService.prototype.skipLevel = function (levelId) {
        var level = this.packLevelService.levels[levelId];
        if (this.skippedLevels.indexOf(levelId) == -1) {
            this.skippedLevels.push(levelId);
        }
        this.unlockLevelsWithIds(this.dependentLevelsOfLevel(levelId));
        this.saveSkippedLevels();
        this.saveUnlockedLevels();
    };
    //Level is available to be skipped if:
    //1. Next level is locked;
    //2. Packs are opened;
    //3. It's not last level of pack
    //4. If not, next pack is free;
    //5. If not, all stars are gained.
    ProgressService.prototype.isAvailableToSkip = function (levelId) {
        //1. Next level is locked;
        var nextLevelId = this.packLevelService.nextLevelId(levelId);
        if (!this.isLevelLocked(nextLevelId)) {
            return false;
        }
        return true;
    };
    ProgressService.prototype.updateProgressBySync = function (progress) {
        var levelIds = this.packLevelService.levelIds;
        var playedLevels = [];
        var unlockedLevels = [];
        var levelResults = [];
        var currentResultsIds = Object.keys(this.levelsResults);
        var syncResultsObj = this.prepareResultsObj(progress.level_results);
        for (var i = 0, len = levelIds.length; i < len; i++) {
            var levelId = levelIds[i];
            var shouldStop = true;
            var existedResultIx = currentResultsIds.indexOf(levelId);
            var existedResult = existedResultIx > -1 ? this.levelsResults[levelId] : null;
            if (existedResult) {
                var resultToSync = syncResultsObj[levelId];
                if (!resultToSync) {
                    continue;
                }
                var level = this.packLevelService.levels[levelId];
                existedResult.e_moves = Math.min(existedResult.e_moves, resultToSync.e_moves);
                existedResult.l_moves = Math.min(existedResult.l_moves, resultToSync.l_moves);
                existedResult.v_count = Math.max(existedResult.v_count, resultToSync.v_count);
                existedResult.stars = level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(existedResult.e_moves, existedResult.l_moves, existedResult.v_count);
                shouldStop = false;
            }
            else {
                var canPrevBeSkipped = this.canPreviousLevelBeSkipped(levelId);
                var isLocked = this.isLevelLocked(levelId);
                if (!canPrevBeSkipped && isLocked) {
                    break;
                }
                var resultToSync = syncResultsObj[levelId];
                // save result if needed
                if (resultToSync) {
                    this.addOrUpdateLevelResult(resultToSync);
                    this.setLevelSkipped(levelId, false);
                    shouldStop = false;
                }
                // skip if needed
                if (progress.skipped_levels.indexOf(levelId) > -1 && !resultToSync) {
                    this.setLevelSkipped(levelId, true);
                    shouldStop = false;
                }
                // unlock if needed
                if (progress.unlocked_levels.indexOf(levelId) > -1) {
                    this.setLevelUnlocked(levelId, true);
                }
                if (shouldStop && this.isLevelBaseOpened(levelId)) {
                    // we shouldn't stop at first tutorials
                    shouldStop = false;
                }
            }
            if (shouldStop) {
                break;
            }
        }
        if (progress.played_levels.length) {
            for (var _i = 0, _a = progress.played_levels; _i < _a.length; _i++) {
                var levelId = _a[_i];
                if (levelIds.indexOf(levelId) > -1) {
                    this.setLevelPlayed(levelId, true);
                }
            }
        }
        this.lockUnlockLevelsIfNeeded();
        this.saveLevelsResults();
        this.saveUnlockedLevels();
        this.savePlayedLevels();
        this.saveSkippedLevels();
    };
    ProgressService.prototype.prepareResultsObj = function (arr) {
        var obj = {};
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var el = arr_1[_i];
            obj[el.level_id] = el;
        }
        return obj;
    };
    ProgressService.prototype.canPreviousLevelBeSkipped = function (levelId) {
        var canBeSkipped = true;
        var prevLevelId = this.packLevelService.previousLevelId(levelId);
        if (prevLevelId) {
            var isPreviousAvailableToSkip = this.isAvailableToSkip(prevLevelId);
            var isPreviousTutorial = this.packLevelService.levels[prevLevelId].tutorial;
            canBeSkipped = isPreviousAvailableToSkip || isPreviousTutorial;
        }
        return canBeSkipped;
    };
    ProgressService.prototype.addOrUpdateLevelResult = function (levelResult) {
        var foundResult = this.levelsResults[levelResult.level_id];
        var level = this.packLevelService.levels[levelResult.level_id];
        if (foundResult) {
            foundResult.e_moves = Math.min(foundResult.e_moves, levelResult.e_moves);
            foundResult.l_moves = Math.min(foundResult.l_moves, levelResult.l_moves);
            foundResult.v_count = Math.max(foundResult.v_count, levelResult.v_count);
            foundResult.stars = level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(foundResult.e_moves, foundResult.l_moves, foundResult.v_count);
        }
        else {
            levelResult.stars = level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(levelResult.e_moves, levelResult.l_moves, levelResult.v_count);
            if (levelResult.level_id) {
                levelResult.levelId = levelResult.level_id;
                delete levelResult.level_id;
            }
            this.levelsResults[levelResult.levelId] = levelResult;
        }
    };
    ProgressService.prototype.setLevelSkipped = function (levelId, isSkipped) {
        var ix = this.skippedLevels.indexOf(levelId);
        if (ix > -1) {
            if (isSkipped) {
                return;
            }
            this.skippedLevels.splice(ix, 1);
        }
        else {
            if (isSkipped) {
                this.skippedLevels.push(levelId);
            }
        }
    };
    ProgressService.prototype.setLevelUnlocked = function (levelId, isUnlocked) {
        var ix = this.unlockedLevels.indexOf(levelId);
        if (ix > -1) {
            if (isUnlocked) {
                return;
            }
            this.unlockedLevels.splice(ix, 1);
        }
        else {
            if (isUnlocked) {
                this.unlockedLevels.push(levelId);
            }
        }
    };
    ProgressService.prototype.setLevelPlayed = function (levelId, isPlayed) {
        var ix = this.playedLevels.indexOf(levelId);
        if (ix > -1) {
            if (isPlayed) {
                return;
            }
            this.playedLevels.splice(ix, 1);
        }
        else {
            if (isPlayed) {
                this.playedLevels.push(levelId);
            }
        }
    };
    return ProgressService;
}());
ProgressService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [storage_service_1.StorageService,
        pack_level_service_1.PackLevelService,
        core_2.CookieService,
        tool_service_1.ToolService,
        level_permutation_analyzer_service_1.LevelPermutationAnalyzerService])
], ProgressService);
exports.ProgressService = ProgressService;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var http_1 = __webpack_require__(53);
var ResourcePreloaderService = (function () {
    function ResourcePreloaderService(http) {
        this.http = http;
    }
    ResourcePreloaderService.prototype.load = function () {
        var _this = this;
        this.toolInfosPromise = this.http.get(__webpack_require__(191))
            .toPromise()
            .then(function (data) { return _this.toolInfos = data.text(); });
        this.stylesPromise = this.http.get(__webpack_require__(876))
            .toPromise()
            .then(function (data) { return _this.styles = data.text(); });
        this.levelsPromise = this.http.get(__webpack_require__(1031))
            .toPromise()
            .then(function (data) { return _this.levels = data.text(); });
        return Promise.all([this.toolInfosPromise, this.stylesPromise, this.levelsPromise]);
    };
    return ResourcePreloaderService;
}());
ResourcePreloaderService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ResourcePreloaderService);
exports.ResourcePreloaderService = ResourcePreloaderService;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var resourcePreloader_service_1 = __webpack_require__(146);
var Module = window.Module;
var ToolService = (function () {
    function ToolService(resourcePreloaderService) {
        this.resourcePreloaderService = resourcePreloaderService;
        this.loadTools();
    }
    ToolService.prototype.loadTools = function () {
        if (this.areToolsLoaded) {
            return this.areToolsLoaded;
        }
        this.areToolsLoaded = Module.GToolManager.sharedInstance().loadToolsFromFileContent(this.resourcePreloaderService.toolInfos);
        return this.areToolsLoaded;
    };
    ToolService.prototype.allToolTypes = function () {
        var vector = Module.GToolManager.sharedInstance().getAllToolTypes();
        var res = [];
        for (var i = 0, len = vector.size(); i < len; i++) {
            res.push(vector.get(i));
        }
        return res;
    };
    ToolService.prototype.toolInfoWithType = function (toolType) {
        var toolInfo = Module.GToolManager.sharedInstance().getToolInfo(toolType);
        toolInfo.icon = toolType + ".svg";
        return toolInfo;
    };
    return ToolService;
}());
ToolService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [resourcePreloader_service_1.ResourcePreloaderService])
], ToolService);
exports.ToolService = ToolService;


/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/help@2x.3d4ee6251043ca40b716c0d286ccd4d8.png";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/bglines.47aaa7ac452c9ba2c5898aeb92cdb571.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/darkTextureplus1Mini.c7cbbae01041925698d3a2a15bc243a8.png";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AppStoreBadgeWhite_RU.13ab67081c7febc7735feefd3f17ba20.svg";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AppStoreBadgeWhite_US.0f3514a45d51f95167e5fe8b6a03bb60.svg";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GooglePlayBadgeWhite_RU.746f45d9be0cdaabb78fa67030e5334e.svg";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GooglePlayBadgeWhite_US.ab43147765bc23f2550f2a15d3e557d5.svg";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/BackBtn.422b70dc3f7e2a8220212e54851f670a.svg";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ExploreBtn.dd9e10916eceeec217a28cca7095f252.svg";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/galleryBtn.7c41703257fa2f68ba3398d8e8b114d2.svg";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/prevTaskBtn.8886166a6fb82db89a529338141b534c.svg";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/restartBtn.1c7d2e3d714c38d96f95a3ce93707f2a.svg";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ProfileIcon.c1c8343e1dc79c400c8c82c7bac1acbc.svg";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ToolInfos.434b09e6e848bc1c31180ce1a1d8e972.xml";

/***/ }),
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isObject(what) {
    return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch ({}.toString.call(value)) {
    case '[object Error]': return true;
    case '[object Exception]': return true;
    case '[object DOMException]': return true;
    default: return value instanceof Error;
  }
}

module.exports = {
    isObject: isObject,
    isError: isError
};


/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1x/3CirclesCDetailed.png": 444,
	"./1x/3CirclesIDetailed.png": 445,
	"./1x/3rdProportionalDetailed.png": 446,
	"./1x/4SymmetricLinesDetailed.png": 447,
	"./1x/4thProportionalDetailed.png": 448,
	"./1x/60RotationCWDetailed.png": 449,
	"./1x/90RotationCCWDetailed.png": 450,
	"./1x/9PointCircleDetailed.png": 451,
	"./1x/AEqualSegments1Detailed.png": 452,
	"./1x/AMinPerimeterDetailed.png": 453,
	"./1x/APtOnCircleMaxDistDetailed.png": 454,
	"./1x/ATrByCentroidDetailed.png": 455,
	"./1x/ATrByCircumcenterDetailed.png": 456,
	"./1x/ATrByOrthocenterDetailed.png": 457,
	"./1x/Angle15Detailed.png": 458,
	"./1x/Angle30Detailed.png": 459,
	"./1x/Angle3Detailed.png": 460,
	"./1x/Angle45Detailed.png": 461,
	"./1x/Angle54Detailed.png": 462,
	"./1x/Angle60Detailed.png": 463,
	"./1x/Angle60DropDetailed.png": 464,
	"./1x/Angle75Detailed.png": 465,
	"./1x/AngleIsoscelesDetailed.png": 466,
	"./1x/AngleMidpointDetailed.png": 467,
	"./1x/AngleTrisection54Detailed.png": 468,
	"./1x/AnnulusDetailed.png": 469,
	"./1x/ArbelosDetailed.png": 470,
	"./1x/BisectAngleDetailed.png": 471,
	"./1x/CDoubleSegDetailed.png": 472,
	"./1x/CIntersectCLDetailed.png": 473,
	"./1x/CIntersectXDetailed.png": 474,
	"./1x/CMidpointDetailed.png": 475,
	"./1x/CTranslateCircleDetailed.png": 476,
	"./1x/CenterOfRotationDetailed.png": 477,
	"./1x/CentroidOfQuadrilateralDetailed.png": 478,
	"./1x/Chord3Detailed.png": 479,
	"./1x/ChordMidpointDetailed.png": 480,
	"./1x/Circle3Detailed.png": 481,
	"./1x/CircleByRadiusDetailed.png": 482,
	"./1x/CircleCenterDetailed.png": 483,
	"./1x/CircleEquidistantFrom4PointsDetailed.png": 484,
	"./1x/CircleInAngleDetailed.png": 485,
	"./1x/CircleInOutSquareDetailed.png": 486,
	"./1x/CircleInRhombusDetailed.png": 487,
	"./1x/CircleInSquareDetailed.png": 488,
	"./1x/CircleInTriangleDetailed.png": 489,
	"./1x/CircleTangentCCDetailed.png": 490,
	"./1x/CircleTangentCCwCenterLDetailed.png": 491,
	"./1x/CircleTangentCLDetailed.png": 492,
	"./1x/CircleTangentCPwCenterLDetailed.png": 493,
	"./1x/CircleTangentLDetailed.png": 494,
	"./1x/CircleTangentLLLDetailed.png": 495,
	"./1x/CircleTangentPLDetailed.png": 496,
	"./1x/CircleTangentPPLDetailed.png": 497,
	"./1x/CleaverDetailed.png": 498,
	"./1x/Cut2RectanglesDetailed.png": 499,
	"./1x/CutRectangleDetailed.png": 500,
	"./1x/Divide3Detailed.png": 501,
	"./1x/DoubleAngleDetailed.png": 502,
	"./1x/DropPerpDetailed.png": 503,
	"./1x/EqualSegments3Detailed.png": 504,
	"./1x/Equidistant2Detailed.png": 505,
	"./1x/Equidistant3Detailed.png": 506,
	"./1x/EquidistantParallelDetailed.png": 507,
	"./1x/Equilateral3Detailed.png": 508,
	"./1x/EquilateralAboutCircleDetailed.png": 509,
	"./1x/EquilateralByCentroid2PDetailed.png": 510,
	"./1x/EquilateralInCircleDetailed.png": 511,
	"./1x/EquilateralOnCCDetailed.png": 512,
	"./1x/ErectPerpDetailed.png": 513,
	"./1x/ExcircleDetailed.png": 514,
	"./1x/GeometricMeanDetailed.png": 515,
	"./1x/GivenAngleBisectorDetailed.png": 516,
	"./1x/GoldenSectionDetailed.png": 517,
	"./1x/HarmonicMeanDetailed.png": 518,
	"./1x/HashDetailed.png": 519,
	"./1x/HeronDetailed.png": 520,
	"./1x/HexagonBySideDetailed.png": 521,
	"./1x/HypotenuseAndAltitudeDetailed.png": 522,
	"./1x/HypotenuseAndLegDetailed.png": 523,
	"./1x/IncenterDetailed.png": 524,
	"./1x/InnerTangentDetailed.png": 525,
	"./1x/InteriorAnglesDetailed.png": 526,
	"./1x/IsoscelesTriangleAboutCircleDetailed.png": 527,
	"./1x/L3ParallelDetailed.png": 528,
	"./1x/LDivide3Detailed.png": 529,
	"./1x/LDropPerp2Detailed.png": 530,
	"./1x/LDropPerpDetailed.png": 531,
	"./1x/LMidpointDetailed.png": 532,
	"./1x/LReflectionDetailed.png": 533,
	"./1x/LTangentDetailed.png": 534,
	"./1x/LineAlongPointsDetailed.png": 535,
	"./1x/LineBetweenPointsDetailed.png": 536,
	"./1x/LozengeDetailed.png": 537,
	"./1x/MidpointDetailed.png": 538,
	"./1x/MirrorSegDetailed.png": 539,
	"./1x/NapoleonDetailed.png": 540,
	"./1x/OctagonBySideDetailed.png": 541,
	"./1x/OrthicTriangleDetailed.png": 542,
	"./1x/OuterTangentDetailed.png": 543,
	"./1x/ParallelDetailed.png": 544,
	"./1x/Parallelogram3VDetailed.png": 545,
	"./1x/ParallelogramBy3MidpointsDetailed.png": 546,
	"./1x/ParallelogramBySPDetailed.png": 547,
	"./1x/ParallelogramVOn4LinesDetailed.png": 548,
	"./1x/PentagonDetailed.png": 549,
	"./1x/PerimeterBisectorDetailed.png": 550,
	"./1x/PerpBisectorDetailed.png": 551,
	"./1x/PtSymmetryDetailed.png": 552,
	"./1x/RTrBy2SidePointsDetailed.png": 553,
	"./1x/RTrByHypAndTangentPtDetailed.png": 554,
	"./1x/RhombusInRectDetailed.png": 555,
	"./1x/RhombusInTriangleDetailed.png": 556,
	"./1x/Secant2Detailed.png": 557,
	"./1x/Segment6Detailed.png": 558,
	"./1x/ShiftAngleDetailed.png": 559,
	"./1x/ShiftSegmentDetailed.png": 560,
	"./1x/Sqrt2Detailed.png": 561,
	"./1x/Sqrt3Detailed.png": 562,
	"./1x/SquareAboutCircleDetailed.png": 563,
	"./1x/SquareBy4PtDetailed.png": 564,
	"./1x/SquareByAdjMidpointsDetailed.png": 565,
	"./1x/SquareByOppMidpointsDetailed.png": 566,
	"./1x/SquareInCircleByPtDetailed.png": 567,
	"./1x/SquareInCircleDetailed.png": 568,
	"./1x/SquareInSquareDetailed.png": 569,
	"./1x/SquareInTriangleDetailed.png": 570,
	"./1x/SumSquaresDetailed.png": 571,
	"./1x/T1_LineDetailed.png": 572,
	"./1x/T2_CircleDetailed.png": 573,
	"./1x/T3_PointDetailed.png": 574,
	"./1x/TBisectAngleDetailed.png": 575,
	"./1x/TCircleByRadiusDetailed.png": 576,
	"./1x/TDropPerpDetailed.png": 577,
	"./1x/TEquilateralDetailed.png": 578,
	"./1x/TIntersectDetailed.png": 579,
	"./1x/TMoveDetailed.png": 580,
	"./1x/TParallelDetailed.png": 581,
	"./1x/TPerpBisectorDetailed.png": 582,
	"./1x/Tangent1Detailed.png": 583,
	"./1x/TangentDetailed.png": 584,
	"./1x/TorricelliPtDetailed.png": 585,
	"./1x/TrByAltitudeBasesDetailed.png": 586,
	"./1x/TrByExcircleCentersDetailed.png": 587,
	"./1x/TrByIncircleBasesDetailed.png": 588,
	"./1x/TrBySideAndCentroidDetailed.png": 589,
	"./1x/TranslateSegmentDetailed.png": 590,
	"./1x/TrapezoidCut3Detailed.png": 591,
	"./1x/TrapezoidCutDetailed.png": 592,
	"./1x/TrapezoidGeomMeanDetailed.png": 593,
	"./1x/TrapezoidHarmMeanDetailed.png": 594,
	"./1x/TriangleByMidpointsDetailed.png": 595,
	"./1x/TriangleBySidesDetailed.png": 596,
	"./1x/TriangleMidSegmentDetailed.png": 597,
	"./2x/retina_3CirclesCDetailed.png": 598,
	"./2x/retina_3CirclesIDetailed.png": 599,
	"./2x/retina_3rdProportionalDetailed.png": 600,
	"./2x/retina_4SymmetricLinesDetailed.png": 601,
	"./2x/retina_4thProportionalDetailed.png": 602,
	"./2x/retina_60RotationCWDetailed.png": 603,
	"./2x/retina_90RotationCCWDetailed.png": 604,
	"./2x/retina_9PointCircleDetailed.png": 605,
	"./2x/retina_AEqualSegments1Detailed.png": 606,
	"./2x/retina_AMinPerimeterDetailed.png": 607,
	"./2x/retina_APtOnCircleMaxDistDetailed.png": 608,
	"./2x/retina_ATrByCentroidDetailed.png": 609,
	"./2x/retina_ATrByCircumcenterDetailed.png": 610,
	"./2x/retina_ATrByOrthocenterDetailed.png": 611,
	"./2x/retina_Angle15Detailed.png": 612,
	"./2x/retina_Angle30Detailed.png": 613,
	"./2x/retina_Angle3Detailed.png": 614,
	"./2x/retina_Angle45Detailed.png": 615,
	"./2x/retina_Angle54Detailed.png": 616,
	"./2x/retina_Angle60Detailed.png": 617,
	"./2x/retina_Angle60DropDetailed.png": 618,
	"./2x/retina_Angle75Detailed.png": 619,
	"./2x/retina_AngleIsoscelesDetailed.png": 620,
	"./2x/retina_AngleMidpointDetailed.png": 621,
	"./2x/retina_AngleTrisection54Detailed.png": 622,
	"./2x/retina_AnnulusDetailed.png": 623,
	"./2x/retina_ArbelosDetailed.png": 624,
	"./2x/retina_BisectAngleDetailed.png": 625,
	"./2x/retina_CDoubleSegDetailed.png": 626,
	"./2x/retina_CIntersectCLDetailed.png": 627,
	"./2x/retina_CIntersectXDetailed.png": 628,
	"./2x/retina_CMidpointDetailed.png": 629,
	"./2x/retina_CTranslateCircleDetailed.png": 630,
	"./2x/retina_CenterOfRotationDetailed.png": 631,
	"./2x/retina_CentroidOfQuadrilateralDetailed.png": 632,
	"./2x/retina_Chord3Detailed.png": 633,
	"./2x/retina_ChordMidpointDetailed.png": 634,
	"./2x/retina_Circle3Detailed.png": 635,
	"./2x/retina_CircleByRadiusDetailed.png": 636,
	"./2x/retina_CircleCenterDetailed.png": 637,
	"./2x/retina_CircleEquidistantFrom4PointsDetailed.png": 638,
	"./2x/retina_CircleInAngleDetailed.png": 639,
	"./2x/retina_CircleInOutSquareDetailed.png": 640,
	"./2x/retina_CircleInRhombusDetailed.png": 641,
	"./2x/retina_CircleInSquareDetailed.png": 642,
	"./2x/retina_CircleInTriangleDetailed.png": 643,
	"./2x/retina_CircleTangentCCDetailed.png": 644,
	"./2x/retina_CircleTangentCCwCenterLDetailed.png": 645,
	"./2x/retina_CircleTangentCLDetailed.png": 646,
	"./2x/retina_CircleTangentCPwCenterLDetailed.png": 647,
	"./2x/retina_CircleTangentLDetailed.png": 648,
	"./2x/retina_CircleTangentLLLDetailed.png": 649,
	"./2x/retina_CircleTangentPLDetailed.png": 650,
	"./2x/retina_CircleTangentPPLDetailed.png": 651,
	"./2x/retina_CleaverDetailed.png": 652,
	"./2x/retina_Cut2RectanglesDetailed.png": 653,
	"./2x/retina_CutRectangleDetailed.png": 654,
	"./2x/retina_Divide3Detailed.png": 655,
	"./2x/retina_DoubleAngleDetailed.png": 656,
	"./2x/retina_DropPerpDetailed.png": 657,
	"./2x/retina_EqualSegments3Detailed.png": 658,
	"./2x/retina_Equidistant2Detailed.png": 659,
	"./2x/retina_Equidistant3Detailed.png": 660,
	"./2x/retina_EquidistantParallelDetailed.png": 661,
	"./2x/retina_Equilateral3Detailed.png": 662,
	"./2x/retina_EquilateralAboutCircleDetailed.png": 663,
	"./2x/retina_EquilateralByCentroid2PDetailed.png": 664,
	"./2x/retina_EquilateralInCircleDetailed.png": 665,
	"./2x/retina_EquilateralOnCCDetailed.png": 666,
	"./2x/retina_ErectPerpDetailed.png": 667,
	"./2x/retina_ExcircleDetailed.png": 668,
	"./2x/retina_GeometricMeanDetailed.png": 669,
	"./2x/retina_GivenAngleBisectorDetailed.png": 670,
	"./2x/retina_GoldenSectionDetailed.png": 671,
	"./2x/retina_HarmonicMeanDetailed.png": 672,
	"./2x/retina_HashDetailed.png": 673,
	"./2x/retina_HeronDetailed.png": 674,
	"./2x/retina_HexagonBySideDetailed.png": 675,
	"./2x/retina_HypotenuseAndAltitudeDetailed.png": 676,
	"./2x/retina_HypotenuseAndLegDetailed.png": 677,
	"./2x/retina_IncenterDetailed.png": 678,
	"./2x/retina_InnerTangentDetailed.png": 679,
	"./2x/retina_InteriorAnglesDetailed.png": 680,
	"./2x/retina_IsoscelesTriangleAboutCircleDetailed.png": 681,
	"./2x/retina_L3ParallelDetailed.png": 682,
	"./2x/retina_LDivide3Detailed.png": 683,
	"./2x/retina_LDropPerp2Detailed.png": 684,
	"./2x/retina_LDropPerpDetailed.png": 685,
	"./2x/retina_LMidpointDetailed.png": 686,
	"./2x/retina_LReflectionDetailed.png": 687,
	"./2x/retina_LTangentDetailed.png": 688,
	"./2x/retina_LineAlongPointsDetailed.png": 689,
	"./2x/retina_LineBetweenPointsDetailed.png": 690,
	"./2x/retina_LozengeDetailed.png": 691,
	"./2x/retina_MidpointDetailed.png": 692,
	"./2x/retina_MirrorSegDetailed.png": 693,
	"./2x/retina_NapoleonDetailed.png": 694,
	"./2x/retina_OctagonBySideDetailed.png": 695,
	"./2x/retina_OrthicTriangleDetailed.png": 696,
	"./2x/retina_OuterTangentDetailed.png": 697,
	"./2x/retina_ParallelDetailed.png": 698,
	"./2x/retina_Parallelogram3VDetailed.png": 699,
	"./2x/retina_ParallelogramBy3MidpointsDetailed.png": 700,
	"./2x/retina_ParallelogramBySPDetailed.png": 701,
	"./2x/retina_ParallelogramVOn4LinesDetailed.png": 702,
	"./2x/retina_PentagonDetailed.png": 703,
	"./2x/retina_PerimeterBisectorDetailed.png": 704,
	"./2x/retina_PerpBisectorDetailed.png": 705,
	"./2x/retina_PtSymmetryDetailed.png": 706,
	"./2x/retina_RTrBy2SidePointsDetailed.png": 707,
	"./2x/retina_RTrByHypAndTangentPtDetailed.png": 708,
	"./2x/retina_RhombusInRectDetailed.png": 709,
	"./2x/retina_RhombusInTriangleDetailed.png": 710,
	"./2x/retina_Secant2Detailed.png": 711,
	"./2x/retina_Segment6Detailed.png": 712,
	"./2x/retina_ShiftAngleDetailed.png": 713,
	"./2x/retina_ShiftSegmentDetailed.png": 714,
	"./2x/retina_Sqrt2Detailed.png": 715,
	"./2x/retina_Sqrt3Detailed.png": 716,
	"./2x/retina_SquareAboutCircleDetailed.png": 717,
	"./2x/retina_SquareBy4PtDetailed.png": 718,
	"./2x/retina_SquareByAdjMidpointsDetailed.png": 719,
	"./2x/retina_SquareByOppMidpointsDetailed.png": 720,
	"./2x/retina_SquareInCircleByPtDetailed.png": 721,
	"./2x/retina_SquareInCircleDetailed.png": 722,
	"./2x/retina_SquareInSquareDetailed.png": 723,
	"./2x/retina_SquareInTriangleDetailed.png": 724,
	"./2x/retina_SumSquaresDetailed.png": 725,
	"./2x/retina_T1_LineDetailed.png": 726,
	"./2x/retina_T2_CircleDetailed.png": 727,
	"./2x/retina_T3_PointDetailed.png": 728,
	"./2x/retina_TBisectAngleDetailed.png": 729,
	"./2x/retina_TCircleByRadiusDetailed.png": 730,
	"./2x/retina_TDropPerpDetailed.png": 731,
	"./2x/retina_TEquilateralDetailed.png": 732,
	"./2x/retina_TIntersectDetailed.png": 733,
	"./2x/retina_TMoveDetailed.png": 734,
	"./2x/retina_TParallelDetailed.png": 735,
	"./2x/retina_TPerpBisectorDetailed.png": 736,
	"./2x/retina_Tangent1Detailed.png": 737,
	"./2x/retina_TangentDetailed.png": 738,
	"./2x/retina_TorricelliPtDetailed.png": 739,
	"./2x/retina_TrByAltitudeBasesDetailed.png": 740,
	"./2x/retina_TrByExcircleCentersDetailed.png": 741,
	"./2x/retina_TrByIncircleBasesDetailed.png": 742,
	"./2x/retina_TrBySideAndCentroidDetailed.png": 743,
	"./2x/retina_TranslateSegmentDetailed.png": 744,
	"./2x/retina_TrapezoidCut3Detailed.png": 745,
	"./2x/retina_TrapezoidCutDetailed.png": 746,
	"./2x/retina_TrapezoidGeomMeanDetailed.png": 747,
	"./2x/retina_TrapezoidHarmMeanDetailed.png": 748,
	"./2x/retina_TriangleByMidpointsDetailed.png": 749,
	"./2x/retina_TriangleBySidesDetailed.png": 750,
	"./2x/retina_TriangleMidSegmentDetailed.png": 751
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 231;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// angular  modules
var core_1 = __webpack_require__(3);
var platform_browser_1 = __webpack_require__(54);
var forms_1 = __webpack_require__(238);
var http_1 = __webpack_require__(53);
// vendor
var cookies_service_1 = __webpack_require__(141);
var Raven = __webpack_require__(1055);
var constants_1 = __webpack_require__(43);
Raven
    .config('https://abe4cc5112f34eaf8f930285e7ef229c@sentry.io/71410', {
    release: constants_1.VERSION
})
    .install();
var RavenErrorHandler = (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        Raven.captureException(err.originalError || err);
        console.error(err);
    };
    return RavenErrorHandler;
}());
exports.RavenErrorHandler = RavenErrorHandler;
// components
var components_1 = __webpack_require__(142);
// services
var services_1 = __webpack_require__(11);
// router
var router_1 = __webpack_require__(23);
var index_router_1 = __webpack_require__(255);
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule = __decorate([
    core_1.NgModule({
        // modules
        imports: [
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            http_1.HttpModule,
            router_1.RouterModule.forRoot(index_router_1.appRoutes)
        ],
        // components
        declarations: [
            components_1.AppComponent,
            components_1.HeaderComponent,
            components_1.ModalComponent,
            components_1.PacksBoxComponent,
            components_1.ModalHelpComponent,
            components_1.MainComponent,
            components_1.LevelsBoxComponent,
            components_1.LevelComponent,
            components_1.ModalSuccessComponent,
            components_1.ModalDescriptionComponent,
            components_1.ModalHelpAddonComponent,
            components_1.UserMenuComponent,
            components_1.ModalHelpAddonProgressComponent,
        ],
        // services
        providers: [
            services_1.EventService,
            services_1.LocalizationService,
            services_1.ProgressService,
            services_1.PackLevelService,
            services_1.StorageService,
            cookies_service_1.CookieService,
            services_1.ToolService,
            services_1.UserService,
            services_1.LevelBoxGuardService,
            services_1.LevelGuardService,
            services_1.ShortPathGameGuardService,
            services_1.ResourcePreloaderService,
            services_1.LevelPermutationAnalyzerService,
            services_1.MigrationService,
            {
                provide: core_1.APP_INITIALIZER,
                useFactory: function (preloader, migration) {
                    migration.migrate();
                    return function () { return preloader.load(); };
                },
                deps: [services_1.ResourcePreloaderService, services_1.MigrationService],
                multi: true
            },
            {
                provide: core_1.ErrorHandler,
                useClass: RavenErrorHandler
            }
        ],
        bootstrap: [components_1.AppComponent]
    })
], AppModule);
exports.AppModule = AppModule;


/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_forkJoin__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__ = __webpack_require__(54);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControlDirective", function() { return AbstractControlDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractFormGroupDirective", function() { return AbstractFormGroupDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxControlValueAccessor", function() { return CheckboxControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlContainer", function() { return ControlContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALUE_ACCESSOR", function() { return NG_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPOSITION_BUFFER_MODE", function() { return COMPOSITION_BUFFER_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultValueAccessor", function() { return DefaultValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControl", function() { return NgControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatus", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatusGroup", function() { return NgControlStatusGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForm", function() { return NgForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModel", function() { return NgModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModelGroup", function() { return NgModelGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioControlValueAccessor", function() { return RadioControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlDirective", function() { return FormControlDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlName", function() { return FormControlName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupDirective", function() { return FormGroupDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArrayName", function() { return FormArrayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupName", function() { return FormGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSelectOption", function() { return NgSelectOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectControlValueAccessor", function() { return SelectControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectMultipleControlValueAccessor", function() { return SelectMultipleControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxRequiredValidator", function() { return CheckboxRequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() { return EmailValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxLengthValidator", function() { return MaxLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinLengthValidator", function() { return MinLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PatternValidator", function() { return PatternValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequiredValidator", function() { return RequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormBuilder", function() { return FormBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControl", function() { return AbstractControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArray", function() { return FormArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return FormControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_ASYNC_VALIDATORS", function() { return NG_ASYNC_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALIDATORS", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Validators", function() { return Validators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormsModule", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactiveFormsModule", function() { return ReactiveFormsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵba", function() { return InternalFormsSharedModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵz", function() { return REACTIVE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵx", function() { return SHARED_FORM_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵy", function() { return TEMPLATE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return CHECKBOX_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return DEFAULT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return AbstractControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return ngControlStatusHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return formDirectiveProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return formControlBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return modelGroupProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbf", function() { return NgNoValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbb", function() { return NUMBER_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbc", function() { return NumberValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return RADIO_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi", function() { return RadioControlRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbd", function() { return RANGE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbe", function() { return RangeValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵj", function() { return formControlBinding$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵk", function() { return controlNameBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵl", function() { return formDirectiveProvider$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵn", function() { return formArrayNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵm", function() { return formGroupNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵo", function() { return SELECT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵq", function() { return NgSelectMultipleOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵp", function() { return SELECT_MULTIPLE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵs", function() { return CHECKBOX_REQUIRED_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵt", function() { return EMAIL_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵv", function() { return MAX_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵu", function() { return MIN_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵw", function() { return PATTERN_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵr", function() { return REQUIRED_VALIDATOR; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.0.1
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */





/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Base class for control directives.
 *
 * Only used internally in the forms module.
 *
 * \@stable
 * @abstract
 */
var AbstractControlDirective = (function () {
    function AbstractControlDirective() {
    }
    Object.defineProperty(AbstractControlDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { throw new Error('unimplemented'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.statusChanges : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.valueChanges : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} value
     * @return {?}
     */
    AbstractControlDirective.prototype.reset = function (value) {
        if (value === void 0) { value = undefined; }
        if (this.control)
            this.control.reset(value);
    };
    /**
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    /**
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A directive that contains multiple {\@link NgControl}s.
 *
 * Only used by the forms module.
 *
 * \@stable
 */
var ControlContainer = (function (_super) {
    __extends(ControlContainer, _super);
    function ControlContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * Get the form to which this container belongs.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * Get the path to this container.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(AbstractControlDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __assign = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * Providers for validators to be used for {\@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * ### Example
 *
 * {\@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
 * \@stable
 */
var NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {\@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {\@link NG_VALIDATORS} for more details.
 *
 * \@stable
 */
var NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('NgAsyncValidators');
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {\@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.required)
 * ```
 *
 * \@stable
 */
var Validators = (function () {
    function Validators() {
    }
    /**
     * Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    Validators.required = function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    Validators.requiredTrue = function (control) {
        return control.value === true ? null : { 'required': true };
    };
    /**
     * Validator that performs email validation.
     * @param {?} control
     * @return {?}
     */
    Validators.email = function (control) {
        return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
    };
    /**
     * Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    Validators.minLength = function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    Validators.maxLength = function (maxLength) {
        return function (control) {
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    Validators.pattern = function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var /** @type {?} */ regex;
        var /** @type {?} */ regexStr;
        if (typeof pattern === 'string') {
            regexStr = "^" + pattern + "$";
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     * No-op validator.
     * @param {?} c
     * @return {?}
     */
    Validators.nullValidator = function (c) { return null; };
    /**
     * Compose multiple validators into a single function that returns the union
     * of the individual error maps.
     * @param {?} validators
     * @return {?}
     */
    Validators.compose = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = validators.filter(isPresent);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.composeAsync = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = validators.filter(isPresent);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var /** @type {?} */ observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
            return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_forkJoin__["forkJoin"])(observables), _mergeErrors);
        };
    };
    return Validators;
}());
/**
 * @param {?} o
 * @return {?}
 */
function isPresent(o) {
    return o != null;
}
/**
 * @param {?} r
 * @return {?}
 */
function toObservable(r) {
    var /** @type {?} */ obs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisPromise"])(r) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
    if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisObservable"])(obs))) {
        throw new Error("Expected validator to return Promise or Observable.");
    }
    return obs;
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} arrayOfErrors
 * @return {?}
 */
function _mergeErrors(arrayOfErrors) {
    var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
        return errors != null ? __assign({}, res, errors) : res;
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to provide a {\@link ControlValueAccessor} for form controls.
 *
 * See {\@link DefaultValueAccessor} for how to implement one.
 * \@stable
 */
var NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('NgValueAccessor');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 *
 *  \@stable
 */
var CheckboxControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return CheckboxControlValueAccessor;
}());
CheckboxControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                providers: [CHECKBOX_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
CheckboxControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DEFAULT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 * @return {?}
 */
function _isAndroid() {
    var /** @type {?} */ userAgent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["ɵgetDOM"])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["ɵgetDOM"])().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
/**
 * Turn this mode on if you want form directives to buffer IME input until compositionend
 * \@experimental
 */
var COMPOSITION_BUFFER_MODE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('CompositionEventMode');
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="text" name="searchQuery" ngModel>
 *  ```
 *
 *  \@stable
 */
var DefaultValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _compositionMode
     */
    function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._composing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype.writeValue = function (value) {
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._handleInput = function (value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this.onChange(value);
        }
    };
    /**
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionStart = function () { this._composing = true; };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionEnd = function (value) {
        this._composing = false;
        this._compositionMode && this.onChange(value);
    };
    return DefaultValueAccessor;
}());
DefaultValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                // TODO: vsavkin replace the above selector with the one below it once
                // https://github.com/angular/angular/issues/3011 is implemented
                // selector: '[ngModel],[formControl],[formControlName]',
                host: {
                    '(input)': '_handleInput($event.target.value)',
                    '(blur)': 'onTouched()',
                    '(compositionstart)': '_compositionStart()',
                    '(compositionend)': '_compositionEnd($event.target.value)'
                },
                providers: [DEFAULT_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
DefaultValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [COMPOSITION_BUFFER_MODE,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeAsyncValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NUMBER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="number" [(ngModel)]="age">
 *  ```
 */
var NumberValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumberValueAccessor.prototype.writeValue = function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return NumberValueAccessor;
}());
NumberValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                host: {
                    '(change)': 'onChange($event.target.value)',
                    '(input)': 'onChange($event.target.value)',
                    '(blur)': 'onTouched()'
                },
                providers: [NUMBER_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
NumberValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {\@link FormControl} object to a DOM element.
 *
 * Used internally by Angular forms.
 *
 * \@stable
 * @abstract
 */
var NgControl = (function (_super) {
    __extends(NgControl, _super);
    function NgControl() {
        var _this = _super.apply(this, arguments) || this;
        /**
         * \@internal
         */
        _this._parent = null;
        _this.name = null;
        _this.valueAccessor = null;
        /**
         * \@internal
         */
        _this._rawValidators = [];
        /**
         * \@internal
         */
        _this._rawAsyncValidators = [];
        return _this;
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    /**
     * @abstract
     * @param {?} newValue
     * @return {?}
     */
    NgControl.prototype.viewToModelUpdate = function (newValue) { };
    return NgControl;
}(AbstractControlDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.add = function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.remove = function (accessor) {
        for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.select = function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    return RadioControlRegistry;
}());
RadioControlRegistry.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
RadioControlRegistry.ctorParameters = function () { return []; };
/**
 * \@whatItDoes Writes radio control values and listens to radio control changes.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {\@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {\@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  \@stable
 */
var RadioControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _registry
     * @param {?} _injector
     */
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnInit = function () {
        this._control = this._injector.get(NgControl);
        this._checkName();
        this._registry.add(this._control, this);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.writeValue = function (value) {
        this._state = value === this.value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._checkName = function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._throwNameError = function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    return RadioControlValueAccessor;
}());
RadioControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                providers: [RADIO_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
RadioControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: RadioControlRegistry, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
]; };
RadioControlValueAccessor.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'formControlName': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RANGE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="range" [(ngModel)]="age" >
 *  ```
 */
var RangeValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RangeValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return RangeValueAccessor;
}());
RangeValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                host: {
                    '(change)': 'onChange($event.target.value)',
                    '(input)': 'onChange($event.target.value)',
                    '(blur)': 'onTouched()'
                },
                providers: [RANGE_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
RangeValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * \@whatItDoes Writes values and listens to changes on a select element.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {\@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {\@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * ### Caveat: Option selection
 *
 * Angular uses object identity to select option. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
 * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects option by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var SelectControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
        /**
         * @param {?} fn
         * @return {?}
         */
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype.writeValue = function (value) {
        this.value = value;
        var /** @type {?} */ id = this._getOptionId(value);
        if (id == null) {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
        }
        var /** @type {?} */ valueString = _buildValueString(id, value);
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = valueString;
            fn(_this._getOptionValue(valueString));
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @return {?}
     */
    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    return SelectControlValueAccessor;
}());
SelectControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                providers: [SELECT_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
SelectControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
SelectControlValueAccessor.propDecorators = {
    'compareWith': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * \@whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * \@howToUse
 *
 * See docs for {\@link SelectControlValueAccessor} for usage examples.
 *
 * \@stable
 */
var NgSelectOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * @return {?}
     */
    NgSelectOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    return NgSelectOption;
}());
NgSelectOption.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
];
/**
 * @nocollapse
 */
NgSelectOption.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
]; };
NgSelectOption.propDecorators = {
    'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString$1(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId$1(valueString) {
    return valueString.split(':')[0];
}
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 *  ### Caveat: Options selection
 *
 * Angular uses object identity to select options. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select multiple>` supports `compareWith`
 * input. `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects options by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select multiple [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * \@stable
 */
var SelectMultipleControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
        /**
         * @param {?} fn
         * @return {?}
         */
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        var /** @type {?} */ optionSelectedStateSetter;
        if (Array.isArray(value)) {
            // convert values to ids
            var /** @type {?} */ ids_1 = value.map(function (v) { return _this._getOptionId(v); });
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
        }
        else {
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
        }
        this._optionMap.forEach(optionSelectedStateSetter);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var /** @type {?} */ selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var /** @type {?} */ options = _.selectedOptions;
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    var /** @type {?} */ val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var /** @type {?} */ options = (_.options);
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    if (opt.selected) {
                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            _this.value = selected;
            fn(selected);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
        var /** @type {?} */ id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(this._optionMap.get(id)._value, value))
                return id;
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId$1(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id)._value : valueString;
    };
    return SelectMultipleControlValueAccessor;
}());
SelectMultipleControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
SelectMultipleControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
SelectMultipleControlValueAccessor.propDecorators = {
    'compareWith': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 */
var NgSelectMultipleOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString$1(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString$1(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * \@internal
     * @param {?} selected
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setSelected = function (selected) {
        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
    };
    /**
     * @return {?}
     */
    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    return NgSelectMultipleOption;
}());
NgSelectMultipleOption.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
];
/**
 * @nocollapse
 */
NgSelectMultipleOption.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
]; };
NgSelectMultipleOption.propDecorators = {
    'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} name
 * @param {?} parent
 * @return {?}
 */
function controlPath(name, parent) {
    return parent.path.concat([name]);
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = Validators.compose([control.validator, dir.validator]);
    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
    dir.valueAccessor.writeValue(control.value);
    // view -> model
    dir.valueAccessor.registerOnChange(function (newValue) {
        dir.viewToModelUpdate(newValue);
        control.markAsDirty();
        control.setValue(newValue, { emitModelToViewChange: false });
    });
    // touched
    dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
    control.registerOnChange(function (newValue, emitModelEvent) {
        // control -> view
        dir.valueAccessor.writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
    if (dir.valueAccessor.setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((validator)).registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((validator)).registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function cleanUpControl(control, dir) {
    dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
    dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpFormContainer(control, dir) {
    if (control == null)
        _throwError(dir, 'Cannot find control with');
    control.validator = Validators.compose([control.validator, dir.validator]);
    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
}
/**
 * @param {?} dir
 * @return {?}
 */
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
/**
 * @param {?} dir
 * @param {?} message
 * @return {?}
 */
function _throwError(dir, message) {
    var /** @type {?} */ messageEnd;
    if (dir.path.length > 1) {
        messageEnd = "path: '" + dir.path.join(' -> ') + "'";
    }
    else if (dir.path[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeValidators(validators) {
    return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeAsyncValidators(validators) {
    return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
        null;
}
/**
 * @param {?} changes
 * @param {?} viewModel
 * @return {?}
 */
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var /** @type {?} */ change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵlooseIdentical"])(viewModel, change.currentValue);
}
var BUILTIN_ACCESSORS = [
    CheckboxControlValueAccessor,
    RangeValueAccessor,
    NumberValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
];
/**
 * @param {?} valueAccessor
 * @return {?}
 */
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
/**
 * @param {?} dir
 * @param {?} valueAccessors
 * @return {?}
 */
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    var /** @type {?} */ defaultAccessor;
    var /** @type {?} */ builtinAccessor;
    var /** @type {?} */ customAccessor;
    valueAccessors.forEach(function (v) {
        if (v.constructor === DefaultValueAccessor) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This is a base class for code shared between {\@link NgModelGroup} and {\@link FormGroupName}.
 *
 * \@stable
 */
var AbstractFormGroupDirective = (function (_super) {
    __extends(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormGroup(this);
    };
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * Get the {\@link FormGroup} backing this binding.
         * @return {?}
         */
        get: function () { return this.formDirective.getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * Get the path to this control group.
         * @return {?}
         */
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * Get the {\@link Form} to which this group belongs.
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return composeAsyncValidators(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @return {?}
     */
    AbstractFormGroupDirective.prototype._checkParentType = function () { };
    return AbstractFormGroupDirective;
}(ControlContainer));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AbstractControlStatus = (function () {
    /**
     * @param {?} cd
     */
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
var ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatus = (function (_super) {
    __extends(NgControlStatus, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatus(cd) {
        return _super.call(this, cd) || this;
    }
    return NgControlStatus;
}(AbstractControlStatus));
NgControlStatus.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
];
/**
 * @nocollapse
 */
NgControlStatus.ctorParameters = function () { return [
    { type: NgControl, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
]; };
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatusGroup = (function (_super) {
    __extends(NgControlStatusGroup, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatusGroup(cd) {
        return _super.call(this, cd) || this;
    }
    return NgControlStatusGroup;
}(AbstractControlStatus));
NgControlStatusGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                host: ngControlStatusHost
            },] },
];
/**
 * @nocollapse
 */
NgControlStatusGroup.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var DISABLED = 'DISABLED';
/**
 * @param {?} control
 * @param {?} path
 * @param {?} delimiter
 * @return {?}
 */
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = ((path)).split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return ((path)).reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(/** @type {?} */ (name)) || null;
        }
        return null;
    }, control);
}
/**
 * @param {?} validator
 * @return {?}
 */
function coerceToValidator(validator) {
    return Array.isArray(validator) ? composeValidators(validator) : validator;
}
/**
 * @param {?} asyncValidator
 * @return {?}
 */
function coerceToAsyncValidator(asyncValidator) {
    return Array.isArray(asyncValidator) ? composeAsyncValidators(asyncValidator) : asyncValidator;
}
/**
 * \@whatItDoes This is the base class for {\@link FormControl}, {\@link FormGroup}, and
 * {\@link FormArray}.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * \@stable
 * @abstract
 */
var AbstractControl = (function () {
    /**
     * @param {?} validator
     * @param {?} asyncValidator
     */
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /**
         * \@internal
         */
        this._onCollectionChange = function () { };
        this._pristine = true;
        this._touched = false;
        /**
         * \@internal
         */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "value", {
        /**
         * The value of the control.
         * @return {?}
         */
        get: function () { return this._value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         * The parent control.
         * @return {?}
         */
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "status", {
        /**
         * The validation status of the control. There are four possible
         * validation statuses:
         *
         * * **VALID**:  control has passed all validation checks
         * * **INVALID**: control has failed at least one validation check
         * * **PENDING**: control is in the midst of conducting a validation check
         * * **DISABLED**: control is exempt from validation checks
         *
         * These statuses are mutually exclusive, so a control cannot be
         * both valid AND invalid or invalid AND disabled.
         * @return {?}
         */
        get: function () { return this._status; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        get: function () { return this._status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        get: function () { return this._status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        get: function () { return this._status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        get: function () { return this._status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        get: function () { return this._status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         * @return {?}
         */
        get: function () { return this._errors; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return this._pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "touched", {
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return !this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         * @return {?}
         */
        get: function () { return this._valueChanges; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         * @return {?}
         */
        get: function () { return this._statusChanges; },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setValidators = function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = true;
        if (this._parent && !onlySelf) {
            this._parent.markAsTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsUntouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsDirty = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = false;
        if (this._parent && !onlySelf) {
            this._parent.markAsDirty({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsPristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = true;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pending`.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsPending = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._status = PENDING;
        if (this._parent && !onlySelf) {
            this._parent.markAsPending({ onlySelf: onlySelf });
        }
    };
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.disable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = DISABLED;
        this._errors = null;
        this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
        this._updateValue();
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.enable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = VALID;
        this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    /**
     * @param {?} onlySelf
     * @return {?}
     */
    AbstractControl.prototype._updateAncestors = function (onlySelf) {
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity();
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    /**
     * @param {?} parent
     * @return {?}
     */
    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
    /**
     * Sets the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.setValue = function (value, options) { };
    /**
     * Patches the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.patchValue = function (value, options) { };
    /**
     * Resets the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.reset = function (value, options) { };
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.updateValueAndValidity = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._cancelExistingSubscription();
            this._errors = this._runValidator();
            this._status = this._calculateStatus();
            if (this._status === VALID || this._status === PENDING) {
                this._runAsyncValidator(emitEvent);
            }
        }
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        }
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updateTreeValidity = function (_a) {
        var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
    /**
     * @return {?}
     */
    AbstractControl.prototype._runValidator = function () {
        return this.validator ? this.validator(this) : null;
    };
    /**
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            this._status = PENDING;
            var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe(function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); });
        }
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._cancelExistingSubscription = function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     * @param {?} errors
     * @param {?=} __1
     * @return {?}
     */
    AbstractControl.prototype.setErrors = function (errors, _a) {
        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
        this._errors = errors;
        this._updateControlsErrors(emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        var /** @type {?} */ control = path ? this.get(path) : this;
        return control && control._errors ? control._errors[errorCode] : null;
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return !!this.getError(errorCode, path);
    };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
        this._status = this._calculateStatus();
        if (emitEvent) {
            this._statusChanges.emit(this._status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._initObservables = function () {
        this._valueChanges = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._statusChanges = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._calculateStatus = function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this._errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /**
     * \@internal
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._updateValue = function () { };
    /**
     * \@internal
     * @abstract
     * @param {?} cb
     * @return {?}
     */
    AbstractControl.prototype._forEachChild = function (cb) { };
    /**
     * \@internal
     * @abstract
     * @param {?} condition
     * @return {?}
     */
    AbstractControl.prototype._anyControls = function (condition) { };
    /**
     * \@internal
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._allControlsDisabled = function () { };
    /**
     * \@internal
     * @param {?} status
     * @return {?}
     */
    AbstractControl.prototype._anyControlsHaveStatus = function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsDirty = function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsTouched = function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updatePristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = !this._anyControlsDirty();
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updateTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = this._anyControlsTouched();
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * \@internal
     * @param {?} formState
     * @return {?}
     */
    AbstractControl.prototype._isBoxedValue = function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
    return AbstractControl;
}());
/**
 * \@whatItDoes Tracks the value and validation status of an individual form control.
 *
 * It is one of the three fundamental building blocks of Angular forms, along with
 * {\@link FormGroup} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormControl}, you can pass in an initial value as the
 * first argument. Example:
 *
 * ```ts
 * const ctrl = new FormControl('some value');
 * console.log(ctrl.value);     // 'some value'
 * ```
 *
 * You can also initialize the control with a form state object on instantiation,
 * which includes both the value and whether or not the control is disabled.
 * You can't use the value key without the disabled key; both are required
 * to use this way of initialization.
 *
 * ```ts
 * const ctrl = new FormControl({value: 'n/a', disabled: true});
 * console.log(ctrl.value);     // 'n/a'
 * console.log(ctrl.status);   // 'DISABLED'
 * ```
 *
 * To include a sync validator (or an array of sync validators) with the control,
 * pass it in as the second argument. Async validators are also supported, but
 * have to be passed in separately as the third arg.
 *
 * ```ts
 * const ctrl = new FormControl('', Validators.required);
 * console.log(ctrl.value);     // ''
 * console.log(ctrl.status);   // 'INVALID'
 * ```
 *
 * See its superclass, {\@link AbstractControl}, for more properties and methods.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormControl = (function (_super) {
    __extends(FormControl, _super);
    /**
     * @param {?=} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormControl(formState, validator, asyncValidator) {
        if (formState === void 0) { formState = null; }
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        var _this = _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator)) || this;
        /**
         * \@internal
         */
        _this._onChange = [];
        _this._applyFormState(formState);
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        _this._initObservables();
        return _this;
    }
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormControl.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
        this._value = value;
        if (this._onChange.length && emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {\@link FormControl.setValue} at this level.
     * It exists for symmetry with {\@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
     * where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.patchValue = function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     * @param {?=} formState
     * @param {?=} __1
     * @return {?}
     */
    FormControl.prototype.reset = function (formState, _a) {
        if (formState === void 0) { formState = null; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._applyFormState(formState);
        this.markAsPristine({ onlySelf: onlySelf });
        this.markAsUntouched({ onlySelf: onlySelf });
        this.setValue(this._value, { onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._updateValue = function () { };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormControl.prototype._anyControls = function (condition) { return false; };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
    /**
     * Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._clearChangeFns = function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnDisabledChange = function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormControl.prototype._forEachChild = function (cb) { };
    /**
     * @param {?} formState
     * @return {?}
     */
    FormControl.prototype._applyFormState = function (formState) {
        if (this._isBoxedValue(formState)) {
            this._value = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            this._value = formState;
        }
    };
    return FormControl;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of a group of {\@link FormControl}
 * instances.
 *
 * A `FormGroup` aggregates the values of each child {\@link FormControl} into one object,
 * with each control name as the key.  It calculates its status by reducing the statuses
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormGroup}, pass in a collection of child controls as the first
 * argument. The key for each child will be the name under which it is registered.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * You can also include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormGroup = (function (_super) {
    __extends(FormGroup, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormGroup(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        var _this = _super.call(this, validator, asyncValidator) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update value or validity of the control, so for
     * most cases you'll want to use {\@link FormGroup.addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.registerControl = function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.addControl = function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype.removeControl = function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.setControl = function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for
     * existence in the group only, use {\@link AbstractControl.get} instead.
     * @param {?} controlName
     * @return {?}
     */
    FormGroup.prototype.contains = function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Resets the {\@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.reset = function (value, _a) {
        if (value === void 0) { value = {}; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    FormGroup.prototype.getRawValue = function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control instanceof FormControl ? control.value : ((control)).getRawValue();
            return acc;
        });
    };
    /**
     * \@internal
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype._throwIfControlMissing = function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormGroup.prototype._forEachChild = function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormGroup.prototype._anyControls = function (condition) {
        var _this = this;
        var /** @type {?} */ res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._reduceValue = function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /**
     * \@internal
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    FormGroup.prototype._reduceChildren = function (initValue, fn) {
        var /** @type {?} */ res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormGroup.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of an array of {\@link FormControl},
 * {\@link FormGroup} or {\@link FormArray} instances.
 *
 * A `FormArray` aggregates the values of each child {\@link FormControl} into an array.
 * It calculates its status by reducing the statuses of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormGroup}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormArray}, pass in an array of child controls as the first
 * argument.
 *
 * ### Example
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * You can also include array-level validators as the second arg, or array-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Adding or removing controls
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that will result in strange and unexpected behavior such
 * as broken change detection.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormArray = (function (_super) {
    __extends(FormArray, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormArray(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        var _this = _super.call(this, validator, asyncValidator) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Get the {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.at = function (index) { return this.controls[index]; };
    /**
     * Insert a new {\@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.push = function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Insert a new {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.insert = function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.removeAt = function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.setControl = function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         * @return {?}
         */
        get: function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Resets the {\@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.reset = function (value, _a) {
        if (value === void 0) { value = []; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    FormArray.prototype.getRawValue = function () {
        return this.controls.map(function (control) {
            return control instanceof FormControl ? control.value : ((control)).getRawValue();
        });
    };
    /**
     * \@internal
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype._throwIfControlMissing = function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormArray.prototype._forEachChild = function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._updateValue = function () {
        var _this = this;
        this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
            .map(function (control) { return control.value; });
    };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormArray.prototype._anyControls = function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormArray.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    /**
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype._registerControl = function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgForm; })
};
var resolvedPromise = Promise.resolve(null);
/**
 * \@whatItDoes Creates a top-level {\@link FormGroup} instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * \@howToUse
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * {\@link FormGroup} instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use {\@link NgModel} with a
 * `name` attribute.  You can also use {\@link NgModelGroup} if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgForm = (function (_super) {
    __extends(NgForm, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgForm(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._submitted = false;
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.form =
            new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
        return _this;
    }
    Object.defineProperty(NgForm.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        /**
         * @return {?}
         */
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            dir._control = (container.registerControl(dir.name, dir.control));
            setUpControl(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            var /** @type {?} */ group = new FormGroup({});
            setUpFormContainer(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.updateModel = function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ ctrl = (_this.form.get(dir.path));
            ctrl.setValue(value);
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
    /**
     * @param {?} $event
     * @return {?}
     */
    NgForm.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    NgForm.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * \@internal
     * @param {?} path
     * @return {?}
     */
    NgForm.prototype._findContainer = function (path) {
        path.pop();
        return path.length ? (this.form.get(path)) : this.form;
    };
    return NgForm;
}(ControlContainer));
NgForm.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                providers: [formDirectiveProvider],
                host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                outputs: ['ngSubmit'],
                exportAs: 'ngForm'
            },] },
];
/**
 * @nocollapse
 */
NgForm.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TemplateDrivenErrors = (function () {
    function TemplateDrivenErrors() {
    }
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelParentException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.formGroupNameException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.missingNameException = function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelGroupParentException = function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    return TemplateDrivenErrors;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var modelGroupProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * \@whatItDoes Creates and binds a {\@link FormGroup} instance to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used as a child of {\@link NgForm} (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {\@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 * \@stable
 */
var NgModelGroup = (function (_super) {
    __extends(NgModelGroup, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgModelGroup(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * \@internal
     * @return {?}
     */
    NgModelGroup.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelGroupParentException();
        }
    };
    return NgModelGroup;
}(AbstractFormGroupDirective));
NgModelGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
];
/**
 * @nocollapse
 */
NgModelGroup.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
NgModelGroup.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelGroup',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var resolvedPromise$1 = Promise.resolve(null);
/**
 * \@whatItDoes Creates a {\@link FormControl} instance from a domain model and binds it
 * to a form control element.
 *
 * The {\@link FormControl} instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * \@howToUse
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional {\@link \@Input}. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated {\@link FormControl} (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in {\@link AbstractControlDirective}.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {\@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgModel = (function (_super) {
    __extends(NgModel, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        /**
         * \@internal
         */
        _this._control = new FormControl();
        /**
         * \@internal
         */
        _this._registered = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype.ngOnChanges = function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? controlPath(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    NgModel.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpControl = function () {
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    /**
     * @return {?}
     */
    NgModel.prototype._isStandalone = function () {
        return !this._parent || (this.options && this.options.standalone);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpStandalone = function () {
        setUpControl(this._control, this);
        this._control.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkForErrors = function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) &&
            this._parent instanceof AbstractFormGroupDirective) {
            TemplateDrivenErrors.formGroupNameException();
        }
        else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelParentException();
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkName = function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            TemplateDrivenErrors.missingNameException();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgModel.prototype._updateValue = function (value) {
        var _this = this;
        resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype._updateDisabled = function (changes) {
        var _this = this;
        var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
        var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise$1.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    return NgModel;
}(NgControl));
NgModel.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[ngModel]:not([formControlName]):not([formControl])',
                providers: [formControlBinding],
                exportAs: 'ngModel'
            },] },
];
/**
 * @nocollapse
 */
NgModel.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
NgModel.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
    'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelOptions',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ReactiveErrors = (function () {
    function ReactiveErrors() {
    }
    /**
     * @return {?}
     */
    ReactiveErrors.controlParentException = function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.ngModelGroupException = function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.missingFormException = function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.groupParentException = function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.arrayParentException = function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.disabledAttrWarning = function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding$1 = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * \@whatItDoes Syncs a standalone {\@link FormControl} instance to a form control element.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * Use this directive if you'd like to create and manage a {\@link FormControl} instance directly.
 * Simply create a {\@link FormControl}, save it to your component class, and pass it into the
 * {\@link FormControlDirective}.
 *
 * This directive is designed to be used as a standalone control.  Unlike {\@link FormControlName},
 * it does not require that your {\@link FormControl} instance be part of any parent
 * {\@link FormGroup}, and it won't be registered to any {\@link FormGroupDirective} that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormControl} instance. See a full list of available properties in
 * {\@link AbstractControl}.
 *
 * **Set the value**: You can pass in an initial value when instantiating the {\@link FormControl},
 * or you can set it programmatically later using {\@link AbstractControl.setValue} or
 * {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 *  \@stable
 */
var FormControlDirective = (function (_super) {
    __extends(FormControlDirective, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this.update = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype.ngOnChanges = function (changes) {
        if (this._isControlChanged(changes)) {
            setUpControl(this.form, this);
            if (this.control.disabled && this.valueAccessor.setDisabledState) {
                this.valueAccessor.setDisabledState(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype._isControlChanged = function (changes) {
        return changes.hasOwnProperty('form');
    };
    return FormControlDirective;
}(NgControl));
FormControlDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
];
/**
 * @nocollapse
 */
FormControlDirective.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
FormControlDirective.propDecorators = {
    'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControl',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider$1 = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * \@whatItDoes Binds an existing {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive accepts an existing {\@link FormGroup} instance. It will then use this
 * {\@link FormGroup} instance to match any child {\@link FormControl}, {\@link FormGroup},
 * and {\@link FormArray} instances to child {\@link FormControlName}, {\@link FormGroupName},
 * and {\@link FormArrayName} directives.
 *
 * **Set value**: You can set the form's initial value when instantiating the
 * {\@link FormGroup}, or you can set it programmatically later using the {\@link FormGroup}'s
 * {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue} methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the {\@link FormGroup}'s {\@link AbstractControl.valueChanges} event.  You can also listen to
 * its {\@link AbstractControl.statusChanges} event to be notified when the validation status is
 * re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormGroupDirective = (function (_super) {
    __extends(FormGroupDirective, _super);
    /**
     * @param {?} _validators
     * @param {?} _asyncValidators
     */
    function FormGroupDirective(_validators, _asyncValidators) {
        var _this = _super.call(this) || this;
        _this._validators = _validators;
        _this._asyncValidators = _asyncValidators;
        _this._submitted = false;
        _this.directives = [];
        _this.form = null;
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    FormGroupDirective.prototype.ngOnChanges = function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addControl = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpControl(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeControl = function (dir) { remove(this.directives, dir); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormGroup = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormArray = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormArray = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormArray = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    FormGroupDirective.prototype.updateModel = function (dir, value) {
        var /** @type {?} */ ctrl = (this.form.get(dir.path));
        ctrl.setValue(value);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FormGroupDirective.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    FormGroupDirective.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroupDirective.prototype._updateDomValue = function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var /** @type {?} */ newCtrl = _this.form.get(dir.path);
            if (dir._control !== newCtrl) {
                cleanUpControl(dir._control, dir);
                if (newCtrl)
                    setUpControl(newCtrl, dir);
                dir._control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateRegistrations = function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateValidators = function () {
        var /** @type {?} */ sync = composeValidators(this._validators);
        this.form.validator = Validators.compose([this.form.validator, sync]);
        var /** @type {?} */ async = composeAsyncValidators(this._asyncValidators);
        this.form.asyncValidator = Validators.composeAsync([this.form.asyncValidator, async]);
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._checkFormPresent = function () {
        if (!this.form) {
            ReactiveErrors.missingFormException();
        }
    };
    return FormGroupDirective;
}(ControlContainer));
FormGroupDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[formGroup]',
                providers: [formDirectiveProvider$1],
                host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                exportAs: 'ngForm'
            },] },
];
/**
 * @nocollapse
 */
FormGroupDirective.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormGroupDirective.propDecorators = {
    'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroup',] },],
    'ngSubmit': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * @template T
 * @param {?} list
 * @param {?} el
 * @return {?}
 */
function remove(list, el) {
    var /** @type {?} */ index = list.indexOf(el);
    if (index > -1) {
        list.splice(index, 1);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formGroupNameProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormGroup} you want to link, and
 * will look for a {\@link FormGroup} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * **Access the group**: You can access the associated {\@link FormGroup} using the
 * {\@link AbstractControl.get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormGroup}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormGroup}, or you can set it programmatically later using
 * {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormGroupName = (function (_super) {
    __extends(FormGroupName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormGroupName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * \@internal
     * @return {?}
     */
    FormGroupName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.groupParentException();
        }
    };
    return FormGroupName;
}(AbstractFormGroupDirective));
FormGroupName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
];
/**
 * @nocollapse
 */
FormGroupName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormGroupName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroupName',] },],
};
var formArrayNameProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormArray} to a DOM element.
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormArray} you want to link, and
 * will look for a {\@link FormArray} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * **Access the array**: You can access the associated {\@link FormArray} using the
 * {\@link AbstractControl.get} method on the parent {\@link FormGroup}.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormArray}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormArray}, or you can set the value programmatically later using the
 * {\@link FormArray}'s {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the {\@link FormArray}'s {\@link AbstractControl.valueChanges} event.  You can also
 * listen to its {\@link AbstractControl.statusChanges} event to be notified when the validation
 * status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the {\@link FormArray} dynamically by
 * calling its {\@link FormArray.push} method.
 *  Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormArrayName = (function (_super) {
    __extends(FormArrayName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormArrayName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormArray(this);
    };
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.formDirective.getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? (this._parent.formDirective) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return composeAsyncValidators(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormArrayName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.arrayParentException();
        }
    };
    return FormArrayName;
}(ControlContainer));
FormArrayName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
];
/**
 * @nocollapse
 */
FormArrayName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormArrayName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formArrayName',] },],
};
/**
 * @param {?} parent
 * @return {?}
 */
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
        !(parent instanceof FormArrayName);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var controlNameBinding = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * \@whatItDoes Syncs a {\@link FormControl} in an existing {\@link FormGroup} to a form control
 * element by name.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the {\@link FormControl} instance you want to
 * link, and will look for a {\@link FormControl} registered with that name in the
 * closest {\@link FormGroup} or {\@link FormArray} above it.
 *
 * **Access the control**: You can access the {\@link FormControl} associated with
 * this directive by using the {\@link AbstractControl.get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the {\@link FormControl}.
 * See a full list of available properties in {\@link AbstractControl}.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  {\@link FormControl}, or you can set it programmatically later using
 *  {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormControlName = (function (_super) {
    __extends(FormControlName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this._added = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlName.prototype.ngOnChanges = function (changes) {
        if (!this._added)
            this._setUpControl();
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlName.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormControlName.prototype._checkParentType = function () {
        if (!(this._parent instanceof FormGroupName) &&
            this._parent instanceof AbstractFormGroupDirective) {
            ReactiveErrors.ngModelGroupException();
        }
        else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
            !(this._parent instanceof FormArrayName)) {
            ReactiveErrors.controlParentException();
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype._setUpControl = function () {
        this._checkParentType();
        this._control = this.formDirective.addControl(this);
        if (this.control.disabled && this.valueAccessor.setDisabledState) {
            this.valueAccessor.setDisabledState(true);
        }
        this._added = true;
    };
    return FormControlName;
}(NgControl));
FormControlName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
];
/**
 * @nocollapse
 */
FormControlName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
FormControlName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControlName',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
var CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxRequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * \@stable
 */
var RequiredValidator = (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        /**
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    RequiredValidator.prototype.validate = function (c) {
        return this.required ? Validators.required(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    return RequiredValidator;
}());
RequiredValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                providers: [REQUIRED_VALIDATOR],
                host: { '[attr.required]': 'required ? "" : null' }
            },] },
];
/**
 * @nocollapse
 */
RequiredValidator.ctorParameters = function () { return []; };
RequiredValidator.propDecorators = {
    'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * A Directive that adds the `required` validator to checkbox controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="checkbox" name="active" ngModel required>
 * ```
 *
 * \@experimental
 */
var CheckboxRequiredValidator = (function (_super) {
    __extends(CheckboxRequiredValidator, _super);
    function CheckboxRequiredValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CheckboxRequiredValidator.prototype.validate = function (c) {
        return this.required ? Validators.requiredTrue(c) : null;
    };
    return CheckboxRequiredValidator;
}(RequiredValidator));
CheckboxRequiredValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                providers: [CHECKBOX_REQUIRED_VALIDATOR],
                host: { '[attr.required]': 'required ? "" : null' }
            },] },
];
/**
 * @nocollapse
 */
CheckboxRequiredValidator.ctorParameters = function () { return []; };
/**
 * Provider which adds {@link EmailValidator} to {@link NG_VALIDATORS}.
 */
var EMAIL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return EmailValidator; }),
    multi: true
};
/**
 * A Directive that adds the `email` validator to controls marked with the
 * `email` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="email" name="email" ngModel email>
 * <input type="email" name="email" ngModel email="true">
 * <input type="email" name="email" ngModel [email]="true">
 * ```
 *
 * \@experimental
 */
var EmailValidator = (function () {
    function EmailValidator() {
    }
    Object.defineProperty(EmailValidator.prototype, "email", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._enabled = value === '' || value === true || value === 'true';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    EmailValidator.prototype.validate = function (c) {
        return this._enabled ? Validators.email(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmailValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    return EmailValidator;
}());
EmailValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[email][formControlName],[email][formControl],[email][ngModel]',
                providers: [EMAIL_VALIDATOR]
            },] },
];
/**
 * @nocollapse
 */
EmailValidator.ctorParameters = function () { return []; };
EmailValidator.propDecorators = {
    'email': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='min'}
 */
var MIN_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MinLengthValidator} for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * \@stable
 */
var MinLengthValidator = (function () {
    function MinLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MinLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MinLengthValidator.prototype.validate = function (c) {
        return this.minlength == null ? null : this._validator(c);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MinLengthValidator.prototype._createValidator = function () {
        this._validator = Validators.minLength(parseInt(this.minlength, 10));
    };
    return MinLengthValidator;
}());
MinLengthValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                providers: [MIN_LENGTH_VALIDATOR],
                host: { '[attr.minlength]': 'minlength ? minlength : null' }
            },] },
];
/**
 * @nocollapse
 */
MinLengthValidator.ctorParameters = function () { return []; };
MinLengthValidator.propDecorators = {
    'minlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='max'}
 */
var MAX_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MaxLengthValidator} for any `formControlName,
 * `formControl`,
 * or control with `ngModel` that also has a `maxlength` attribute.
 *
 * \@stable
 */
var MaxLengthValidator = (function () {
    function MaxLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MaxLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MaxLengthValidator.prototype.validate = function (c) {
        return this.maxlength != null ? this._validator(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MaxLengthValidator.prototype._createValidator = function () {
        this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
    };
    return MaxLengthValidator;
}());
MaxLengthValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                providers: [MAX_LENGTH_VALIDATOR],
                host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
            },] },
];
/**
 * @nocollapse
 */
MaxLengthValidator.ctorParameters = function () { return []; };
MaxLengthValidator.propDecorators = {
    'maxlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var PATTERN_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the {\@link NG_VALIDATORS} binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 * \@stable
 */
var PatternValidator = (function () {
    function PatternValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    PatternValidator.prototype.ngOnChanges = function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
    /**
     * @param {?} fn
     * @return {?}
     */
    PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
    return PatternValidator;
}());
PatternValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                providers: [PATTERN_VALIDATOR],
                host: { '[attr.pattern]': 'pattern ? pattern : null' }
            },] },
];
/**
 * @nocollapse
 */
PatternValidator.ctorParameters = function () { return []; };
PatternValidator.propDecorators = {
    'pattern': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Creates an {\@link AbstractControl} from a user-specified configuration.
 *
 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
 * forms.
 *
 * \@howToUse
 *
 * To use, inject `FormBuilder` into your component class. You can then call its methods
 * directly.
 *
 * {\@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  * **NgModule**: {\@link ReactiveFormsModule}
 *
 * \@stable
 */
var FormBuilder = (function () {
    function FormBuilder() {
    }
    /**
     * Construct a new {\@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {\@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    FormBuilder.prototype.group = function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var /** @type {?} */ controls = this._reduceControls(controlsConfig);
        var /** @type {?} */ validator = extra != null ? extra['validator'] : null;
        var /** @type {?} */ asyncValidator = extra != null ? extra['asyncValidator'] : null;
        return new FormGroup(controls, validator, asyncValidator);
    };
    /**
     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        return new FormControl(formState, validator, asyncValidator);
    };
    /**
     * Construct a {\@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new FormArray(controls, validator, asyncValidator);
    };
    /**
     * \@internal
     * @param {?} controlsConfig
     * @return {?}
     */
    FormBuilder.prototype._reduceControls = function (controlsConfig) {
        var _this = this;
        var /** @type {?} */ controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /**
     * \@internal
     * @param {?} controlConfig
     * @return {?}
     */
    FormBuilder.prototype._createControl = function (controlConfig) {
        if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
            controlConfig instanceof FormArray) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var /** @type {?} */ value = controlConfig[0];
            var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    return FormBuilder;
}());
FormBuilder.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
FormBuilder.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('4.0.1');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Adds `novalidate` attribute to all forms by default.
 *
 * `novalidate` is used to disable browser's native form validation.
 *
 * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
 *
 * ```
 * <form ngNativeValidate></form>
 * ```
 *
 * \@experimental
 */
var NgNoValidate = (function () {
    function NgNoValidate() {
    }
    return NgNoValidate;
}());
NgNoValidate.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
                host: { 'novalidate': '' },
            },] },
];
/**
 * @nocollapse
 */
NgNoValidate.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SHARED_FORM_DIRECTIVES = [
    NgNoValidate,
    NgSelectOption,
    NgSelectMultipleOption,
    DefaultValueAccessor,
    NumberValueAccessor,
    RangeValueAccessor,
    CheckboxControlValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
    NgControlStatus,
    NgControlStatusGroup,
    RequiredValidator,
    MinLengthValidator,
    MaxLengthValidator,
    PatternValidator,
    CheckboxRequiredValidator,
    EmailValidator,
];
var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = (function () {
    function InternalFormsSharedModule() {
    }
    return InternalFormsSharedModule;
}());
InternalFormsSharedModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: SHARED_FORM_DIRECTIVES,
                exports: SHARED_FORM_DIRECTIVES,
            },] },
];
/**
 * @nocollapse
 */
InternalFormsSharedModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The ng module for forms.
 * \@stable
 */
var FormsModule = (function () {
    function FormsModule() {
    }
    return FormsModule;
}());
FormsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: TEMPLATE_DRIVEN_DIRECTIVES,
                providers: [RadioControlRegistry],
                exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
            },] },
];
/**
 * @nocollapse
 */
FormsModule.ctorParameters = function () { return []; };
/**
 * The ng module for reactive forms.
 * \@stable
 */
var ReactiveFormsModule = (function () {
    function ReactiveFormsModule() {
    }
    return ReactiveFormsModule;
}());
ReactiveFormsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: [REACTIVE_DRIVEN_DIRECTIVES],
                providers: [FormBuilder, RadioControlRegistry],
                exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
            },] },
];
/**
 * @nocollapse
 */
ReactiveFormsModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * This module is used for handling user input, by defining and building a {@link FormGroup} that
 * consists of {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl}
 * objects can then be used to read information from the form DOM elements.
 *
 * Forms providers are not included in default providers; you must import these providers
 * explicitly.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the forms package.
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=forms.es5.js.map


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var services_1 = __webpack_require__(139);
__export(__webpack_require__(139));
exports.ANGULAR2_COOKIE_PROVIDERS = [
    { provide: services_1.CookieOptions, useClass: services_1.BaseCookieOptions },
    { provide: services_1.CookieService, useFactory: cookieServiceFactory, deps: [services_1.CookieOptions] }
];
function cookieServiceFactory(options) {
    return new services_1.CookieService(options);
}
exports.cookieServiceFactory = cookieServiceFactory;

//# sourceMappingURL=core.js.map


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__(23);
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var AppComponent = (function () {
    function AppComponent(route, eventService, userService) {
        this.route = route;
        this.eventService = eventService;
        this.userService = userService;
    }
    AppComponent.prototype.hideModals = function ($event) {
        if ($event && $event.keyCode !== 27) {
            if ($event.keyCode === 8) {
                $event.preventDefault();
            }
            return;
        }
        this.eventService.fire('hideModals');
    };
    AppComponent.prototype.syncOnFocus = function () {
        this.userService.sync();
    };
    AppComponent.prototype.ngOnInit = function () {
        this.subscribeOnEvents();
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    AppComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionHideScrollEvent
            = this.eventService.subscribe('hideScroll', function () { return _this.hideScroll(); });
        this.subscriptionShowScrollEvent
            = this.eventService.subscribe('showScroll', function () { return _this.showScroll(); });
    };
    AppComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionHideScrollEvent.unsubscribe();
        this.subscriptionShowScrollEvent.unsubscribe();
    };
    AppComponent.prototype.hideScroll = function () {
        document.body.classList.add('scroll-hidden');
    };
    AppComponent.prototype.showScroll = function () {
        document.body.classList.remove('scroll-hidden');
    };
    return AppComponent;
}());
__decorate([
    core_1.HostListener('document:keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], AppComponent.prototype, "hideModals", null);
__decorate([
    core_1.HostListener('window:focus'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AppComponent.prototype, "syncOnFocus", null);
AppComponent = __decorate([
    core_1.Component({
        selector: 'app-component',
        template: __webpack_require__(1039),
        styles: [__webpack_require__(428)]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        services_1.EventService,
        services_1.UserService])
], AppComponent);
exports.AppComponent = AppComponent;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var router_1 = __webpack_require__(23);
var constants_1 = __webpack_require__(43);
var HeaderComponent = (function () {
    function HeaderComponent(activatedRoute, eventService, localizationService, progressService, packLevelService) {
        this.activatedRoute = activatedRoute;
        this.eventService = eventService;
        this.localizationService = localizationService;
        this.progressService = progressService;
        this.packLevelService = packLevelService;
        this.RETINA = constants_1.RETINA;
        this.interfaceLocals = {};
    }
    HeaderComponent.prototype.ngOnInit = function () {
        this.renderInterfaceLocals();
        this.subscribeOnEvents();
        this.renderStarsData();
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    HeaderComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionChangeLocalsEvent = this.eventService.subscribe('changeLocals', function () {
            _this.renderInterfaceLocals();
        });
        this.subscriptionGetStarsProgressEvent = this.eventService.subscribe('getStarsProgress', function (stars) {
            if (stars) {
                _this.starsData = stars;
                return;
            }
            _this.renderStarsData();
        });
    };
    HeaderComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionChangeLocalsEvent.unsubscribe();
        this.subscriptionGetStarsProgressEvent.unsubscribe();
    };
    HeaderComponent.prototype.renderStarsData = function () {
        this.starsData = [this.progressService.totalStarsEarned(), this.packLevelService.totalStars()];
    };
    HeaderComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.currentLangLinkAppStore = _this.localizationService.currentLangLinkAppStore;
            _this.currentLang = _this.localizationService.currentLang;
        });
    };
    HeaderComponent.prototype.showModalComponent = function () {
        this.eventService.fire('showModalComponent');
        this.eventService.fire('hideScroll');
    };
    return HeaderComponent;
}());
HeaderComponent = __decorate([
    core_1.Component({
        selector: 'header-component',
        template: __webpack_require__(1040),
        styles: [__webpack_require__(429)]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        services_1.EventService,
        services_1.LocalizationService,
        services_1.ProgressService,
        services_1.PackLevelService])
], HeaderComponent);
exports.HeaderComponent = HeaderComponent;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var router_1 = __webpack_require__(23);
var http_1 = __webpack_require__(53);
var config_1 = __webpack_require__(253);
var constants_1 = __webpack_require__(43);
var toolKeys = __webpack_require__(1333);
var services_1 = __webpack_require__(11);
var canvasRender_1 = __webpack_require__(258);
var gameView_1 = __webpack_require__(254);
var Module = window.Module;
var LevelComponent = (function () {
    function LevelComponent(activatedRoute, router, http, renderer, packLevelService, localizationService, progressService, resourcePreloaderService, eventService, storageService, userService) {
        var _this = this;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.http = http;
        this.renderer = renderer;
        this.packLevelService = packLevelService;
        this.localizationService = localizationService;
        this.progressService = progressService;
        this.resourcePreloaderService = resourcePreloaderService;
        this.eventService = eventService;
        this.storageService = storageService;
        this.userService = userService;
        this.sendSolutionUrl = config_1.SEND_SOLUTION_URL;
        this.sendBestSolutionUrl = config_1.SEND_BEST_SOLUTION_URL;
        this.currentLang = this.localizationService.currentLang;
        this.currentLangLinkAppStore = this.localizationService.currentLangLinkAppStore;
        this.urlPartPath = constants_1.RETINA ? '2x/retina_' : '1x/';
        this.RETINA = constants_1.RETINA;
        this.canUndo = false;
        this.canRedo = false;
        this.exploreActive = false;
        this.shouldShowResult = true;
        this.shouldShowVStar = false;
        this.isMoveToolTutorial = false;
        this.needLevelDetailOpen = true;
        this.isLevelDecoded = false;
        this.lMoves = 0;
        this.eMoves = 0;
        this.starsResult = {};
        this.justEarnedStars = {};
        this.tools = [];
        this.toolsLocals = {};
        this.hotKeysLocals = {};
        this.rootLevelUrl = this.localizationService.getRootUrlForLevel();
        this.browser = (function () {
            var ua = navigator.userAgent;
            var tem;
            var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null)
                    return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null)
                M.splice(1, 1, tem[1]);
            return M.join(' ');
        })();
        this.interfaceCalculation = function (resized) {
            this.render.wrapper.style.width = window.innerWidth + 'px';
            this.render.wrapper.style.height = window.innerHeight + 'px';
            this.render.canvas.width = window.innerWidth;
            this.render.canvas.height = window.innerHeight;
            if (this.gameView) {
                this.gameView.gameControl.setViewSize(this.render.canvas.width, this.render.canvas.height);
                this.render.renderFigures();
            }
            var counter = document.getElementById('moves-counter-wrapper');
            var counterWidth = counter.clientWidth > 53 ? counter.clientWidth : 53;
            counter.style.left = (window.innerWidth / 2 - counterWidth / 2) + 'px';
        }.bind(this);
        this.localizationService.toolsLocals.then(function (result) {
            _this.toolsLocals = result;
        });
        this.localizationService.hotKeysLocals.then(function (result) {
            _this.hotKeysLocals = result;
        });
    }
    LevelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscribeOnEvents();
        this.subscriptionRouter = this.activatedRoute.params.subscribe(function (params) {
            _this.starsResult = {};
            _this.justEarnedStars = {};
            _this.levelId = params.levelId;
            _this.levelId = _this.packLevelService.levelIdsByNumbers[_this.levelId] || _this.levelId;
            _this.level = _this.packLevelService.levels[_this.levelId];
            _this.isLevelDecoded = false;
            _this.imageUrl = __webpack_require__(231)("./" + (_this.urlPartPath + _this.levelId) + "Detailed.png");
            _this.canUndo = false;
            _this.canRedo = false;
            _this.exploreActive = false;
            _this.shouldShowResult = true;
            _this.shouldShowVStar = false;
            _this.shouldShowVHelp = false;
            _this.isMoveToolTutorial = false;
            _this.needLevelDetailOpen = true;
            _this.tutorial = _this.level.tutorial;
            _this.packNumber = _this.level.packNumber;
            _this.levelNumber = _this.level.levelNumber;
            _this.goalLineMoves = _this.level.goalLineMoves;
            _this.goalElementaryMoves = _this.level.goalElementaryMoves;
            _this.pack = _this.packLevelService.packWithLevelId(_this.levelId);
            _this.isMoveToolTutorial = _this.level.levelId == _this.packLevelService.GM_MOVE_TOOL_TUTORIAL_LEVEL_ID;
            _this.isLevelLocked = _this.progressService.isLevelLocked(_this.levelId);
            _this.needLevelDetailOpen = _this.progressService.playedLevels.indexOf(_this.levelId) == -1;
            _this.nextLevelId = _this.packLevelService.nextLevelId(_this.levelId);
            _this.nextLevelIsLocked = _this.progressService.isLevelLocked(_this.nextLevelId);
            _this.nextPackForLevel = _this.packLevelService.packWithLevelId(_this.nextLevelId);
            _this.prevLevelId = _this.packLevelService.previousLevelId(_this.levelId);
            _this.prevLevelIsLocked = _this.progressService.isLevelLocked(_this.prevLevelId);
            _this.prevPackForLevel = _this.packLevelService.packWithLevelId(_this.prevLevelId);
            _this.levelResult = _this.progressService.levelsResults[_this.levelId];
            _this.setFoundVariants();
            _this.setStarsResult();
            if (!_this.render) {
                _this.render = new canvasRender_1.CanvasRender('scene_wrapper');
            }
            _this.setTitleInHead();
            //Star results
            _this.init();
        });
    };
    LevelComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
        if (this.render) {
            this.render.remove();
        }
        window.removeEventListener('resize', this.interfaceCalculation);
    };
    LevelComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionNextLevelEvent = this.eventService.subscribe('nextLevel', function () { return _this.goToNextLevel(); });
        this.subscriptionLevelScreenEvent = this.eventService.subscribe('levelScreen', function () { return _this.goToLevelsScreen(); });
        this.subscriptionRestartEvent = this.eventService.subscribe('restart', function () { return _this.restart(); });
        this.subscriptionHintCheckerEvent = this.eventService.subscribe('hintChecker', function () { return _this.hintChecker(); });
        this.subscriptionProgressSyncEvent = this.eventService.subscribe('progressSynced', function () {
            _this.setFoundVariants();
            _this.setStarsResult();
        });
    };
    LevelComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionRouter.unsubscribe();
        this.subscriptionNextLevelEvent.unsubscribe();
        this.subscriptionLevelScreenEvent.unsubscribe();
        this.subscriptionRestartEvent.unsubscribe();
        this.subscriptionHintCheckerEvent.unsubscribe();
    };
    LevelComponent.prototype.undoRedo = function ($event) {
        if (this.isLocked || this.levelSuccessOpen) {
            return;
        }
        var char = String.fromCharCode($event.charCode).toLowerCase();
        if (char === 'z' || $event.charCode === 26 || $event.code === 'KeyZ') {
            if (!$event.shiftKey && $event.ctrlKey) {
                if (this.isCanUndo()) {
                    this.undo();
                    return;
                }
            }
            else if ($event.shiftKey && $event.ctrlKey) {
                if (this.isCanRedo()) {
                    this.redo();
                    return;
                }
            }
        }
        for (var i = toolKeys.length; i--;) {
            var el = toolKeys[i];
            if (el.chars && el.chars.indexOf(char) > -1) {
                this.createEvent(el.tool);
                break;
            }
        }
    };
    LevelComponent.prototype.keyUpHandler = function ($event) {
        if ($event.keyCode === 33) {
            this.gameView.scaleField(1, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateBegan);
            this.gameView.scaleField(1.1, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateChanged);
            this.gameView.scaleField(1.1, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateEnded);
            return;
        }
        if ($event.keyCode === 34) {
            this.gameView.scaleField(1, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateBegan);
            this.gameView.scaleField(0.9, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateChanged);
            this.gameView.scaleField(0.9, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateEnded);
            return;
        }
    };
    LevelComponent.prototype.createEvent = function (tool) {
        if (this.tools.indexOf(tool) !== -1) {
            this.setToolType(tool);
        }
    };
    LevelComponent.prototype.showModalDescription = function () {
        this.eventService.fire('showModalDescription');
    };
    LevelComponent.prototype.showModalHelp = function () {
        this.eventService.fire('showModalHelp', true);
    };
    LevelComponent.prototype.showModalSuccess = function () {
        this.lockScene();
        if (!this.levelResult.justEarnedStars.length) {
            this.renderOldStars();
        }
        else if (this.levelResult.justEarnedStars.length < Object.keys(this.starsResult).length) {
            this.animateRestStars();
        }
        this.startAnimateStars();
    };
    LevelComponent.prototype.disablePointerEvents = function () {
        this.renderer.addClass(document.body, 'disable');
    };
    LevelComponent.prototype.enablePointerEvents = function () {
        this.renderer.removeClass(document.body, 'disable');
    };
    LevelComponent.prototype.showModalHelpAddon = function () {
        this.eventService.fire('showModalHelpAddon');
    };
    LevelComponent.prototype.showModalHelpAddonCircle = function () {
        this.eventService.fire('showModalHelpAddonCircle');
    };
    LevelComponent.prototype.showModalHintExplore = function () {
        this.eventService.fire('showModalHintExplore');
    };
    LevelComponent.prototype.setFoundVariants = function () {
        this.foundVariantsCount = this.levelResult && this.levelResult.v_count;
    };
    LevelComponent.prototype.lockScene = function () {
        this.render.lockScene(true);
        this.isLocked = true;
        this.disablePointerEvents();
    };
    LevelComponent.prototype.renderOldStars = function () {
        for (var star in this.starsResult) {
            this.justEarnedStars[star] = star;
        }
    };
    LevelComponent.prototype.animateRestStars = function () {
        var oldResultObject = {};
        var levelResultObject = {};
        for (var _i = 0, _a = this.levelResult.justEarnedStars; _i < _a.length; _i++) {
            var star = _a[_i];
            levelResultObject[star] = star;
        }
        for (var star in this.starsResult) {
            if (!levelResultObject[star]) {
                this.justEarnedStars[star] = star;
            }
        }
    };
    LevelComponent.prototype.startAnimateStars = function () {
        var _this = this;
        setTimeout(function () {
            _this.render.lockScene(false);
            _this.levelSuccessOpen = true;
            _this.isLocked = false;
            _this.enablePointerEvents();
            _this.eventService.fire('showModalSuccess');
            var iteratorStars = _this.levelResult.justEarnedStars[Symbol.iterator]();
            var i = 0;
            var interval = setInterval(function () {
                if (i === 2) {
                    clearInterval(interval);
                }
                var propStar = iteratorStars.next().value;
                _this.justEarnedStars[propStar] = propStar;
                i++;
            }, 300);
        }, 1500);
    };
    LevelComponent.prototype.clear = function () {
        localStorage.clear();
        location.reload();
    };
    LevelComponent.prototype.hintChecker = function () {
        var shouldShowHint = false;
        if (this.levelId === 'CircleCenter') {
            var circleHintAlreadyShown = JSON.parse(this.storageService.get('CircleHintAlreadyShown'));
            if (!circleHintAlreadyShown) {
                shouldShowHint = true;
            }
        }
        this.levelSuccessOpen = false;
        if (this.shouldShowVHelp) {
            this.showModalHelpAddon();
            this.shouldShowVHelp = false;
        }
        if (shouldShowHint) {
            this.showModalHelpAddonCircle();
        }
    };
    LevelComponent.prototype.init = function () {
        var _this = this;
        this.http.get(__webpack_require__(1328)("./" + this.levelId + ".gmt"))
            .subscribe(function (data) {
            var gameControl = _this.packLevelService.gameControl;
            gameControl.setStyleFile(_this.resourcePreloaderService.styles, Module.GMGameViewRenderStyle.GMStandartRenderStyle);
            if (!_this.gameView) {
                _this.gameView = new gameView_1.GameView(gameControl, _this.render, _this);
                window.addEventListener('resize', _this.interfaceCalculation);
            }
            _this.loadToolPanel(true);
            _this.interfaceCalculation(true);
            _this.gameView.decodeTaskWithFormatWithUndoList(data.text(), Module.GMTaskFormat.GMGeomTaskFormat, false);
            _this.isLevelDecoded = true;
            _this.progressService.setLastPlayedLevelId(_this.levelId);
            _this.setToolType(_this.defaultToolType());
            _this.render.renderFigures();
        });
    };
    LevelComponent.prototype.setStarsResult = function () {
        if (this.levelResult && this.levelResult.stars.length != 0) {
            var resultStars = this.levelResult.stars;
            for (var i = 0; i < resultStars.length; i++) {
                this.starsResult[resultStars[i]] = resultStars[i];
            }
        }
    };
    LevelComponent.prototype.setTitleInHead = function () {
        var _this = this;
        this.localizationService.levelLocals
            .then(function (locals) {
            _this.localizationService.setTitleInHead(locals[_this.levelId].title);
        });
    };
    LevelComponent.prototype.loadToolPanel = function (isForcePlayMode) {
        if (this.gameView.gameMode() == Module.GMGameMode.GMPlayMode || isForcePlayMode) {
            this.tools = this.progressService.toolTypesAvailableForLevel(this.levelId);
        }
        else {
            this.tools = this.progressService.toolTypesAvailableForExploreForLevel(this.levelId);
        }
    };
    LevelComponent.prototype.setToolType = function (toolId) {
        this.gameView.setToolType(toolId);
    };
    LevelComponent.prototype.toolType = function () {
        return this.gameView.toolType();
    };
    LevelComponent.prototype.getToolTitle = function (toolId) {
        if (this.toolsLocals[toolId] && this.hotKeysLocals[toolId]) {
            return this.toolsLocals[toolId].title + ' (' + this.hotKeysLocals[toolId] + ')';
        }
        else {
            return '';
        }
    };
    LevelComponent.prototype.defaultToolType = function () {
        var availableTypes = this.progressService.toolTypesAvailableForLevel(this.levelId);
        if (availableTypes.length == 0) {
            return null;
        }
        else if (availableTypes.length == 1) {
            return availableTypes[0];
        }
        else if (availableTypes.indexOf('CircleTool') != -1) {
            return 'CircleTool';
        }
        else if (this.level.allowedToolTypes != null && this.level.allowedToolTypes.length > 0) {
            return this.level.allowedToolTypes[0];
        }
        return availableTypes[0];
    };
    LevelComponent.prototype.notifyTouchScreen = function (status) {
    };
    LevelComponent.prototype.notifyChangeUndoStatus = function () {
        this.canUndo = this.isCanUndo();
    };
    LevelComponent.prototype.notifyChangeRedoStatus = function () {
        this.canRedo = this.isCanRedo();
    };
    LevelComponent.prototype.isCanUndo = function () {
        return this.gameView.isCanUndo();
    };
    LevelComponent.prototype.isCanRedo = function () {
        return this.gameView.isCanRedo();
    };
    LevelComponent.prototype.notifyChangeTaskStatus = function () {
        if (this.isMoveToolTutorial) {
            return;
        }
        if (this.gameView.solved() != Module.GMSolvedStatus.GMNoSolution) {
            this.handleResult();
        }
    };
    LevelComponent.prototype.notifyChangeGameMode = function () {
    };
    LevelComponent.prototype.notifyChangeCursor = function (status) {
        if (status) {
            this.render.wrapper.style.cursor != 'move' ? this.render.wrapper.style.cursor = 'pointer' : '';
        }
        else {
            this.render.wrapper.style.cursor != 'move' ? this.render.wrapper.style.cursor = 'default' : '';
        }
    };
    LevelComponent.prototype.notifyMovePoint = function () {
        if (!this.isMoveToolTutorial) {
            return;
        }
        if (this.shouldShowResult) {
            this.handleResult();
        }
    };
    LevelComponent.prototype.notifyChangeMoveCount = function () {
        this.updateMoveLabel();
    };
    LevelComponent.prototype.handleResult = function () {
        if (!this.isLevelDecoded) {
            return;
        }
        if (this.gameView.gameMode == Module.GMGameMode.GM_EXPLORE_MODE) {
            return;
        }
        var needToSend = false;
        var levelResult = {};
        levelResult.levelId = this.level.levelId;
        levelResult.date = (new Date()).toISOString();
        levelResult.e_moves = this.gameView.elementaryMovesCount();
        levelResult.l_moves = this.gameView.lineMovesCount();
        var solved = this.gameView.solved();
        switch (solved.value) {
            case Module.GMSolvedStatus.GMNoSolution.value:
                levelResult.v_count = 0;
                break;
            case Module.GMSolvedStatus.GMOneSolution.value:
                levelResult.v_count = 1;
                break;
            case Module.GMSolvedStatus.GMAllSolution.value:
                levelResult.v_count = this.level.variantsCount;
                break;
            default:
                break;
        }
        levelResult.stars = this.level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(levelResult.e_moves, levelResult.l_moves, levelResult.v_count);
        levelResult.encodedHints = '';
        var bestResult = this.progressService.levelsResults[this.level.levelId];
        if (bestResult && bestResult.v_count === undefined) {
            bestResult.v_count = 1;
        }
        if (bestResult == undefined) {
            if (!this.isLevelLocked) {
                needToSend = true;
            }
        }
        else if (bestResult.e_moves > levelResult.e_moves || bestResult.l_moves > levelResult.l_moves || bestResult.v_count < levelResult.v_count) {
            needToSend = true;
            if (!this.shouldShowResult) {
                this.shouldShowResult = true;
            }
            if (bestResult.v_count < levelResult.v_count) {
                this.shouldShowVStar = true;
            }
        }
        if (this.isLevelLocked) {
            this.shouldShowResult = false;
            if (this.levelResult == null) {
                needToSend = true;
                this.shouldShowResult = true;
                this.levelResult = levelResult;
                this.levelResult.justEarnedStars = levelResult.stars;
            }
            else {
                bestResult = this.levelResult;
                this.fakeRegisterResultForLevel(levelResult);
                if (bestResult.e_moves > levelResult.e_moves || bestResult.l_moves > levelResult.l_moves || bestResult.v_count < levelResult.v_count) {
                    this.shouldShowResult = true;
                    needToSend = true;
                }
            }
            if (this.levelResult.v_count < levelResult.v_count) {
                this.levelResult.v_count = levelResult.v_count;
                this.shouldShowVStar = true;
            }
        }
        else {
            this.progressService.registerResultForLevel(levelResult, this.level.levelId);
            this.levelResult = this.progressService.levelsResults[this.level.levelId];
            this.levelResult.justEarnedStars = levelResult.justEarnedStars;
        }
        if (needToSend) {
            if (this.storageService.get('userToken')) {
                this.sendBestSolution(levelResult);
            }
            this.sendSolution(levelResult);
        }
        if (this.shouldShowResult) {
            this.setFoundVariants();
            this.setStarsResult();
            this.showModalSuccess();
            this.shouldShowResult = false;
            this.nextLevelIsLocked = this.progressService.isLevelLocked(this.nextLevelId);
            if (this.levelId == 'TEquilateral' && this.levelResult && this.levelResult.stars.indexOf('GM_STAR_TYPE_V') == -1) {
                this.shouldShowVHelp = true;
            }
        }
    };
    LevelComponent.prototype.sendSolution = function (levelResult) {
        var version = this.progressService.sharedPreferences[this.progressService.GM_APP_VERSION_STR];
        var requestParameters = {
            app_version: version.charAt(0) == 'v' ? version.slice(1) : version,
            level_id: levelResult.levelId,
            date: levelResult.date,
            lang: navigator.browserLanguage || navigator.language || navigator.userLanguage || this.currentLang,
            gmt: this.gameView.encodeTaskWithUndoList(true),
            e_moves: levelResult.e_moves,
            l_moves: levelResult.l_moves,
            v_count: levelResult.v_count,
            stars: this.levelResult.stars.length,
            app: 'BrowserGeom',
            browser: this.browser
        };
        this.httpPost(this.sendSolutionUrl, requestParameters);
        this.userService.sync();
    };
    LevelComponent.prototype.sendBestSolution = function (levelResult) {
        var requestParameters = {
            level_id: levelResult.levelId,
            date: levelResult.date,
            encoded_solution: this.gameView.encodeTaskWithUndoList(true),
            e_moves: levelResult.e_moves,
            l_moves: levelResult.l_moves,
            v_count: levelResult.v_count
        };
        this.httpPost(this.sendBestSolutionUrl + "?token=" + this.storageService.get('userToken'), requestParameters);
    };
    LevelComponent.prototype.httpPost = function (url, params) {
        this.http.post(url, params)
            .toPromise()
            .catch(function (error) {
            console.error('Server error');
        });
    };
    LevelComponent.prototype.fakeRegisterResultForLevel = function (levelResult) {
        var stars = levelResult.stars.slice();
        for (var _i = 0, _a = this.levelResult.stars; _i < _a.length; _i++) {
            var exStar = _a[_i];
            if (stars.indexOf(exStar) == -1) {
                stars.push(exStar);
            }
        }
        var newStars = levelResult.stars.slice();
        for (var _b = 0, _c = this.levelResult.stars; _b < _c.length; _b++) {
            var curStar = _c[_b];
            if (newStars.indexOf(curStar) > -1) {
                newStars.splice(newStars.indexOf(curStar), 1);
            }
        }
        this.levelResult.stars = stars;
        this.levelResult.justEarnedStars = newStars;
    };
    LevelComponent.prototype.updateMoveLabel = function () {
        this.lMoves = this.gameView.lineMovesCount();
        this.eMoves = this.gameView.elementaryMovesCount();
    };
    LevelComponent.prototype.undo = function () {
        if (this.isLocked) {
            return;
        }
        this.gameView.undo();
    };
    LevelComponent.prototype.redo = function () {
        if (this.isLocked) {
            return;
        }
        this.gameView.redo();
    };
    LevelComponent.prototype.restart = function () {
        if (this.isLocked || this.shouldShowVHelp) {
            return;
        }
        this.init();
        this.gameView.restart();
        this.updateViewsDependsOnMode();
    };
    LevelComponent.prototype.goToNextLevel = function () {
        if (this.isLocked || this.shouldShowVHelp) {
            return;
        }
        this.router.navigate([this.rootLevelUrl, this.nextPackForLevel.packId, 'level', this.nextLevelId]);
    };
    LevelComponent.prototype.goToPrevLevel = function () {
        if (this.isLocked || this.shouldShowVHelp) {
            return;
        }
        this.router.navigate([this.rootLevelUrl, this.prevPackForLevel.packId, 'level', this.prevLevelId]);
    };
    LevelComponent.prototype.goToLevelsScreen = function () {
        if (this.isLocked || this.shouldShowVHelp) {
            return;
        }
        this.router.navigate([this.rootLevelUrl, this.pack.packId]);
    };
    LevelComponent.prototype.updateViewsDependsOnMode = function () {
        this.loadToolPanel(false);
        this.setToolType(this.defaultToolType());
        this.exploreActive = this.gameView.gameMode() == Module.GMGameMode.GMExploreMode;
    };
    LevelComponent.prototype.toggleExploreMode = function () {
        if (this.isLocked) {
            return;
        }
        if (this.gameView.gameMode() == Module.GMGameMode.GMPlayMode) {
            this.turnOnExploreMode();
        }
        else {
            this.turnOffExploreMode();
        }
        this.updateViewsDependsOnMode();
    };
    LevelComponent.prototype.turnOnExploreMode = function () {
        this.gameView.setGameMode(Module.GMGameMode.GMExploreMode);
        var exploreModeAlreadyShown = JSON.parse(this.storageService.get('ExploreModeAlreadyShown'));
        if (!exploreModeAlreadyShown) {
            this.eventService.fire('showModalHintExplore');
        }
    };
    LevelComponent.prototype.turnOffExploreMode = function () {
        this.gameView.setGameMode(Module.GMGameMode.GMPlayMode);
    };
    return LevelComponent;
}());
__decorate([
    core_1.HostListener('document:keypress', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], LevelComponent.prototype, "undoRedo", null);
__decorate([
    core_1.HostListener('document:keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], LevelComponent.prototype, "keyUpHandler", null);
LevelComponent = __decorate([
    core_1.Component({
        selector: 'level-component',
        template: __webpack_require__(1041),
        styles: [__webpack_require__(430)]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        router_1.Router,
        http_1.Http,
        core_1.Renderer2,
        services_1.PackLevelService,
        services_1.LocalizationService,
        services_1.ProgressService,
        services_1.ResourcePreloaderService,
        services_1.EventService,
        services_1.StorageService,
        services_1.UserService])
], LevelComponent);
exports.LevelComponent = LevelComponent;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var router_1 = __webpack_require__(23);
var services_1 = __webpack_require__(11);
var constants_1 = __webpack_require__(43);
var LevelsBoxComponent = (function () {
    function LevelsBoxComponent(activatedRoute, router, packLevelService, localizationService, eventService, progressService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.packLevelService = packLevelService;
        this.localizationService = localizationService;
        this.eventService = eventService;
        this.progressService = progressService;
        this.retina = constants_1.RETINA;
    }
    LevelsBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.renderInterfaceLocals()
            .then(function () {
            _this.routerSubscribe();
            _this.subscribeOnEvents();
            _this.setRouterLink();
        });
    };
    LevelsBoxComponent.prototype.ngOnDestroy = function () {
        this.setTitleInHead();
        this.eventService.fire('getStarsProgress');
        this.unSubscribeFromEvents();
    };
    LevelsBoxComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionChangeLocalsEvent = this.eventService.subscribe('changeLocals', function () {
            _this.setRouterLink();
            _this.renderInterfaceLocals()
                .then(function () {
                _this.setTitleInHead(_this.interfaceLocals[_this.packId]);
            });
            _this.renderLevelInfos();
            _this.setPrevNextLinks();
        });
        this.subscriptionProgressSyncEvent = this.eventService.subscribe('progressSynced', function () {
            _this.localizationService.interfaceLocals
                .then(function () {
                _this.assignStats();
                _this.renderLevelInfos();
                _this.getStarsProgress();
            });
        });
    };
    LevelsBoxComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionChangeLocalsEvent.unsubscribe();
        this.subscriptionRouter.unsubscribe();
    };
    LevelsBoxComponent.prototype.renderLevelInfos = function () {
        var _this = this;
        this.localizationService.levelLocals
            .then(function (levels) {
            _this.levelLocals = levels;
            var levelOptions = [];
            for (var _i = 0, _a = _this.levels; _i < _a.length; _i++) {
                var level = _a[_i];
                levelOptions.push({
                    level: level,
                    levelLocals: _this.levelLocals,
                    levelIcon: 'icon-' + level.levelId + 'Icon',
                    isLocked: _this.isLocked(level.levelId),
                    isTutorial: level.tutorial,
                    levelNumber: level.levelNumber,
                    stars: _this.stats[level.levelId],
                    levelId: level.levelId
                });
            }
            _this.levelOptions = levelOptions;
        });
    };
    LevelsBoxComponent.prototype.routerSubscribe = function () {
        var _this = this;
        this.subscriptionRouter = this.activatedRoute.params.subscribe(function (params) {
            var packId = params.packId;
            _this.packNumber = _this.packLevelService.numberForPackWithId(packId);
            _this.levels = _this.packLevelService.levelsInPackId(packId);
            _this.packId = packId;
            _this.assignStats();
            _this.renderLevelInfos();
            _this.setPrevNextPacks();
            _this.setPrevNextPacksUnlocked();
            _this.setPrevNextLinks();
            _this.getStarsProgress();
            _this.setTitleInHead(_this.interfaceLocals[packId]);
        });
    };
    LevelsBoxComponent.prototype.assignStats = function () {
        this.stats = this.calcStats();
    };
    LevelsBoxComponent.prototype.getStarsProgress = function () {
        var starsEarned = this.progressService.starsEarnedWithPackId(this.packId);
        var limitStars = this.packLevelService.starsCountForPackId(this.packId);
        this.eventService.fire('getStarsProgress', [starsEarned, limitStars]);
    };
    LevelsBoxComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        return this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
        });
    };
    LevelsBoxComponent.prototype.setPrevNextLinks = function () {
        this.prevPackLink = this.setRouterLink(this.prevPack);
        this.nextPackLink = this.setRouterLink(this.nextPack);
    };
    LevelsBoxComponent.prototype.setPrevNextPacks = function () {
        this.prevPack = this.packLevelService.previousPackId(this.packId);
        this.nextPack = this.packLevelService.nextPackId(this.packId);
    };
    LevelsBoxComponent.prototype.setPrevNextPacksUnlocked = function () {
        this.isPrevPackUnlocked = this.isPackUnlocked(this.prevPack);
        this.isNextPackUnlocked = this.isPackUnlocked(this.nextPack);
    };
    LevelsBoxComponent.prototype.isLocked = function (levelId) {
        return this.progressService.isLevelLocked(levelId);
    };
    LevelsBoxComponent.prototype.calcStats = function () {
        var stats = {};
        for (var _i = 0, _a = this.levels; _i < _a.length; _i++) {
            var level = _a[_i];
            var levelId = level.levelId;
            var levelResult = this.progressService.levelsResults[levelId];
            var stars = {};
            if (levelResult && levelResult.stars && levelResult.stars.length != 0) {
                var resultStars = levelResult.stars;
                for (var j = 0; j < resultStars.length; j++) {
                    stars[resultStars[j]] = resultStars[j];
                }
            }
            else {
                stars = {};
            }
            stats[levelId] = stars;
        }
        return stats;
    };
    LevelsBoxComponent.prototype.setRouterLink = function (packId) {
        var path = this.localizationService.getRootUrl();
        if (packId) {
            path = path + '/' + packId;
            return path;
        }
        this.backLink = path;
    };
    LevelsBoxComponent.prototype.isPackUnlocked = function (packId) {
        if (!packId) {
            return false;
        }
        return !this.progressService.isPackLocked(packId);
    };
    LevelsBoxComponent.prototype.setTitleInHead = function (title) {
        this.localizationService.setTitleInHead(title);
    };
    return LevelsBoxComponent;
}());
LevelsBoxComponent = __decorate([
    core_1.Component({
        selector: 'levels-box-component',
        template: __webpack_require__(1042),
        styles: [__webpack_require__(431)]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        router_1.Router,
        services_1.PackLevelService,
        services_1.LocalizationService,
        services_1.EventService,
        services_1.ProgressService])
], LevelsBoxComponent);
exports.LevelsBoxComponent = LevelsBoxComponent;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var MainComponent = (function () {
    function MainComponent(eventService) {
        this.eventService = eventService;
    }
    MainComponent.prototype.ngOnInit = function () {
        this.subscribeOnEvents();
    };
    MainComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    MainComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionShowPacksBoxLayoutEvent = this.eventService.subscribe('showPacksBoxLayout', function () {
            _this.stateActiveLayout = true;
        });
        this.subscriptionHidePacksBoxLayoutEvent = this.eventService.subscribe('hidePacksBoxLayout', function () {
            _this.stateActiveLayout = false;
        });
    };
    MainComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionShowPacksBoxLayoutEvent.unsubscribe();
        this.subscriptionHidePacksBoxLayoutEvent.unsubscribe();
    };
    return MainComponent;
}());
MainComponent = __decorate([
    core_1.Component({
        selector: 'main-component',
        template: __webpack_require__(1043),
        styles: [__webpack_require__(432)]
    }),
    __metadata("design:paramtypes", [services_1.EventService])
], MainComponent);
exports.MainComponent = MainComponent;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var router_1 = __webpack_require__(23);
var services_1 = __webpack_require__(11);
var constants_1 = __webpack_require__(43);
var ModalDescriptionComponent = (function () {
    function ModalDescriptionComponent(router, activatedRoute, changeDetectorRef, localizationService, packLevelService, progressService, eventService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.changeDetectorRef = changeDetectorRef;
        this.localizationService = localizationService;
        this.packLevelService = packLevelService;
        this.progressService = progressService;
        this.eventService = eventService;
        this.urlPartPath = constants_1.RETINA ? '2x/retina_' : '1x/';
        this.isImageHide = true;
        this.stateActiveModalDescription = true;
        this.rootLevelUrl = this.localizationService.getRootUrlForLevel();
    }
    ModalDescriptionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscribeOnEvents();
        this.renderLevelInfos();
        this.renderInterfaceLocals();
        this.subscriptionRouter = this.activatedRoute.params.subscribe(function (params) {
            _this.imageUrl = '';
            _this.isImageHide = true;
            _this.changeDetectorRef.detectChanges();
            _this.levelId = params.levelId;
            _this.levelId = _this.packLevelService.levelIdsByNumbers[parseFloat(_this.levelId)] || _this.levelId;
            _this.level = _this.packLevelService.levels[_this.levelId];
            if (!_this.level) {
                _this.router.navigate([_this.rootLevelUrl]);
                return;
            }
            _this.goalLineMoves = _this.level.goalLineMoves;
            _this.goalElementaryMoves = _this.level.goalElementaryMoves;
            _this.setFoundVariants();
            _this.imageUrl = __webpack_require__(231)("./" + (_this.urlPartPath + _this.levelId) + "Detailed.png");
            _this.tutorial = _this.level.tutorial;
            _this.packNumber = _this.level.packNumber;
            _this.levelNumber = _this.level.levelNumber;
            if (_this.progressService.isLevelPlayed(_this.levelId)) {
                _this.hideModal();
            }
            else {
                _this.showModal();
            }
            _this.isImageHide = false;
        });
    };
    ModalDescriptionComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalDescriptionComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionHideModalsEvent
            = this.eventService.subscribe('hideModals', function () { return _this.hideModal(); });
        this.subscriptionShowModalDescriptionEvent
            = this.eventService.subscribe('showModalDescription', function () { return _this.showModal(); });
    };
    ModalDescriptionComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionHideModalsEvent.unsubscribe();
        this.subscriptionShowModalDescriptionEvent.unsubscribe();
    };
    ModalDescriptionComponent.prototype.showModalHelp = function () {
        this.eventService.fire('showModalHelp');
    };
    ModalDescriptionComponent.prototype.showModal = function () {
        this.setFoundVariants();
        this.stateActiveModalDescription = true;
    };
    ModalDescriptionComponent.prototype.hideModal = function () {
        this.stateActiveModalDescription = false;
        this.eventService.fire('hintChecker');
    };
    ModalDescriptionComponent.prototype.setFoundVariants = function () {
        this.foundVariantsCount = this.progressService.levelsResults[this.levelId] ? this.progressService.levelsResults[this.levelId].v_count : 0;
    };
    ModalDescriptionComponent.prototype.renderLevelInfos = function () {
        var _this = this;
        this.localizationService.levelLocals
            .then(function (levels) {
            _this.levelLocals = levels;
        });
    };
    ModalDescriptionComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
        });
    };
    return ModalDescriptionComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ModalDescriptionComponent.prototype, "starsResult", void 0);
ModalDescriptionComponent = __decorate([
    core_1.Component({
        selector: 'modal-description-component',
        template: __webpack_require__(1044),
        styles: [__webpack_require__(433)]
    }),
    __metadata("design:paramtypes", [router_1.Router,
        router_1.ActivatedRoute,
        core_1.ChangeDetectorRef,
        services_1.LocalizationService,
        services_1.PackLevelService,
        services_1.ProgressService,
        services_1.EventService])
], ModalDescriptionComponent);
exports.ModalDescriptionComponent = ModalDescriptionComponent;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var ModalHelpAddonProgressComponent = (function () {
    function ModalHelpAddonProgressComponent(localizationService, eventService, userService) {
        this.localizationService = localizationService;
        this.eventService = eventService;
        this.userService = userService;
        this.interfaceLocals = {};
        this.renderInterfaceLocals();
    }
    ModalHelpAddonProgressComponent.prototype.ngOnInit = function () {
        this.subscribeOnEvents();
    };
    ModalHelpAddonProgressComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalHelpAddonProgressComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionHideModalEvent =
            this.eventService.subscribe('showModalHelpProgress', function () { return _this.showModal(); });
        this.subscriptionChangeLocalsEvent =
            this.eventService.subscribe('changeLocals', function () { return _this.renderInterfaceLocals(); });
    };
    ModalHelpAddonProgressComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionHideModalEvent.unsubscribe();
        this.subscriptionChangeLocalsEvent.unsubscribe();
    };
    ModalHelpAddonProgressComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
        });
    };
    ModalHelpAddonProgressComponent.prototype.showModal = function () {
        this.stateActiveModal = true;
        this.eventService.fire('hideScroll');
    };
    ModalHelpAddonProgressComponent.prototype.hideModal = function () {
        this.stateActiveModal = false;
        this.eventService.fire('showScroll');
    };
    ModalHelpAddonProgressComponent.prototype.syncProgress = function () {
        var _this = this;
        this.userService.sync()
            .then(function () {
            _this.hideModal();
            _this.eventService.fire('progressSynced');
        });
    };
    ModalHelpAddonProgressComponent.prototype.replaceProgress = function () {
        var _this = this;
        this.userService.replaceProgress()
            .then(function () {
            _this.hideModal();
        });
    };
    return ModalHelpAddonProgressComponent;
}());
ModalHelpAddonProgressComponent = __decorate([
    core_1.Component({
        selector: 'modal-help-addon-progress-component',
        template: __webpack_require__(1045),
        styles: [__webpack_require__(434)]
    }),
    __metadata("design:paramtypes", [services_1.LocalizationService,
        services_1.EventService,
        services_1.UserService])
], ModalHelpAddonProgressComponent);
exports.ModalHelpAddonProgressComponent = ModalHelpAddonProgressComponent;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var ModalHelpAddonComponent = (function () {
    function ModalHelpAddonComponent(localizationService, eventService, storageService) {
        this.localizationService = localizationService;
        this.eventService = eventService;
        this.storageService = storageService;
    }
    ModalHelpAddonComponent.prototype.ngOnInit = function () {
        this.renderInterfaceLocals();
        this.subscribeOnEvents();
    };
    ModalHelpAddonComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalHelpAddonComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionShowModalHelpAddonEvent
            = this.eventService.subscribe('showModalHelpAddon', function () { return _this.showModal(); });
        this.subscriptionShowModalHelpAddonCircleEvent
            = this.eventService.subscribe('showModalHelpAddonCircle', function () { return _this.showModalHintCircle(); });
        this.subscriptionShowModalHintExploreEvent
            = this.eventService.subscribe('showModalHintExplore', function () { return _this.showModalHintExplore(); });
    };
    ModalHelpAddonComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionShowModalHelpAddonEvent.unsubscribe();
        this.subscriptionShowModalHelpAddonCircleEvent.unsubscribe();
        this.subscriptionShowModalHintExploreEvent.unsubscribe();
    };
    ModalHelpAddonComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
        });
    };
    ModalHelpAddonComponent.prototype.hideModal = function () {
        this.stateActiveModal = false;
    };
    ModalHelpAddonComponent.prototype.showModal = function () {
        this.stateActiveModal = true;
    };
    ModalHelpAddonComponent.prototype.hideModalHintCircle = function () {
        this.stateActiveModalHintCircle = false;
        this.storageService.save('CircleHintAlreadyShown', true);
    };
    ModalHelpAddonComponent.prototype.hideModalHintExplore = function () {
        this.stateActiveModalHintExplore = false;
    };
    ModalHelpAddonComponent.prototype.hideModalHintExploreForever = function () {
        this.hideModalHintExplore();
        this.storageService.save('ExploreModeAlreadyShown', true);
    };
    ModalHelpAddonComponent.prototype.showModalHintExplore = function () {
        this.stateActiveModalHintExplore = true;
    };
    ModalHelpAddonComponent.prototype.showModalHintCircle = function () {
        this.stateActiveModalHintCircle = true;
    };
    return ModalHelpAddonComponent;
}());
ModalHelpAddonComponent = __decorate([
    core_1.Component({
        selector: 'modal-help-addon-component',
        template: __webpack_require__(1046),
        styles: [__webpack_require__(435)]
    }),
    __metadata("design:paramtypes", [services_1.LocalizationService,
        services_1.EventService,
        services_1.StorageService])
], ModalHelpAddonComponent);
exports.ModalHelpAddonComponent = ModalHelpAddonComponent;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var ModalHelpComponent = (function () {
    function ModalHelpComponent(elementRef, eventService, localizationService) {
        this.elementRef = elementRef;
        this.eventService = eventService;
        this.localizationService = localizationService;
    }
    ModalHelpComponent.prototype.ngOnInit = function () {
        this.renderLocals();
        this.subscribeOnEvents();
    };
    ModalHelpComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalHelpComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionHideModalsEvent =
            this.eventService.subscribe('hideModals', function () { return _this.hideModalHelp(); });
        this.subscriptionShowModalHelpEvent =
            this.eventService.subscribe('showModalHelp', function (stateDarkModalHelp) { return _this.showModalHelp(stateDarkModalHelp); });
        this.subscriptionChangeLocalsEvent =
            this.eventService.subscribe('changeLocals', function () { return _this.renderLocals(); });
    };
    ModalHelpComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionHideModalsEvent.unsubscribe();
        this.subscriptionShowModalHelpEvent.unsubscribe();
        this.subscriptionChangeLocalsEvent.unsubscribe();
    };
    ModalHelpComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.currentLang = _this.localizationService.currentLang;
        });
    };
    ModalHelpComponent.prototype.renderToolsInfos = function () {
        var _this = this;
        this.localizationService.toolsLocals
            .then(function (tools) {
            _this.toolsLocals = tools;
        });
    };
    ModalHelpComponent.prototype.renderHotKeysLocals = function () {
        var _this = this;
        this.localizationService.hotKeysLocals
            .then(function (hotKeys) {
            _this.hotKeysLocals = hotKeys;
        });
    };
    ModalHelpComponent.prototype.renderLocals = function () {
        this.renderInterfaceLocals();
        this.renderToolsInfos();
        this.renderHotKeysLocals();
    };
    ModalHelpComponent.prototype.detectForModalEnd = function (event) {
        var target = event.target;
        this.changeScrollStateToBottom(target);
        this.changeScrollStateToTop(target);
    };
    ModalHelpComponent.prototype.isScrollBottom = function (target) {
        return target.scrollHeight - target.clientHeight === target.scrollTop;
    };
    ModalHelpComponent.prototype.isScrollTop = function (target) {
        return target.scrollTop === 0;
    };
    ModalHelpComponent.prototype.changeScrollStateToBottom = function (target) {
        if (this.isScrollBottom(target)) {
            this.focusHelpWindow();
            this.stateBottomScroll = true;
        }
    };
    ModalHelpComponent.prototype.changeScrollStateToTop = function (target) {
        if (this.isScrollTop(target)) {
            this.stateBottomScroll = false;
        }
    };
    ModalHelpComponent.prototype.hideModalHelp = function () {
        this.stateActiveModalHelp = false;
        this.stateDarkModalHelp = false;
        this.pureScrollTop();
    };
    ModalHelpComponent.prototype.showModalHelp = function (stateDarkModalHelp) {
        var _this = this;
        this.helpWindow = this.elementRef.nativeElement.querySelector('.js-help-window');
        this.modalHelp = this.elementRef.nativeElement.querySelector('.js-modal-help');
        this.modalHelp.addEventListener('transitionend', function () { return _this.focusHelpWindow(); });
        this.modalHelp.addEventListener('click', function () { return _this.focusHelpWindow(); });
        if (stateDarkModalHelp) {
            this.stateDarkModalHelp = true;
        }
        this.stateActiveModalHelp = true;
    };
    ModalHelpComponent.prototype.focusHelpWindow = function () {
        this.helpWindow.focus();
    };
    ModalHelpComponent.prototype.scrollDown = function () {
        var _this = this;
        this.animateScroll(function (helpWindow, step) {
            if (_this.isScrollBottom(helpWindow)) {
                return true;
            }
            helpWindow.scrollTop += step;
        });
    };
    ModalHelpComponent.prototype.pureScrollTop = function () {
        this.stop = true;
        if (this.helpWindow) {
            this.helpWindow.scrollTop = 0;
            this.changeScrollStateToTop(this.helpWindow);
        }
    };
    ModalHelpComponent.prototype.animateScroll = function (callback) {
        var _this = this;
        var step = 0;
        this.stop = false;
        var animate = function () {
            step++;
            var stop = _this.stop || callback(_this.helpWindow, step);
            if (stop) {
                return;
            }
            requestAnimationFrame(animate);
        };
        animate();
    };
    return ModalHelpComponent;
}());
ModalHelpComponent = __decorate([
    core_1.Component({
        selector: 'modal-help-component',
        template: __webpack_require__(1047),
        styles: [__webpack_require__(436)]
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        services_1.EventService,
        services_1.LocalizationService])
], ModalHelpComponent);
exports.ModalHelpComponent = ModalHelpComponent;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var router_1 = __webpack_require__(23);
var ModalSuccessComponent = (function () {
    function ModalSuccessComponent(activatedRoute, progressService, eventService, localizationService) {
        this.activatedRoute = activatedRoute;
        this.progressService = progressService;
        this.eventService = eventService;
        this.localizationService = localizationService;
        this.starsResult = {};
        this.interfaceLocals = {};
    }
    ModalSuccessComponent.prototype.ngOnInit = function () {
        this.renderLevelInfos();
        this.renderInterfaceLocals();
        this.subscribeOnEvents();
    };
    ModalSuccessComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalSuccessComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionShowModalSuccessEvent
            = this.eventService.subscribe('showModalSuccess', function () { return _this.showModal(); });
        this.subscriptionHideModalsEvent
            = this.eventService.subscribe('hideModals', function () { return _this.hideModal(); });
    };
    ModalSuccessComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionHideModalsEvent.unsubscribe();
        this.subscriptionShowModalSuccessEvent.unsubscribe();
    };
    ModalSuccessComponent.prototype.showModal = function () {
        this.setFoundVariants();
        this.stateActiveModalComponent = true;
    };
    ModalSuccessComponent.prototype.hideModal = function () {
        this.stateActiveModalComponent = false;
        this.eventService.fire('hintChecker');
    };
    ModalSuccessComponent.prototype.setFoundVariants = function () {
        var levelId = this.activatedRoute.snapshot.params.levelId;
        this.foundVariantsCount = this.progressService.levelsResults[levelId] && this.progressService.levelsResults[levelId].v_count;
    };
    ModalSuccessComponent.prototype.showModalHelp = function () {
        this.eventService.fire('showModalHelp');
    };
    ModalSuccessComponent.prototype.renderLevelInfos = function () {
        var _this = this;
        this.localizationService.levelLocals
            .then(function (locals) {
            _this.levelLocals = locals;
        });
    };
    ModalSuccessComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
        });
    };
    ModalSuccessComponent.prototype.goToNextLevel = function () {
        this.eventService.fire('nextLevel');
        this.hideModal();
    };
    ModalSuccessComponent.prototype.goToLevelsScreen = function () {
        this.eventService.fire('levelScreen');
        this.hideModal();
    };
    ModalSuccessComponent.prototype.restart = function () {
        this.eventService.fire('restart');
        this.hideModal();
    };
    return ModalSuccessComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ModalSuccessComponent.prototype, "options", void 0);
ModalSuccessComponent = __decorate([
    core_1.Component({
        selector: 'modal-success-component',
        template: __webpack_require__(1048),
        styles: [__webpack_require__(437)]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        services_1.ProgressService,
        services_1.EventService,
        services_1.LocalizationService])
], ModalSuccessComponent);
exports.ModalSuccessComponent = ModalSuccessComponent;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var router_1 = __webpack_require__(23);
var constants_1 = __webpack_require__(43);
var ModalComponent = (function () {
    function ModalComponent(activatedRoute, router, eventService, localizationService, progressService, userService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventService = eventService;
        this.localizationService = localizationService;
        this.progressService = progressService;
        this.userService = userService;
        this.langsLinks = [];
        this.interfaceLocals = {};
        this.stateHiddenSpinner = true;
        this.version = constants_1.VERSION;
        this.copyright = this.localizationService.copyright;
        this.langsObject = this.localizationService.langsObject;
        this.langsArray = this.localizationService.langsArray;
        this.loadingText = this.localizationService.loadingText;
    }
    ModalComponent.prototype.ngOnInit = function () {
        this.routerSubscribe();
        this.subscribeOnEvents();
    };
    ModalComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptioShowModalEvent = this.eventService.subscribe('showModalComponent', function () { return _this.showModal(); });
        this.subscriptionHideModalEvent = this.eventService.subscribe('hideModals', function () { return _this.hideModal(); });
    };
    ModalComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptioShowModalEvent.unsubscribe();
        this.subscriptionRouter.unsubscribe();
        this.subscriptionHideModalEvent.unsubscribe();
    };
    ModalComponent.prototype.routerSubscribe = function () {
        var _this = this;
        this.subscriptionRouter = this.activatedRoute.params.subscribe(function (data) {
            if (_this.localizationService.currentLang !== data.lang) {
                _this.showSpinner();
                _this.localizationService.getLocals();
            }
            _this.renderInterfaceLocals();
        });
    };
    ModalComponent.prototype.resetProgress = function () {
        var rootUrl = this.localizationService.getRootUrl();
        this.progressService.resetProgress();
        this.userService.resetProgress();
        this.eventService.fire('progressSynced');
        this.router.navigate([rootUrl]);
        this.pullRightContent();
    };
    ModalComponent.prototype.hideModal = function () {
        this.stateActiveModalComponent = false;
        this.pullRightContent();
        this.eventService.fire('showScroll');
    };
    ModalComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.currentLang = _this.localizationService.currentLang;
            _this.hideSpinner();
        });
    };
    ModalComponent.prototype.showSpinner = function () {
        this.stateHiddenSpinner = false;
    };
    ModalComponent.prototype.hideSpinner = function () {
        this.stateHiddenSpinner = true;
    };
    ModalComponent.prototype.showModal = function () {
        this.stateActiveModalComponent = true;
        this.setRouterLinks();
    };
    ModalComponent.prototype.pushRightContentWithLangs = function () {
        this.setRouterLinks();
        this.enableStateRightContent();
        this.enableStateActiveLangs();
    };
    ModalComponent.prototype.pushRightContent = function () {
        this.stateActiveReset = true;
        this.enableStateRightContent();
        this.disableStateActiveLangs();
    };
    ModalComponent.prototype.pullRightContent = function () {
        this.stateActiveReset = false;
        this.disableStateRightContent();
        this.hideBackButton();
    };
    ModalComponent.prototype.enableStateRightContent = function () {
        this.stateRightContent = true;
    };
    ModalComponent.prototype.disableStateRightContent = function () {
        this.stateRightContent = false;
    };
    ModalComponent.prototype.enableStateActiveLangs = function () {
        this.stateActiveLangs = true;
        this.showBackButton();
    };
    ModalComponent.prototype.disableStateActiveLangs = function () {
        this.stateActiveLangs = false;
    };
    ModalComponent.prototype.showModalHelpComponent = function () {
        this.eventService.fire('showModalHelp');
    };
    ModalComponent.prototype.setRouterLinks = function () {
        this.langsLinks = this.localizationService.setRouterLinks();
    };
    ModalComponent.prototype.showBackButton = function () {
        this.stateActiveBack = true;
    };
    ModalComponent.prototype.hideBackButton = function () {
        this.stateActiveBack = false;
    };
    return ModalComponent;
}());
ModalComponent = __decorate([
    core_1.Component({
        selector: 'modal-component',
        template: __webpack_require__(1049),
        styles: [__webpack_require__(438)]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        router_1.Router,
        services_1.EventService,
        services_1.LocalizationService,
        services_1.ProgressService,
        services_1.UserService])
], ModalComponent);
exports.ModalComponent = ModalComponent;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var constants_1 = __webpack_require__(43);
var PacksBoxComponent = (function () {
    function PacksBoxComponent(packLevelService, localizationService, eventService, progressService) {
        this.packLevelService = packLevelService;
        this.localizationService = localizationService;
        this.eventService = eventService;
        this.progressService = progressService;
        this.packsOptions = [];
        this.cheat = 0;
        this.interfaceLocals = {};
        this.RETINA = constants_1.RETINA;
    }
    PacksBoxComponent.prototype.ngOnInit = function () {
        this.renderInterfaceLocals();
        this.subscribeOnEvents();
    };
    PacksBoxComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    PacksBoxComponent.prototype.checkForCheating = function ($event) {
        if (($event.charCode === 25 || $event.charCode === 121) && $event.ctrlKey) {
            this.cheat++;
        }
        if (this.cheat >= 3) {
            this.progressService.unlockAllLevels();
            this.renderPacksData();
        }
    };
    PacksBoxComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionChangeLocalsEvent = this.eventService.subscribe('changeLocals', function () {
            _this.renderInterfaceLocals();
        });
        this.subscriptionProgressSyncEvent = this.eventService.subscribe('progressSynced', function () {
            _this.localizationService.interfaceLocals
                .then(function () {
                _this.renderPacksData();
                _this.eventService.fire('getStarsProgress');
            });
        });
    };
    PacksBoxComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionChangeLocalsEvent.unsubscribe();
        this.subscriptionProgressSyncEvent.unsubscribe();
    };
    PacksBoxComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        return this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.titleLocked = _this.interfaceLocals['LockedPacksLabel'];
            _this.renderPacksData();
        });
    };
    PacksBoxComponent.prototype.renderPacksData = function () {
        this.packIds = this.packLevelService.packIds;
        this.packs = this.packLevelService.packs;
        var packsOptions = [];
        var index = 0;
        for (var _i = 0, _a = this.packIds; _i < _a.length; _i++) {
            var packId = _a[_i];
            ++index;
            packsOptions.push({
                index: index,
                packId: packId,
                title: this.interfaceLocals[packId],
                isLocked: this.isLocked(packId),
                packEarnedStars: this.packEarnedStars(packId),
                packLimitStars: this.packLimitStars(packId),
                isEarnedStarsBiggerThanLimited: this.packEarnedStars(packId) >= this.packLimitStars(packId),
                image: __webpack_require__(1324)("./" + packId + ".png"),
                imageRetina: __webpack_require__(1326)("./" + packId + ".png"),
                imageGold: __webpack_require__(1325)("./Gold" + packId + ".png"),
                imageGoldRetina: __webpack_require__(1327)("./Gold" + packId + "2x.png")
            });
        }
        this.packsOptions = packsOptions;
    };
    PacksBoxComponent.prototype.isLocked = function (packId) {
        return this.progressService.isPackLocked(packId);
    };
    PacksBoxComponent.prototype.packEarnedStars = function (packId) {
        return this.progressService.starsEarnedWithPackId(packId);
    };
    PacksBoxComponent.prototype.packLimitStars = function (packId) {
        return this.packLevelService.starsCountForPackId(packId);
    };
    return PacksBoxComponent;
}());
__decorate([
    core_1.HostListener('document:keypress', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], PacksBoxComponent.prototype, "checkForCheating", null);
PacksBoxComponent = __decorate([
    core_1.Component({
        selector: 'packs-box-component',
        template: __webpack_require__(1050),
        styles: [__webpack_require__(439)]
    }),
    __metadata("design:paramtypes", [services_1.PackLevelService,
        services_1.LocalizationService,
        services_1.EventService,
        services_1.ProgressService])
], PacksBoxComponent);
exports.PacksBoxComponent = PacksBoxComponent;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var services_1 = __webpack_require__(11);
var UserMenuComponent = (function () {
    function UserMenuComponent(localizationService, userService, eventService, storageService) {
        this.localizationService = localizationService;
        this.userService = userService;
        this.eventService = eventService;
        this.storageService = storageService;
        this.interfaceLocals = {};
    }
    UserMenuComponent.prototype.shouldHideDropdown = function ($event) {
        if (!$event.target.closest('.js-wrapper-dropdown') || $event.target.classList.contains('js-dropdown-logout')) {
            this.stateActiveDropdown = false;
            this.eventService.fire('hidePacksBoxLayout');
        }
    };
    UserMenuComponent.prototype.changeBackUrl = function () {
        this.burl = encodeURIComponent("/" + this.localizationService.currentLang + "/game/packs");
        //this.burl = encodeURIComponent(location.pathname);
    };
    UserMenuComponent.prototype.ngOnInit = function () {
        this.renderInterfaceLocals();
        this.subscribeOnEvents();
    };
    UserMenuComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    UserMenuComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionChangeLocalsEvent = this.eventService.subscribe('changeLocals', function () {
            _this.renderInterfaceLocals();
        });
    };
    UserMenuComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionChangeLocalsEvent.unsubscribe();
    };
    UserMenuComponent.prototype.toggleDropdown = function () {
        if (this.userService.authorized) {
            this.stateActiveDropdown = !this.stateActiveDropdown;
            if (this.stateActiveDropdown) {
                this.eventService.fire('showPacksBoxLayout');
            }
            else {
                this.eventService.fire('hidePacksBoxLayout');
            }
        }
    };
    UserMenuComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.currentLang = _this.localizationService.currentLang;
            _this.changeBackUrl();
        });
    };
    return UserMenuComponent;
}());
__decorate([
    core_1.HostListener('document:click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserMenuComponent.prototype, "shouldHideDropdown", null);
UserMenuComponent = __decorate([
    core_1.Component({
        selector: 'user-menu-component',
        template: __webpack_require__(1051),
        styles: [__webpack_require__(440)]
    }),
    __metadata("design:paramtypes", [services_1.LocalizationService,
        services_1.UserService,
        services_1.EventService,
        services_1.StorageService])
], UserMenuComponent);
exports.UserMenuComponent = UserMenuComponent;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_SOLUTION_URL = 'https://www.euclidea.xyz/api/v1/game/solutions';
exports.SEND_BEST_SOLUTION_URL = 'https://www.euclidea.xyz/api/v1/sync/savedsolutions';


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Module = window.Module;
var GameView = (function () {
    function GameView(gameControl, render, level) {
        this.isReadingMessages = false;
        this.gameControl = gameControl;
        this.level = level;
        this.render = render;
        this.gameControl.setViewSize(this.render.width, this.render.height);
        this.render.setGameControl(this.gameControl);
        this.render.setOnTouchListener(this);
        this.render.setWheelListener(this);
    }
    GameView.prototype.isCanUndo = function () {
        var res = this.gameControl.isCanUndo();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.isCanRedo = function () {
        var res = this.gameControl.isCanRedo();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.solved = function () {
        var res = this.gameControl.getSolvedStatus();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.elementaryMovesCount = function () {
        var res = this.gameControl.getElementaryMovesCount();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.lineMovesCount = function () {
        var res = this.gameControl.getLineMovesCount();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.hintFigureType = function () {
        var res = this.gameControl.getHintFigureType();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.hintCoordinate = function (num) {
        var coord = this.gameControl.getHintCoordinate(num);
        this.readGameControlMessages();
        return coord;
    };
    GameView.prototype.undo = function () {
        this.gameControl.undo();
        this.readGameControlMessages();
    };
    GameView.prototype.redo = function () {
        this.gameControl.redo();
        this.readGameControlMessages();
    };
    GameView.prototype.restart = function () {
        this.gameControl.restart();
        this.readGameControlMessages();
    };
    GameView.prototype.detailSolutionWithLMovesWithEMoves = function (content, lMoves, eMoves) {
        var moves = new Module.SolutionMoves();
        var resStr = this.gameControl.detailSolution(content, moves);
        this.readGameControlMessages();
        return resStr;
    };
    GameView.prototype.isSolutionEqualToSolution = function (content1, content2) {
        return Module.GameControl.isSolutionEqualToSolution(content1, content2);
    };
    GameView.prototype.encodeTaskWithUndoList = function (withUndo) {
        var resStr = this.gameControl.encodeTaskWithUndoListCnt(withUndo);
        this.readGameControlMessages();
        return resStr;
    };
    GameView.prototype.decodeTaskWithFormatWithUndoList = function (content, format, withUndo) {
        this.gameControl.decodeTask(content, format, withUndo);
        this.readGameControlMessages();
    };
    GameView.prototype.recreateFieldWithGrid = function (gridType) {
        this.gameControl.recreateField(gridType);
        this.readGameControlMessages();
    };
    GameView.prototype.showSolution = function () {
        this.gameControl.showSolution();
        this.readGameControlMessages();
    };
    GameView.prototype.moveField = function (coord, moveState) {
        this.gameControl.moveField(coord, moveState);
        this.readGameControlMessages();
    };
    GameView.prototype.scaleField = function (scale, coords, moveState) {
        this.gameControl.scaleField(scale, coords, moveState);
        this.readGameControlMessages();
    };
    GameView.prototype.rotateField = function (rotation, moveState) {
        this.gameControl.rotateField(rotation, moveState);
        this.readGameControlMessages();
    };
    GameView.prototype.tapped = function (coordinate) {
        this.gameControl.tapped(coordinate);
        this.readGameControlMessages();
    };
    GameView.prototype.move = function (coord, moveState) {
        this.gameControl.move(coord, moveState);
        this.readGameControlMessages();
    };
    GameView.prototype.hover = function (coord) {
        this.gameControl.hover(coord);
        this.readGameControlMessages();
    };
    GameView.prototype.toolType = function () {
        var resStr = this.gameControl.getToolType();
        this.readGameControlMessages();
        return resStr;
    };
    GameView.prototype.setToolType = function (toolType) {
        this.gameControl.setToolType(toolType);
        this.readGameControlMessages();
    };
    GameView.prototype.resetToolType = function () {
        this.gameControl.resetTool();
        this.readGameControlMessages();
    };
    GameView.prototype.gameMode = function () {
        var res = this.gameControl.getGameMode();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.setGameMode = function (gameMode) {
        this.gameControl.setGameMode(gameMode);
        this.readGameControlMessages();
    };
    GameView.prototype.startTutorial = function () {
        this.gameControl.startTutorial();
        this.readGameControlMessages();
    };
    GameView.prototype.updateHintIfNeeded = function () {
        var res = this.gameControl.updateHintIfNeeded();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.readGameControlMessages = function () {
        if (this.isReadingMessages) {
            return;
        }
        this.isReadingMessages = true;
        var messageInfo = new Module.MessageInfo();
        while (this.gameControl.popGameMessage(messageInfo)) {
            switch (messageInfo.message) {
                case Module.GameMessage.GameMessageDidChangeMoveCount:
                    this.level.notifyChangeMoveCount();
                    break;
                case Module.GameMessage.GameMessageDidChangeUndoStatus:
                    this.level.notifyChangeUndoStatus();
                    break;
                case Module.GameMessage.GameMessageDidChangeRedoStatus:
                    this.level.notifyChangeRedoStatus();
                    break;
                case Module.GameMessage.GameMessageDidChangeTaskStatus:
                    this.level.notifyChangeTaskStatus();
                    break;
                case Module.GameMessage.GameMessageDidChangeMode:
                    this.level.notifyChangeGameMode();
                    break;
                case Module.GameMessage.GameMessageDidMovePoint:
                    this.level.notifyMovePoint();
                    break;
                case Module.GameMessage.GameMessageDidTouchScreen:
                    this.level.notifyTouchScreen(messageInfo.value != 0);
                    break;
                case Module.GameMessage.GameMessageDidChangeCursor:
                    this.level.notifyChangeCursor(messageInfo.value != 0);
                    break;
                case Module.GameMessage.GameMessageDidAddObject:
                    var figure = new Module.GMFigureType();
                    this.gameControlDidAddObjectWithType(figure[(messageInfo.value)]);
                    break;
                case Module.GameMessage.GameMessageNeedDisplay:
                    this.gameControlNeedDisplay();
                    break;
            }
        }
        this.isReadingMessages = false;
    };
    GameView.prototype.gameControlDidAddObjectWithType = function (figureType) {
    };
    GameView.prototype.gameControlNeedDisplay = function () {
        this.render.renderFigures();
    };
    GameView.prototype.checkHandCursor = function (coord) {
        var flag = false;
        this.gameControl.hover(coord);
        var messageInfo = new Module.MessageInfo();
        while (this.gameControl.popGameMessage(messageInfo)) {
            if (messageInfo.message == Module.GameMessage.GameMessageDidChangeCursor && messageInfo.value == 0) {
                flag = true;
            }
        }
        return flag;
    };
    GameView.prototype.remove = function () {
        this.render.remove();
    };
    return GameView;
}());
exports.GameView = GameView;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var components_1 = __webpack_require__(142);
var services_1 = __webpack_require__(11);
exports.appRoutes = [
    {
        path: ':lang/game',
        redirectTo: ':lang/game/packs',
        pathMatch: 'full'
    },
    {
        path: 'game',
        component: components_1.MainComponent,
        canActivate: [services_1.ShortPathGameGuardService]
    },
    {
        path: ':lang/game/packs',
        component: components_1.MainComponent,
        children: [
            {
                path: '',
                component: components_1.PacksBoxComponent
            },
            {
                path: ':packId',
                component: components_1.LevelsBoxComponent,
                canActivate: [services_1.LevelBoxGuardService]
            }
        ]
    },
    {
        path: 'game/packs',
        component: components_1.MainComponent,
        children: [
            {
                path: '',
                component: components_1.PacksBoxComponent,
                canActivate: [services_1.ShortPathGameGuardService]
            },
            {
                path: ':packId',
                component: components_1.LevelsBoxComponent,
                canActivate: [services_1.ShortPathGameGuardService]
            }
        ]
    },
    {
        path: 'game/:levelId',
        component: components_1.MainComponent,
        canActivate: [services_1.ShortPathGameGuardService]
    },
    {
        path: ':lang/game/packs/:packId/level/:levelId',
        component: components_1.LevelComponent,
        canActivate: [services_1.LevelGuardService]
    },
    {
        path: 'game/packs/:packId/level/:levelId',
        component: components_1.LevelComponent,
        canActivate: [services_1.ShortPathGameGuardService]
    },
    {
        path: ':lang/game/:levelId',
        component: components_1.LevelComponent,
        canActivate: [services_1.LevelGuardService]
    },
    {
        path: '**',
        redirectTo: 'game/notfound'
    }
];


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var level_1 = __webpack_require__(257);
exports.Level = level_1.Level;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Level = (function () {
    function Level(obj) {
        Object.assign(this, obj);
    }
    Level.prototype.starsForSolutionWithElementaryMovesLineMovesVariantsFound = function (e_moves, l_moves, _variantsCount) {
        var stars = [];
        stars.push('GM_STAR_TYPE_B');
        if (l_moves <= this.goalLineMoves) {
            stars.push('GM_STAR_TYPE_L');
        }
        if (e_moves <= this.goalElementaryMoves) {
            stars.push('GM_STAR_TYPE_E');
        }
        if (this.variantsCount == _variantsCount && _variantsCount > 1) {
            stars.push('GM_STAR_TYPE_V');
        }
        return stars;
    };
    return Level;
}());
exports.Level = Level;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Module = window.Module;
var CanvasRender = (function () {
    function CanvasRender(wrapperId) {
        this.density = 1;
        this.bgColor = '';
        this.currentScale = 1;
        this.isMoveField = false;
        this.wrapperId = '';
        this.isLocked = false;
        this.wrapperId = wrapperId;
        this.wrapper = document.querySelector("#" + wrapperId);
        this.canvas = document.createElement('canvas');
        this.wrapper.appendChild(this.canvas);
        this.ctx = this.canvas.getContext('2d');
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.wrapper.style.width = window.innerWidth + 'px';
        this.wrapper.style.height = window.innerHeight + 'px';
        this.width = this.wrapper.clientWidth;
        this.height = this.wrapper.clientHeight;
        var rect = {
            width: 0,
            height: 0
        };
        rect.width = this.width;
        rect.height = this.height;
        if (!rect.width && !rect.height) {
            rect = this.canvas.getBoundingClientRect();
        }
        this.halfWidth = rect.width / 2;
        this.halfHeight = rect.height / 2;
        this.ctx.imageSmoothingEnabled = true;
        this.ctx.mozImageSmoothingEnabled = true;
        this.ctx.webkitImageSmoothingEnabled = true;
        this.ctx.msImageSmoothingEnabled = true;
        this.ctx.imageSmoothingQuality = 'high';
    }
    CanvasRender.prototype.setGameControl = function (gc) {
        this.gameControl = gc;
    };
    CanvasRender.prototype.renderFigures = function () {
        if (!this.gameControl) {
            return;
        }
        this.clearCanvas();
        this.gameControl.redrawGameObjects();
        var type = {};
        var gameObj = null;
        do {
            type = this.gameControl.popGameObject();
            switch (type) {
                case Module.GameObjectType.GameLineType:
                    gameObj = this.gameControl.popGameLineObject();
                    this.renderGameLine(gameObj);
                    break;
                case Module.GameObjectType.GameArcType:
                    gameObj = this.gameControl.popGameArcObject();
                    this.renderGameArc(gameObj);
                    break;
                case Module.GameObjectType.GamePointType:
                    gameObj = this.gameControl.popGamePointObject();
                    this.renderGamePoint(gameObj);
                    break;
                case Module.GameObjectType.GameLabelType:
                    gameObj = this.gameControl.popGameLabelObject();
                    this.renderGameLabel(gameObj);
                    break;
            }
        } while (type != Module.GameObjectType.GameEmptyType);
    };
    CanvasRender.prototype.clearCanvas = function () {
        if (this.ctx) {
            this.ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        }
    };
    CanvasRender.prototype.renderGamePoint = function (point) {
        if (this.ctx) {
            this.ctx.setLineDash([]);
            this.ctx.beginPath();
            this.ctx.arc(point.coord.x, point.coord.y, point.radius, 0, 2 * Math.PI, false);
            this.ctx.fillStyle = this._colorFromString(point.color);
            this.ctx.fill();
            if (point.borderWidth != 0) {
                this.ctx.lineWidth = point.borderWidth;
                this.ctx.strokeStyle = this._colorFromString(point.borderColor);
                this.ctx.stroke();
            }
            this.ctx.closePath();
        }
    };
    ;
    CanvasRender.prototype.renderGameLine = function (line) {
        if (this.ctx) {
            if (line.dash.length != 0) {
                this.ctx.setLineDash(this._extractDashPatternFromString(line.dash));
            }
            else {
                this.ctx.setLineDash([]);
            }
            this.ctx.beginPath();
            this.ctx.moveTo(line.startCoord.x, line.startCoord.y);
            this.ctx.lineTo(line.endCoord.x, line.endCoord.y);
            this.ctx.lineWidth = line.width;
            this.ctx.strokeStyle = this._colorFromString(line.color);
            this.ctx.stroke();
            this.ctx.closePath();
        }
    };
    ;
    CanvasRender.prototype.renderGameArc = function (arc) {
        if (this.ctx) {
            if (arc.dash.length != 0) {
                this.ctx.setLineDash(this._extractDashPatternFromString(arc.dash));
            }
            else {
                this.ctx.setLineDash([]);
            }
            this.ctx.beginPath();
            this.ctx.arc(arc.centerCoord.x, arc.centerCoord.y, arc.radius, arc.startAngle, arc.endAngle, arc.clockwise);
            this.ctx.lineWidth = arc.width;
            this.ctx.strokeStyle = this._colorFromString(arc.color);
            this.ctx.stroke();
            this.ctx.closePath();
        }
    };
    ;
    CanvasRender.prototype.renderGameLabel = function (label) {
        if (this.ctx) {
            var color = label.fontColor ? this._colorFromString(label.fontColor) : this._colorFromString("255 255 255");
            var coords = label.coord;
            var textSize = label.fontSize > 0 ? label.fontSize : 17;
            coords.y += textSize;
            var textStyle = label.fontName ? label.fontName : "Open Sans";
            this.ctx.beginPath();
            this.ctx.fillStyle = color;
            this.ctx.font = textSize + "px " + textStyle;
            this.ctx.fillText(label.text, coords.x, coords.y);
            this.ctx.stroke();
            this.ctx.closePath();
        }
    };
    ;
    CanvasRender.prototype._colorFromString = function (colorStr) {
        var components = colorStr.split(" ");
        if (components.length < 3 || components.length > 4) {
            return '';
        }
        var red = components[0];
        var green = components[1];
        var blue = components[2];
        var alpha = components.length == 4 ? components[3] : 1;
        return 'rgba(' + red + ',' + green + ',' + blue + ',' + alpha + ')';
    };
    ;
    CanvasRender.prototype._extractDashPatternFromString = function (dashPatternStr) {
        if (dashPatternStr == undefined || dashPatternStr.length == 0)
            return [0];
        var arr = dashPatternStr.split(",");
        return arr.map(function (el) {
            return parseFloat(el);
        });
    };
    ;
    CanvasRender.prototype.setOnTouchListener = function (gameView) {
        var self = this;
        var isMoving = false;
        var isMousedown = false;
        var startCoord = { x: 0, y: 0 };
        var prevCoord = { x: 0, y: 0 };
        var trackLen = 0;
        var isHoverLocked = false;
        this.canvas.addEventListener('mousemove', onHover);
        this.canvas.addEventListener('mousedown', onMouseDown);
        function getCoords(evt) {
            return {
                x: evt.pageX,
                y: evt.pageY
            };
        }
        window.onkeydown = function (e) {
            if (self.isLocked) {
                return true;
            }
            var center = { x: self.halfWidth, y: self.halfHeight };
            var key = e.keyCode;
            var modalDescription = document.querySelector('.js-modal-description');
            var modalHelp = document.querySelector('.js-modal-help');
            var modalSuccess = document.querySelector('.js-modal-success');
            var modalHelpAddon = document.querySelectorAll('.js-modal-help-addon');
            var isModalDescriptionActive = modalDescription && modalDescription.classList.contains('active');
            var isModalHelpActive = modalHelp && modalHelp.classList.contains('active');
            var isModalSuccessActive = modalSuccess && modalSuccess.classList.contains('active');
            var isModalHelpAddonActive;
            if (modalHelpAddon) {
                for (var _i = 0, modalHelpAddon_1 = modalHelpAddon; _i < modalHelpAddon_1.length; _i++) {
                    var modal = modalHelpAddon_1[_i];
                    if (modal.classList.contains('active')) {
                        isModalHelpAddonActive = true;
                    }
                }
            }
            var isLayoutActive = isModalDescriptionActive || isModalHelpActive || isModalSuccessActive || isModalHelpAddonActive;
            if (isLayoutActive) {
                return;
            }
            switch (key) {
                case 38:
                    gameView.moveField(center, Module.MoveState.MoveStateBegan);
                    gameView.moveField({ x: center.x, y: center.y - 10 }, Module.MoveState.MoveStateChanged);
                    gameView.moveField({ x: center.x, y: center.y - 10 }, Module.MoveState.MoveStateEnded);
                    break;
                case 39:
                    gameView.moveField(center, Module.MoveState.MoveStateBegan);
                    gameView.moveField({ x: center.x + 10, y: center.y }, Module.MoveState.MoveStateChanged);
                    gameView.moveField({ x: center.x + 10, y: center.y }, Module.MoveState.MoveStateEnded);
                    break;
                case 37:
                    gameView.moveField(center, Module.MoveState.MoveStateBegan);
                    gameView.moveField({ x: center.x - 10, y: center.y }, Module.MoveState.MoveStateChanged);
                    gameView.moveField({ x: center.x - 10, y: center.y }, Module.MoveState.MoveStateEnded);
                    break;
                case 40:
                    gameView.moveField(center, Module.MoveState.MoveStateBegan);
                    gameView.moveField({ x: center.x, y: center.y + 10 }, Module.MoveState.MoveStateChanged);
                    gameView.moveField({ x: center.x, y: center.y + 10 }, Module.MoveState.MoveStateEnded);
                    break;
                case 27:
                    gameView.resetToolType();
                    break;
            }
        };
        function onMouseDown(evt) {
            isHoverLocked = true;
            var coord = getCoords(evt);
            if (evt.button == 0) {
                isMousedown = true;
                if (gameView.toolType() == 'HandTool' && gameView.checkHandCursor(coord)) {
                    self.isMoveField = true;
                    self.wrapper.style.cursor = 'move';
                }
            }
            startCoord = coord;
            prevCoord = coord;
            trackLen = 0;
            if (isMousedown && evt.button == 2 && !self.isLocked) {
                gameView.resetToolType();
                isMousedown = false;
            }
            else if (!isMousedown && evt.button == 2 && !self.isLocked) {
                if (isMoving) {
                    gameView.resetToolType();
                }
                self.canvas.addEventListener('mousemove', onMove);
                self.canvas.addEventListener('mouseup', onUp);
            }
            else if (!self.isLocked) {
                self.canvas.addEventListener('mousemove', onMouseMove);
                self.canvas.addEventListener('mouseup', onMouseUp);
            }
            self.canvas.addEventListener('contextmenu', contextMenu);
        }
        function onHover(evt) {
            var coord = getCoords(evt);
            if (!isHoverLocked) {
                gameView.hover(coord);
            }
        }
        function contextMenu(event) {
            event.preventDefault();
            self.canvas.removeEventListener('contextmenu', contextMenu);
        }
        function onMove(evt) {
            self.wrapper.style.cursor = 'move';
            var coords = getCoords(evt);
            if (!isMoving) {
                gameView.moveField(startCoord, Module.MoveState.MoveStateBegan);
                isMoving = true;
            }
            else {
                gameView.moveField(coords, Module.MoveState.MoveStateChanged);
            }
        }
        function onUp(evt) {
            var coords = getCoords(evt);
            self.canvas.removeEventListener('mousemove', onMove);
            if (startCoord.x == coords.x && startCoord.y == coords.y) {
                gameView.resetToolType();
            }
            if (isMoving) {
                gameView.moveField(coords, Module.MoveState.MoveStateEnded);
                isMoving = false;
            }
            self.canvas.removeEventListener('mouseup', onUp);
            self.wrapper.style.cursor = 'default';
            isHoverLocked = false;
        }
        function onMouseMove(evt) {
            var coords = getCoords(evt);
            if (!isMoving) {
                if (trackLen > 0) {
                    gameView.move(startCoord, Module.MoveState.MoveStateBegan);
                    isMoving = true;
                }
                else {
                    trackLen += distanceBetweenCoords(prevCoord, coords);
                    prevCoord = coords;
                }
            }
            else {
                gameView.move(coords, Module.MoveState.MoveStateChanged);
            }
        }
        function onMouseUp(evt) {
            if (self.isMoveField) {
                self.isMoveField = false;
                self.wrapper.style.cursor = 'default';
            }
            var coords = getCoords(evt);
            self.canvas.removeEventListener('mousemove', onMouseMove);
            if (isMoving) {
                gameView.move(coords, Module.MoveState.MoveStateEnded);
                isMoving = false;
            }
            else {
                gameView.tapped(coords);
            }
            self.canvas.removeEventListener('mouseup', onMouseUp);
            isMousedown = false;
            isHoverLocked = false;
        }
        CanvasRender.prototype.deleteOnTouchListener = function () {
            this.canvas.removeEventListener('mousemove', onMouseMove);
            this.canvas.removeEventListener('mousemove', onHover);
            this.canvas.removeEventListener('mousedown', onMouseDown);
            this.canvas.removeEventListener('mouseup', onMouseUp);
            this.canvas.removeEventListener('contextmenu', contextMenu);
        };
    };
    CanvasRender.prototype.setWheelListener = function (gameView) {
        this.canvas.addEventListener('wheel', onWheel);
        function onWheel(e) {
            var coords = {
                x: e.pageX,
                y: e.pageY
            };
            var scale = 1;
            gameView.scaleField(scale, coords, Module.MoveState.MoveStateBegan);
            if (e.deltaY < 0) {
                scale += 0.1;
            }
            else {
                scale -= 0.1;
            }
            gameView.scaleField(scale, coords, Module.MoveState.MoveStateChanged);
            gameView.scaleField(scale, coords, Module.MoveState.MoveStateEnded);
            this.currentScale = scale;
            e.preventDefault();
        }
        CanvasRender.prototype.deleteWheelListener = function () {
            this.canvas.removeEventListener('wheel', onWheel);
        };
    };
    CanvasRender.prototype.deleteWheelListener = function () {
    };
    CanvasRender.prototype.deleteOnTouchListener = function () {
    };
    CanvasRender.prototype.lockScene = function (lock) {
        this.isLocked = lock || false;
    };
    CanvasRender.prototype.remove = function () {
        this.deleteOnTouchListener();
        this.deleteWheelListener();
        delete this.ctx;
        this.canvas.parentNode.removeChild(this.canvas);
        delete this.canvas;
    };
    return CanvasRender;
}());
exports.CanvasRender = CanvasRender;
function distanceBetweenCoords(coord1, coord2) {
    return Math.abs(Math.sqrt(Math.pow(coord1.x - coord2.x, 2) + Math.pow(coord1.y - coord2.y, 2)));
}


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var router_1 = __webpack_require__(23);
var LevelBoxGuardService = (function () {
    function LevelBoxGuardService(router, localizationService, packLevelService) {
        this.router = router;
        this.localizationService = localizationService;
        this.packLevelService = packLevelService;
        this.rootUrl = this.localizationService.getRootUrl();
    }
    LevelBoxGuardService.prototype.canActivate = function (route) {
        var packId = route.params.packId;
        var packNumber = this.packLevelService.numberForPackWithId(packId);
        if (packNumber === 0) {
            this.router.navigate([this.rootUrl]);
            return;
        }
        return true;
    };
    return LevelBoxGuardService;
}());
LevelBoxGuardService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router,
        _1.LocalizationService,
        _1.PackLevelService])
], LevelBoxGuardService);
exports.LevelBoxGuardService = LevelBoxGuardService;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var router_1 = __webpack_require__(23);
var LevelGuardService = (function () {
    function LevelGuardService(router, localizationService, packLevelService) {
        this.router = router;
        this.localizationService = localizationService;
        this.packLevelService = packLevelService;
        this.rootLevelUrl = this.localizationService.getRootUrlForLevel();
    }
    LevelGuardService.prototype.canActivate = function (route) {
        var levelId = route.params.levelId;
        var levelIdOrLevel = this.packLevelService.levelIdsByNumbers[levelId] || this.packLevelService.levels[levelId];
        if (!levelIdOrLevel) {
            this.router.navigate([this.rootLevelUrl]);
            return;
        }
        return true;
    };
    return LevelGuardService;
}());
LevelGuardService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router,
        _1.LocalizationService,
        _1.PackLevelService])
], LevelGuardService);
exports.LevelGuardService = LevelGuardService;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var http_1 = __webpack_require__(53);
var _1 = __webpack_require__(11);
var router_1 = __webpack_require__(23);
var platform_browser_1 = __webpack_require__(54);
var LocalizationService = (function () {
    function LocalizationService(http, title, progressService, eventService, router, activatedRoute, resourcePreloaderService) {
        this.http = http;
        this.title = title;
        this.progressService = progressService;
        this.eventService = eventService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.resourcePreloaderService = resourcePreloaderService;
        this.langsArrayShort = ['ru', 'en'];
        this.copyright = new Date().getFullYear() + " HIL";
        this.langsArray = ['Русский', 'English'];
        this.langsObject = {
            ru: 'Русский',
            en: 'English'
        };
        this.loadingText = {
            en: 'Загрузка...',
            ru: 'Loading...'
        };
        this.getLocals();
    }
    LocalizationService.prototype.setRouterLinks = function () {
        var langsLinks = [];
        var path = window.location.pathname.split('/').slice(2);
        for (var _i = 0, _a = this.langsArrayShort; _i < _a.length; _i++) {
            var lang = _a[_i];
            langsLinks.push(['/' + lang].concat(path).join('/'));
        }
        return langsLinks;
    };
    LocalizationService.prototype.getLevelLocals = function () {
        var _this = this;
        return this.http.get(__webpack_require__(1330)("./" + this.currentLang + "-lproj/LevelInfos.xml"))
            .toPromise()
            .then(function (response) {
            return _this.parseLevelInfos(response);
        }).catch(function (error) { return console.log(error + " ---> localization.service - level"); });
    };
    LocalizationService.prototype.getLocals = function () {
        this.currentLang = this.getCurrentLang();
        this.currentLangLinkAppStore = this.getCurrentLangAppStore();
        this.interfaceLocals = this.getInterfaceLocals();
        this.toolsLocals = this.getToolsLocals();
        this.hotKeysLocals = this.getHotKeysLocals();
        this.levelLocals = this.getLevelLocals();
        this.eventService.fire('changeLocals'); // say to update models
    };
    LocalizationService.prototype.setTitleInHead = function (name) {
        if (name === void 0) { name = ''; }
        var title = name ? "Euclidea - " + name : 'Euclidea';
        this.title.setTitle(title);
    };
    LocalizationService.prototype.getRootUrl = function () {
        return window.location.pathname.split('/').slice(0, 4).join('/');
    };
    LocalizationService.prototype.getRootUrlForLevel = function () {
        var url = window.location.pathname.split('/');
        if (url.indexOf('packs') === -1) {
            return url.slice(0, 3).join('/') + '/packs';
        }
        return url.slice(0, 4).join('/');
    };
    LocalizationService.prototype.getInterfaceLocals = function () {
        return this.httpGet(__webpack_require__(1331)("./" + this.currentLang + "-lproj/Localizable.strings"));
    };
    LocalizationService.prototype.getHotKeysLocals = function () {
        return this.httpGet(__webpack_require__(1329)("./" + this.currentLang + "-lproj/HotKeys.strings"));
    };
    LocalizationService.prototype.httpGet = function (url) {
        var _this = this;
        return this.http
            .get(url)
            .toPromise()
            .then(function (response) {
            return _this.parseData(response);
        }).catch(function (error) {
            console.log(error + " ---> localization.service");
        });
    };
    LocalizationService.prototype.getToolsLocals = function () {
        var _this = this;
        if (this.currentLang === 'en') {
            return this.resourcePreloaderService.toolInfosPromise.then(function (toolInfos) {
                return _this.parseToolsInfos(toolInfos);
            });
        }
        return this.http
            .get(__webpack_require__(1332)("./" + this.currentLang + "-lproj/ToolInfos.xml"))
            .toPromise()
            .then(function (response) {
            return _this.parseToolsInfos(response.text());
        }).catch(function (error) { return console.log(error + " ---> localization.service - tools"); });
    };
    LocalizationService.prototype.getCurrentLang = function () {
        var lang;
        var url = location.pathname;
        var match = url.match(/^\/([A-Za-z]{2})([\/\?].*)?$/i);
        if (match && this.langsArrayShort.indexOf(match[1]) > -1) {
            lang = match[1];
            this.progressService.sharedPreferences.local = lang;
            this.progressService.saveSharedPreferences();
            return lang;
        }
        if (this.progressService.sharedPreferences.local) {
            return this.progressService.sharedPreferences.local;
        }
        else {
            lang = navigator.browserLanguage || navigator.language || navigator.userLanguage;
            if (lang.length > 2) {
                lang = lang.substr(0, 2);
            }
            if (this.langsArrayShort.indexOf(lang) === -1) {
                lang = 'en';
            }
            this.progressService.sharedPreferences.local = lang;
            this.progressService.saveSharedPreferences();
            return lang;
        }
    };
    LocalizationService.prototype.getCurrentLangAppStore = function () {
        return this.currentLang === 'en' ? '/' : "/" + this.currentLang + "/";
    };
    LocalizationService.prototype.parseData = function (response) {
        var localsObj = {};
        var localRegExp = /^"(.+)" = "(.+)";$/g;
        var result = response.text().replace(/\r\n/gm, '\n');
        var strings = result.split('\n');
        for (var _i = 0, strings_1 = strings; _i < strings_1.length; _i++) {
            var str = strings_1[_i];
            str = str.replace(/\\n/gm, '<br>').replace(/\\/g, '');
            localRegExp.lastIndex = 0;
            if (localRegExp.test(str)) {
                localRegExp.lastIndex = 0;
                var execRes = localRegExp.exec(str);
                localsObj[execRes[1]] = execRes[2];
            }
        }
        return localsObj;
    };
    LocalizationService.prototype.parseToolsInfos = function (response) {
        var localsObj = {};
        var parser = new DOMParser();
        var xmlData = parser.parseFromString(response, "application/xml");
        for (var _i = 0, _a = xmlData.querySelectorAll('tool'); _i < _a.length; _i++) {
            var tool = _a[_i];
            localsObj[tool.getAttribute('id')] = {
                title: tool.getAttribute('title'),
                cost: tool.getAttribute('cost')
            };
        }
        return localsObj;
    };
    LocalizationService.prototype.parseLevelInfos = function (response) {
        var localsObj = {};
        var parser = new DOMParser();
        var xmlData = parser.parseFromString(response.text(), "application/xml");
        for (var _i = 0, _a = xmlData.querySelectorAll('level'); _i < _a.length; _i++) {
            var level = _a[_i];
            localsObj[level.getAttribute('id')] = {
                title: level.getAttribute('title'),
                description: level.getAttribute('description'),
                quote: level.getAttribute('quote'),
                quoteAuthor: level.getAttribute('quote_author')
            };
        }
        return localsObj;
    };
    return LocalizationService;
}());
LocalizationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        platform_browser_1.Title,
        _1.ProgressService,
        _1.EventService,
        router_1.Router,
        router_1.ActivatedRoute,
        _1.ResourcePreloaderService])
], LocalizationService);
exports.LocalizationService = LocalizationService;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var storage_service_1 = __webpack_require__(69);
var MigrationService = (function () {
    function MigrationService(storageService) {
        this.storageService = storageService;
    }
    MigrationService.prototype.migrate = function () {
        this.removeAndReplacePGIfNeeded();
        this.removeAndReplaceOldfIfNeeded();
    };
    MigrationService.prototype.removeAndReplacePGIfNeeded = function () {
        var storage = this.storageService.getStorage();
        if (storage.SharedPreferences) {
            return;
        }
        for (var oldProperty in storage) {
            if (oldProperty.indexOf('PG') !== -1) {
                var oldPropertyPG = oldProperty;
                var newPropertyWithoutPG = oldPropertyPG.slice(2);
                if (newPropertyWithoutPG === 'SharedPreferences') {
                    var oldPropertyPGValue = this.storageService.getObject(oldPropertyPG);
                    this.storageService.save(newPropertyWithoutPG, oldPropertyPGValue);
                }
                else if (newPropertyWithoutPG === 'LevelsResult') {
                    var oldPropertyPGValue = this.storageService.getObject(oldPropertyPG);
                    for (var levelId in oldPropertyPGValue) {
                        var level = oldPropertyPGValue[levelId];
                        level.e_moves = level.elementaryMoves;
                        level.v_count = level.foundVariantsCount;
                        level.l_moves = level.lineMoves;
                        delete level.elementaryMoves;
                        delete level.foundVariantsCount;
                        delete level.lineMoves;
                    }
                    this.storageService.save(newPropertyWithoutPG, oldPropertyPGValue);
                }
                else {
                    var oldPropertyPGValue = this.storageService.get(oldPropertyPG);
                    if (!oldPropertyPGValue) {
                        this.storageService.save(newPropertyWithoutPG, []);
                    }
                    else {
                        this.storageService.save(newPropertyWithoutPG, oldPropertyPGValue.split(','));
                    }
                }
                this.storageService.remove(oldPropertyPG);
            }
        }
    };
    MigrationService.prototype.removeAndReplaceOldfIfNeeded = function () {
        var tokenFromOldSite = this.storageService.get('CurrentUser');
        var wasLoginFromOldSite = this.storageService.get('wasLogin');
        var usersFromOldSite = this.storageService.get('Users');
        if (tokenFromOldSite) {
            this.storageService.saveString('userToken', tokenFromOldSite);
            this.storageService.remove('CurrentUser');
        }
        if (wasLoginFromOldSite) {
            this.storageService.remove('wasLogin');
        }
        if (usersFromOldSite) {
            this.storageService.remove('Users');
        }
    };
    return MigrationService;
}());
MigrationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [storage_service_1.StorageService])
], MigrationService);
exports.MigrationService = MigrationService;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var router_1 = __webpack_require__(23);
var ShortPathGameGuardService = (function () {
    function ShortPathGameGuardService(router, localizationService) {
        this.router = router;
        this.localizationService = localizationService;
        this.currentLang = this.localizationService.currentLang;
        this.rootUrl = this.localizationService.getRootUrl();
    }
    ShortPathGameGuardService.prototype.canActivate = function (route) {
        if (route.params.levelId === 'notfound') {
            this.router.navigate([this.currentLang + '/game/packs']);
        }
        else if (route.url.join('/').indexOf('level') !== -1) {
            this.router.navigate([this.currentLang + '/' + route.url.join('/')]);
        }
        else {
            this.router.navigate([this.currentLang + this.rootUrl]);
        }
        return false;
    };
    return ShortPathGameGuardService;
}());
ShortPathGameGuardService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router,
        _1.LocalizationService])
], ShortPathGameGuardService);
exports.ShortPathGameGuardService = ShortPathGameGuardService;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var http_1 = __webpack_require__(53);
var progress_service_1 = __webpack_require__(145);
var pack_level_service_1 = __webpack_require__(101);
var event_service_1 = __webpack_require__(143);
var storage_service_1 = __webpack_require__(69);
var Module = window.Module;
var UserService = (function () {
    function UserService(http, progressService, packLevelService, eventService, storageService) {
        this.http = http;
        this.progressService = progressService;
        this.packLevelService = packLevelService;
        this.eventService = eventService;
        this.storageService = storageService;
        this.authorized = false;
        this.getCurrentUser();
    }
    UserService.prototype.getCurrentUser = function () {
        var _this = this;
        var headers = new http_1.Headers({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
        this.userPromise = this.http.get('/api/v1/auth/user', { headers: headers })
            .toPromise()
            .then(function (data) {
            _this.user = data.json();
            _this.userToken = _this.user.token;
            _this.authorized = true;
            _this.user;
            var tokenFromStorage = _this.storageService.get('userToken');
            if (!tokenFromStorage && _this.storageService.getArray('PlayedLevels').length) {
                // только залогинился
                _this.eventService.fire('showModalHelpProgress');
            }
            else if (tokenFromStorage && tokenFromStorage !== _this.userToken) {
                // два разных
                _this.replaceProgress();
            }
            else {
                _this.sync();
            }
            _this.storageService.saveString('userToken', _this.userToken);
        }, function (err) {
            _this.authorized = false;
            if (_this.storageService.get('userToken')) {
                _this.storageService.remove('userToken');
                _this.progressService.resetProgress();
                _this.eventService.fire('getStarsProgress');
            }
        });
    };
    UserService.prototype.sync = function () {
        var _this = this;
        var lastSyncDate = this.storageService.get('SyncDate');
        return this.userPromise
            .then(function () {
            if (!_this.authorized) {
                return;
            }
            var progress = {
                app: 'Geom',
                unlocked_levels: _this.progressService.unlockedLevels,
                played_levels: _this.progressService.playedLevels,
                skipped_levels: _this.progressService.skippedLevels,
                level_results: [],
                timestamp: _this.storageService.get('SyncTimestamp')
            };
            progress.timestamp = progress.timestamp ? parseInt(progress.timestamp) : progress.timestamp;
            var keys = Object.keys(_this.progressService.levelsResults);
            lastSyncDate = lastSyncDate ? new Date(lastSyncDate) : null;
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                var el = _this.progressService.levelsResults[key];
                var elDate = new Date(el.date);
                if (!lastSyncDate || elDate > lastSyncDate) {
                    progress.level_results.push({
                        level_id: el.level_id || el.levelId,
                        date: elDate.toISOString(),
                        e_moves: el.e_moves,
                        l_moves: el.l_moves,
                        v_count: el.v_count
                    });
                }
            }
            _this.storageService.saveString('SyncDate', (new Date()).toISOString());
            return _this.http.post('/api/v1/sync/progress?token=' + _this.userToken, progress).toPromise();
        })
            .then(function (res) {
            if (!res) {
                return;
            }
            var progress = res.json();
            if (progress.is_reset) {
                _this.progressService.resetProgress();
            }
            _this.progressService.updateProgressBySync(progress);
            _this.storageService.saveString('SyncTimestamp', progress.timestamp);
            _this.eventService.fire('progressSynced');
        })
            .catch(function () {
            if (lastSyncDate) {
                _this.storageService.saveString('SyncDate', lastSyncDate);
            }
            else {
                _this.storageService.remove('SyncDate');
            }
        });
    };
    UserService.prototype.replaceProgress = function () {
        this.progressService.resetProgress();
        return this.sync();
    };
    UserService.prototype.resetProgress = function () {
        var _this = this;
        return this.userPromise
            .then(function () {
            if (!_this.authorized) {
                return;
            }
            return _this.http.delete('/api/v1/sync/progress?token=' + _this.userToken).toPromise();
        })
            .then(function (res) {
            var progress = res.json();
            _this.storageService.saveString('SyncTimestamp', progress.timestamp);
        });
    };
    return UserService;
}());
UserService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        progress_service_1.ProgressService,
        pack_level_service_1.PackLevelService,
        event_service_1.EventService,
        storage_service_1.StorageService])
], UserService);
exports.UserService = UserService;


/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".app {\n  height: 100vh;\n}\n\n.app-background {\n  position: fixed;\n  width: 3600px;\n  height: 3600px;\n  opacity: 0.3;\n  background-image: url(" + __webpack_require__(179) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.app-background-first {\n  bottom: -1810px;\n  right: -1300px;\n  -ms-transform: rotate(54deg);\n  transform: rotate(54deg);\n}\n\n.app-background-second {\n  top: -1810px;\n  left: -1300px;\n  -ms-transform: rotate(300deg);\n  transform: rotate(300deg);\n}\n\n", ""]);

// exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".header {\n  position: fixed;\n  z-index: 9;\n  padding: 10px;\n  background-repeat: repeat;\n  background-color: #2d3336;\n  width: 100%;\n  min-width: 940px;\n  box-shadow: 0 0 20px 0 #000;\n}\n\n.logo {\n  margin-right: 10px;\n  float: left;\n  width: 222px;\n  height: 40px;\n}\n\n.logo-img {\n  max-width: 100%;\n}\n\n.settings {\n  margin: 0 10px;\n  float: left;\n  cursor: pointer;\n  height: 40px;\n  width: 40px;\n  background-image: url(" + __webpack_require__(861) + ");\n  background-position: 0 -80px;\n  background-repeat: no-repeat;\n}\n\n.settings:hover {\n  background-position: 0 -40px;\n}\n\n.settings:active {\n  background-position: 0 0;\n}\n\n.divider {\n  margin-top: -10px;\n  float: left;\n  margin-bottom: -10px;\n  width: 2px;\n  background: #1e2327;\n  height: 60px;\n}\n\n.buttons {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  display: inline-block;\n  width: 292px;\n  height: 40px;\n}\n\n.button {\n  display: inline-block;\n  height: 40px;\n  background-position: 0 0;\n}\n\n.button-apple-en {\n  width: 120px;\n  background-image: url(" + __webpack_require__(182) + ");\n}\n\n.button-google-en {\n  float: right;\n  width: 120px;\n  background-image: url(" + __webpack_require__(184) + ");\n}\n\n.button-apple-ru {\n  width: 120px;\n  background-image: url(" + __webpack_require__(181) + ");\n}\n\n.button-google-ru {\n  float: right;\n  width: 120px;\n  background-image: url(" + __webpack_require__(183) + ");\n}\n\n.button:hover {\n  background-position: 0 -40px;\n}\n\n.count {\n  display: inline-block;\n  font-weight: 400;\n  line-height: 32px;\n}\n\n.count-box {\n  margin: 5px 10px 0 0;\n  padding: 0 8px 0 5px;\n  float: right;\n  background-color: rgba(0, 0, 0, 0.5);\n  height: 30px;\n  border-radius: 10px;\n}\n\n.count-inner-bold {\n  font-weight: 900;\n  margin-right: 5px;\n}\n\n.sign-in-out {\n  margin-right: -10px;\n  padding: 0 30px;\n  display: inline-block;\n  float: right;\n  color: #3189ff;\n  height: 40px;\n  line-height: 40px;\n  cursor: pointer;\n  text-shadow: 0 1px 2px #000;\n}\n\n.sign-in-out:hover {\n  color: #5AA0FF;\n}\n\n.star {\n  display: inline-block;\n  height: 30px;\n  width: 30px;\n  float: left;\n  background-image: url(" + __webpack_require__(21) + ");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.total-count {\n  display: inline-block;\n  color: #fff;\n  line-height: 30px;\n}\n\n", ""]);

// exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".game-toolbar button.levels-list,\n.game-toolbar button.level-prev,\n.game-toolbar button.level-next,\n.game-toolbar button.level-restart {\n  background-position: 0 -80px;\n}\n\n.game-toolbar button.levels-list:hover,\n.game-toolbar button.level-prev:hover,\n.game-toolbar button.level-next:hover,\n.game-toolbar button.level-restart:hover {\n  background-position: 0 -40px;\n}\n\n.gold-color {\n  color: #f8ad00;\n}\n\n.grey-color {\n  color: #4c4c4c;\n}\n\n.black-color {\n  color: #000;\n}\n\n#scene_wrapper {\n  background-color: #f4f5f7;\n}\n\n.game-toolbar {\n  border-radius: 10px;\n  height: 48px;\n  width: 185px;\n  padding: 3px 0 5px 5px;\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  z-index: 100;\n  background-color: #F7F7F7;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);\n}\n\n.game-toolbar button {\n  display: inline-block;\n  z-index: 101;\n  position: relative;\n  height: 40px;\n  width: 40px;\n  margin: 2px;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background-color: transparent;\n}\n\n.game-toolbar button.levels-list {\n  background-image: url(" + __webpack_require__(187) + ");\n}\n\n.game-toolbar button.level-prev {\n  background-image: url(" + __webpack_require__(188) + ");\n}\n\n.game-toolbar button.level-next {\n  background-image: url(" + __webpack_require__(123) + ");\n}\n\n.game-toolbar button.dis-level-prev {\n  background-image: url(" + __webpack_require__(188) + ");\n  background-position: 0 0;\n  cursor: default;\n}\n\n.game-toolbar button.dis-level-next {\n  background-image: url(" + __webpack_require__(123) + ");\n  background-position: 0 0;\n  cursor: default;\n}\n\n.game-toolbar button.level-restart {\n  background-image: url(" + __webpack_require__(189) + ");\n}\n\n.level-target {\n  padding: 10px;\n  width: 185px;\n  height: 150px;\n  background-color: #F7F7F7;\n  border-radius: 10px;\n  position: absolute;\n  top: 68px;\n  left: 10px;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 700;\n  font-family: \"Open Sans\", sans-serif;\n  color: #4c4c4c;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.level-number {\n  position: absolute;\n  top: 10px;\n}\n\n.undo-redo-toolbar {\n  position: fixed;\n  top: 15px;\n  right: 15px;\n}\n\n.undo-redo-toolbar a {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  width: 40px;\n  height: 40px;\n  border: none;\n  cursor: pointer;\n  outline: none;\n}\n\n.undo-redo-toolbar a.undo {\n  margin-right: 4px;\n  background-image: url(" + __webpack_require__(870) + ");\n  background-position: 0 -40px;\n}\n\n.undo-redo-toolbar a.undo:hover {\n  background-position: 0 -80px;\n}\n\n.undo-redo-toolbar a.undo.btn-disabled {\n  background-position: 0 0;\n  cursor: default;\n  pointer-events: none;\n}\n\n.undo-redo-toolbar a.redo {\n  background-image: url(" + __webpack_require__(869) + ");\n  background-position: 0 -40px;\n}\n\n.undo-redo-toolbar a.redo:hover {\n  background-position: 0 -80px;\n}\n\n.undo-redo-toolbar a.redo.btn-disabled {\n  background-position: 0 0;\n  cursor: default;\n}\n\n.undo-redo-toolbar a.explore {\n  background-image: url(" + __webpack_require__(186) + ");\n  background-position: 0 -40px;\n  margin-left: 5px;\n}\n\n.undo-redo-toolbar a.explore.btn-active {\n  background-position: 0 0;\n}\n\n.undo-redo-toolbar a.explore.hidden {\n  display: none;\n}\n\n#tool_box {\n  position: fixed;\n  bottom: 10px;\n  left: 50%;\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  text-align: center;\n  z-index: 100;\n}\n\n#tool_box .buttons-wrapper {\n  display: inline-block;\n}\n\n#tool_box .buttons-wrapper .tool-button {\n  display: inline-block;\n  z-index: 101;\n  cursor: pointer;\n  width: 48px;\n  height: 48px;\n  margin: 4px;\n}\n\n#moves-counter-wrapper {\n  position: absolute;\n  top: 20px;\n  font-size: 19px;\n  font-weight: bold;\n  color: #707070;\n  text-align: center;\n}\n\n#moves-counter-wrapper .moves-counter {\n  padding: 5px;\n  border-radius: 10px;\n  background-color: rgba(247, 247, 247, 0.6);\n  display: inline-block;\n  font-weight: 700;\n  font-family: \"Open Sans\", sans-serif;\n  color: #b2b2b2;\n}\n\n.figure-image {\n  max-width: 100%;\n}\n\n.varial-box {\n  position: fixed;\n  bottom: 8px;\n  left: 10px;\n}\n\n.help {\n  width: 48px;\n  height: 48px;\n  z-index: 101;\n  cursor: pointer;\n  background: url(" + __webpack_require__(862) + ") 0 0;\n}\n\n.help:hover {\n  background-position: 0 -48px;\n}\n\n.help:active {\n  background-position: 0 -96px;\n}\n\n.logo {\n  margin-top: 10px;\n  display: block;\n  width: 212px;\n}\n\n.logo-img {\n  max-width: 100%;\n}\n\n.logo-img.adaptive {\n  display: none;\n}\n\n@media all and (max-width: 990px) {\n  .logo-img {\n    display: none;\n  }\n\n  .logo-img.adaptive {\n    display: inline-block;\n  }\n}\n\n.buttons {\n  position: fixed;\n  bottom: 10px;\n  right: 10px;\n}\n\n.button {\n  margin-top: 5px;\n  display: block;\n  height: 40px;\n  width: 120px;\n  background-position: 0 0;\n  background-repeat: no-repeat;\n}\n\n.button-apple-en {\n  background-image: url(" + __webpack_require__(182) + ");\n}\n\n.button-google-en {\n  background-image: url(" + __webpack_require__(184) + ");\n}\n\n.button-apple-ru {\n  background-image: url(" + __webpack_require__(181) + ");\n}\n\n.button-google-ru {\n  background-image: url(" + __webpack_require__(183) + ");\n}\n\n.reward {\n  position: absolute;\n  bottom: 10px;\n  left: 7px;\n}\n\n.reward-inner {\n  margin: 3px;\n}\n\n#counter {\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n", ""]);

// exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".levels-box {\n  position: relative;\n  padding-top: 40px;\n  height: 100%;\n}\n\n.levels-box-inner {\n  position: relative;\n  margin: 0 auto;\n  padding-top: 120px;\n  height: 100%;\n  max-width: 852px;\n}\n\n.pack-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  top: 60px;\n  text-align: center;\n}\n\n.title {\n  font-family: \"Roboto Slab\", sans-serif;\n  color: #fff;\n  font-size: 25px;\n  font-weight: 900;\n  text-shadow: 1px 1px 1px #000;\n}\n\n.icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  z-index: -1;\n  top: -19px;\n  bottom: auto;\n  width: 64px;\n  height: 64px;\n  -ms-transform: scale(1.7);\n  transform: scale(1.7);\n  opacity: .6;\n}\n\n.button-back-icon {\n  position: fixed;\n  top: 120px;\n  left: 10px;\n}\n\n.pack-button {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  display: block;\n  left: auto;\n  right: -35px;\n  background-color: rgba(0, 0, 0, 0.3);\n  width: 100px;\n  height: 80px;\n  border-radius: 40px;\n}\n\n.previous {\n  left: -35px;\n  right: auto;\n}\n\n.button-pack-icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  left: auto;\n  right: 5px;\n  width: 64px;\n  height: 64px;\n}\n\n.button-pack-icon-next {\n  right: auto;\n  left: 5px;\n}\n\n.level {\n  position: relative;\n  background-image: url(" + __webpack_require__(865) + ");\n  margin: 12px;\n  display: block;\n  float: left;\n  width: 260px;\n  height: 200px;\n  text-align: center;\n  overflow: hidden;\n  opacity: .9;\n  transition: opacity .25s ease-in-out;\n  text-decoration: none;\n}\n\n.level:hover {\n  opacity: 1;\n}\n\n.level-title {\n  margin: 2px 4px;\n  color: #4c4c4c;\n}\n\n.level-icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  width: 260px;\n  height: 110px;\n}\n\n.locked {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  height: 100%;\n  background-image: url(" + __webpack_require__(866) + ");\n  cursor: default;\n}\n\n.locked .level-title {\n  color: #787c7f;\n}\n\n.footer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  top: auto;\n  height: 50px;\n  color: rgba(107, 110, 111, 0.7);\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n}\n\n.state {\n  margin: 0 -10px 0 0;\n  float: right;\n}\n\n.solve {\n  margin-top: 28px;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n}\n\n.tutorial {\n  width: 30px;\n  height: 30px;\n  background-image: url(" + __webpack_require__(872) + ");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.level-type {\n  position: relative;\n  float: left;\n  width: 30px;\n  height: 30px;\n  text-align: left;\n  margin: 0 0 0 -10px;\n  color: rgba(107, 110, 111, 0.7);\n  font-weight: 900;\n  font-size: 24px;\n  font-family: \"Roboto Slab\", sans-serif;\n}\n\n.level-header {\n  margin: 10px 15px 0 25px;\n}\n\n.star-block {\n  position: relative;\n  float: left;\n  width: 30px;\n  height: 30px;\n}\n\n.star-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.star-check {\n  top: -1px;\n}\n\n", ""]);

// exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".main {\n  height: 100vh;\n  min-width: 990px;\n}\n\n.main-background {\n  position: fixed;\n  width: 3600px;\n  height: 3600px;\n  opacity: 0.3;\n  background-image: url(" + __webpack_require__(179) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.main-background-first {\n  bottom: -1810px;\n  right: -1300px;\n  -ms-transform: rotate(54deg);\n  transform: rotate(54deg);\n}\n\n.main-background-second {\n  top: -1810px;\n  left: -1300px;\n  -ms-transform: rotate(300deg);\n  transform: rotate(300deg);\n}\n\n.layout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.5);\n  transition: .2s;\n}\n\n.layout.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n", ""]);

// exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  top: 10%;\n  bottom: auto;\n  width: 450px;\n  background-color: #F7F7F7;\n  border-radius: 10px;\n  -ms-transform-origin: center 38%;\n  transform-origin: center 38%;\n  box-shadow: 0px 23px 57px -20px #000;\n  font-family: \"Open Sans\", sans-serif;\n  color: #4c4c4c;\n  will-change: transform;\n}\n\n.active .modal {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-description {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 125;\n  background: rgba(0, 0, 0, 0.5);\n  transition: .2s;\n  opacity: 0;\n  visibility: hidden;\n  transition: .3s;\n  z-index: 100;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.modal-description.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-layout {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .modal .header,\n  .modal .level-description {\n    cursor: text;\n  }\n}\n\n.header {\n  position: relative;\n  padding: 15px 35px;\n  text-align: center;\n  font-weight: 600;\n  font-size: 17px;\n  cursor: auto;\n}\n\n.close-icon {\n  position: absolute;\n  top: 5px;\n  bottom: 0;\n  right: 5px;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.level-detail {\n  text-align: center;\n}\n\n.level-detail .level-image {\n  max-width: 100%;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-drag: none;\n  pointer-events: none;\n}\n\n.level-detail-img-container {\n  margin: 0 auto;\n  height: 200px;\n  width: 72%;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.level-description {\n  padding: 30px;\n  text-align: left;\n  line-height: 22px;\n  cursor: auto;\n}\n\n.divider {\n  height: 0;\n  width: 88%;\n  margin: 0 6%;\n  border-bottom: solid 1px #efeaea;\n}\n\n.help {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  width: 40px;\n  height: 40px;\n  background: url(" + __webpack_require__(178) + ") no-repeat center;\n  background-size: 61px;\n  cursor: pointer;\n}\n\n.state {\n  position: absolute;\n  right: 0;\n  margin: 4px 6% 0 0;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  pointer-events: none;\n}\n\n.star-block {\n  position: relative;\n  float: left;\n  width: 30px;\n  height: 30px;\n}\n\n.star-image {\n  position: absolute;\n  z-index: 20;\n  left: 0;\n}\n\n.star-check {\n  top: -1px;\n}\n\n.goal {\n  position: absolute;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  font-size: 14px;\n  float: left;\n  display: block;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.goal-inner {\n  margin-left: 5px;\n  display: inline-block;\n  font-weight: 700;\n}\n\n.goal-inner:first-child {\n  margin-left: 3px;\n}\n\n.goal-bar {\n  position: relative;\n  padding: 10px 30px;\n  height: 60px;\n}\n\n.gold-color {\n  color: #f8ad00;\n}\n\n.title-level {\n  margin-right: 10px;\n}\n\n", ""]);

// exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 125;\n  background: rgba(0, 0, 0, 0.5);\n  transition: .2s;\n  z-index: 10;\n}\n\n.modal.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-layout {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.window {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 100;\n  width: 450px;\n  top: 10%;\n  bottom: auto;\n  background-color: #F7F7F7;\n  border-radius: 15px;\n  transition: .2s;\n  box-shadow: 0 5px 15px #000;\n  padding-bottom: 20px;\n}\n\n.active .window {\n  opacity: 1;\n  visibility: visible;\n}\n\n.header {\n  position: relative;\n  width: 100%;\n  height: 50px;\n  background-image: url(" + __webpack_require__(180) + ");\n}\n\n.header {\n  text-align: center;\n  border-radius: 10px 10px 0 0;\n}\n\n.title {\n  color: #cdcdcd;\n  font-family: \"Open Sans\", sans-serif;\n  text-transform: capitalize;\n  font-weight: 600;\n  line-height: 50px;\n  text-shadow: 0 1px 2px #000;\n}\n\n.close {\n  position: absolute;\n  top: 5px;\n  bottom: 0;\n  right: 5px;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.buttons {\n  text-align: center;\n}\n\n.button {\n  margin: 0 38px;\n  padding: 12px 24px;\n  display: inline-block;\n  background-color: #fff;\n  border-radius: 10px;\n  text-align: center;\n  cursor: pointer;\n  transition: .2s;\n  border: 1px solid #e6e6e6;\n}\n\n.button:hover {\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.button:active {\n  box-shadow: none;\n}\n\n.question {\n  margin: 30px 38px 16px;\n  line-height: 22px;\n}\n\n", ""]);

// exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".modal {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  z-index: 100;\n  top: 20%;\n  bottom: auto;\n  background-color: #F7F7F7;\n  border-radius: 15px;\n  transition: .6s;\n  box-shadow: 0px 23px 57px -20px #000;\n  will-change: transform;\n  opacity: 0;\n  visibility: hidden;\n  transition: .3s;\n  width: 550px;\n  line-height: 20px;\n  padding: 35px;\n}\n\n.active .modal {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-body,\n.modal-footer {\n  margin-bottom: 20px;\n}\n\n.modal-help-addon {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 125;\n  background: rgba(0, 0, 0, 0.5);\n  transition: .2s;\n  z-index: 100;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.modal-help-addon.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-layout {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.modal-title {\n  margin-bottom: 15px;\n  font-size: 17px;\n  font-weight: 700;\n  color: #4c4c4c;\n  text-align: center;\n}\n\n.modal-circle {\n  padding-top: 20px;\n}\n\n.close {\n  position: absolute;\n  top: 5px;\n  bottom: 0;\n  right: 5px;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  bottom: auto;\n}\n\n.ok {\n  position: absolute;\n  text-align: center;\n  left: 0;\n  right: 0;\n}\n\n.ok-text {\n  font-size: 16px;\n  color: #5AA0FF;\n  cursor: pointer;\n  display: inline-block;\n  transition: .1s;\n}\n\n.ok-text:hover {\n  text-decoration: underline;\n}\n\n.confirm {\n  margin: 0 72px;\n}\n\n", ""]);

// exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, "@keyframes rotate {\n  0% {\n\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes arrow-down {\n  0% {\n\n  }\n\n  100% {\n    opacity: .2;\n    transform: translateY(20%);\n  }\n}\n\n@keyframes arrow-top {\n  0% {\n    transform: translateY(0) rotate(180deg);\n  }\n\n  100% {\n    opacity: .2;\n    transform: translateY(20%) rotate(180deg);\n  }\n}\n\n@keyframes star {\n  0% {\n    transform: scale(0);\n  }\n\n  70% {\n    transform: scale(1.15);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n.modal-help {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 120;\n  transition: .2s;\n}\n\n.modal-help.active {\n  opacity: 1;\n  visibility: visible;\n  transition: 0s;\n}\n\n.modal-help.scroll-bottom .scroll-down {\n  display: none;\n}\n\n.modal-help.scroll-bottom .scroll-top {\n  display: block;\n}\n\n.modal-help.dark {\n  transition: .3s;\n}\n\n.modal-help.dark .modal-layout {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.modal-layout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n.modal-inner {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  z-index: 100;\n  top: 10%;\n  bottom: auto;\n  width: 550px;\n  height: 580px;\n  background-color: #F7F7F7;\n  border-radius: 10px;\n  transition: cubic-bezier(0.17, 0.67, 0.61, 1.1) 0.2s;\n  -ms-transform-origin: center 38%;\n  transform-origin: center 38%;\n  -ms-transform: scale(0.8);\n  transform: scale(0.8);\n  box-shadow: 0px 23px 57px -20px #000;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.active .modal-inner {\n  opacity: 1;\n  visibility: visible;\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n\n.header {\n  color: #cdcdcd;\n  font-family: \"Open Sans\", sans-serif;\n  text-transform: capitalize;\n  font-weight: 600;\n  position: absolute;\n  width: 100%;\n  height: 50px;\n  text-align: center;\n  padding: 17px 35px;\n  background-color: #2d3336;\n  border-radius: 10px 10px 0 0;\n  top: -10px;\n  text-shadow: 0 1px 2px #000;\n}\n\n.close-icon {\n  position: absolute;\n  top: 5px;\n  bottom: 0;\n  right: 5px;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.scroll-down {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 6px;\n  margin: 0 auto;\n  cursor: pointer;\n  background-image: url(" + __webpack_require__(860) + ");\n  background-position: center;\n  width: 30px;\n  height: 30px;\n}\n\n.star-image {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  pointer-events: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  left: 0;\n}\n\n.star-image:after {\n  content: '';\n  display: block;\n  clear: both;\n}\n\n.star-block {\n  position: relative;\n  height: 40px;\n  padding: 1px 0;\n}\n\n.star-block > img {\n  height: 30px;\n  position: absolute;\n  left: -35px;\n  margin-top: -6px;\n}\n\n.star-check {\n  top: -1px;\n}\n\n.help-window {\n  margin-top: 40px;\n  height: 496px;\n  overflow-y: scroll;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.help-description-title {\n  padding-top: 10px;\n  padding-left: 35px;\n  font-weight: 600;\n}\n\n.help-description {\n  padding: 0 35px;\n  line-height: normal;\n}\n\n.help-description > p {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n\n.help-description-stars {\n  margin: 15px 0;\n}\n\n.stars-block {\n  margin-top: 20px;\n  margin-bottom: 15px;\n  display: block;\n  padding-left: 60px;\n}\n\n.hand-block {\n  padding: 7px 0;\n  position: relative;\n}\n\n.tool-icon-absolute {\n  position: absolute;\n  z-index: -1;\n  left: -60px;\n  top: 12px;\n  width: 48px;\n  height: 48px;\n}\n\n.tool-icon-absolute:hover {\n  background-position: 0 0;\n}\n\n.icon-Explore {\n  height: 40px;\n  width: 40px;\n  background-image: url(" + __webpack_require__(186) + ");\n  background-repeat: no-repeat;\n  background-position: 0 -40px;\n}\n\n.icon-HandTool {\n  background: url(" + __webpack_require__(873) + ") no-repeat center;\n  background-position: 0 0;\n}\n\n.support-mail {\n  padding: 5px;\n  display: block;\n  text-align: center;\n  color: #5AA0FF;\n}\n\ntable.tools-list {\n  position: relative;\n  z-index: -1;\n  border-collapse: collapse;\n  background: #fff;\n  width: 90%;\n  border-radius: 10px;\n  margin: 10px auto;\n}\n\ntable.tools-list tr {\n  border-bottom: 1px solid #ddd;\n}\n\ntable.tools-list tr td:last-of-type {\n  padding: 0 10px;\n}\n\ntable.tools-list tr .tool-icon {\n  width: 48px;\n  height: 48px;\n  margin: 10px 15px;\n}\n\ntable.tools-list tr .tool-icon:hover {\n  background-position: 0 0;\n}\n\ntable.tools-list tr:last-of-type {\n  border-bottom: none;\n}\n\ntable.hotKeys-list {\n  position: relative;\n  z-index: -1;\n  border-collapse: collapse;\n  background: #fff;\n  width: 90%;\n  border-radius: 10px;\n  margin: 10px auto;\n}\n\ntable.hotKeys-list tr {\n  border-bottom: 1px solid #ddd;\n}\n\ntable.hotKeys-list tr td {\n  padding: 10px;\n  line-height: 17px;\n}\n\ntable.hotKeys-list tr .tool-icon {\n  width: 48px;\n  height: 48px;\n  margin: 10px 15px;\n}\n\ntable.hotKeys-list tr .tool-icon:hover {\n  background-position: 0 0;\n}\n\ntable.hotKeys-list tr:last-of-type {\n  border-bottom: none;\n}\n\n", ""]);

// exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".modal-success {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 125;\n  background: rgba(0, 0, 0, 0.5);\n  transition: .2s;\n  z-index: 110;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.modal-success.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-layout {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.window {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 100;\n  width: 450px;\n  top: 10%;\n  bottom: auto;\n  background-color: #F7F7F7;\n  border-radius: 15px;\n  transition: .2s;\n  box-shadow: 0 5px 15px #000;\n  border-radius: 10px;\n  font-family: \"Open Sans\", sans-serif;\n  will-change: transform;\n  transition: 0s;\n  box-shadow: 0px 23px 57px -20px #000;\n}\n\n.active .window {\n  transition: linear .2s .5s;\n  opacity: 1;\n  visibility: visible;\n}\n\n.header {\n  position: relative;\n  text-align: center;\n  font-weight: 600;\n  color: #4c4c4c;\n  font-size: 17px;\n  padding: 20px;\n}\n\n.result-counts {\n  width: 100%;\n  display: inline-block;\n  text-align: center;\n  color: #8c8c8c;\n  font-weight: 700;\n  font-size: 14px;\n  margin-top: 7px;\n}\n\n.result-counts-inner {\n  margin: 0 2px;\n}\n\n.result-bar {\n  background-image: url(" + __webpack_require__(443) + ");\n}\n\n.stars {\n  -webkit-user-drag: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 5px auto 15px;\n  width: 100%;\n  text-align: center;\n  pointer-events: none;\n}\n\n.stars-animate {\n  position: absolute;\n  top: 78px;\n}\n\n.stars-animate .star {\n  -ms-transform: scale(0);\n  transform: scale(0);\n  animation-delay: 0s;\n}\n\n.stars-animate .star.bubble {\n  opacity: 1;\n  visibility: visible;\n  animation: star 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) 1s forwards 1;\n}\n\n.stars-animate .starV {\n  position: absolute;\n}\n\n.stars-animate .starV.bubble {\n  position: relative;\n}\n\n.star {\n  margin: 5px;\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  -webkit-user-drag: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.close-icon {\n  position: absolute;\n  top: 5px;\n  bottom: 0;\n  right: 5px;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.quote {\n  font-family: \"Roboto\", sans-serif;\n  min-height: 50px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.quote-text {\n  margin: 0 auto;\n  color: #8c8c8c;\n  font-style: italic;\n  font-size: 13px;\n  line-height: 15px;\n}\n\n.quote-body {\n  position: relative;\n  padding: 15px 60px;\n}\n\n.quote-author {\n  font-size: 13px;\n  color: #8c8c8c;\n  padding: 0 60px 0 60px;\n}\n\n.open-quote,\n.close-quote {\n  position: absolute;\n  right: 20px;\n  width: 30px;\n  height: 30px;\n}\n\n.open-quote {\n  top: 0;\n  left: 20px;\n  background: url(" + __webpack_require__(863) + ") no-repeat;\n}\n\n.close-quote {\n  bottom: 0;\n  background: url(" + __webpack_require__(864) + ") no-repeat;\n}\n\n.goal {\n  position: relative;\n  background-color: rgba(0, 0, 0, 0.3);\n  font-size: 14px;\n  color: #8c8c8c;\n  padding: 8px 20px;\n  font-weight: 700;\n}\n\n.goal-inner {\n  margin-left: 5px;\n}\n\n.help {\n  float: right;\n  width: 25px;\n  height: 25px;\n  margin-top: -6px;\n  background: url(" + __webpack_require__(178) + ") no-repeat center;\n  background-size: 51px;\n  cursor: pointer;\n}\n\n.divider {\n  height: 0;\n  width: 88%;\n  margin: 0 6%;\n  border-bottom: solid 1px #efeaea;\n}\n\n.buttons {\n  padding: 5px;\n  text-align: center;\n}\n\n.button {\n  display: inline-block;\n  height: 40px;\n  width: 40px;\n  margin: 0 30px;\n  cursor: pointer;\n  background-position: 0 -80px;\n}\n\n.button:hover {\n  background-position: 0 -40px;\n}\n\n.level-list {\n  background-image: url(" + __webpack_require__(187) + ");\n}\n\n.level-restart {\n  background-image: url(" + __webpack_require__(189) + ");\n}\n\n.level-next {\n  background-image: url(" + __webpack_require__(123) + ");\n}\n\n.gold-color {\n  color: #f8ad00;\n}\n\n.hidden {\n  opacity: 0;\n  visibility: hidden;\n}\n\n", ""]);

// exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 125;\n  background: rgba(0, 0, 0, 0.5);\n  transition: .2s;\n  z-index: 10;\n}\n\n.modal.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-layout {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.modal-spinner {\n  transition: 1s;\n}\n\n.settings {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 100;\n  width: 450px;\n  top: 10%;\n  bottom: auto;\n  background-color: #F7F7F7;\n  border-radius: 15px;\n  transition: .2s;\n  box-shadow: 0 5px 15px #000;\n  height: 530px;\n  -ms-transform: translateY(200%);\n  transform: translateY(200%);\n}\n\n.active .settings {\n  opacity: 1;\n  visibility: visible;\n  -ms-transform: translateY(0%);\n  transform: translateY(0%);\n}\n\n.content {\n  white-space: nowrap;\n  transition: linear .2s;\n  height: 86%;\n}\n\n.content.right {\n  -ms-transform: translateX(-100%);\n  transform: translateX(-100%);\n}\n\n.content-wrapper {\n  height: 100%;\n  overflow: hidden;\n}\n\n.content.activeSpinner {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.content.activeSpinner .item {\n  position: relative;\n  z-index: -1;\n}\n\n.text {\n  margin: 41px 38px 41px;\n  line-height: 20px;\n  text-align: center;\n  white-space: normal;\n}\n\n.header,\n.footer {\n  position: relative;\n  width: 100%;\n  height: 50px;\n  background-color: #2d3336;\n}\n\n.header {\n  text-align: center;\n  border-radius: 10px 10px 0 0;\n}\n\n.footer {\n  position: absolute;\n  height: 42px;\n  bottom: 0;\n  border-radius: 0 0 10px 10px;\n  color: #cdcdcd;\n  font-size: 12px;\n}\n\n.title {\n  color: #cdcdcd;\n  font-family: \"Open Sans\", sans-serif;\n  text-transform: capitalize;\n  font-weight: 600;\n  line-height: 50px;\n  text-shadow: 0 1px 2px #000;\n  display: none;\n}\n\n.title.active {\n  display: block;\n}\n\n.close {\n  position: absolute;\n  top: 5px;\n  bottom: 0;\n  right: 5px;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.copyright,\n.version {\n  display: inline-block;\n  line-height: 42px;\n}\n\n.copyright {\n  margin-left: 15px;\n}\n\n.version {\n  margin-right: 15px;\n  float: right;\n}\n\n.items {\n  display: none;\n  padding-bottom: 42px;\n  width: 100%;\n  text-align: center;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.items.active {\n  display: inline-block;\n}\n\n.item {\n  padding: 12px 0;\n  margin: 15px auto 0;\n  background-color: #fff;\n  border-radius: 10px;\n  width: 90%;\n  cursor: pointer;\n  transition: .2s;\n  border: 1px solid #e6e6e6;\n}\n\n.item:hover {\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.item:active {\n  box-shadow: none;\n  transition: .1s;\n}\n\n.item-lang {\n  padding: 0;\n}\n\n.item-lang.active {\n  pointer-events: none;\n}\n\n.item-lang.active .item-link {\n  pointer-events: none;\n  background-repeat: no-repeat;\n  background-position: 98% center;\n  background-image: url(" + __webpack_require__(871) + ");\n  background-size: 25px;\n}\n\n.item-link {\n  padding: 12px 0;\n  display: block;\n  color: #000;\n  text-decoration: none;\n}\n\n.hidden {\n  display: none;\n}\n\n.invisible {\n  opacity: 0;\n  visibility: hidden;\n  transition: 0s;\n}\n\n.inner-layout {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  visibility: hidden;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 10;\n  transition: 1s;\n}\n\n.spinner + .inner-layout {\n  opacity: 1;\n  visibility: visible;\n}\n\n.spinner.invisible + .inner-layout {\n  opacity: 0;\n  visibility: hidden;\n  transition: 0s;\n}\n\n.back-btn {\n  position: absolute;\n  left: 2px;\n  top: 5px;\n  bottom: 0;\n  visibility: hidden;\n  opacity: 0;\n  cursor: pointer;\n  transition: .2s;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  width: 34px;\n  transition: .1s;\n  backface-visibility: hidden;\n}\n\n.back-btn.active {\n  visibility: visible;\n  opacity: 1;\n}\n\n", ""]);

// exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".packs-box {\n  margin: 0 auto;\n  padding-top: 85px;\n  height: 100%;\n  max-width: 840px;\n}\n\n.pack {\n  position: relative;\n  width: 240px;\n  height: 240px;\n  background-image: url(" + __webpack_require__(867) + ");\n  margin: 0 20px 40px 20px;\n  display: block;\n  float: left;\n  text-align: center;\n  color: #4c4c4c;\n  font-size: 20px;\n  font-weight: 600;\n  opacity: .9;\n  transition: opacity .25s ease-in-out;\n  text-decoration: none;\n}\n\n.pack:hover {\n  opacity: 1;\n}\n\n.pack-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  max-width: 125px;\n}\n\n.pack-icon-wrapper {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n.pack-title {\n  position: absolute;\n  right: 0;\n  bottom: 32px;\n  left: 0;\n  margin: 0 auto;\n  font-family: \"Roboto Slab\", sans-serif;\n}\n\n.pack-locked-title {\n  position: absolute;\n  top: 38px;\n  right: 0;\n  left: 0;\n  display: none;\n  font-weight: 400;\n  font-size: 16px;\n  color: #e6e6e6;\n}\n\n.pack.locked {\n  background-image: url(" + __webpack_require__(868) + ");\n  cursor: default;\n}\n\n.pack.locked .pack-locked-title {\n  display: block;\n}\n\n.pack.locked .stars-count,\n.pack.locked .star-pack {\n  display: none;\n}\n\n.pack.locked .pack-title {\n  color: #787c7f;\n}\n\n.stars-count {\n  margin-top: 31px;\n  margin-left: 7px;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  float: left;\n}\n\n.stars-earned {\n  margin-right: 2px;\n  font-weight: 700;\n}\n\n.stars-total {\n  margin-left: 2px;\n}\n\n.star-pack {\n  float: left;\n  margin-left: 30px;\n  margin-top: 25px;\n  width: 25px;\n  height: 25px;\n}\n\n", ""]);

// exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(25)();
// imports


// module
exports.push([module.i, ".wrapper {\n  position: relative;\n  margin-right: -10px;\n  display: inline-block;\n  float: right;\n  color: #3189ff;\n  height: 40px;\n  line-height: 40px;\n  text-shadow: 0 1px 2px #000;\n}\n\n.wrapper .sign-in {\n  padding: 0 30px;\n}\n\n.wrapper .user-block {\n  width: 190px;\n  height: 100%;\n  white-space: nowrap;\n}\n\n.wrapper .user-block .avatar {\n  position: absolute;\n  top: 0;\n  left: 16px;\n  bottom: 0;\n  margin: auto;\n  width: 30px;\n  height: 30px;\n  background-image: url(" + __webpack_require__(190) + ");\n  background-position: center;\n}\n\n.wrapper .user-block .user-name {\n  margin-left: 55px;\n  width: 124px;\n  color: #5AA0FF;\n  font-size: 16px;\n  display: inline-block;\n  transition: .2s;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wrapper .user-block .user-name span {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.wrapper .user-block .dropdown-arrow {\n  width: 32px;\n  height: 32px;\n  margin-top: 4px;\n  background-image: url(" + __webpack_require__(874) + ");\n  float: left;\n}\n\n.wrapper .user-block:hover .user-name {\n  text-decoration: underline;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.dropdown {\n  position: absolute;\n  top: 51px;\n  width: 100%;\n  text-align: center;\n  background-image: url(" + __webpack_require__(180) + ");\n  box-shadow: 0 0 1px #000;\n  transition: .2s;\n  -ms-transform: translateX(100%);\n  transform: translateX(100%);\n  cursor: pointer;\n  border-bottom-left-radius: 5px;\n}\n\n.dropdown.active {\n  -ms-transform: translateX(0);\n  transform: translateX(0);\n}\n\n.dropdown:hover .link {\n  text-decoration: underline;\n}\n\n.dropdown .sign-out-icon {\n  position: absolute;\n  top: 0;\n  left: 16px;\n  bottom: 0;\n  margin: auto;\n  width: 30px;\n  height: 30px;\n  background-image: url(" + __webpack_require__(875) + ");\n  background-position: center;\n}\n\n.dropdown .profile-icon {\n  position: absolute;\n  top: 0;\n  left: 16px;\n  bottom: 0;\n  margin: auto;\n  width: 30px;\n  height: 30px;\n  background-image: url(" + __webpack_require__(190) + ");\n  background-position: center;\n}\n\n.dropdown.js-dropdown-logout {\n  top: 110px;\n}\n\n.dropdown.js-dropdown-profile {\n  border-radius: 0;\n}\n\n.link {\n  text-align: left;\n  padding: 9px 0;\n  padding-left: 55px;\n  display: block;\n  color: #5AA0FF;\n  text-decoration: none;\n  transition: .2s;\n}\n\n.link-sign-in {\n  margin-left: 0;\n  padding: 0;\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n.link:hover-text {\n  text-decoration: underline;\n}\n\n", ""]);

// exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(415);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(416);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(417);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(418);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(419);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(420);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(421);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(422);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(423);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(424);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(425);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(426);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(427);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),
/* 441 */,
/* 442 */,
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/navBg@2x.98e976ef13460208b2a75314e6025e51.png";

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/3CirclesCDetailed.d607bafb5e7f5eaf4de4f234e5fccdb2.png";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/3CirclesIDetailed.3109cecd0d927230d229a9e5d195e5b9.png";

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/3rdProportionalDetailed.320da7346f5b231d7b516ec6f87d84cd.png";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/4SymmetricLinesDetailed.a724582e583349e456a02d6da70b909e.png";

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/4thProportionalDetailed.3622c1af44ac92bd2130988bc0dbcc39.png";

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/60RotationCWDetailed.28dffbd33a78a4854761049cdf68cb82.png";

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/90RotationCCWDetailed.ae54ffae349c824e59a854d24fd8935a.png";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/9PointCircleDetailed.0a69598b916482e2ca89538143a5a62e.png";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AEqualSegments1Detailed.e371b2279a1a4d2febc1ad105ca95582.png";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AMinPerimeterDetailed.1cc30cb5b7a5044415bee196d5b3a154.png";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/APtOnCircleMaxDistDetailed.c06a51134109dba2bd8d2a785c25ee68.png";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ATrByCentroidDetailed.cb4ab5222bce972ccfe62da3948d4c23.png";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ATrByCircumcenterDetailed.0f0ab9c11fdaad23c1d08516e6917123.png";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ATrByOrthocenterDetailed.335a5e9af9c3431cc625fbab2047dc0f.png";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle15Detailed.201b69de6426ec18080ee62f1a599b51.png";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle30Detailed.7ed3dea5e5b9c258ac78557d37f5daa5.png";

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle3Detailed.9b96f52b3eb7541328ecd15c8933f4c6.png";

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle45Detailed.de0114128377dc7f5fb64faea975f4dd.png";

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle54Detailed.f88f57dbef65398c2bb4404f26ca48b0.png";

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle60Detailed.da7c7b029960d7c8bb52725778732097.png";

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle60DropDetailed.a8fecc42bb58d423235fc06b20fa8474.png";

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle75Detailed.bb76eb7286850769cc5d2fa3f4088f93.png";

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AngleIsoscelesDetailed.9abb126853dc8dc80c49e0d744d2ed16.png";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AngleMidpointDetailed.2f0652e116e746fbd91058f825418c04.png";

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AngleTrisection54Detailed.9a59da57d8364fe0ae8ee173dd6ef301.png";

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AnnulusDetailed.118e475dbb3aefb8795a28e64bd36978.png";

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ArbelosDetailed.093a23d70228f605f7c0ca566b82fcac.png";

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/BisectAngleDetailed.8a3113fa7c8c2c31c9555991bda860f8.png";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CDoubleSegDetailed.fa1e245fc7beb56c572b74aa2efcdb34.png";

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CIntersectCLDetailed.60144046e5fa5bbf026e7c35813d3095.png";

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CIntersectXDetailed.4a7ab080f9a7db2f314a145867c5a3df.png";

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CMidpointDetailed.fdf4f4e394f892c7e6f5116ba7672a04.png";

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CTranslateCircleDetailed.140e8d123ae1ca652fcd5b5045e61506.png";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CenterOfRotationDetailed.1e5a980fc36eb4f14f901ad2e6e05cb5.png";

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CentroidOfQuadrilateralDetailed.381006421de9d291d326e0bbcb032b42.png";

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Chord3Detailed.c5cf3b54490ae2d0b9053e8838d93cc8.png";

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ChordMidpointDetailed.cad9fde3235868388a70939587b59a1e.png";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Circle3Detailed.759a9eaafd50dbe9d64f798dcc6f4fe8.png";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleByRadiusDetailed.76a4f4ece14b7ab90cba1320bc0c2fa5.png";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleCenterDetailed.1888c58f35a46ae5442180e8540e7c07.png";

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleEquidistantFrom4PointsDetailed.e0011b949ad81862ff01ab10495b9910.png";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInAngleDetailed.6898d29eb16a79f4606b870fcb05cff9.png";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInOutSquareDetailed.2c50ddedc0428a6f93ea2e70971fc622.png";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInRhombusDetailed.3eb104afd025e2a327301c14ee11f4d9.png";

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInSquareDetailed.c0bc34abea25a1eeea292d3e3547feb8.png";

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInTriangleDetailed.f060552103bf733033bf8a75dc7b0830.png";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentCCDetailed.f162b8e6d448dd06dbdc9e9887c533c1.png";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentCCwCenterLDetailed.d233875abe8885fa8dac7af12c4dd894.png";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentCLDetailed.348b5cefe3cf95295ccd4116ed5ed1f6.png";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentCPwCenterLDetailed.6e253b95f7ba23f36d5fa731b2689bed.png";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentLDetailed.1a522641eea2f86364b01ed5a07ca0c7.png";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentLLLDetailed.4179e94a590225817da8915237fa26bc.png";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentPLDetailed.2475b33b699d14fb818235c2ac816ca0.png";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentPPLDetailed.0371de1502239111d7d7a17892509a0c.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CleaverDetailed.ae2e8bb0d0b356be039ead193d69a4c6.png";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Cut2RectanglesDetailed.7ff7b16d8eaf942a3aa4ff1004986d18.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CutRectangleDetailed.5f1c47579798974bead1489abdc28a8a.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Divide3Detailed.cf381ddcc4137596887496736424b175.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/DoubleAngleDetailed.073a6075b30cd2a7dc8841c82232fffd.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/DropPerpDetailed.80a2af1f5b9bcb96fcc4c0def44dd113.png";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EqualSegments3Detailed.1b46ac4e65c548f67da3ca6451d78856.png";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Equidistant2Detailed.bb0cbd1b1e51276a38852e2f5bf2dd4f.png";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Equidistant3Detailed.c30a194bfe9fa697cf81f4d154afb183.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquidistantParallelDetailed.56c209ce00e3f5086b51eb88f28f9459.png";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Equilateral3Detailed.19c77375153cc4a0cec2cb72a33f23c7.png";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquilateralAboutCircleDetailed.64cad0edcb0ed055376c8e7bc3befa5d.png";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquilateralByCentroid2PDetailed.fe89bdf82b8feb830f1f7b3642eff6a4.png";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquilateralInCircleDetailed.5742052bdc7ef10b71983e63187ec73b.png";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquilateralOnCCDetailed.53d4652d6ff4d4c5337537adf876f4c3.png";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ErectPerpDetailed.89224590ee4043cd9b205103ed87e3f1.png";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ExcircleDetailed.f32017ba8ac7ed1b2646eceaca245ed8.png";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GeometricMeanDetailed.b479ca3f97a7982b390cba0d00b27fde.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GivenAngleBisectorDetailed.b217cae7360ddb674f663de5d27fdd84.png";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldenSectionDetailed.55e540260a2c189dafde9655cd54643d.png";

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HarmonicMeanDetailed.228c7354411bf1166c7ecedc26c04696.png";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HashDetailed.5ef67d18ce6b6c83c7563033d9fd76de.png";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HeronDetailed.8a5f39e1676f2d2d19b1a43998ce8e30.png";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HexagonBySideDetailed.c81c16f4f7580489688641d0cbdb53d7.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HypotenuseAndAltitudeDetailed.74fafb1d1cc836fb12ec3b865e328407.png";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HypotenuseAndLegDetailed.660a8d32c462bef7367fc30a9e6c50ec.png";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/IncenterDetailed.10118d773208a877077abaa145e6a6d2.png";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/InnerTangentDetailed.931e611bb41a2b0be27b30e684383858.png";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/InteriorAnglesDetailed.6201d051d4536c3ac4237702c9eb8117.png";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/IsoscelesTriangleAboutCircleDetailed.4c4ba1f25057b256899968fcd1941a8f.png";

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/L3ParallelDetailed.58920ca0880e640c15e67d1ab7af6dbe.png";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LDivide3Detailed.be77e081636bae5baf481846614e4afc.png";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LDropPerp2Detailed.e092bcec3966d036dd4d8d27484e2791.png";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LDropPerpDetailed.e9c2f9b0b6cafe0709b088e1de403a76.png";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LMidpointDetailed.5624f0c0c7732d88bc112dc3685de0f5.png";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LReflectionDetailed.32df527c0daceb66f373cf99b8966695.png";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LTangentDetailed.1760f75cdc899b4b4db49be5f13f64c4.png";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LineAlongPointsDetailed.6f99eb1cd103bf4fa450f26952895985.png";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LineBetweenPointsDetailed.e057780752f409e5637e27a358bb582b.png";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LozengeDetailed.bec74b2339c825fa6a6c14b813c5433f.png";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/MidpointDetailed.fc3f188c78a654ff325904a334156a09.png";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/MirrorSegDetailed.affe9e43ea4c946b8e08282b95e3df72.png";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/NapoleonDetailed.ec764bbf977fbcb2f6e8866da738cdef.png";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/OctagonBySideDetailed.2833f9f4a485e182761ad20abeb28efa.png";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/OrthicTriangleDetailed.e77afc076d3cb2c4fe420be3f5661e35.png";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/OuterTangentDetailed.0ed6fad0eeedc4fa83ebde0fecbbe1af.png";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ParallelDetailed.231972becaf1bd7b126919497962a12e.png";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Parallelogram3VDetailed.e8ea283a4917a74c296bf4876eb5ce27.png";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ParallelogramBy3MidpointsDetailed.91a5bcea633efe727b884635c8b4e7fb.png";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ParallelogramBySPDetailed.ab26fbf1b6a304404125eb0f5744bdb5.png";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ParallelogramVOn4LinesDetailed.c4a46b0522e0c4d54d3bc079817817d9.png";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PentagonDetailed.864e3c296ad07bf040f8f26c9af1ffbf.png";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PerimeterBisectorDetailed.5d3bb628cd6965214c802a1206c594e0.png";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PerpBisectorDetailed.6aaa85304d05eddbfcdcc61cc7ef9019.png";

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PtSymmetryDetailed.40e648b4d1f0b65bf6075968b1e96c2a.png";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RTrBy2SidePointsDetailed.fc70031cd621529237e72192c398d71f.png";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RTrByHypAndTangentPtDetailed.e833bb43453f06813a2c6426c82a8c55.png";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RhombusInRectDetailed.084f9d9a70025bf2096bd413b8fe7f11.png";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RhombusInTriangleDetailed.f77fe3cc485b50803ff87e744bc8e545.png";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Secant2Detailed.11c59ea419bf2df28d7f6ff6470c5708.png";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Segment6Detailed.d45b4f81e0d663daac8a288d28fa684c.png";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ShiftAngleDetailed.085b67a4aa91a17199a279c9524874a4.png";

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ShiftSegmentDetailed.d24f17b714b74603a248c5cbaba584e8.png";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Sqrt2Detailed.fdb424abed25b7f40914db4081472f5d.png";

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Sqrt3Detailed.869526e40075e60250bbd8a7dc48f263.png";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareAboutCircleDetailed.d96eb637a4b55f4ce7b055f11548dece.png";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareBy4PtDetailed.0454fa55c98259c2c764a4576c413929.png";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareByAdjMidpointsDetailed.7e74914eace3b0deab671a3d9801ad85.png";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareByOppMidpointsDetailed.be59e729459c0960a742a5062cd65965.png";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareInCircleByPtDetailed.5a389e113ed63e4e7d7e62642e343d22.png";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareInCircleDetailed.5505c8e87f332ba524d6772f9c9330dd.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareInSquareDetailed.62b94c4d4126a471bf693fb53a5194bc.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareInTriangleDetailed.1eb4042cbf4871e3e95df167a09d26c4.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SumSquaresDetailed.8a22e766f7b41531ada9388eae6149e1.png";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/T1_LineDetailed.a8bd5ce0140eed0d2d57b5eecb4ae7b6.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/T2_CircleDetailed.4468f2ac8e15dfac2e93d84a4fa61b6b.png";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/T3_PointDetailed.265a4ce127c5bfb8f7d37adaae03d1e9.png";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TBisectAngleDetailed.a3e5458beeeb74a3be1ae9c85df75ccc.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TCircleByRadiusDetailed.a609e7bcb13e8853189b8cd11d907b14.png";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TDropPerpDetailed.910789faaa217d13dc7c484e3b568605.png";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TEquilateralDetailed.291b44032c73ce226b280c4230aee8ae.png";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TIntersectDetailed.c00abfb645dd43dc8a05a3d290826b2c.png";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TMoveDetailed.94bbebe7397f1ea7925c9b45b8e20dcd.png";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TParallelDetailed.c38feab7d63d29cd4c0a474db3f7069f.png";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TPerpBisectorDetailed.e957c231de663d9909e45910c294b423.png";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Tangent1Detailed.d9019ee701e5626fd6a49abcb3bd57b0.png";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TangentDetailed.ce17dd7d5d96e67225bcf2b627ac10fe.png";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TorricelliPtDetailed.4bf1febf8918888448910749c2036649.png";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrByAltitudeBasesDetailed.fb412593667438faaf58ff0036dcd81c.png";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrByExcircleCentersDetailed.0d8d3aaa8dc76035935a45f244f6abd0.png";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrByIncircleBasesDetailed.146ab4c6de7885419266dd12016403f5.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrBySideAndCentroidDetailed.8b9d9eaf886483e88af7e711e482f1a3.png";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TranslateSegmentDetailed.e9e2ed3ce746e2ace1c94a1b900e8bf5.png";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrapezoidCut3Detailed.a2c3b48ece8cf1c79862f3207e875c42.png";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrapezoidCutDetailed.5423828d1cf0640aff5e25c6ccb22017.png";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrapezoidGeomMeanDetailed.e7af3cbbd2107b56c1eee7a512270c24.png";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrapezoidHarmMeanDetailed.d3dc80e065e34f002440047fc215aab0.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TriangleByMidpointsDetailed.3c85fd99af3a17d62f755f2933f9135b.png";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TriangleBySidesDetailed.cb18d12cf5feafdbe57e331a773ffd0e.png";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TriangleMidSegmentDetailed.8790c6c98ce52a19932514cd7a719c33.png";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_3CirclesCDetailed.fba7354c3643ebef17a9681337c8b8f7.png";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_3CirclesIDetailed.b1563ad3efa855d35537c92e40c2f985.png";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_3rdProportionalDetailed.4c708c6e73235748dcffaa416a28694a.png";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_4SymmetricLinesDetailed.8d1fe849c01034decc9dd71a96b20f34.png";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_4thProportionalDetailed.d1a7b124c5ff669ffd17b62acaba03f7.png";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_60RotationCWDetailed.52d0b661c38e783bdd93fd130610f4d3.png";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_90RotationCCWDetailed.894cbd7cdbcf45c7659ac0f2e341deb4.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_9PointCircleDetailed.664f93e5eddd293de2d5582b4d5fa57e.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_AEqualSegments1Detailed.d3f5a17dbea4025c1ed0799d16465b87.png";

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_AMinPerimeterDetailed.df6863a8ad864166be113d2babd84b60.png";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_APtOnCircleMaxDistDetailed.657cc692bccdba4db9695d00fa3b2b9a.png";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ATrByCentroidDetailed.a25dbcc4ce5503c01d24e9d3db1c3b6c.png";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ATrByCircumcenterDetailed.aec2284ed80e94c56e39b34a6fe8c3aa.png";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ATrByOrthocenterDetailed.4760f31f6969e71f27c1063cd7332215.png";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Angle15Detailed.526f81bfabe335a32168c1e6aaab7358.png";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Angle30Detailed.8b2c2e038601022f906cbde1274fa900.png";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Angle3Detailed.3e129e312c8a20beacc7a8063cc4ac7a.png";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Angle45Detailed.c49bfdc760979cfe9b9b7cb841c0c35b.png";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Angle54Detailed.a178221e5f98f88acff280d705a415a5.png";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Angle60Detailed.d57dc1ea07d6aa132e3dceff51eeecd4.png";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Angle60DropDetailed.36e0677daa0e9c5df4ff402029abf6a6.png";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Angle75Detailed.bcfd73c4a0493aa28f2ea394850155ef.png";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_AngleIsoscelesDetailed.2c74687df61fcb0987a37ea5a7b8441e.png";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_AngleMidpointDetailed.c6748bb8ad490425efe5ce3af30475b6.png";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_AngleTrisection54Detailed.8cef2335b9545da97198a4ace4c2117c.png";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_AnnulusDetailed.b9ec70e55a995f5531f577b84905663c.png";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ArbelosDetailed.84f1e6874807465c1b8a692422bd23b0.png";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_BisectAngleDetailed.49daa2f7617e93aba5a3534c852c04a9.png";

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CDoubleSegDetailed.0d01031c07de341d5266908200651f13.png";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CIntersectCLDetailed.1f0b6018edcab310dbc8033510b06acb.png";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CIntersectXDetailed.b763a620ed7f11f92f90c473923357ee.png";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CMidpointDetailed.c30e7fdf80c59a9ce4b3f076c3fd4ad0.png";

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CTranslateCircleDetailed.2d513072643bda91a1e71ff18b521ce7.png";

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CenterOfRotationDetailed.1ddb788b0884f476fbf7e02fe9876178.png";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CentroidOfQuadrilateralDetailed.1645288061b86501011c5766940aba48.png";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Chord3Detailed.22a7c2455921e04e91bfcbc80c0b6630.png";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ChordMidpointDetailed.cf25b6b2b84aa32b99afaebf986f2bca.png";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Circle3Detailed.cb1e57c9021010d6cedb74215f91b866.png";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleByRadiusDetailed.e3e4dd0da16983417e1d0a46f9439052.png";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleCenterDetailed.40179137b25daca728a9f0c76bceae1a.png";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleEquidistantFrom4PointsDetailed.c09caa0d8cbe796c2f6086b5f92c58f3.png";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleInAngleDetailed.a3fe7072e23a2ddb7a25f0c79162717d.png";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleInOutSquareDetailed.b27eb42674cf8dad8ecfd5911a0640fb.png";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleInRhombusDetailed.d68164f1d0197d80eec15e5e0079b457.png";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleInSquareDetailed.6abe2f4528ff246288552a35238995bf.png";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleInTriangleDetailed.ba65dd697ff84e768ed5f8088c3cbef8.png";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleTangentCCDetailed.91dd669e31b59ae00b8a55abe9a9012b.png";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleTangentCCwCenterLDetailed.26dcad1887ff8054c09e26139e47032c.png";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleTangentCLDetailed.654500784465390216bf83a999573ac3.png";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleTangentCPwCenterLDetailed.c9909a539b48868fbf37907f41e618f6.png";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleTangentLDetailed.39befb64a395393c5913072a6eb7d72e.png";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleTangentLLLDetailed.50d6fbaae21c3072805b603b51f49713.png";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleTangentPLDetailed.c1c8dc2c91936ece9db160533459217e.png";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CircleTangentPPLDetailed.472c7125d4cab6a5f268fc830003f63c.png";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CleaverDetailed.ad51200ab8ece4af4a1d800b86ec309e.png";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Cut2RectanglesDetailed.86569a0cb960919760af5b6d1e39e614.png";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_CutRectangleDetailed.423a7b792362b8b095fd17074e94cd7a.png";

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Divide3Detailed.e21a57609f11826e8848b95372546d07.png";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_DoubleAngleDetailed.0cd7e36ae45e21d7f6fedc725447dbc8.png";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_DropPerpDetailed.03be433c6595a9b5f41f60de8c469bbb.png";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_EqualSegments3Detailed.18dc042a584fc9658491f2ccd513a666.png";

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Equidistant2Detailed.f9396b97549c58e7409bab26dfb3f5ca.png";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Equidistant3Detailed.e3f3dd9626b8a426d6b98d1afb877e76.png";

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_EquidistantParallelDetailed.70b415047c00f064c377a98df7b6388d.png";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Equilateral3Detailed.1c3f9c81a868a7c697a18a75a64e0fc5.png";

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_EquilateralAboutCircleDetailed.2303ae241a10a6b674792496e1899e13.png";

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_EquilateralByCentroid2PDetailed.34c1abbf81070b355731e41ad29b27fa.png";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_EquilateralInCircleDetailed.9038cc64c830b0596c4952190e39f6dd.png";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_EquilateralOnCCDetailed.d8ed82a7b1e1e8d56ff3b320ee3bf181.png";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ErectPerpDetailed.f0ff805962c0ffe961e28a4830781c47.png";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ExcircleDetailed.dca9118ae74b007d6f4f0f38ff7a4303.png";

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_GeometricMeanDetailed.1332cd817460b7cb5188e70368a287d6.png";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_GivenAngleBisectorDetailed.ffea8cd095109035a7c9bb28013449be.png";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_GoldenSectionDetailed.8aaf7c1b8af2b09640efef5553ddaee8.png";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_HarmonicMeanDetailed.ed88070a8df5231e66a782726f9b1166.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_HashDetailed.259a57d148444a702f08268afbe03331.png";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_HeronDetailed.384ba1a428e5ad9ee8cf8be782eee817.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_HexagonBySideDetailed.e33a07882dda5caf6f40c83f07751013.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_HypotenuseAndAltitudeDetailed.3d5256f736b54351b847cd77a1e56b24.png";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_HypotenuseAndLegDetailed.5c8d83b8ea208b81858a8479364d8c2a.png";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_IncenterDetailed.be675b20a310f4ab823bae02ecf73944.png";

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_InnerTangentDetailed.093f1841903cf1cf759ac1aedce19aeb.png";

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_InteriorAnglesDetailed.ff0ebf56c6bf17a4fb5d7a2cd2e5cea1.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_IsoscelesTriangleAboutCircleDetailed.a4598c45e62171d5ecbd9e30e01c47ab.png";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_L3ParallelDetailed.11f774f5b9605d8bdf36241e851e0366.png";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LDivide3Detailed.2fbde83bd2b19a3508f0d7f8aa51ca98.png";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LDropPerp2Detailed.1c3c6ef3f0a0c1b6caa4fe491d8931be.png";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LDropPerpDetailed.bec1d3978f6a288a354607b974d3a351.png";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LMidpointDetailed.875cb2d548e8eca3cd64e34d27db9a3a.png";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LReflectionDetailed.c9d47d56a4831f534457973cc26466e9.png";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LTangentDetailed.4d97640f4eaeb72f1652be7e3393d671.png";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LineAlongPointsDetailed.e8db5d15e9ec5c19cd0f2509d60b46c9.png";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LineBetweenPointsDetailed.80d6cc6575b7afe1b499abb3ef1eeac9.png";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_LozengeDetailed.2c9b97f5e98c18e100f52fecc76c45c6.png";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_MidpointDetailed.fee80f687b78b6305a34ed9658dd0bb0.png";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_MirrorSegDetailed.c04d8b3dd762a708decd2699c930603b.png";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_NapoleonDetailed.ed78871ef98194dc34e9bfbdd76b5441.png";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_OctagonBySideDetailed.04dfe5a7c4cc65bc3daf98d9013d7066.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_OrthicTriangleDetailed.6b99878b818a1d0ac32bcaf07eff29e9.png";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_OuterTangentDetailed.c0f461ddb0e1edc0b3049933c3251259.png";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ParallelDetailed.3842d0c17897df405f9181a6341b3e0b.png";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Parallelogram3VDetailed.2692c4cff23eda1e8dac847a49d20b91.png";

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ParallelogramBy3MidpointsDetailed.e5a9057e4a0833cad781749967c68da1.png";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ParallelogramBySPDetailed.7fe1a9b091daf0c509b362ec13b039d7.png";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ParallelogramVOn4LinesDetailed.358aedde915fbc220bd816978bec14c8.png";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_PentagonDetailed.f8b7a6bc956e73e45b5f5360ed5bb00a.png";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_PerimeterBisectorDetailed.64a668391f8b0a3f0174ccc09d6b2c65.png";

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_PerpBisectorDetailed.518d520735250521d2e6142a9913355e.png";

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_PtSymmetryDetailed.768ff4dab8cd6960ab66e9ce6d877cc5.png";

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_RTrBy2SidePointsDetailed.e44798137a7e3e02552d10f9243ac259.png";

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_RTrByHypAndTangentPtDetailed.ca2fa50cda7d3e40f5c7deb2c30476ca.png";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_RhombusInRectDetailed.039082b751f9fb720cc0842986aabbf7.png";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_RhombusInTriangleDetailed.176e7367957d7ca7ba4ff4e169c7b630.png";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Secant2Detailed.5c1debedd94a3c49ea3b09f35c8f4d06.png";

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Segment6Detailed.3a109e3db1cf8d0f6473eb956a14fb1d.png";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ShiftAngleDetailed.245ab8f54a0d174303bdbc5b2adbb710.png";

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_ShiftSegmentDetailed.29f9b029ffa11b5dc05e192cae61a727.png";

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Sqrt2Detailed.1cfd5ef906888fc33db81f403b907605.png";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Sqrt3Detailed.a019d0d852b27135475f5c9a7e525805.png";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SquareAboutCircleDetailed.adfe5333455198171f92de0a5304ffb4.png";

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SquareBy4PtDetailed.c3d37d23ec6616871efec147c3f9388b.png";

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SquareByAdjMidpointsDetailed.802b49149fbab8fa7d45e23cab8e2d93.png";

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SquareByOppMidpointsDetailed.c0ae9bc8bf97b3701246ee5495f91b99.png";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SquareInCircleByPtDetailed.a93059cba9620cbd41eb5fd20187fcc9.png";

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SquareInCircleDetailed.0498041787459846ffd54fb7c22c3595.png";

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SquareInSquareDetailed.9c9882b7a72b594176ccaaf9fb312981.png";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SquareInTriangleDetailed.e44cf2a436d166320f341cad0f4444dd.png";

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_SumSquaresDetailed.07b36aedbf5ec447889cf2af28b36e52.png";

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_T1_LineDetailed.e5be42481ef1e3ffb67a45a12bc9ab74.png";

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_T2_CircleDetailed.9904508108dca2f63cfb9a1d31815fb0.png";

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_T3_PointDetailed.b9ff95655543f4150fba166736c0fd7c.png";

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TBisectAngleDetailed.4e966d8071acd4b63dc2af5954029d8c.png";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TCircleByRadiusDetailed.9f1396fb142fbce4e2ff45e10f244971.png";

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TDropPerpDetailed.08f856c1e0c56df9da56bd0f6f4c32e0.png";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TEquilateralDetailed.a9e9f8a95be93cd9bab3f95e371506ef.png";

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TIntersectDetailed.cc2c3b6dfdc2f641c42904dd101bcfbe.png";

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TMoveDetailed.9861edff872236fba84891d4ec06775e.png";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TParallelDetailed.3a0494a424c7b13f553990efed8ab76f.png";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TPerpBisectorDetailed.2a12e5312482c647751cebd633061513.png";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_Tangent1Detailed.472d7c0fd39d746e0df5a62c4f4ad454.png";

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TangentDetailed.c1b35086695bd4995e3148e17f0a5561.png";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TorricelliPtDetailed.437e79acf2b7ade1b3a688a9c6e62ee7.png";

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TrByAltitudeBasesDetailed.02b67249e1e7bd076d906cab116f76cb.png";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TrByExcircleCentersDetailed.3c35e251d0127fc00661e2b73a52ee2a.png";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TrByIncircleBasesDetailed.095dcf0d80d286124707c8c584829b90.png";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TrBySideAndCentroidDetailed.37934f3b0452492cd2e9a53380861cb6.png";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TranslateSegmentDetailed.0927e95efb003e3c0210b1523b46fe30.png";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TrapezoidCut3Detailed.c7a3e9093509086ed8e3bd981071cde1.png";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TrapezoidCutDetailed.e7ece02a4db6f0d8e9ad2b9f77e3feac.png";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TrapezoidGeomMeanDetailed.ebd473828f366a10e22e2731f78aa080.png";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TrapezoidHarmMeanDetailed.be606fc1ba9165621e4bcbf76439b72b.png";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TriangleByMidpointsDetailed.8942aea9d8e59898673fca08aa4531b7.png";

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TriangleBySidesDetailed.acbe4dcd01cc1e47be75a0ce2db857a5.png";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/retina_TriangleMidSegmentDetailed.ad16d66aa2b6f79071f11ea7050fee8f.png";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LogoGameScreen.104c8048d2661c885ec99a0b0e565ef2.png";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LogoGameScreen@2x.c029874878f31ba0f471a38951afd762.png";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LogoPacksScreen.c069f9500aef06e1c5ae920210b3d5c6.png";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LogoS.876a4138a1f551779d35b16f1667fb84.png";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldAlpha.fc0a8db8b5136aa03f3d684d0ed9b1d7.png";

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldBeta.cc88ac699c9bd1ebab0ee8ae4411faf3.png";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldChi.525ffb7d62d4cb4c3af157de8b3208f3.png";

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldDelta.6e63d7c729e1c677bf467bfbaa87d77f.png";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldEpsilon.d9754cfdc7208300aba3fdb1f696adf5.png";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldEta.eb6088bd98b42e030abe334a59c007eb.png";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldGamma.d421649258b2d12d05780c806b88f410.png";

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldIota.594417d453a981492ff438e8512d34ff.png";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldKappa.0739dc0055c91db4c199e74ad0e71646.png";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldLambda.a779aef1ee592bb6af88efb707e43468.png";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldMu.088a1ba1c0cb90b8c6e6d0148f3c09dc.png";

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldNu.0fe062fa64da4f395354c8d87dc9449e.png";

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldOmega.84bf637cf26e4f5b417e3c6e04fb6604.png";

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldOmicron.5bd1cbf672d7117e317ac073e0245910.png";

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldPhi.88655eba8eded3615a3c6e35f70de961.png";

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldPi.b4875aba3f956ffd7833071be314b31f.png";

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldPsi.20fd61a22f1468cd051757a090928b53.png";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldRho.f85172207b470675c59fc102a7460187.png";

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldSigma.a8822494f0bf438d5efb43a17a164561.png";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldTau.ea26d8b5587fc3bcbe983bdad07671e7.png";

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldTheta.7bb2d1ec8503f53d4cee96a49c201ebe.png";

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldUpsilon.71fafdd51ef77d06cb4e154891de6d29.png";

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldXi.4e23893d4cdaaa13bed7d8cf9d1578fc.png";

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldZeta.6e7dfcc93c112e3e5e3ef2681b26a8a5.png";

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Alpha.a670e567c1d620a14f58b0ed560bd5ae.png";

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Beta.152fab31bd96bbe7366332d931431fc6.png";

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Chi.3771559248d3da4074099e6ec0b9ec22.png";

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Delta.1eb0480dac3f64daf944ebe60ed5cde1.png";

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Epsilon.a5d078093f076ba73903deb4751030db.png";

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Eta.e6d6b8d1483b5cdc5b98d3f6982c52de.png";

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Gamma.01d79e5da3e65c85f28403e20eac482f.png";

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Iota.4ba623c96c4fecd37fb202db107745d2.png";

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Kappa.8123fe4ed246dae58206544694c99fd8.png";

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Lambda.1cb86b301430a7963f14a10361c3c2e4.png";

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Mu.694fa4f6f427706f2afdff4e3c488630.png";

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Nu.8df9fdd77c72ef81cd8ce0bf29351247.png";

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Omega.fb76124f163d75dca949969c94c5e876.png";

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Omicron.210da46e64a3ed24edf79e05730d11de.png";

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Phi.ebe31f9586a59172054949e88acc7d48.png";

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Pi.5a4919603859a60cabd8317aa75c4ff8.png";

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Psi.7c6a0795c23dd3a6b0f39dbb8b9934cd.png";

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Rho.b806061761fca6880d26c5bd32552fa6.png";

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Sigma.507cecf2da0dcc53fb82d45b1d1dcd32.png";

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Tau.724a30b77a9b2b123caf454f3221adf0.png";

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Theta.7dafb02414e7741aaff404ff8e29033e.png";

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Upsilon.e975108e86588d84880c343c8285c6f9.png";

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Xi.687ea38219d96f24b9091e4704e5cea9.png";

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Zeta.a63bdeeaf72cdd74fd00012f5de002b3.png";

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldAlpha2x.897d5e216379c02cdad35d609a7f323d.png";

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldBeta2x.81063c166c03eef8a11dd5e5116afc11.png";

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldChi2x.43c83736df0952ed24b0299c0910e2d5.png";

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldDelta2x.2265908f0e3447fc6ef66bc0ca93f3b5.png";

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldEpsilon2x.240e0e3e8d53b37f6427cbbe7dc6d9cc.png";

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldEta2x.0bee51637a8655d4abef8858102bbcbe.png";

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldGamma2x.7cc1156d1739111db2ce302a720b44ca.png";

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldIota2x.d6e2e1c2c6129da3cbcd31ae524c39fe.png";

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldKappa2x.71fe3b3b8bc2aea3a68e0d4b05b29853.png";

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldLambda2x.ee0f4bb397649b704809e394dfa05065.png";

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldMu2x.4d581478be9c379b588e4fcc8ba62ce6.png";

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldNu2x.028591dab1a7cd62190ff8125a7ab086.png";

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldOmega2x.6ea56eb4681229396a90b94860942813.png";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldOmicron2x.f6618a3aee9075ef1086ad018fcb2dfb.png";

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldPhi2x.81f5e3f1adf5fe3262341636a2bf5add.png";

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldPi2x.1c60a41ebd25761447add373b0994b50.png";

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldPsi2x.bb01097bd1a338ed0a10a7e2395e7710.png";

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldRho2x.5ec986c3042186793f9c66d01b4fca43.png";

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldSigma2x.d5dfc8ac1983df2f0ddcacf3bc3cae20.png";

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldTau2x.6289698a9ffe17dbf67519dfaff6bcfa.png";

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldTheta2x.c2fb41b6348ae763096aee6c53855ac0.png";

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldUpsilon2x.a3f2e7da4c1f6778790dee4f3a64885a.png";

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldXi2x.405ce2baf0ca270f969f0bc712efbfe8.png";

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldZeta2x.4bc250ac21d723fff221d01ac376b257.png";

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Alpha.49a5e705cdf84a7afe7b252ba27a3d23.png";

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Beta.abdd9e08ccb550946cf99b00b1b95def.png";

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Chi.c91b548009751dddccde00dcecf3ec14.png";

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Delta.56722fa49aeb6f731fdd1b9347e477b0.png";

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Epsilon.8c12b3624f6ce0ec96fff6e28e218626.png";

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Eta.5bf6fd865afd40cf6a1528f5d590832c.png";

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Gamma.0e9794d6b477c397ce37a8fec7b115af.png";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Iota.cdb33e86bcbf01623a490598cd189395.png";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Kappa.0f016c0d1865cc3df075b7c094ff99f9.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Lambda.eeb3f12a1aac4aad0649a0be9fa9eb58.png";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Mu.6a2ae3f25e57203bc4dc831ebcd6c791.png";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Nu.5394ed2de52ef365ebe37e6401c5977c.png";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Omega.e648fd009fd4456fde7d9a05708ec47f.png";

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Omicron.d4bb087b4eb1cea1206af7b36b7a0300.png";

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Phi.fe794e606441b69ce36bfa00528417ee.png";

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Pi.3a9bc7dd99d9b87c7945233b18434c2e.png";

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Psi.e2bc608c779a93fe614958286d9bcef8.png";

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Rho.8699bfa1f9efc557e4f5e19e7c35912a.png";

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Sigma.3b68260b26f7e71c7a4c121c20b472d6.png";

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Tau.524fa92bb9a6a02cb54233ec53fbcf54.png";

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Theta.95df9d8f231adb66a1ab5aad923d4f67.png";

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Upsilon.59bf4fd4bdea091dacb6aa78d7025b28.png";

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Xi.219f43c940baac3f60fd119a50008771.png";

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Zeta.3ca68dc938252d5d3276138c81c5bd96.png";

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/resstar1-0at2x.0c1fe8c7ff661183e3c961882c0010b0.png";

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/resstar1-1at2x.36b15b10e8e34f9e20f601fffcf66c50.png";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/resstar2-0at2x.95d76f377970aaa60d8c77b6c40c2509.png";

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/resstar2-1at2x.4360e43abefd4943d1bc1b0fdede1745.png";

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/resstar3-0at2x.be64912a331d5fef8a335b66daad2fd9.png";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/resstar3-1at2x.13228343e39943a5b9c05c494366b78b.png";

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/resstar4-0at2x.7ff52f48661e503b6cec9359e2c86410.png";

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/resstar4-1at2x.aae3de4750cf893b7816313daf3781b8.png";

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ScrollDownIcon.0443d3c1640c6343b5276e9f22f1f601.svg";

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SettingsBtnWhite.5ef78200d1f01dd84e2ef85b76ffbdf0.svg";

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SupportBtn.667d4f7cb0a104274a7a976cfe5c4c19.svg";

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/quoteLeft.8dceb128d7d45e8ed1eb581a2fa7b13b.svg";

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/quoteRight.32d4565e1b5d0f2a32a6bbba95e15352.svg";

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TaskCard.b5bdda68bdd0a83937ca0feb30e4006a.svg";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TaskLockedOverlay.d898dc9caf11bc531aa8236862a4fc7a.svg";

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PackIcon.3c83cbf3dd3857b80545c4d560b660b6.svg";

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PackLockedIcon.b03c345967482bde646dd3bb9e8028d2.svg";

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RedoBtn.d832d7b095a342ccc194b0f7e40a515e.svg";

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/UndoBtn.031098d1692fa96a1e44c1acd2e53b83.svg";

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/StarCheckIconBlue.06d60f194699881de677e86c2b84e6e5.svg";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/tutIcon.e26da8cb1e01d634e65bf8acfff8fa04.svg";

/***/ }),
/* 873 */,
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ArrowDown.15b8f3c583bab2448274b77d9573b7f9.svg";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LogOut.af2d51f7d8060f12b3eefee28ca614e4.svg";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/FigureStyles.43596525050ddaecfc07187f22d7a592.xml";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/3CirclesC.f07e9516ff85aca4f51af36994247a2a.gmt";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/3CirclesI.9ef598a1ee6acf5b7be223afd49df9bb.gmt";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/3rdProportional.b2ebd626854d7d38b9a954d73e1b5c28.gmt";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/4SymmetricLines.f1137097f873bc7a0b5241897faf6120.gmt";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/4thProportional.fba4f7d749492fdbf69a779c84621546.gmt";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/60RotationCW.313585cc9a966673ef7825261a9509bb.gmt";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/90RotationCCW.22de27f3753e6d7c7571891b0ed2c19e.gmt";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/9PointCircle.5e675a1bd1e82f6a986d9b3c6baa83e9.gmt";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AEqualSegments1.a0f362e1f5cfd1519d483c6b7b778699.gmt";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AMinPerimeter.49f132cb17f4b3d01a93eaae6f16cfb3.gmt";

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/APtOnCircleMaxDist.41afeead6fb6ea31a78d04be345f8a89.gmt";

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ATrByCentroid.624a8f4eedcba64be8b7d652fe4e7b28.gmt";

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ATrByCircumcenter.6438b438b2572118fa7897ff26440d50.gmt";

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ATrByOrthocenter.7261b4df8e11c0ded649671b5c281c05.gmt";

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle15.a801f0ed0ea506cfd74958926b700df2.gmt";

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle3.5ea3996b372690a605dcc8fefc1f72bd.gmt";

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle30.484d97cd1235b7731b84ba03f5e2440c.gmt";

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle45.48ae8afa9e0bc552aadf7adb7b7211cf.gmt";

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle54.1526d735d581a912bb0fb440e4debfad.gmt";

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle60.f79d9fa93d5e07e0bb541fedf845080c.gmt";

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle60Drop.781293e498d313ab313de5f048528bdf.gmt";

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Angle75.5cd65543ad71019bc3f9fb58e36ff591.gmt";

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AngleIsosceles.f71425bb2fb3b09d3bd02d5e6b31ea69.gmt";

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AngleMidpoint.d28a6ec8c59a387fe7319586fad50e4f.gmt";

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/AngleTrisection54.ffc7ef5f288aa2f77fb8dc5d91ae1e6c.gmt";

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Annulus.3fc9d5563c82eeb995e59a6826e8b7cf.gmt";

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Arbelos.5703cf3861fbc80458e02e1f2ea0cf2a.gmt";

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/BisectAngle.ff6a54ce4912e93297c36414cc41ce06.gmt";

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CDoubleSeg.5e9581ae83be0c92b2ade83f561650a4.gmt";

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CIntersectCL.29f833b4eccd95641fd1fd8ddffa623a.gmt";

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CIntersectX.b21e841af416440672dbfa01229e0225.gmt";

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CMidpoint.2e87214c2546777844ed8e31216f2f60.gmt";

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CTranslateCircle.68e5f8847cb6695cce9a4e318cf320c0.gmt";

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CenterOfRotation.d4f05800a6c43be77cc7484efc136c87.gmt";

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CentroidOfQuadrilateral.d94a3fa45962e740a49d4ae62081d499.gmt";

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Chord3.d283d3506d6e8e97a50fa7641467f2e2.gmt";

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ChordMidpoint.158f350ba08478b910966c0d75e797bc.gmt";

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Circle3.b365e3d8b434fbeaf1d1b7cfb4eee034.gmt";

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleByRadius.e600a6e8c80ef2a8834e4ea4cb20aef0.gmt";

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleCenter.bfa10f581d2ba83b506881b3b6f9ad58.gmt";

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleEquidistantFrom4Points.753786d72694463d7de37a1855110ec9.gmt";

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInAngle.41b33c4966d0554924087d5c63569a3d.gmt";

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInOutSquare.8f001be08324734fcaff861bdc7e084e.gmt";

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInRhombus.d74520e0ab0e9a9aa7049915bedef161.gmt";

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInSquare.d005eea77b82ef26caed878e2e6950bd.gmt";

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleInTriangle.25e117ba70d7308605926b02c65ae0ff.gmt";

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentCC.19b0484055c34858884d06ee506bca08.gmt";

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentCCwCenterL.b743e308eb84833aa56e0b278d449906.gmt";

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentCL.4e6107affb38a7bbc2e2edae794b22fd.gmt";

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentCPwCenterL.31a69a776e8570476d021b9fedcb225b.gmt";

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentL.a027519672830c045b1c217029c908f3.gmt";

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentLLL.93d5fb603e7f01dbdbf40576704fd1c5.gmt";

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentPL.bfc291359aef5a38896bdfd8a811f3be.gmt";

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CircleTangentPPL.4de134c2d46f52a5f23156b7a5bfca96.gmt";

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Cleaver.c0af2f014dc0ce45993806ea63528d5b.gmt";

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Cut2Rectangles.cf0bd5a73f0cd2a1a8961810f716d44c.gmt";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CutRectangle.9dcee79ecbf33e5701cf4f4722234e2c.gmt";

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Divide3.efe9d31c19ba6d61aa5c37b38758c056.gmt";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/DoubleAngle.e46683bfe7779a1adc0710907f2f4895.gmt";

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/DropPerp.080c45ce120320218bfbc2263aff2254.gmt";

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EqualSegments3.cb5c4031060b8799866a6374685a54bc.gmt";

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Equidistant2.f2406179963ed527eec28bfaaf80218b.gmt";

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Equidistant3.e33a504a301608f60446bb75dbb96388.gmt";

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquidistantParallel.dbbdfbcd598a6c9f9c78357980aa1ec9.gmt";

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Equilateral3.094be7e90e1ce39a0522df1d002ec578.gmt";

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquilateralAboutCircle.185f27a12a9e8bcdfc67ebb881928794.gmt";

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquilateralByCentroid2P.986de13d57b191a5d566e3eb48e45928.gmt";

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquilateralInCircle.de29a5093e47ee98f7e21121ad784863.gmt";

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/EquilateralOnCC.977dc051675dabae7cd05d6df4b2b827.gmt";

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ErectPerp.9990862ec0bb08e854d0ba59384240ae.gmt";

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Excircle.e984b770919b5463ea40dc63eef2c9a5.gmt";

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GeometricMean.57a39f7cdfe42826622ef029e025e4a2.gmt";

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GivenAngleBisector.841fa3e53f9ea79620889f924368d6b7.gmt";

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/GoldenSection.06869f8b4fb7ffce35f7242e79621262.gmt";

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HarmonicMean.027b750c626fbff0f1297e7586f37e77.gmt";

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Hash.5d4bd81f913b15ec757522102df65c4b.gmt";

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Heron.ccef9ced32769cca0d1c660a38489d1a.gmt";

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HexagonBySide.2cc2a3f7134aba6f9956421d25b865fc.gmt";

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HypotenuseAndAltitude.93db0fd1625135c0b167901fab30c758.gmt";

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HypotenuseAndLeg.504647f003a90d9d62525b845e103aa6.gmt";

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Incenter.2e0cc91807ae38b9e3d425855a0b0ea5.gmt";

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/InnerTangent.18610182d9156cce54ecce925314fed7.gmt";

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/InteriorAngles.4f58163cd244b31db7a84cf30ded040e.gmt";

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/IsoscelesTriangleAboutCircle.6fc4a1a32a95cdcfa9c8b95a8c1cc095.gmt";

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/L3Parallel.6a4b00331ade4478561c3d96bf1be2da.gmt";

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LDivide3.a3241e9854b182de40f5cd91d9096c04.gmt";

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LDropPerp.cf3e55a21303a7fd6fce3187b749d369.gmt";

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LDropPerp2.0f5acc5e3d6b7ddbda13e88cd0e42548.gmt";

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LMidpoint.aca5d7e14213d34eeefdcd9308c60a17.gmt";

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LReflection.a7d26c4e6e931c9b0f91e771b23aa81e.gmt";

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LTangent.6fcd18bd63146070ea9252bab01d2d4c.gmt";

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LineAlongPoints.23c1adca19b5440e7f810685f6149364.gmt";

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LineBetweenPoints.7b0e9a43a7793e05c8c6765e15a4ba37.gmt";

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Lozenge.72745819c34ec58098da7db5768e465f.gmt";

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Midpoint.d2b4be2cd40b0cab7e414a25a24d58f9.gmt";

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/MirrorSeg.9be31b13ad5d4bdd0699161f1ee2300e.gmt";

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Napoleon.a926482840ed1c7821cba3219e9bcdf0.gmt";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/OctagonBySide.bfc9741db3d9676aba5af106b73ec8ee.gmt";

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/OrthicTriangle.f55a49d36ddc3d26ae468a4934e6d583.gmt";

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/OuterTangent.fd2a9410790c2d2c49296863bd5065ce.gmt";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Parallel.5da6e48b28007ed18c319d74993217a1.gmt";

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Parallelogram3V.52aba50ba922136add8d35caa4babd93.gmt";

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ParallelogramBy3Midpoints.315d21c166ff0d176f7ccfe199cb5b1b.gmt";

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ParallelogramBySP.f8af059f8e4f131a1253b8813faf8b9e.gmt";

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ParallelogramVOn4Lines.06e2b151829b42978d719d617fd6fc24.gmt";

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Pentagon.7829214b9f88420dc5382355858b2ae5.gmt";

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PerimeterBisector.fed2840713d7039c5a4b2e9046caa091.gmt";

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PerpBisector.547d1a70d54120c9aa59e7dca15c1176.gmt";

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/PtSymmetry.9c94cad3bba2925147295118df90495b.gmt";

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RTrBy2SidePoints.3ef20876b367c66cd3ab366f642fba1f.gmt";

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RTrByHypAndTangentPt.de0a61e5af87740d80d74072b5a0dc2b.gmt";

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RhombusInRect.daab5e879a96ec1df7dac20f06f4de5e.gmt";

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RhombusInTriangle.a7cd34d86270a93944e4e18866cd18b8.gmt";

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Secant2.30181e2be6a08d32c617db76df699d7a.gmt";

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Segment6.3ef140ed935516bdfb20feed395c1912.gmt";

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ShiftAngle.f44e2e1d2a98105bff8e37a277790f62.gmt";

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ShiftSegment.0466861c752f1aae7064f99749399a4b.gmt";

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Sqrt2.e1fdf8f301f6fe1a740a8b5b5d39ff42.gmt";

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Sqrt3.597f0d51b79045f4030c5e17e64f2674.gmt";

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareAboutCircle.526e0a3e62ba15b6aa045d50b3aa252a.gmt";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareBy4Pt.c684d16cbbb0a92220cf5b02d5e8c46d.gmt";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareByAdjMidpoints.6872ed88855bf21062bbf7938a044b86.gmt";

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareByOppMidpoints.4237244395f35ffd63520a643866b07a.gmt";

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareInCircle.d1b4dc825128aa41942bf511a03e5a00.gmt";

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareInCircleByPt.6eac442ac7c4b544cac78954d47b64cc.gmt";

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareInSquare.9301cccb3d4f935020275c0cb20e3c60.gmt";

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SquareInTriangle.f085c8c01ad9ffdbec8920a9e35c317e.gmt";

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/SumSquares.faa1209bc85f8feb7deffff99b8b780b.gmt";

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/T1_Line.53a3b48b71cc11c153782d8fabd41d95.gmt";

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/T2_Circle.6da677513e804710d585962f4cf3d08f.gmt";

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/T3_Point.e693549a2ff76ebdd05ebdee20f4faed.gmt";

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TBisectAngle.b44c0ba5469d982889cca1ff673ee1c0.gmt";

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TCircleByRadius.b507a5a09a3a81f915aaafa4a0b6e637.gmt";

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TDropPerp.a85ba7121ea5b6d8b637f0be661adb28.gmt";

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TEquilateral.c1c6e4b1762a5c4da4976a82025827cf.gmt";

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TIntersect.943c294788c01e3c502805041ca68765.gmt";

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TMove.9917e4b1c379e977459583e8b6c13a7d.gmt";

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TParallel.15ca3f42a061cf8c73ae88622c7e7a2e.gmt";

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TPerpBisector.46b2209185ca3510706f926e95e00ecd.gmt";

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Tangent.f5e03a840ddd10a1413d9eb3f31acfb1.gmt";

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Tangent1.b8b6724414e3021ed7516d7d316aa0c4.gmt";

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TorricelliPt.f01f6daf177b426ecbd6b1c45bc6eef8.gmt";

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrByAltitudeBases.4cc8a216005db4c215b9dd0bb24b01b8.gmt";

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrByExcircleCenters.97ceb0179402c4e15cd887c239d0f1ed.gmt";

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrByIncircleBases.d1cccdb34565cf674dcd04ebce783f85.gmt";

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrBySideAndCentroid.647752b0da3e3c3cb0276ead8ac78238.gmt";

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TranslateSegment.9b0c25607c022e87121e6931e774ac26.gmt";

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrapezoidCut.95888969473243af0e899fe368e33593.gmt";

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrapezoidCut3.450ebac1d82e066c2cb4bfeae43591e0.gmt";

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrapezoidGeomMean.6316bb36e9a0de3bfee4a8bf74ccca2e.gmt";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TrapezoidHarmMean.0427bb28d6ba54a4bda64c69e051d032.gmt";

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TriangleByMidpoints.f8f9973b0822b10d1c996b7645848b67.gmt";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TriangleBySides.2be84864b01680a8d6fdbd1cdecdc524.gmt";

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/TriangleMidSegment.fe4ec77f455a6bacc415865b9f345be4.gmt";

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Levels.17c91eef5a5fb6f5c4e4178dcca6e68a.xml";

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HotKeys.e1acd60edbd28c29c98bb934a59a86e0.strings";

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LevelInfos.4bfde9f4212c9ba763332acef3206794.xml";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Localizable.804c3dbbd18b4bb2f81a1312d605784d.strings";

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/HotKeys.f832ff845c45251dd5ec0e3a1affee6f.strings";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/LevelInfos.adb88b9299d613725758d5d99ba4f2c4.xml";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/Localizable.a8bd0771057773a4db5720600c38a184.strings";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ToolInfos.5caa324a0c3e7d84c7a985aaac189f2f.xml";

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = "<router-outlet></router-outlet><modal-help-component></modal-help-component>";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<header class=\"header\"><a class=\"logo\" href=\"/\"><img class=\"logo-img\" src=\"" + __webpack_require__(754) + "\" alt=\"\"/></a><div class=\"divider\"></div><div class=\"settings\" (click)=\"showModalComponent()\"></div><div class=\"divider\"></div><div class=\"buttons\"><a class=\"button button-apple-{{currentLang}}\" href=\"https://itunes.apple.com{{currentLangLinkAppStore}}app/euclidea-2-geometric-constructions/id927914361?mt=8\" target=\"_blank\"></a><a class=\"button button-google-{{currentLang}}\" href=\"https://play.google.com/store/apps/details?id=com.hil_hk.euclidea&amp;hl={{currentLang}}\" target=\"_blank\"></a></div><user-menu-component></user-menu-component><div class=\"divider float-right\"></div><div class=\"count-box\"><div class=\"star\"></div><div class=\"total-count\"><p class=\"count\" *ngIf=\"starsData\"><span class=\"count-inner-bold\">{{starsData[0]}}</span><span class=\"count-inner\">/ {{starsData[1]}}</span></p></div></div></header>";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"level\"><div id=\"scene_wrapper\"></div><div class=\"game-toolbar\"><button class=\"levels-list\" (click)=\"goToLevelsScreen()\"></button><button [ngClass]=\"{\n                'level-prev': prevLevelId &amp;&amp; !prevLevelIsLocked,\n                'dis-level-prev': !prevLevelId || prevLevelIsLocked\n                }\" [disabled]=\"!prevLevelId || prevLevelIsLocked\" (click)=\"goToPrevLevel()\"></button><button [ngClass]=\"{\n                'level-next': nextLevelId &amp;&amp; !nextLevelIsLocked,\n                'dis-level-next': !nextLevelId || nextLevelIsLocked\n                }\" [disabled]=\"!nextLevelId || nextLevelIsLocked\" (click)=\"goToNextLevel()\"></button><button class=\"level-restart\" (click)=\"restart()\"></button></div><div id=\"moves-counter-wrapper\"><div class=\"moves-counter\"><div id=\"counter\" *ngIf=\"!(eMoves === 0 &amp;&amp; lMoves === 0)\">{{lMoves}}L {{eMoves}}E</div></div></div><div class=\"level-target\" (click)=\"showModalDescription()\"><img class=\"figure-image\" [src]=\"imageUrl\" alt=\"\"/><div class=\"level-number\" *ngIf=\"!tutorial\">{{packNumber}}.{{levelNumber}}</div><div class=\"reward\"><span class=\"reward-inner\" [ngClass]=\"(starsResult['GM_STAR_TYPE_L']) ? 'gold-color' : 'grey-color'\">{{goalLineMoves}}L</span><span class=\"reward-inner\" [ngClass]=\"(starsResult['GM_STAR_TYPE_E']) ? 'gold-color' : 'grey-color'\">{{goalElementaryMoves}}E</span><span class=\"gold-color\" *ngIf=\"starsResult['GM_STAR_TYPE_V']\">{{foundVariantsCount}}V</span></div></div><div class=\"undo-redo-toolbar\"><a class=\"undo\" [ngClass]=\"{'btn-disabled': !canUndo}\" (click)=\"undo()\"></a><a class=\"redo\" [ngClass]=\"{'btn-disabled': !canRedo}\" (click)=\"redo()\"></a><a class=\"explore\" (click)=\"toggleExploreMode()\" [ngClass]=\"{'btn-active': !exploreActive, 'hidden': tutorial}\"></a></div><div id=\"tool_box\"><div class=\"buttons-wrapper\"><div class=\"tool-button\" *ngFor=\"let tool of tools\" [ngClass]=\"'icon-' + tool + ' ' + (toolType() == tool ? 'active' : '')\" title=\"{{toolsLocals[tool].title + ' (' + hotKeysLocals[tool] + ')'}}\" (click)=\"setToolType(tool)\"></div></div></div><div class=\"varial-box\"><div class=\"help\" (click)=\"showModalHelp()\"></div><a class=\"logo\" routerLink=\"/{{currentLang}}/game/packs\"><img class=\"logo-img\" *ngIf=\"!RETINA\" src=\"" + __webpack_require__(752) + "\" alt=\"\"/><img class=\"logo-img\" *ngIf=\"RETINA\" src=\"" + __webpack_require__(753) + "\" alt=\"\"/><img class=\"logo-img adaptive\" src=\"" + __webpack_require__(755) + "\" alt=\"\"/></a></div><div class=\"buttons\"><a class=\"button button-apple-{{currentLang}}\" href=\"https://itunes.apple.com{{currentLangLinkAppStore}}app/euclidea-2-geometric-constructions/id927914361?mt=8\" target=\"_blank\"></a><a class=\"button button-google-{{currentLang}}\" href=\"https://play.google.com/store/apps/details?id=com.hil_hk.euclidea&amp;hl={{currentLang}}\" target=\"_blank\"></a></div><modal-success-component [options]=\"{\n                    starsResult: starsResult,\n                    goalLineMoves: goalLineMoves,\n                    goalElementaryMoves: goalElementaryMoves,\n                    lMoves: lMoves,\n                    eMoves: eMoves,\n                    justEarnedStars: justEarnedStars,\n                    levelId: levelId,\n                    nextLevelIsLocked: nextLevelIsLocked\n                }\"></modal-success-component><modal-description-component [starsResult]=\"starsResult\"></modal-description-component><modal-help-addon-component></modal-help-addon-component></div>";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"levels-box\"><a class=\"button-back-icon\" [routerLink]=\"backLink\"><img src=\"" + __webpack_require__(185) + "\" alt=\"\"/></a><a class=\"pack-button previous\" *ngIf=\"isPrevPackUnlocked\" [routerLink]=\"prevPackLink\"><div class=\"button-pack-icon svg-{{prevPack}}\" alt=\"\"></div></a><a class=\"pack-button next\" *ngIf=\"isNextPackUnlocked\" [routerLink]=\"nextPackLink\"><div class=\"button-pack-icon button-pack-icon-next svg-{{nextPack}}\" alt=\"\"></div></a><div class=\"levels-box-inner\"><div class=\"pack-label\"><div class=\"icon svg-{{packId}}\" alt=\"\"></div><div class=\"title\" *ngIf=\"interfaceLocals\">{{packNumber}}. {{interfaceLocals[packId]}}</div></div><div class=\"level-item-wrapper\" *ngFor=\"let options of levelOptions\"><a class=\"level\" *ngIf=\"!options.isLocked &amp;&amp; options.levelLocals\" routerLink=\"level/{{options.levelId}}\" (click)=\"setTitleInHead(options.levelLocals[options.levelId].title)\"><div class=\"level-header\"><div class=\"level-type\"><div class=\"level-number\" *ngIf=\"!options.isTutorial\">{{options.levelNumber}}</div><div class=\"tutorial\" *ngIf=\"options.isTutorial\"></div></div><div class=\"state\" *ngIf=\"!options.stars['GM_STAR_TYPE_B']\"><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(66) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(66) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(66) + "\" alt=\"\"/></div></div><div class=\"state\" *ngIf=\"options.stars['GM_STAR_TYPE_B']\"><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image star-check\" src=\"" + __webpack_require__(90) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" *ngIf=\"!options.stars['GM_STAR_TYPE_L']\" src=\"" + __webpack_require__(49) + "\" alt=\"\"/><img class=\"star-image\" *ngIf=\"options.stars['GM_STAR_TYPE_L']\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(92) + "\"/></div><div class=\"star-block\"><img class=\"star-image\" *ngIf=\"!options.stars['GM_STAR_TYPE_E']\" src=\"" + __webpack_require__(49) + "\" alt=\"\"/><img class=\"star-image\" *ngIf=\"options.stars['GM_STAR_TYPE_E']\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(91) + "\" alt=\"\"/></div><div class=\"star-block\" *ngIf=\"options.stars['GM_STAR_TYPE_V']\"><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(124) + "\" alt=\"\"/></div></div></div><div class=\"level-icon {{options.levelIcon}}\"></div><div class=\"footer\"><p class=\"level-title\" *ngIf=\"options.levelLocals\">{{options.levelLocals[options.levelId].title}}</p></div></a><div class=\"level\" *ngIf=\"options.isLocked &amp;&amp; options.levelLocals &amp;&amp; interfaceLocals\"><div class=\"level-header\"><div class=\"level-type\"><div class=\"level-number\" *ngIf=\"!options.isTutorial\">{{options.levelNumber}}</div><div class=\"tutorial\" *ngIf=\"options.isTutorial\"></div></div><div class=\"state\"><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(66) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(66) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(66) + "\" alt=\"\"/></div></div></div><div class=\"level-icon {{options.levelIcon}}\"></div><div class=\"locked\"><div class=\"solve\">{{interfaceLocals['Solve the previous']}}</div><div class=\"footer\"><p class=\"level-title\">{{options.levelLocals[options.levelId].title}}</p></div></div></div></div></div></div>";

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = "<main class=\"main\"><div class=\"main-background main-background-first\"></div><div class=\"main-background main-background-second\"></div><div class=\"layout\" [class.active]=\"stateActiveLayout\"></div><header-component></header-component><router-outlet></router-outlet><modal-component></modal-component><modal-help-addon-progress-component></modal-help-addon-progress-component></main>";

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"modal-description js-modal-description\" [class.active]=\"stateActiveModalDescription\"><div class=\"modal-layout\" (click)=\"hideModal()\"></div><div class=\"modal\"><div class=\"header\" *ngIf=\"levelLocals\"><span class=\"title-level\" *ngIf=\"!tutorial\">{{packNumber}}.{{levelNumber}}</span>{{levelLocals[levelId].title}}<img class=\"close-icon\" (click)=\"hideModal()\" src=\"" + __webpack_require__(59) + "\" alt=\"\"/></div><div class=\"level-detail\"><div class=\"level-detail-img-container\"><img class=\"level-image\" [src]=\"imageUrl\" [hidden]=\"isImageHide\" alt=\"\"/></div><div class=\"level-description\" *ngIf=\"levelLocals\">{{levelLocals[levelId].description}}</div><div class=\"divider\"></div><div class=\"goal-bar\"><div class=\"goal\" *ngIf=\"interfaceLocals &amp;&amp; starsResult\">{{interfaceLocals['Goal: ']}}<span class=\"goal-inner\" [ngClass]=\"(starsResult['GM_STAR_TYPE_L']) ? 'gold-color' : ''\">{{goalLineMoves}}L</span><span class=\"goal-inner\" [ngClass]=\"(starsResult['GM_STAR_TYPE_E']) ? 'gold-color' : ''\">{{goalElementaryMoves}}E</span><span class=\"goal-inner gold-color\" *ngIf=\"starsResult['GM_STAR_TYPE_V']\">{{foundVariantsCount}}V</span></div><div class=\"help\" (click)=\"showModalHelp()\"></div><div class=\"state\" *ngIf=\"!starsResult || !starsResult['GM_STAR_TYPE_B']\"><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(49) + "\" alt=\"\"/><img class=\"star-image star-check\" src=\"" + __webpack_require__(90) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(49) + "\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(92) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(49) + "\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(91) + "\" alt=\"\"/></div></div><div class=\"state\" *ngIf=\"starsResult &amp;&amp; starsResult['GM_STAR_TYPE_B']\"><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image star-check\" src=\"" + __webpack_require__(90) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(49) + "\" *ngIf=\"!starsResult['GM_STAR_TYPE_L']\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" *ngIf=\"starsResult['GM_STAR_TYPE_L']\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(92) + "\" alt=\"\"/></div><div class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(49) + "\" *ngIf=\"!starsResult['GM_STAR_TYPE_E']\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" *ngIf=\"starsResult['GM_STAR_TYPE_E']\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(91) + "\" alt=\"\"/></div><div class=\"star-block\" *ngIf=\"starsResult['GM_STAR_TYPE_V']\"><img class=\"star-image\" src=\"" + __webpack_require__(49) + "\" *ngIf=\"!starsResult['GM_STAR_TYPE_V']\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" *ngIf=\"starsResult['GM_STAR_TYPE_V']\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(124) + "\" alt=\"\"/></div></div></div></div></div></div>";

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal\" [class.active]=\"stateActiveModal\"><div class=\"modal-layout\"></div><div class=\"window\"><header class=\"header\"><p class=\"title\">{{interfaceLocals['authMigrateProgressMessageTitle']}}</p></header><p class=\"question\">{{interfaceLocals['authMigrateProgressMessage']}}</p><div class=\"buttons\"><div class=\"button\" (click)=\"syncProgress()\">{{interfaceLocals['yes']}}</div><div class=\"button\" (click)=\"replaceProgress()\">{{interfaceLocals['no']}}</div></div></div></div>";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"modal-help-addon js-modal-help-addon\" [class.active]=\"stateActiveModal\"><div class=\"modal-layout\" (click)=\"hideModal()\"></div><div class=\"modal\"><div class=\"modal-inner\" *ngIf=\"interfaceLocals\"><div class=\"modal-body\" [innerHTML]=\"interfaceLocals['VHelpText']\"></div><div class=\"modal-footer\">{{interfaceLocals['TEquilateral text footer']}}</div><div class=\"ok\"><span class=\"ok-text\" (click)=\"hideModal()\">{{interfaceLocals['OK']}}</span></div><img class=\"close\" (click)=\"hideModal()\" src=\"" + __webpack_require__(59) + "\" alt=\"\"/></div></div></div><div class=\"modal-help-addon js-modal-help-addon\" [class.active]=\"stateActiveModalHintCircle\"><div class=\"modal-layout\" (click)=\"hideModalHintCircle()\"></div><div class=\"modal modal-circle\"><div class=\"modal-inner\" *ngIf=\"interfaceLocals\"><div class=\"modal-title\">{{interfaceLocals['Hint title']}}</div><div class=\"modal-body\">{{interfaceLocals['Hint message']}}</div><div class=\"ok\"><span class=\"ok-text\" (click)=\"hideModalHintCircle()\">{{interfaceLocals['OK']}}</span></div><img class=\"close\" (click)=\"hideModalHintCircle()\" src=\"" + __webpack_require__(59) + "\" alt=\"\"/></div></div></div><div class=\"modal-help-addon js-modal-help-addon\" [class.active]=\"stateActiveModalHintExplore\"><div class=\"modal-layout\" (click)=\"hideModalHintExplore()\"></div><div class=\"modal modal-circle\"><div class=\"modal-inner\" *ngIf=\"interfaceLocals\"><div class=\"modal-title\">{{interfaceLocals['Explore mode alert title']}}</div><div class=\"modal-body\">{{interfaceLocals['Explore mode alert message']}}</div><div class=\"ok\"><span class=\"ok-text confirm\" (click)=\"hideModalHintExplore()\">{{interfaceLocals['Explore mode alert hmm button']}}</span><span class=\"ok-text confirm\" (click)=\"hideModalHintExploreForever()\">{{interfaceLocals['Explore mode alert cancel button']}}</span></div><img class=\"close\" (click)=\"hideModalHintExplore()\" src=\"" + __webpack_require__(59) + "\" alt=\"\"/></div></div></div>";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"modal-help js-modal-help\" [ngClass]=\"{'scroll-bottom': stateBottomScroll, 'active': stateActiveModalHelp, 'dark': stateDarkModalHelp}\"><div class=\"modal-layout\" (click)=\"hideModalHelp()\"></div><div class=\"modal-inner\" *ngIf=\"interfaceLocals\"><div class=\"header\">{{interfaceLocals['rules']}}<img class=\"close-icon\" (click)=\"hideModalHelp()\" src=\"" + __webpack_require__(59) + "\" alt=\"\"/></div><div class=\"help-window js-help-window\" (scroll)=\"detectForModalEnd($event)\" tabindex=\"0\"><div class=\"help-description-title\">{{interfaceLocals['rulesScoringTitle']}}</div><div class=\"help-description\"><p>{{interfaceLocals['rulesScoringText1']}}</p><p [innerHTML]=\"interfaceLocals['rulesScoringText2']\"></p><p>{{interfaceLocals['rulesScoringText3']}}</p><p>{{interfaceLocals['rulesScoringText4']}}</p><ul class=\"stars-block\"><li class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image star-check\" src=\"" + __webpack_require__(90) + "\" alt=\"\"/>{{interfaceLocals['rules1StarComment']}}</li><li class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(92) + "\" alt=\"\"/>{{interfaceLocals['rulesLStarComment']}}</li><li class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(91) + "\" alt=\"\"/>{{interfaceLocals['rulesEStarComment']}}</li><li class=\"star-block\"><img class=\"star-image\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><img class=\"star-image\" src=\"" + __webpack_require__(124) + "\" alt=\"\"/>{{interfaceLocals['rulesVStarComment']}}</li></ul></div><div class=\"help-description-title\">{{interfaceLocals['rulesVStarTittle']}}</div><div class=\"help-description help-description-stars\">{{interfaceLocals['rulesVStarText']}}</div><div class=\"help-description-title\">{{interfaceLocals['rulesSolutionNotAcceptedTitle']}}</div><div class=\"help-description\"><ul class=\"stars-block\"><li class=\"hand-block\"><div class=\"tool-icon-absolute icon-HandTool\"></div><p [innerHTML]=\"interfaceLocals['rulesSolutionNotAcceptedHandAdvice']\"></p></li><li class=\"hand-block\"><div class=\"tool-icon-absolute icon-Explore\"></div><p>{{interfaceLocals['rulesSolutionNotAcceptedExploreAdvice']}}</p></li></ul>{{interfaceLocals['nothing helps']}}</div><div class=\"help-description\" [innerHTML]=\"interfaceLocals['rulesSolutionNotAcceptedText']\"></div><a class=\"support-mail\" href=\"/{{currentLang}}/support?app=EuclideaWeb\">support@euclidea.xyz</a><div class=\"help-description-title\">{{interfaceLocals['rulesToolsCost']}}</div><table class=\"tools-list\" *ngIf=\"toolsLocals\"><tr><td><div class=\"tool-icon icon-HandTool\"></div></td><td>{{toolsLocals['HandTool'].title}}</td><td>{{toolsLocals['HandTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['HandTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-PointTool\"></div></td><td>{{toolsLocals['PointTool'].title}}</td><td>{{toolsLocals['PointTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['PointTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-LineTool\"></div></td><td>{{toolsLocals['LineTool'].title}}</td><td>{{toolsLocals['LineTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['LineTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-CircleTool\"></div></td><td>{{toolsLocals['CircleTool'].title}}</td><td>{{toolsLocals['CircleTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['CircleTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-PBisectTool\"></div></td><td>{{toolsLocals['PBisectTool'].title}}</td><td>{{toolsLocals['PBisectTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['PBisectTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-PerpTool\"></div></td><td>{{toolsLocals['PerpTool'].title}}</td><td>{{toolsLocals['PerpTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['PerpTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-ABisectTool\"></div></td><td>{{toolsLocals['ABisectTool'].title}}</td><td>{{toolsLocals['ABisectTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['ABisectTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-ParallelTool\"></div></td><td>{{toolsLocals['ParallelTool'].title}}</td><td>{{toolsLocals['ParallelTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['ParallelTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-CompassTool\"></div></td><td>{{toolsLocals['CompassTool'].title}}</td><td>{{toolsLocals['CompassTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['CompassTool'].cost}}E</td></tr><tr><td><div class=\"tool-icon icon-IntersectTool\"></div></td><td>{{toolsLocals['IntersectTool'].title}}</td><td>{{toolsLocals['IntersectTool'].cost > 0 ? 1 : 0}}L</td><td>{{toolsLocals['IntersectTool'].cost}}E</td></tr></table><div class=\"help-description-title\" *ngIf=\"hotKeysLocals\">{{hotKeysLocals['Hot keys']}}</div><table class=\"hotKeys-list\" *ngIf=\"hotKeysLocals\"><tr><td><span class=\"bold\">{{hotKeysLocals['Tools']}}</span></td><td></td></tr><tr><td>{{hotKeysLocals['HandTool']}}</td><td>{{hotKeysLocals['HandTool Description']}}</td></tr><tr><td>{{hotKeysLocals['PointTool']}}</td><td>{{hotKeysLocals['PointTool Description']}}</td></tr><tr><td>{{hotKeysLocals['LineTool']}}</td><td>{{hotKeysLocals['LineTool Description']}}</td></tr><tr><td>{{hotKeysLocals['CircleTool']}}</td><td>{{hotKeysLocals['CircleTool Description']}}</td></tr><tr><td>{{hotKeysLocals['PBisectTool']}}</td><td>{{hotKeysLocals['PBisectTool Description']}}</td></tr><tr><td>{{hotKeysLocals['PerpTool']}}</td><td>{{hotKeysLocals['PerpTool Description']}}</td></tr><tr><td>{{hotKeysLocals['ABisectTool']}}</td><td>{{hotKeysLocals['ABisectTool Description']}}</td></tr><tr><td>{{hotKeysLocals['ParallelTool']}}</td><td>{{hotKeysLocals['ParallelTool Description']}}</td></tr><tr><td>{{hotKeysLocals['CompassTool']}}</td><td>{{hotKeysLocals['CompassTool Description']}}</td></tr><tr><td>{{hotKeysLocals['IntersectTool']}}</td><td>{{hotKeysLocals['IntersectTool Description']}}</td></tr><tr><td><span class=\"bold\">{{hotKeysLocals['Control']}}</span></td><td></td></tr><tr><td>{{hotKeysLocals['Arrow keys']}}</td><td>{{hotKeysLocals['Arrow keys Description']}}</td></tr><tr><td>{{hotKeysLocals['Drag']}}</td><td>{{hotKeysLocals['Drag Description']}}</td></tr><tr><td>{{hotKeysLocals['Page up']}},<br/>{{ hotKeysLocals['Mouse wheel forward'] }}</td><td>{{hotKeysLocals['Zoom in']}}</td></tr><tr><td>{{hotKeysLocals['Page down']}},<br/>{{ hotKeysLocals['Mouse wheel backward'] }}</td><td>{{hotKeysLocals['Zoom out']}}</td></tr><tr><td>{{hotKeysLocals['Cancel']}}</td><td>{{hotKeysLocals['Cancel Description']}}</td></tr><tr><td>{{hotKeysLocals['Undo']}}</td><td>{{hotKeysLocals['Undo Description']}}</td></tr><tr><td>{{hotKeysLocals['Redo']}}</td><td>{{hotKeysLocals['Redo Description']}}</td></tr></table></div><div class=\"scroll-down\" (click)=\"scrollDown()\"></div></div></div>";

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"modal-success js-modal-success\" [class.active]=\"stateActiveModalComponent\"><div class=\"modal-layout\" (click)=\"hideModal()\"></div><div class=\"window\"><div class=\"header\">{{interfaceLocals['Task Completed']}}<img class=\"close-icon\" (click)=\"hideModal()\" src=\"" + __webpack_require__(59) + "\" alt=\"\"/></div><div class=\"level-result\"><div class=\"result-bar\"><div class=\"result-counts\"><span class=\"result-counts-inner\" [ngClass]=\"(options.starsResult &amp;&amp; options.goalLineMoves &gt;= options.lMoves) ? 'gold-color' : '' \">{{options.lMoves}}L</span><span class=\"result-counts-inner\" [ngClass]=\"(options.starsResult &amp;&amp; options.goalElementaryMoves &gt;= options.eMoves) ? 'gold-color' : '' \">{{options.eMoves}}E</span><span class=\"result-counts-inner gold-color\" *ngIf=\"options.starsResult['GM_STAR_TYPE_V']\">{{foundVariantsCount}}V</span></div><div class=\"stars\"><img class=\"star\" src=\"" + __webpack_require__(852) + "\" alt=\"\"/><img class=\"star\" src=\"" + __webpack_require__(854) + "\" alt=\"\"/><img class=\"star\" src=\"" + __webpack_require__(856) + "\" alt=\"\"/><img class=\"star\" *ngIf=\"options.justEarnedStars['GM_STAR_TYPE_V']\" src=\"" + __webpack_require__(858) + "\" alt=\"\"/></div><div class=\"stars stars-animate\"><img class=\"star\" [class.bubble]=\"options.justEarnedStars['GM_STAR_TYPE_B']\" src=\"" + __webpack_require__(853) + "\" alt=\"\"/><img class=\"star\" [class.bubble]=\"options.justEarnedStars['GM_STAR_TYPE_L']\" src=\"" + __webpack_require__(855) + "\" alt=\"\"/><img class=\"star\" [class.bubble]=\"options.justEarnedStars['GM_STAR_TYPE_E']\" src=\"" + __webpack_require__(857) + "\" alt=\"\"/><img class=\"star starV\" [class.bubble]=\"options.justEarnedStars['GM_STAR_TYPE_V']\" src=\"" + __webpack_require__(859) + "\" alt=\"\"/></div><div class=\"goal\">{{interfaceLocals['Goal: ']}}<span class=\"goal-inner\">{{options.goalLineMoves}}L</span><span class=\"goal-inner\">{{options.goalElementaryMoves}}E</span><div class=\"help\" (click)=\"showModalHelp()\"></div></div></div><div class=\"quote\" *ngIf=\"levelLocals\"><div class=\"quote-body\"><div class=\"open-quote\"></div><p class=\"quote-text\">{{levelLocals[options.levelId].quote}}</p><div class=\"close-quote\"></div></div><p class=\"quote-author\">— {{levelLocals[options.levelId].quoteAuthor}}</p></div><div class=\"divider\"></div><div class=\"buttons\"><a class=\"level-list button\" (click)=\"goToLevelsScreen()\"></a><a class=\"level-restart button\" (click)=\"restart()\"></a><a class=\"level-next button\" *ngIf=\"!options.nextLevelIsLocked\" (click)=\"goToNextLevel()\"></a></div></div></div></div>";

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"modal\" [class.active]=\"stateActiveModalComponent\"><div class=\"modal-layout\" (click)=\"hideModal()\"></div><div class=\"settings\" *ngIf=\"interfaceLocals\"><div class=\"spinner modal-spinner\" [class.invisible]=\"stateHiddenSpinner\"><div class=\"spinner-animation\"></div><div class=\"spinner-text js-spinner-text\">{{loadingText[currentLang]}}</div></div><div class=\"inner-layout\"></div><header class=\"header\"><img class=\"back-btn\" (click)=\"pullRightContent()\" [class.active]=\"stateActiveBack\" src=\"" + __webpack_require__(185) + "\" alt=\"\"/><p class=\"title\" [class.active]=\"!stateActiveBack &amp;&amp; !stateActiveReset\">{{interfaceLocals['Settings']}}</p><p class=\"title\" [class.active]=\"stateActiveBack\">{{interfaceLocals['languageTitle']}}</p><p class=\"title\" [class.active]=\"stateActiveReset\">{{interfaceLocals['Reset Progress']}}</p><img class=\"close\" (click)=\"hideModal()\" src=\"" + __webpack_require__(59) + "\" alt=\"\"/></header><div class=\"content-wrapper\" [class.activeDropdown]=\"stateActiveDropdown\"><div class=\"content\" [ngClass]=\"{right: stateRightContent, activeSpinner: !stateHiddenSpinner}\"><ul class=\"items active\"><li class=\"item\" (click)=\"pushRightContentWithLangs()\">{{interfaceLocals['languageTitle']}}</li><li class=\"item\" (click)=\"pushRightContent()\">{{interfaceLocals['Reset Progress']}}</li><li class=\"item\" (click)=\"showModalHelpComponent()\">{{interfaceLocals['rules']}}</li></ul><ul class=\"items\" [class.active]=\"stateActiveLangs\"><li class=\"item item-lang\" *ngFor=\"let langLink of langsLinks; let i = index\" routerLinkActive=\"active\"><a class=\"item-link\" [routerLink]=\"langLink\">{{langsArray[i]}}</a></li></ul><ul class=\"items\" [class.active]=\"!stateActiveLangs\"><li><p class=\"text\">{{interfaceLocals['Reset progress warn']}}</p></li><li class=\"item\" (click)=\"resetProgress()\">{{interfaceLocals['Reset']}}</li><li class=\"item\" (click)=\"pullRightContent()\">{{interfaceLocals['Cancel']}}</li></ul></div></div><footer class=\"footer\"><p class=\"copyright\">&copy; {{copyright}}</p><p class=\"version\">{{version}}</p></footer></div></div>";

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"packs-box\"><div class=\"pack-wrapper\" *ngFor=\"let options of packsOptions\"><a class=\"pack\" *ngIf=\"!options.isLocked\" [routerLink]=\"options.packId\"><img class=\"star-pack\" src=\"" + __webpack_require__(21) + "\" alt=\"\"/><p class=\"stars-count\"><span class=\"stars-earned\">{{options.packEarnedStars}}</span><span class=\"stars-total\">/ {{options.packLimitStars}}</span></p><p class=\"pack-title\">{{options.index}}. {{options.title}}</p><div class=\"pack-icon-wrapper\"><img class=\"pack-icon\" *ngIf=\"options.isEarnedStarsBiggerThanLimited &amp;&amp; !RETINA\" [src]=\"options.imageGold\" alt=\"\"/><img class=\"pack-icon\" *ngIf=\"options.isEarnedStarsBiggerThanLimited &amp;&amp; RETINA\" [src]=\"options.imageGoldRetina\" alt=\"\"/><img class=\"pack-icon\" *ngIf=\"!options.isEarnedStarsBiggerThanLimited &amp;&amp; !RETINA\" [src]=\"options.image\" alt=\"\"/><img class=\"pack-icon\" *ngIf=\"!options.isEarnedStarsBiggerThanLimited &amp;&amp; RETINA\" [src]=\"options.imageRetina\" alt=\"\"/></div></a><div class=\"pack locked\" *ngIf=\"options.isLocked\"><p class=\"pack-title\">{{options.index}}. {{options.title}}</p><p class=\"pack-locked-title\">{{titleLocked}}</p></div></div></div>";

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper js-wrapper-dropdown\" (click)=\"toggleDropdown()\" (mouseover)=\"changeBackUrl()\"><div class=\"sign-in cursor-pointer\" *ngIf=\"!userService.authorized\"><a class=\"link link-sign-in\" href=\"{{currentLang}}/login?burl={{burl}}#sign-in\">{{interfaceLocals['authMainScreenButton']}}</a></div><div class=\"user-block cursor-pointer\" *ngIf=\"userService.authorized\"><div class=\"avatar\"></div><div class=\"user-name\">{{userService.user.name}}</div></div><a class=\"link dropdown js-dropdown-profile\" [class.active]=\"stateActiveDropdown\" href=\"{{currentLang}}/profile\"><div class=\"profile-icon\"></div><span class=\"link-text\">{{interfaceLocals['authUserProfileTitle2']}}</span></a><a class=\"link dropdown js-dropdown-logout\" [class.active]=\"stateActiveDropdown\" href=\"{{currentLang}}/logout\"><div class=\"sign-out-icon\"></div><span class=\"link-text\">{{interfaceLocals['authLogOutButton']}}</span></a></div>";

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function RavenConfigError(message) {
    this.name = 'RavenConfigError';
    this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wrapMethod = function(console, level, callback) {
    var originalConsoleLevel = console[level];
    var originalConsole = console;

    if (!(level in console)) {
        return;
    }

    var sentryLevel = level === 'warn'
        ? 'warning'
        : level;

    console[level] = function () {
        var args = [].slice.call(arguments);

        var msg = '' + args.join(' ');
        var data = {level: sentryLevel, logger: 'console', extra: {'arguments': args}};
        callback && callback(msg, data);

        // this fails for some browsers. :(
        if (originalConsoleLevel) {
            // IE9 doesn't allow calling apply on console functions directly
            // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
            Function.prototype.apply.call(
                originalConsoleLevel,
                originalConsole,
                args
            );
        }
    };
};

module.exports = {
    wrapMethod: wrapMethod
};


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false, __DEV__:false*/


var TraceKit = __webpack_require__(1056);
var stringify = __webpack_require__(1057);
var RavenConfigError = __webpack_require__(1052);
var utils = __webpack_require__(193);

var isError = utils.isError,
    isObject = utils.isObject;

var wrapConsoleMethod = __webpack_require__(1053).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
    return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};
var _document = _window.document;
var _navigator = _window.navigator;

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
    this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
    // Raven can run in contexts where there's no document (react-native)
    this._hasDocument = !isUndefined(_document);
    this._hasNavigator = !isUndefined(_navigator);
    this._lastCapturedException = null;
    this._lastData = null;
    this._lastEventId = null;
    this._globalServer = null;
    this._globalKey = null;
    this._globalProject = null;
    this._globalContext = {};
    this._globalOptions = {
        logger: 'javascript',
        ignoreErrors: [],
        ignoreUrls: [],
        whitelistUrls: [],
        includePaths: [],
        crossOrigin: 'anonymous',
        collectWindowErrors: true,
        maxMessageLength: 0,

        // By default, truncates URL values to 250 chars
        maxUrlLength: 250,
        stackTraceLimit: 50,
        autoBreadcrumbs: true,
        sampleRate: 1
    };
    this._ignoreOnError = 0;
    this._isRavenInstalled = false;
    this._originalErrorStackTraceLimit = Error.stackTraceLimit;
    // capture references to window.console *and* all its methods first
    // before the console plugin has a chance to monkey patch
    this._originalConsole = _window.console || {};
    this._originalConsoleMethods = {};
    this._plugins = [];
    this._startTime = now();
    this._wrappedBuiltIns = [];
    this._breadcrumbs = [];
    this._lastCapturedEvent = null;
    this._keypressTimeout;
    this._location = _window.location;
    this._lastHref = this._location && this._location.href;
    this._resetBackoff();

    for (var method in this._originalConsole) {  // eslint-disable-line guard-for-in
      this._originalConsoleMethods[method] = this._originalConsole[method];
    }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
    // Hardcode version string so that raven source can be loaded directly via
    // webpack (using a build step causes webpack #1617). Grunt verifies that
    // this value matches package.json during build.
    //   See: https://github.com/getsentry/raven-js/issues/465
    VERSION: '3.14.2',

    debug: false,

    TraceKit: TraceKit, // alias to TraceKit

    /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Optional set of of global options [optional]
     * @return {Raven}
     */
    config: function(dsn, options) {
        var self = this;

        if (self._globalServer) {
                this._logDebug('error', 'Error: Raven has already been configured');
            return self;
        }
        if (!dsn) return self;

        var globalOptions = self._globalOptions;

        // merge in options
        if (options) {
            each(options, function(key, value){
                // tags and extra are special and need to be put into context
                if (key === 'tags' || key === 'extra' || key === 'user') {
                    self._globalContext[key] = value;
                } else {
                    globalOptions[key] = value;
                }
            });
        }

        self.setDSN(dsn);

        // "Script error." is hard coded into browsers for errors that it can't read.
        // this is the result of a script being pulled in from an external domain and CORS.
        globalOptions.ignoreErrors.push(/^Script error\.?$/);
        globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

        // join regexp rules into one big rule
        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
        globalOptions.maxBreadcrumbs = Math.max(0, Math.min(globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100

        var autoBreadcrumbDefaults = {
            xhr: true,
            console: true,
            dom: true,
            location: true
        };

        var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
        if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
            autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
        } else if (autoBreadcrumbs !== false) {
            autoBreadcrumbs = autoBreadcrumbDefaults;
        }
        globalOptions.autoBreadcrumbs = autoBreadcrumbs;

        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

        // return for chaining
        return self;
    },

    /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
    install: function() {
        var self = this;
        if (self.isSetup() && !self._isRavenInstalled) {
            TraceKit.report.subscribe(function () {
                self._handleOnErrorStackInfo.apply(self, arguments);
            });
            self._instrumentTryCatch();
            if (self._globalOptions.autoBreadcrumbs)
                self._instrumentBreadcrumbs();

            // Install all of the plugins
            self._drainPlugins();

            self._isRavenInstalled = true;
        }

        Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
        return this;
    },

    /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
    setDSN: function(dsn) {
        var self = this,
            uri = self._parseDSN(dsn),
          lastSlash = uri.path.lastIndexOf('/'),
          path = uri.path.substr(1, lastSlash);

        self._dsn = dsn;
        self._globalKey = uri.user;
        self._globalSecret = uri.pass && uri.pass.substr(1);
        self._globalProject = uri.path.substr(lastSlash + 1);

        self._globalServer = self._getGlobalServer(uri);

        self._globalEndpoint = self._globalServer +
            '/' + path + 'api/' + self._globalProject + '/store/';

        // Reset backoff state since we may be pointing at a
        // new project/server
        this._resetBackoff();
    },

    /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
    context: function(options, func, args) {
        if (isFunction(options)) {
            args = func || [];
            func = options;
            options = undefined;
        }

        return this.wrap(options, func).apply(this, args);
    },

    /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
    wrap: function(options, func, _before) {
        var self = this;
        // 1 argument has been passed, and it's not a function
        // so just return it
        if (isUndefined(func) && !isFunction(options)) {
            return options;
        }

        // options is optional
        if (isFunction(options)) {
            func = options;
            options = undefined;
        }

        // At this point, we've passed along 2 arguments, and the second one
        // is not a function either, so we'll just return the second argument.
        if (!isFunction(func)) {
            return func;
        }

        // We don't wanna wrap it twice!
        try {
            if (func.__raven__) {
                return func;
            }

            // If this has already been wrapped in the past, return that
            if (func.__raven_wrapper__ ){
                return func.__raven_wrapper__ ;
            }
        } catch (e) {
            // Just accessing custom props in some Selenium environments
            // can cause a "Permission denied" exception (see raven-js#495).
            // Bail on wrapping and return the function as-is (defers to window.onerror).
            return func;
        }

        function wrapped() {
            var args = [], i = arguments.length,
                deep = !options || options && options.deep !== false;

            if (_before && isFunction(_before)) {
                _before.apply(this, arguments);
            }

            // Recursively wrap all of a function's arguments that are
            // functions themselves.
            while(i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

            try {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means Raven caught an error invoking your application code. This is
                //       expected behavior and NOT indicative of a bug with Raven.js.
                return func.apply(this, args);
            } catch(e) {
                self._ignoreNextOnError();
                self.captureException(e, options);
                throw e;
            }
        }

        // copy over properties of the old function
        for (var property in func) {
            if (hasKey(func, property)) {
                wrapped[property] = func[property];
            }
        }
        wrapped.prototype = func.prototype;

        func.__raven_wrapper__ = wrapped;
        // Signal that this function has been wrapped already
        // for both debugging and to prevent it to being wrapped twice
        wrapped.__raven__ = true;
        wrapped.__inner__ = func;

        return wrapped;
    },

    /*
     * Uninstalls the global error handler.
     *
     * @return {Raven}
     */
    uninstall: function() {
        TraceKit.report.uninstall();

        this._restoreBuiltIns();

        Error.stackTraceLimit = this._originalErrorStackTraceLimit;
        this._isRavenInstalled = false;

        return this;
    },

    /*
     * Manually capture an exception and send it over to Sentry
     *
     * @param {error} ex An exception to be logged
     * @param {object} options A specific set of options for this error [optional]
     * @return {Raven}
     */
    captureException: function(ex, options) {
        // If not an Error is passed through, recall as a message instead
        if (!isError(ex)) {
            return this.captureMessage(ex, objectMerge({
                trimHeadFrames: 1,
                stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
            }, options));
        }

        // Store the raw exception object for potential debugging and introspection
        this._lastCapturedException = ex;

        // TraceKit.report will re-raise any exception passed to it,
        // which means you have to wrap it in try/catch. Instead, we
        // can wrap it here and only re-raise if TraceKit.report
        // raises an exception different from the one we asked to
        // report on.
        try {
            var stack = TraceKit.computeStackTrace(ex);
            this._handleStackInfo(stack, options);
        } catch(ex1) {
            if(ex !== ex1) {
                throw ex1;
            }
        }

        return this;
    },

    /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
    captureMessage: function(msg, options) {
        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
        // early call; we'll error on the side of logging anything called before configuration since it's
        // probably something you should see:
        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
            return;
        }

        options = options || {};

        var data = objectMerge({
            message: msg + ''  // Make sure it's actually a string
        }, options);

        if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
            var ex;
            // Generate a "synthetic" stack trace from this point.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
            //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
            //       or if it catches a thrown object without a "stack" property.
            try {
                throw new Error(msg);
            } catch (ex1) {
                ex = ex1;
            }

            // null exception name so `Error` isn't prefixed to msg
            ex.name = null;

            options = objectMerge({
                // fingerprint on msg, not stack trace (legacy behavior, could be
                // revisited)
                fingerprint: msg,
                // since we know this is a synthetic trace, the top N-most frames
                // MUST be from Raven.js, so mark them as in_app later by setting
                // trimHeadFrames
                trimHeadFrames: (options.trimHeadFrames || 0) + 1
            }, options);

            var stack = TraceKit.computeStackTrace(ex);
            var frames = this._prepareFrames(stack, options);
            data.stacktrace = {
                // Sentry expects frames oldest to newest
                frames: frames.reverse()
            }
        }

        // Fire away!
        this._send(data);

        return this;
    },

    captureBreadcrumb: function (obj) {
        var crumb = objectMerge({
            timestamp: now() / 1000
        }, obj);

        if (isFunction(this._globalOptions.breadcrumbCallback)) {
            var result = this._globalOptions.breadcrumbCallback(crumb);

            if (isObject(result) && !isEmptyObject(result)) {
                crumb = result;
            } else if (result === false) {
                return this;
            }
        }

        this._breadcrumbs.push(crumb);
        if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
            this._breadcrumbs.shift();
        }
        return this;
    },

    addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
        var pluginArgs = [].slice.call(arguments, 1);

        this._plugins.push([plugin, pluginArgs]);
        if (this._isRavenInstalled) {
            this._drainPlugins();
        }

        return this;
    },

    /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
    setUserContext: function(user) {
        // Intentionally do not merge here since that's an unexpected behavior.
        this._globalContext.user = user;

        return this;
    },

    /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
    setExtraContext: function(extra) {
        this._mergeContext('extra', extra);

        return this;
    },

    /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
    setTagsContext: function(tags) {
        this._mergeContext('tags', tags);

        return this;
    },

    /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
    clearContext: function() {
        this._globalContext = {};

        return this;
    },

    /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
    getContext: function() {
        // lol javascript
        return JSON.parse(stringify(this._globalContext));
    },


    /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
    setEnvironment: function(environment) {
        this._globalOptions.environment = environment;

        return this;
    },

    /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
    setRelease: function(release) {
        this._globalOptions.release = release;

        return this;
    },

    /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
    setDataCallback: function(callback) {
        var original = this._globalOptions.dataCallback;
        this._globalOptions.dataCallback = isFunction(callback)
          ? function (data) { return callback(data, original); }
          : callback;

        return this;
    },

    /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
    setBreadcrumbCallback: function(callback) {
        var original = this._globalOptions.breadcrumbCallback;
        this._globalOptions.breadcrumbCallback = isFunction(callback)
          ? function (data) { return callback(data, original); }
          : callback;

        return this;
    },

    /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
    setShouldSendCallback: function(callback) {
        var original = this._globalOptions.shouldSendCallback;
        this._globalOptions.shouldSendCallback = isFunction(callback)
            ? function (data) { return callback(data, original); }
            : callback;

        return this;
    },

    /**
     * Override the default HTTP transport mechanism that transmits data
     * to the Sentry server.
     *
     * @param {function} transport Function invoked instead of the default
     *                             `makeRequest` handler.
     *
     * @return {Raven}
     */
    setTransport: function(transport) {
        this._globalOptions.transport = transport;

        return this;
    },

    /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
    lastException: function() {
        return this._lastCapturedException;
    },

    /*
     * Get the last event id
     *
     * @return {string}
     */
    lastEventId: function() {
        return this._lastEventId;
    },

    /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
    isSetup: function() {
        if (!this._hasJSON) return false;  // needs JSON support
        if (!this._globalServer) {
            if (!this.ravenNotConfiguredError) {
              this.ravenNotConfiguredError = true;
              this._logDebug('error', 'Error: Raven has not been configured.');
            }
            return false;
        }
        return true;
    },

    afterLoad: function () {
        // TODO: remove window dependence?

        // Attempt to initialize Raven on load
        var RavenConfig = _window.RavenConfig;
        if (RavenConfig) {
            this.config(RavenConfig.dsn, RavenConfig.config).install();
        }
    },

    showReportDialog: function (options) {
        if (!_document) // doesn't work without a document (React native)
            return;

        options = options || {};

        var lastEventId = options.eventId || this.lastEventId();
        if (!lastEventId) {
            throw new RavenConfigError('Missing eventId');
        }

        var dsn = options.dsn || this._dsn;
        if (!dsn) {
            throw new RavenConfigError('Missing DSN');
        }

        var encode = encodeURIComponent;
        var qs = '';
        qs += '?eventId=' + encode(lastEventId);
        qs += '&dsn=' + encode(dsn);

        var user = options.user || this._globalContext.user;
        if (user) {
            if (user.name)  qs += '&name=' + encode(user.name);
            if (user.email) qs += '&email=' + encode(user.email);
        }

        var globalServer = this._getGlobalServer(this._parseDSN(dsn));

        var script = _document.createElement('script');
        script.async = true;
        script.src = globalServer + '/api/embed/error-page/' + qs;
        (_document.head || _document.body).appendChild(script);
    },

    /**** Private functions ****/
    _ignoreNextOnError: function () {
        var self = this;
        this._ignoreOnError += 1;
        setTimeout(function () {
            // onerror should trigger before setTimeout
            self._ignoreOnError -= 1;
        });
    },

    _triggerEvent: function(eventType, options) {
        // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
        var evt, key;

        if (!this._hasDocument)
            return;

        options = options || {};

        eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);

        if (_document.createEvent) {
            evt = _document.createEvent('HTMLEvents');
            evt.initEvent(eventType, true, true);
        } else {
            evt = _document.createEventObject();
            evt.eventType = eventType;
        }

        for (key in options) if (hasKey(options, key)) {
            evt[key] = options[key];
        }

        if (_document.createEvent) {
            // IE9 if standards
            _document.dispatchEvent(evt);
        } else {
            // IE8 regardless of Quirks or Standards
            // IE9 if quirks
            try {
                _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
            } catch(e) {
                // Do nothing
            }
        }
    },

    /**
     * Wraps addEventListener to capture UI breadcrumbs
     * @param evtName the event name (e.g. "click")
     * @returns {Function}
     * @private
     */
    _breadcrumbEventHandler: function(evtName) {
        var self = this;
        return function (evt) {
            // reset keypress timeout; e.g. triggering a 'click' after
            // a 'keypress' will reset the keypress debounce so that a new
            // set of keypresses can be recorded
            self._keypressTimeout = null;

            // It's possible this handler might trigger multiple times for the same
            // event (e.g. event propagation through node ancestors). Ignore if we've
            // already captured the event.
            if (self._lastCapturedEvent === evt)
                return;

            self._lastCapturedEvent = evt;

            // try/catch both:
            // - accessing evt.target (see getsentry/raven-js#838, #768)
            // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
            //   can throw an exception in some circumstances.
            var target;
            try {
                target = htmlTreeAsString(evt.target);
            } catch (e) {
                target = '<unknown>';
            }

            self.captureBreadcrumb({
                category: 'ui.' + evtName, // e.g. ui.click, ui.input
                message: target
            });
        };
    },

    /**
     * Wraps addEventListener to capture keypress UI events
     * @returns {Function}
     * @private
     */
    _keypressEventHandler: function() {
        var self = this,
            debounceDuration = 1000; // milliseconds

        // TODO: if somehow user switches keypress target before
        //       debounce timeout is triggered, we will only capture
        //       a single breadcrumb from the FIRST target (acceptable?)
        return function (evt) {
            var target;
            try {
                target = evt.target;
            } catch (e) {
                // just accessing event properties can throw an exception in some rare circumstances
                // see: https://github.com/getsentry/raven-js/issues/838
                return;
            }
            var tagName = target && target.tagName;

            // only consider keypress events on actual input elements
            // this will disregard keypresses targeting body (e.g. tabbing
            // through elements, hotkeys, etc)
            if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
                return;

            // record first keypress in a series, but ignore subsequent
            // keypresses until debounce clears
            var timeout = self._keypressTimeout;
            if (!timeout) {
                self._breadcrumbEventHandler('input')(evt);
            }
            clearTimeout(timeout);
            self._keypressTimeout = setTimeout(function () {
                self._keypressTimeout = null;
            }, debounceDuration);
        };
    },

    /**
     * Captures a breadcrumb of type "navigation", normalizing input URLs
     * @param to the originating URL
     * @param from the target URL
     * @private
     */
    _captureUrlChange: function(from, to) {
        var parsedLoc = parseUrl(this._location.href);
        var parsedTo = parseUrl(to);
        var parsedFrom = parseUrl(from);

        // because onpopstate only tells you the "new" (to) value of location.href, and
        // not the previous (from) value, we need to track the value of the current URL
        // state ourselves
        this._lastHref = to;

        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
            to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
            from = parsedFrom.relative;

        this.captureBreadcrumb({
            category: 'navigation',
            data: {
                to: to,
                from: from
            }
        });
    },

    /**
     * Install any queued plugins
     */
    _instrumentTryCatch: function() {
        var self = this;

        var wrappedBuiltIns = self._wrappedBuiltIns;

        function wrapTimeFn(orig) {
            return function (fn, t) { // preserve arity
                // Make a copy of the arguments to prevent deoptimization
                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                var args = new Array(arguments.length);
                for(var i = 0; i < args.length; ++i) {
                    args[i] = arguments[i];
                }
                var originalCallback = args[0];
                if (isFunction(originalCallback)) {
                    args[0] = self.wrap(originalCallback);
                }

                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                // also supports only two arguments and doesn't care what this is, so we
                // can just call the original function directly.
                if (orig.apply) {
                    return orig.apply(this, args);
                } else {
                    return orig(args[0], args[1]);
                }
            };
        }

        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

        function wrapEventTarget(global) {
            var proto = _window[global] && _window[global].prototype;
            if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
                fill(proto, 'addEventListener', function(orig) {
                    return function (evtName, fn, capture, secure) { // preserve arity
                        try {
                            if (fn && fn.handleEvent) {
                                fn.handleEvent = self.wrap(fn.handleEvent);
                            }
                        } catch (err) {
                            // can sometimes get 'Permission denied to access property "handle Event'
                        }

                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                        // so that we don't have more than one wrapper function
                        var before,
                            clickHandler,
                            keypressHandler;

                        if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
                            // NOTE: generating multiple handlers per addEventListener invocation, should
                            //       revisit and verify we can just use one (almost certainly)
                            clickHandler = self._breadcrumbEventHandler('click');
                            keypressHandler = self._keypressEventHandler();
                            before = function (evt) {
                                // need to intercept every DOM event in `before` argument, in case that
                                // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                                // see #724
                                if (!evt) return;

                                var eventType;
                                try {
                                    eventType = evt.type
                                } catch (e) {
                                    // just accessing event properties can throw an exception in some rare circumstances
                                    // see: https://github.com/getsentry/raven-js/issues/838
                                    return;
                                }
                                if (eventType === 'click')
                                    return clickHandler(evt);
                                else if (eventType === 'keypress')
                                    return keypressHandler(evt);
                            };
                        }
                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
                    };
                }, wrappedBuiltIns);
                fill(proto, 'removeEventListener', function (orig) {
                    return function (evt, fn, capture, secure) {
                        try {
                            fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__  : fn);
                        } catch (e) {
                            // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
                        }
                        return orig.call(this, evt, fn, capture, secure);
                    };
                }, wrappedBuiltIns);
            }
        }

        fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
        fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
        if (_window.requestAnimationFrame) {
            fill(_window, 'requestAnimationFrame', function (orig) {
                return function (cb) {
                    return orig(self.wrap(cb));
                };
            }, wrappedBuiltIns);
        }

        // event targets borrowed from bugsnag-js:
        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
        var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
        for (var i = 0; i < eventTargets.length; i++) {
            wrapEventTarget(eventTargets[i]);
        }
    },


    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - XMLHttpRequests
     *  - DOM interactions (click/typing)
     *  - window.location changes
     *  - console
     *
     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
     */
    _instrumentBreadcrumbs: function () {
        var self = this;
        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

        var wrappedBuiltIns = self._wrappedBuiltIns;

        function wrapProp(prop, xhr) {
            if (prop in xhr && isFunction(xhr[prop])) {
                fill(xhr, prop, function (orig) {
                    return self.wrap(orig);
                }); // intentionally don't track filled methods on XHR instances
            }
        }

        if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
            var xhrproto = XMLHttpRequest.prototype;
            fill(xhrproto, 'open', function(origOpen) {
                return function (method, url) { // preserve arity

                    // if Sentry key appears in URL, don't capture
                    if (isString(url) && url.indexOf(self._globalKey) === -1) {
                        this.__raven_xhr = {
                            method: method,
                            url: url,
                            status_code: null
                        };
                    }

                    return origOpen.apply(this, arguments);
                };
            }, wrappedBuiltIns);

            fill(xhrproto, 'send', function(origSend) {
                return function (data) { // preserve arity
                    var xhr = this;

                    function onreadystatechangeHandler() {
                        if (xhr.__raven_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
                            try {
                                // touching statusCode in some platforms throws
                                // an exception
                                xhr.__raven_xhr.status_code = xhr.status;
                            } catch (e) { /* do nothing */ }
                            self.captureBreadcrumb({
                                type: 'http',
                                category: 'xhr',
                                data: xhr.__raven_xhr
                            });
                        }
                    }

                    var props = ['onload', 'onerror', 'onprogress'];
                    for (var j = 0; j < props.length; j++) {
                        wrapProp(props[j], xhr);
                    }

                    if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
                        fill(xhr, 'onreadystatechange', function (orig) {
                            return self.wrap(orig, undefined, onreadystatechangeHandler);
                        } /* intentionally don't track this instrumentation */);
                    } else {
                        // if onreadystatechange wasn't actually set by the page on this xhr, we
                        // are free to set our own and capture the breadcrumb
                        xhr.onreadystatechange = onreadystatechangeHandler;
                    }

                    return origSend.apply(this, arguments);
                };
            }, wrappedBuiltIns);
        }

        if (autoBreadcrumbs.xhr && 'fetch' in _window) {
            fill(_window, 'fetch', function(origFetch) {
                return function (fn, t) { // preserve arity
                    // Make a copy of the arguments to prevent deoptimization
                    // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                    var args = new Array(arguments.length);
                    for (var i = 0; i < args.length; ++i) {
                        args[i] = arguments[i];
                    }

                    var fetchInput = args[0];
                    var method = 'GET';
                    var url;

                    if (typeof fetchInput === 'string') {
                        url = fetchInput;
                    } else {
                        url = fetchInput.url;
                        if (fetchInput.method) {
                            method = fetchInput.method;
                        }
                    }

                    if (args[1] && args[1].method) {
                        method = args[1].method;
                    }

                    var fetchData = {
                        method: method,
                        url: url,
                        status_code: null
                    };

                    self.captureBreadcrumb({
                        type: 'http',
                        category: 'fetch',
                        data: fetchData
                    });

                    return origFetch.apply(this, args).then(function (response) {
                        fetchData.status_code = response.status;

                        return response;
                    });
                };
            }, wrappedBuiltIns);
        }

        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
        // to the document. Do this before we instrument addEventListener.
        if (autoBreadcrumbs.dom && this._hasDocument) {
            if (_document.addEventListener) {
                _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
                _document.addEventListener('keypress', self._keypressEventHandler(), false);
            }
            else {
                // IE8 Compatibility
                _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
                _document.attachEvent('onkeypress', self._keypressEventHandler());
            }
        }

        // record navigation (URL) changes
        // NOTE: in Chrome App environment, touching history.pushState, *even inside
        //       a try/catch block*, will cause Chrome to output an error to console.error
        // borrowed from: https://github.com/angular/angular.js/pull/13945/files
        var chrome = _window.chrome;
        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
        var hasPushState = !isChromePackagedApp && _window.history && history.pushState;
        if (autoBreadcrumbs.location && hasPushState) {
            // TODO: remove onpopstate handler on uninstall()
            var oldOnPopState = _window.onpopstate;
            _window.onpopstate = function () {
                var currentHref = self._location.href;
                self._captureUrlChange(self._lastHref, currentHref);

                if (oldOnPopState) {
                    return oldOnPopState.apply(this, arguments);
                }
            };

            fill(history, 'pushState', function (origPushState) {
                // note history.pushState.length is 0; intentionally not declaring
                // params to preserve 0 arity
                return function (/* state, title, url */) {
                    var url = arguments.length > 2 ? arguments[2] : undefined;

                    // url argument is optional
                    if (url) {
                        // coerce to string (this is what pushState does)
                        self._captureUrlChange(self._lastHref, url + '');
                    }

                    return origPushState.apply(this, arguments);
                };
            }, wrappedBuiltIns);
        }

        if (autoBreadcrumbs.console && 'console' in _window && console.log) {
            // console
            var consoleMethodCallback = function (msg, data) {
                self.captureBreadcrumb({
                    message: msg,
                    level: data.level,
                    category: 'console'
                });
            };

            each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
                wrapConsoleMethod(console, level, consoleMethodCallback);
            });
        }

    },

    _restoreBuiltIns: function () {
        // restore any wrapped builtins
        var builtin;
        while (this._wrappedBuiltIns.length) {
            builtin = this._wrappedBuiltIns.shift();

            var obj = builtin[0],
              name = builtin[1],
              orig = builtin[2];

            obj[name] = orig;
        }
    },

    _drainPlugins: function() {
        var self = this;

        // FIX ME TODO
        each(this._plugins, function(_, plugin) {
            var installer = plugin[0];
            var args = plugin[1];
            installer.apply(self, [self].concat(args));
        });
    },

    _parseDSN: function(str) {
        var m = dsnPattern.exec(str),
            dsn = {},
            i = 7;

        try {
            while (i--) dsn[dsnKeys[i]] = m[i] || '';
        } catch(e) {
            throw new RavenConfigError('Invalid DSN: ' + str);
        }

        if (dsn.pass && !this._globalOptions.allowSecretKey) {
            throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
        }

        return dsn;
    },

    _getGlobalServer: function(uri) {
        // assemble the endpoint from the uri pieces
        var globalServer = '//' + uri.host +
            (uri.port ? ':' + uri.port : '');

        if (uri.protocol) {
            globalServer = uri.protocol + ':' + globalServer;
        }
        return globalServer;
    },

    _handleOnErrorStackInfo: function() {
        // if we are intentionally ignoring errors via onerror, bail out
        if (!this._ignoreOnError) {
            this._handleStackInfo.apply(this, arguments);
        }
    },

    _handleStackInfo: function(stackInfo, options) {
        var frames = this._prepareFrames(stackInfo, options);

        this._triggerEvent('handle', {
            stackInfo: stackInfo,
            options: options
        });

        this._processException(
            stackInfo.name,
            stackInfo.message,
            stackInfo.url,
            stackInfo.lineno,
            frames,
            options
        );
    },

    _prepareFrames: function(stackInfo, options) {
        var self = this;
        var frames = [];
        if (stackInfo.stack && stackInfo.stack.length) {
            each(stackInfo.stack, function(i, stack) {
                var frame = self._normalizeFrame(stack);
                if (frame) {
                    frames.push(frame);
                }
            });

            // e.g. frames captured via captureMessage throw
            if (options && options.trimHeadFrames) {
                for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
                    frames[j].in_app = false;
                }
            }
        }
        frames = frames.slice(0, this._globalOptions.stackTraceLimit);
        return frames;
    },


    _normalizeFrame: function(frame) {
        if (!frame.url) return;

        // normalize the frames data
        var normalized = {
            filename:   frame.url,
            lineno:     frame.line,
            colno:      frame.column,
            'function': frame.func || '?'
        };

        normalized.in_app = !( // determine if an exception came from outside of our app
            // first we check the global includePaths list.
            !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
            // Now we check for fun, if the function name is Raven or TraceKit
            /(Raven|TraceKit)\./.test(normalized['function']) ||
            // finally, we do a last ditch effort and check for raven.min.js
            /raven\.(min\.)?js$/.test(normalized.filename)
        );

        return normalized;
    },

    _processException: function(type, message, fileurl, lineno, frames, options) {
        var stacktrace;
        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(message)) return;

        message += '';

        if (frames && frames.length) {
            fileurl = frames[0].filename || fileurl;
            // Sentry expects frames oldest to newest
            // and JS sends them as newest to oldest
            frames.reverse();
            stacktrace = {frames: frames};
        } else if (fileurl) {
            stacktrace = {
                frames: [{
                    filename: fileurl,
                    lineno: lineno,
                    in_app: true
                }]
            };
        }

        if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) return;
        if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) return;

        var data = objectMerge({
            // sentry.interfaces.Exception
            exception: {
                values: [{
                    type: type,
                    value: message,
                    stacktrace: stacktrace
                }]
            },
            culprit: fileurl
        }, options);

        // Fire away!
        this._send(data);
    },

    _trimPacket: function(data) {
        // For now, we only want to truncate the two different messages
        // but this could/should be expanded to just trim everything
        var max = this._globalOptions.maxMessageLength;
        if (data.message) {
            data.message = truncate(data.message, max);
        }
        if (data.exception) {
            var exception = data.exception.values[0];
            exception.value = truncate(exception.value, max);
        }

        var request = data.request;
        if (request) {
            if (request.url) {
                request.url = truncate(request.url, this._globalOptions.maxUrlLength);
            }
            if (request.Referer) {
                request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
            }
        }

        if (data.breadcrumbs && data.breadcrumbs.values)
            this._trimBreadcrumbs(data.breadcrumbs);

        return data;
    },

    /**
     * Truncate breadcrumb values (right now just URLs)
     */
    _trimBreadcrumbs: function (breadcrumbs) {
        // known breadcrumb properties with urls
        // TODO: also consider arbitrary prop values that start with (https?)?://
        var urlProps = ['to', 'from', 'url'],
            urlProp,
            crumb,
            data;

        for (var i = 0; i < breadcrumbs.values.length; ++i) {
            crumb = breadcrumbs.values[i];
            if (!crumb.hasOwnProperty('data') || !isObject(crumb.data))
                continue;

            data = crumb.data;
            for (var j = 0; j < urlProps.length; ++j) {
                urlProp = urlProps[j];
                if (data.hasOwnProperty(urlProp)) {
                    data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
                }
            }
        }
    },

    _getHttpData: function() {
        if (!this._hasNavigator && !this._hasDocument) return;
        var httpData = {};

        if (this._hasNavigator && _navigator.userAgent) {
            httpData.headers = {
              'User-Agent': navigator.userAgent
            };
        }

        if (this._hasDocument) {
            if (_document.location && _document.location.href) {
                httpData.url = _document.location.href;
            }
            if (_document.referrer) {
                if (!httpData.headers) httpData.headers = {};
                httpData.headers.Referer = _document.referrer;
            }
        }

        return httpData;
    },

    _resetBackoff: function() {
        this._backoffDuration = 0;
        this._backoffStart = null;
    },

    _shouldBackoff: function() {
        return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
    },

    /**
     * Returns true if the in-process data payload matches the signature
     * of the previously-sent data
     *
     * NOTE: This has to be done at this level because TraceKit can generate
     *       data from window.onerror WITHOUT an exception object (IE8, IE9,
     *       other old browsers). This can take the form of an "exception"
     *       data object with a single frame (derived from the onerror args).
     */
    _isRepeatData: function (current) {
        var last = this._lastData;

        if (!last ||
            current.message !== last.message || // defined for captureMessage
            current.culprit !== last.culprit)   // defined for captureException/onerror
            return false;

        // Stacktrace interface (i.e. from captureMessage)
        if (current.stacktrace || last.stacktrace) {
            return isSameStacktrace(current.stacktrace, last.stacktrace);
        }
        // Exception interface (i.e. from captureException/onerror)
        else if (current.exception || last.exception) {
            return isSameException(current.exception, last.exception);
        }

        return true;
    },

    _setBackoffState: function(request) {
        // If we are already in a backoff state, don't change anything
        if (this._shouldBackoff()) {
            return;
        }

        var status = request.status;

        // 400 - project_id doesn't exist or some other fatal
        // 401 - invalid/revoked dsn
        // 429 - too many requests
        if (!(status === 400 || status === 401 || status === 429))
            return;

        var retry;
        try {
            // If Retry-After is not in Access-Control-Expose-Headers, most
            // browsers will throw an exception trying to access it
            retry = request.getResponseHeader('Retry-After');
            retry = parseInt(retry, 10) * 1000; // Retry-After is returned in seconds
        } catch (e) {
            /* eslint no-empty:0 */
        }


        this._backoffDuration = retry
            // If Sentry server returned a Retry-After value, use it
            ? retry
            // Otherwise, double the last backoff duration (starts at 1 sec)
            : this._backoffDuration * 2 || 1000;

        this._backoffStart = now();
    },

    _send: function(data) {
        var globalOptions = this._globalOptions;

        var baseData = {
            project: this._globalProject,
            logger: globalOptions.logger,
            platform: 'javascript'
        }, httpData = this._getHttpData();

        if (httpData) {
            baseData.request = httpData;
        }

        // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
        if (data.trimHeadFrames) delete data.trimHeadFrames;

        data = objectMerge(baseData, data);

        // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
        data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
        data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

        // Send along our own collected metadata with extra
        data.extra['session:duration'] = now() - this._startTime;

        if (this._breadcrumbs && this._breadcrumbs.length > 0) {
            // intentionally make shallow copy so that additions
            // to breadcrumbs aren't accidentally sent in this request
            data.breadcrumbs = {
                values: [].slice.call(this._breadcrumbs, 0)
            };
        }

        // If there are no tags/extra, strip the key from the payload alltogther.
        if (isEmptyObject(data.tags)) delete data.tags;

        if (this._globalContext.user) {
            // sentry.interfaces.User
            data.user = this._globalContext.user;
        }

        // Include the environment if it's defined in globalOptions
        if (globalOptions.environment) data.environment = globalOptions.environment;

        // Include the release if it's defined in globalOptions
        if (globalOptions.release) data.release = globalOptions.release;

        // Include server_name if it's defined in globalOptions
        if (globalOptions.serverName) data.server_name = globalOptions.serverName;

        if (isFunction(globalOptions.dataCallback)) {
            data = globalOptions.dataCallback(data) || data;
        }

        // Why??????????
        if (!data || isEmptyObject(data)) {
            return;
        }

        // Check if the request should be filtered or not
        if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
            return;
        }

        // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
        // so drop requests until "cool-off" period has elapsed.
        if (this._shouldBackoff()) {
            this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
            return;
        }

        if (typeof globalOptions.sampleRate === 'number') {
            if (Math.random() < globalOptions.sampleRate) {
                this._sendProcessedPayload(data);
            }
        } else {
            this._sendProcessedPayload(data);
        }
    },

    _getUuid: function () {
      return uuid4();
    },

    _sendProcessedPayload: function(data, callback) {
        var self = this;
        var globalOptions = this._globalOptions;

        if (!this.isSetup()) return;

        // Send along an event_id if not explicitly passed.
        // This event_id can be used to reference the error within Sentry itself.
        // Set lastEventId after we know the error should actually be sent
        this._lastEventId = data.event_id || (data.event_id = this._getUuid());

        // Try and clean up the packet before sending by truncating long values
        data = this._trimPacket(data);

        // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
        // but this would require copying an un-truncated copy of the data packet, which can be
        // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
        if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
            this._logDebug('warn', 'Raven dropped repeat event: ', data);
            return;
        }

        // Store outbound payload after trim
        this._lastData = data;

        this._logDebug('debug', 'Raven about to send:', data);

        var auth = {
            sentry_version: '7',
            sentry_client: 'raven-js/' + this.VERSION,
            sentry_key: this._globalKey
        };
        if (this._globalSecret) {
            auth.sentry_secret = this._globalSecret;
        }

        var exception = data.exception && data.exception.values[0];
        this.captureBreadcrumb({
            category: 'sentry',
            message: exception
                ? (exception.type ? exception.type + ': ' : '') + exception.value
                : data.message,
            event_id: data.event_id,
            level: data.level || 'error' // presume error unless specified
        });

        var url = this._globalEndpoint;
        (globalOptions.transport || this._makeRequest).call(this, {
            url: url,
            auth: auth,
            data: data,
            options: globalOptions,
            onSuccess: function success() {
                self._resetBackoff();

                self._triggerEvent('success', {
                    data: data,
                    src: url
                });
                callback && callback();
            },
            onError: function failure(error) {
                self._logDebug('error', 'Raven transport failed to send: ', error);

                if (error.request) {
                    self._setBackoffState(error.request);
                }

                self._triggerEvent('failure', {
                    data: data,
                    src: url
                });
                error = error || new Error('Raven send failed (no additional details provided)');
                callback && callback(error);
            }
        });
    },

    _makeRequest: function(opts) {
        var request = new XMLHttpRequest();

        // if browser doesn't support CORS (e.g. IE7), we are out of luck
        var hasCORS =
            'withCredentials' in request ||
            typeof XDomainRequest !== 'undefined';

        if (!hasCORS) return;

        var url = opts.url;

        if ('withCredentials' in request) {
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                } else if (request.status === 200) {
                    opts.onSuccess && opts.onSuccess();
                } else if (opts.onError) {
                    var err = new Error('Sentry error code: ' + request.status);
                    err.request = request;
                    opts.onError(err);
                }
            };
        } else {
            request = new XDomainRequest();
            // xdomainrequest cannot go http -> https (or vice versa),
            // so always use protocol relative
            url = url.replace(/^https?:/, '');

            // onreadystatechange not supported by XDomainRequest
            if (opts.onSuccess) {
                request.onload = opts.onSuccess;
            }
            if (opts.onError) {
                request.onerror = function () {
                    var err = new Error('Sentry error code: XDomainRequest');
                    err.request = request;
                    opts.onError(err);
                }
            }
        }

        // NOTE: auth is intentionally sent as part of query string (NOT as custom
        //       HTTP header) so as to avoid preflight CORS requests
        request.open('POST', url + '?' + urlencode(opts.auth));
        request.send(stringify(opts.data));
    },

    _logDebug: function(level) {
        if (this._originalConsoleMethods[level] && this.debug) {
            // In IE<10 console methods do not have their own 'apply' method
            Function.prototype.apply.call(
                this._originalConsoleMethods[level],
                this._originalConsole,
                [].slice.call(arguments, 1)
            );
        }
    },

    _mergeContext: function(key, context) {
        if (isUndefined(context)) {
            delete this._globalContext[key];
        } else {
            this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
        }
    }
};

/*------------------------------------------------
 * utils
 *
 * conditionally exported for test via Raven.utils
 =================================================
 */
var objectPrototype = Object.prototype;

function isUndefined(what) {
    return what === void 0;
}

function isFunction(what) {
    return typeof what === 'function';
}

function isString(what) {
    return objectPrototype.toString.call(what) === '[object String]';
}


function isEmptyObject(what) {
    for (var _ in what) return false;  // eslint-disable-line guard-for-in, no-unused-vars
    return true;
}

function each(obj, callback) {
    var i, j;

    if (isUndefined(obj.length)) {
        for (i in obj) {
            if (hasKey(obj, i)) {
                callback.call(null, i, obj[i]);
            }
        }
    } else {
        j = obj.length;
        if (j) {
            for (i = 0; i < j; i++) {
                callback.call(null, i, obj[i]);
            }
        }
    }
}

function objectMerge(obj1, obj2) {
    if (!obj2) {
        return obj1;
    }
    each(obj2, function(key, value){
        obj1[key] = value;
    });
    return obj1;
}

function truncate(str, max) {
    return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
    return objectPrototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
    // Combine an array of regular expressions and strings into one large regexp
    // Be mad.
    var sources = [],
        i = 0, len = patterns.length,
        pattern;

    for (; i < len; i++) {
        pattern = patterns[i];
        if (isString(pattern)) {
            // If it's a string, we need to escape it
            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
        } else if (pattern && pattern.source) {
            // If it's a regexp already, we want to extract the source
            sources.push(pattern.source);
        }
        // Intentionally skip other cases
    }
    return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
    var pairs = [];
    each(o, function(key, value) {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};

    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        protocol: match[2],
        host: match[4],
        path: match[5],
        relative: match[5] + query + fragment // everything minus origin
    };
}
function uuid4() {
    var crypto = _window.crypto || _window.msCrypto;

    if (!isUndefined(crypto) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);

        // set 4 in byte 7
        arr[3] = arr[3] & 0xFFF | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        arr[4] = arr[4] & 0x3FFF | 0x8000;

        var pad = function(num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = '0' + v;
            }
            return v;
        };

        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
        pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    } else {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0,
                v = c === 'x' ? r : r&0x3|0x8;
            return v.toString(16);
        });
    }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
    /* eslint no-extra-parens:0*/
    var MAX_TRAVERSE_HEIGHT = 5,
        MAX_OUTPUT_LEN = 80,
        out = [],
        height = 0,
        len = 0,
        separator = ' > ',
        sepLength = separator.length,
        nextStr;

    while (elem && height++ < MAX_TRAVERSE_HEIGHT) {

        nextStr = htmlElementAsString(elem);
        // bail out if
        // - nextStr is the 'html' element
        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
        //   (ignore this limit if we are on the first iteration)
        if (nextStr === 'html' || height > 1 && len + (out.length * sepLength) + nextStr.length >= MAX_OUTPUT_LEN) {
            break;
        }

        out.push(nextStr);

        len += nextStr.length;
        elem = elem.parentNode;
    }

    return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
    var out = [],
        className,
        classes,
        key,
        attr,
        i;

    if (!elem || !elem.tagName) {
        return '';
    }

    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push('#' + elem.id);
    }

    className = elem.className;
    if (className && isString(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push('.' + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push('[' + key + '="' + attr + '"]');
        }
    }
    return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
    return !!(!!a ^ !!b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
    if (isOnlyOneTruthy(ex1, ex2))
        return false;

    ex1 = ex1.values[0];
    ex2 = ex2.values[0];

    if (ex1.type !== ex2.type ||
        ex1.value !== ex2.value)
        return false;

    return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
    if (isOnlyOneTruthy(stack1, stack2))
        return false;

    var frames1 = stack1.frames;
    var frames2 = stack2.frames;

    // Exit early if frame count differs
    if (frames1.length !== frames2.length)
        return false;

    // Iterate through every frame; bail out if anything differs
    var a, b;
    for (var i = 0; i < frames1.length; i++) {
        a = frames1[i];
        b = frames2[i];
        if (a.filename !== b.filename ||
            a.lineno !== b.lineno ||
            a.colno !== b.colno ||
            a['function'] !== b['function'])
            return false;
    }
    return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
    var orig = obj[name];
    obj[name] = replacement(orig);
    if (track) {
        track.push([obj, name, orig]);
    }
}

if (typeof __DEV__ !== 'undefined' && __DEV__) {
    Raven.utils = {
        isUndefined: isUndefined,
        isFunction: isFunction,
        isString: isString,
        isObject: isObject,
        isEmptyObject: isEmptyObject,
        isError: isError,
        each: each,
        objectMerge: objectMerge,
        truncate: truncate,
        hasKey: hasKey,
        joinRegExp: joinRegExp,
        urlencode: urlencode,
        uuid4: uuid4,
        htmlTreeAsString: htmlTreeAsString,
        htmlElementAsString: htmlElementAsString,
        parseUrl: parseUrl,
        fill: fill
    };
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/



var RavenConstructor = __webpack_require__(1054);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function () {
	_window.Raven = _Raven;
	return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var utils = __webpack_require__(193);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
    collectWindowErrors: true,
    debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
    if (typeof document === 'undefined' || typeof document.location === 'undefined')
        return '';

    return document.location.href;
}


/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
    var handlers = [],
        lastArgs = null,
        lastException = null,
        lastExceptionStack = null;

    /**
     * Add a crash handler.
     * @param {Function} handler
     */
    function subscribe(handler) {
        installGlobalHandler();
        handlers.push(handler);
    }

    /**
     * Remove a crash handler.
     * @param {Function} handler
     */
    function unsubscribe(handler) {
        for (var i = handlers.length - 1; i >= 0; --i) {
            if (handlers[i] === handler) {
                handlers.splice(i, 1);
            }
        }
    }

    /**
     * Remove all crash handlers.
     */
    function unsubscribeAll() {
        uninstallGlobalHandler();
        handlers = [];
    }

    /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
    function notifyHandlers(stack, isWindowError) {
        var exception = null;
        if (isWindowError && !TraceKit.collectWindowErrors) {
          return;
        }
        for (var i in handlers) {
            if (handlers.hasOwnProperty(i)) {
                try {
                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                } catch (inner) {
                    exception = inner;
                }
            }
        }

        if (exception) {
            throw exception;
        }
    }

    var _oldOnerrorHandler, _onErrorHandlerInstalled;

    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     * @param {?(number|string)} colNo The column number at which the error
     * occurred.
     * @param {?Error} ex The actual Error object.
     */
    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
        var stack = null;

        if (lastExceptionStack) {
            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
            processLastException();
        } else if (ex && utils.isError(ex)) {
            // non-string `ex` arg; attempt to extract stack trace

            // New chrome and blink send along a real error object
            // Let's just report that like a normal error.
            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
            stack = TraceKit.computeStackTrace(ex);
            notifyHandlers(stack, true);
        } else {
            var location = {
                'url': url,
                'line': lineNo,
                'column': colNo
            };

            var name = undefined;
            var msg = message; // must be new var or will modify original `arguments`
            var groups;
            if ({}.toString.call(message) === '[object String]') {
                var groups = message.match(ERROR_TYPES_RE);
                if (groups) {
                    name = groups[1];
                    msg = groups[2];
                }
            }

            location.func = UNKNOWN_FUNCTION;

            stack = {
                'name': name,
                'message': msg,
                'url': getLocationHref(),
                'stack': [location]
            };
            notifyHandlers(stack, true);
        }

        if (_oldOnerrorHandler) {
            return _oldOnerrorHandler.apply(this, arguments);
        }

        return false;
    }

    function installGlobalHandler ()
    {
        if (_onErrorHandlerInstalled) {
            return;
        }
        _oldOnerrorHandler = _window.onerror;
        _window.onerror = traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }

    function uninstallGlobalHandler ()
    {
        if (!_onErrorHandlerInstalled) {
            return;
        }
        _window.onerror = _oldOnerrorHandler;
        _onErrorHandlerInstalled = false;
        _oldOnerrorHandler = undefined;
    }

    function processLastException() {
        var _lastExceptionStack = lastExceptionStack,
            _lastArgs = lastArgs;
        lastArgs = null;
        lastExceptionStack = null;
        lastException = null;
        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
    }

    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @param {?boolean} rethrow If false, do not re-throw the exception.
     * Only used for window.onerror to not cause an infinite loop of
     * rethrowing.
     */
    function report(ex, rethrow) {
        var args = _slice.call(arguments, 1);
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            } else {
              processLastException();
            }
        }

        var stack = TraceKit.computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;
        lastArgs = args;

        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function () {
            if (lastException === ex) {
                processLastException();
            }
        }, (stack.incomplete ? 2000 : 0));

        if (rethrow !== false) {
            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
        }
    }

    report.subscribe = subscribe;
    report.unsubscribe = unsubscribe;
    report.uninstall = unsubscribeAll;
    return report;
}());

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceFromStackProp(ex) {
        if (typeof ex.stack === 'undefined' || !ex.stack) return;

        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,

            // Used to additionally parse URL/line/column from eval frames
            geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
            chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/,

            lines = ex.stack.split('\n'),
            stack = [],
            submatch,
            parts,
            element,
            reference = /^(.*) is undefined$/.exec(ex.message);

        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = chrome.exec(lines[i]))) {
                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
                var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
                if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                    // throw out eval line/column and use top-most line/column number
                    parts[2] = submatch[1]; // url
                    parts[3] = submatch[2]; // line
                    parts[4] = submatch[3]; // column
                }
                element = {
                    'url': !isNative ? parts[2] : null,
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': isNative ? [parts[2]] : [],
                    'line': parts[3] ? +parts[3] : null,
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ( parts = winjs.exec(lines[i]) ) {
                element = {
                    'url': parts[2],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': [],
                    'line': +parts[3],
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ((parts = gecko.exec(lines[i]))) {
                var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
                if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                    // throw out eval line/column and use top-most line number
                    parts[3] = submatch[1];
                    parts[4] = submatch[2];
                    parts[5] = null; // no column when eval
                } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
                    // FireFox uses this awesome columnNumber property for its top frame
                    // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                    // so adding 1
                    // NOTE: this hack doesn't work if top-most frame is eval
                    stack[0].column = ex.columnNumber + 1;
                }
                element = {
                    'url': parts[3],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': parts[2] ? parts[2].split(',') : [],
                    'line': parts[4] ? +parts[4] : null,
                    'column': parts[5] ? +parts[5] : null
                };
            } else {
                continue;
            }

            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }

            stack.push(element);
        }

        if (!stack.length) {
            return null;
        }

        return {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref(),
            'stack': stack
        };
    }

    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            'url': url,
            'line': lineNo
        };

        if (initial.url && initial.line) {
            stackInfo.incomplete = false;

            if (!initial.func) {
                initial.func = UNKNOWN_FUNCTION;
            }

            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        return false;
                    }
                }
            }

            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        } else {
            stackInfo.incomplete = true;
        }

        return false;
    }

    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
            stack = [],
            funcs = {},
            recursion = false,
            parts,
            item,
            source;

        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === computeStackTrace || curr === TraceKit.report) {
                // console.log('skipping internal function');
                continue;
            }

            item = {
                'url': null,
                'func': UNKNOWN_FUNCTION,
                'line': null,
                'column': null
            };

            if (curr.name) {
                item.func = curr.name;
            } else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }

            if (typeof item.func === 'undefined') {
              try {
                item.func = parts.input.substring(0, parts.input.indexOf('{'));
              } catch (e) { }
            }

            if (funcs['' + curr]) {
                recursion = true;
            }else{
                funcs['' + curr] = true;
            }

            stack.push(item);
        }

        if (depth) {
            // console.log('depth is ' + depth);
            // console.log('stack is ' + stack.length);
            stack.splice(0, depth);
        }

        var result = {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref(),
            'stack': stack
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }

    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        depth = (depth == null ? 0 : +depth);

        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (TraceKit.debug) {
                throw e;
            }
        }

        try {
            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (TraceKit.debug) {
                throw e;
            }
        }
        return {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref()
        };
    }

    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

    return computeStackTrace;
}());

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified for IE8 compatibility.
 Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify
exports.getSerialize = serializer

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return '[Circular ~]'
    return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']'
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~indexOf(stack, value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Alpha.png": 780,
	"./Beta.png": 781,
	"./Chi.png": 782,
	"./Delta.png": 783,
	"./Epsilon.png": 784,
	"./Eta.png": 785,
	"./Gamma.png": 786,
	"./Iota.png": 787,
	"./Kappa.png": 788,
	"./Lambda.png": 789,
	"./Mu.png": 790,
	"./Nu.png": 791,
	"./Omega.png": 792,
	"./Omicron.png": 793,
	"./Phi.png": 794,
	"./Pi.png": 795,
	"./Psi.png": 796,
	"./Rho.png": 797,
	"./Sigma.png": 798,
	"./Tau.png": 799,
	"./Theta.png": 800,
	"./Upsilon.png": 801,
	"./Xi.png": 802,
	"./Zeta.png": 803
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1324;


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./GoldAlpha.png": 756,
	"./GoldBeta.png": 757,
	"./GoldChi.png": 758,
	"./GoldDelta.png": 759,
	"./GoldEpsilon.png": 760,
	"./GoldEta.png": 761,
	"./GoldGamma.png": 762,
	"./GoldIota.png": 763,
	"./GoldKappa.png": 764,
	"./GoldLambda.png": 765,
	"./GoldMu.png": 766,
	"./GoldNu.png": 767,
	"./GoldOmega.png": 768,
	"./GoldOmicron.png": 769,
	"./GoldPhi.png": 770,
	"./GoldPi.png": 771,
	"./GoldPsi.png": 772,
	"./GoldRho.png": 773,
	"./GoldSigma.png": 774,
	"./GoldTau.png": 775,
	"./GoldTheta.png": 776,
	"./GoldUpsilon.png": 777,
	"./GoldXi.png": 778,
	"./GoldZeta.png": 779
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1325;


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Alpha.png": 828,
	"./Beta.png": 829,
	"./Chi.png": 830,
	"./Delta.png": 831,
	"./Epsilon.png": 832,
	"./Eta.png": 833,
	"./Gamma.png": 834,
	"./Iota.png": 835,
	"./Kappa.png": 836,
	"./Lambda.png": 837,
	"./Mu.png": 838,
	"./Nu.png": 839,
	"./Omega.png": 840,
	"./Omicron.png": 841,
	"./Phi.png": 842,
	"./Pi.png": 843,
	"./Psi.png": 844,
	"./Rho.png": 845,
	"./Sigma.png": 846,
	"./Tau.png": 847,
	"./Theta.png": 848,
	"./Upsilon.png": 849,
	"./Xi.png": 850,
	"./Zeta.png": 851
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1326;


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./GoldAlpha2x.png": 804,
	"./GoldBeta2x.png": 805,
	"./GoldChi2x.png": 806,
	"./GoldDelta2x.png": 807,
	"./GoldEpsilon2x.png": 808,
	"./GoldEta2x.png": 809,
	"./GoldGamma2x.png": 810,
	"./GoldIota2x.png": 811,
	"./GoldKappa2x.png": 812,
	"./GoldLambda2x.png": 813,
	"./GoldMu2x.png": 814,
	"./GoldNu2x.png": 815,
	"./GoldOmega2x.png": 816,
	"./GoldOmicron2x.png": 817,
	"./GoldPhi2x.png": 818,
	"./GoldPi2x.png": 819,
	"./GoldPsi2x.png": 820,
	"./GoldRho2x.png": 821,
	"./GoldSigma2x.png": 822,
	"./GoldTau2x.png": 823,
	"./GoldTheta2x.png": 824,
	"./GoldUpsilon2x.png": 825,
	"./GoldXi2x.png": 826,
	"./GoldZeta2x.png": 827
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./3CirclesC.gmt": 877,
	"./3CirclesI.gmt": 878,
	"./3rdProportional.gmt": 879,
	"./4SymmetricLines.gmt": 880,
	"./4thProportional.gmt": 881,
	"./60RotationCW.gmt": 882,
	"./90RotationCCW.gmt": 883,
	"./9PointCircle.gmt": 884,
	"./AEqualSegments1.gmt": 885,
	"./AMinPerimeter.gmt": 886,
	"./APtOnCircleMaxDist.gmt": 887,
	"./ATrByCentroid.gmt": 888,
	"./ATrByCircumcenter.gmt": 889,
	"./ATrByOrthocenter.gmt": 890,
	"./Angle15.gmt": 891,
	"./Angle3.gmt": 892,
	"./Angle30.gmt": 893,
	"./Angle45.gmt": 894,
	"./Angle54.gmt": 895,
	"./Angle60.gmt": 896,
	"./Angle60Drop.gmt": 897,
	"./Angle75.gmt": 898,
	"./AngleIsosceles.gmt": 899,
	"./AngleMidpoint.gmt": 900,
	"./AngleTrisection54.gmt": 901,
	"./Annulus.gmt": 902,
	"./Arbelos.gmt": 903,
	"./BisectAngle.gmt": 904,
	"./CDoubleSeg.gmt": 905,
	"./CIntersectCL.gmt": 906,
	"./CIntersectX.gmt": 907,
	"./CMidpoint.gmt": 908,
	"./CTranslateCircle.gmt": 909,
	"./CenterOfRotation.gmt": 910,
	"./CentroidOfQuadrilateral.gmt": 911,
	"./Chord3.gmt": 912,
	"./ChordMidpoint.gmt": 913,
	"./Circle3.gmt": 914,
	"./CircleByRadius.gmt": 915,
	"./CircleCenter.gmt": 916,
	"./CircleEquidistantFrom4Points.gmt": 917,
	"./CircleInAngle.gmt": 918,
	"./CircleInOutSquare.gmt": 919,
	"./CircleInRhombus.gmt": 920,
	"./CircleInSquare.gmt": 921,
	"./CircleInTriangle.gmt": 922,
	"./CircleTangentCC.gmt": 923,
	"./CircleTangentCCwCenterL.gmt": 924,
	"./CircleTangentCL.gmt": 925,
	"./CircleTangentCPwCenterL.gmt": 926,
	"./CircleTangentL.gmt": 927,
	"./CircleTangentLLL.gmt": 928,
	"./CircleTangentPL.gmt": 929,
	"./CircleTangentPPL.gmt": 930,
	"./Cleaver.gmt": 931,
	"./Cut2Rectangles.gmt": 932,
	"./CutRectangle.gmt": 933,
	"./Divide3.gmt": 934,
	"./DoubleAngle.gmt": 935,
	"./DropPerp.gmt": 936,
	"./EqualSegments3.gmt": 937,
	"./Equidistant2.gmt": 938,
	"./Equidistant3.gmt": 939,
	"./EquidistantParallel.gmt": 940,
	"./Equilateral3.gmt": 941,
	"./EquilateralAboutCircle.gmt": 942,
	"./EquilateralByCentroid2P.gmt": 943,
	"./EquilateralInCircle.gmt": 944,
	"./EquilateralOnCC.gmt": 945,
	"./ErectPerp.gmt": 946,
	"./Excircle.gmt": 947,
	"./GeometricMean.gmt": 948,
	"./GivenAngleBisector.gmt": 949,
	"./GoldenSection.gmt": 950,
	"./HarmonicMean.gmt": 951,
	"./Hash.gmt": 952,
	"./Heron.gmt": 953,
	"./HexagonBySide.gmt": 954,
	"./HypotenuseAndAltitude.gmt": 955,
	"./HypotenuseAndLeg.gmt": 956,
	"./Incenter.gmt": 957,
	"./InnerTangent.gmt": 958,
	"./InteriorAngles.gmt": 959,
	"./IsoscelesTriangleAboutCircle.gmt": 960,
	"./L3Parallel.gmt": 961,
	"./LDivide3.gmt": 962,
	"./LDropPerp.gmt": 963,
	"./LDropPerp2.gmt": 964,
	"./LMidpoint.gmt": 965,
	"./LReflection.gmt": 966,
	"./LTangent.gmt": 967,
	"./LineAlongPoints.gmt": 968,
	"./LineBetweenPoints.gmt": 969,
	"./Lozenge.gmt": 970,
	"./Midpoint.gmt": 971,
	"./MirrorSeg.gmt": 972,
	"./Napoleon.gmt": 973,
	"./OctagonBySide.gmt": 974,
	"./OrthicTriangle.gmt": 975,
	"./OuterTangent.gmt": 976,
	"./Parallel.gmt": 977,
	"./Parallelogram3V.gmt": 978,
	"./ParallelogramBy3Midpoints.gmt": 979,
	"./ParallelogramBySP.gmt": 980,
	"./ParallelogramVOn4Lines.gmt": 981,
	"./Pentagon.gmt": 982,
	"./PerimeterBisector.gmt": 983,
	"./PerpBisector.gmt": 984,
	"./PtSymmetry.gmt": 985,
	"./RTrBy2SidePoints.gmt": 986,
	"./RTrByHypAndTangentPt.gmt": 987,
	"./RhombusInRect.gmt": 988,
	"./RhombusInTriangle.gmt": 989,
	"./Secant2.gmt": 990,
	"./Segment6.gmt": 991,
	"./ShiftAngle.gmt": 992,
	"./ShiftSegment.gmt": 993,
	"./Sqrt2.gmt": 994,
	"./Sqrt3.gmt": 995,
	"./SquareAboutCircle.gmt": 996,
	"./SquareBy4Pt.gmt": 997,
	"./SquareByAdjMidpoints.gmt": 998,
	"./SquareByOppMidpoints.gmt": 999,
	"./SquareInCircle.gmt": 1000,
	"./SquareInCircleByPt.gmt": 1001,
	"./SquareInSquare.gmt": 1002,
	"./SquareInTriangle.gmt": 1003,
	"./SumSquares.gmt": 1004,
	"./T1_Line.gmt": 1005,
	"./T2_Circle.gmt": 1006,
	"./T3_Point.gmt": 1007,
	"./TBisectAngle.gmt": 1008,
	"./TCircleByRadius.gmt": 1009,
	"./TDropPerp.gmt": 1010,
	"./TEquilateral.gmt": 1011,
	"./TIntersect.gmt": 1012,
	"./TMove.gmt": 1013,
	"./TParallel.gmt": 1014,
	"./TPerpBisector.gmt": 1015,
	"./Tangent.gmt": 1016,
	"./Tangent1.gmt": 1017,
	"./TorricelliPt.gmt": 1018,
	"./TrByAltitudeBases.gmt": 1019,
	"./TrByExcircleCenters.gmt": 1020,
	"./TrByIncircleBases.gmt": 1021,
	"./TrBySideAndCentroid.gmt": 1022,
	"./TranslateSegment.gmt": 1023,
	"./TrapezoidCut.gmt": 1024,
	"./TrapezoidCut3.gmt": 1025,
	"./TrapezoidGeomMean.gmt": 1026,
	"./TrapezoidHarmMean.gmt": 1027,
	"./TriangleByMidpoints.gmt": 1028,
	"./TriangleBySides.gmt": 1029,
	"./TriangleMidSegment.gmt": 1030
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1328;


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-lproj/HotKeys.strings": 1032,
	"./ru-lproj/HotKeys.strings": 1035
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1329;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-lproj/LevelInfos.xml": 1033,
	"./ru-lproj/LevelInfos.xml": 1036
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1330;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-lproj/Localizable.strings": 1034,
	"./ru-lproj/Localizable.strings": 1037
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1331;


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-lproj/ToolInfos.xml": 191,
	"./ru-lproj/ToolInfos.xml": 1038
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1332;


/***/ }),
/* 1333 */
/***/ (function(module, exports) {

module.exports = [{"chars":["h","m","w","р","ь","ц"],"tool":"HandTool"},{"chars":[".","ю"],"tool":"PointTool"},{"chars":["i","/","|","\\","ш"],"tool":"LineTool"},{"chars":["o","0","щ"],"tool":"CircleTool"},{"chars":["t","+","е"],"tool":"PBisectTool"},{"chars":["l","д"],"tool":"PerpTool"},{"chars":["a","ф"],"tool":"ABisectTool"},{"chars":["z","n","=","я","т"],"tool":"ParallelTool"},{"chars":["q","й"],"tool":"CompassTool"},{"chars":["x","ч"],"tool":"IntersectTool"}]

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_dynamic_1 = __webpack_require__(100);
var core_1 = __webpack_require__(3);
var index_module_1 = __webpack_require__(232);
if (true) {
    core_1.enableProdMode();
}
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(index_module_1.AppModule);


/***/ })
],[1334]);


// WEBPACK FOOTER //
// app.9d4d21c2f91d1c14f8ec.js